/* ============================================================
   Lienzo Librería · Horarios y Nómina  —  app.js
   Lógica del cliente: estado, datos (Apps Script), horarios,
   horarios con arrastre, cálculo de nómina e impresión.
   ============================================================ */
(function(){
"use strict";

/* ------------------------------------------------------------
   CONFIGURACIÓN
   Pega aquí la URL del Web App publicado desde Codigo.gs
   (Implementar › Aplicación web › URL que termina en /exec).
   El token debe coincidir con el TOKEN de Codigo.gs.
   ------------------------------------------------------------ */
var EXEC_URL = "https://script.google.com/macros/s/AKfycbyuyJ7vKK0ASMFnM9SG81XFqBKzxS4FRcq0jEo9V-LQ8UsqIkyQqhwhLTHpgrpSG6Rx/exec";
var EXEC_TOKEN = "lienzo-2026";

var CONFIG = {
  apiUrl: EXEC_URL,
  token : EXEC_TOKEN
};

/* Imágenes de marca incrustadas (no requieren assets en Shopify).
   header -> encabezado del sistema (ícono);  recibo -> recibos (logo horizontal). */
var LIENZO_IMG_HEADER = "data:image/jpeg;base64,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";
var LIENZO_IMG_RECIBO = "data:image/jpeg;base64,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";
var IMG = { header: LIENZO_IMG_HEADER, recibo: LIENZO_IMG_RECIBO };

/* ---------- Catálogos ---------- */
var TURNOS = {
  mat:{nom:"Matutino",  ini:"07:00", fin:"15:00"},
  ves:{nom:"Vespertino",ini:"14:00", fin:"22:00"},
  int:{nom:"Intermedio",ini:"11:00", fin:"19:00"},
  esp:{nom:"Especial",  ini:"09:00", fin:"14:00"},
  descanso:{nom:"Descanso",        especial:true},
  cumpleanos:{nom:"Cumpleaños",     especial:true,pagado:true},
  vacaciones:{nom:"Vacaciones",     especial:true,pagado:true},
  permiso: {nom:"Permiso especial", especial:true}
};
var DIAS = ["Lunes","Martes","Miércoles","Jueves","Viernes","Sábado","Domingo"];
var DIAS_CORTO = ["Lun","Mar","Mié","Jue","Vie","Sáb","Dom"];

var TIPOS_SUELDO = {hora:"Por hora", semana:"Por semana", mes:"Por mes"};
var PERIODOS = {
  semanal:{nom:"Semanal", dias:7},
  catorcenal:{nom:"Catorcenal", dias:14},
  mensual:{nom:"Mensual", dias:30}
};

/* Conceptos editables sugeridos (no todos aparecen siempre).
   tipo: percepcion | deduccion | otro ; grav: gravable para ISR */
var CONCEPTOS_BASE = [
  {clave:"DESCANSO",  nom:"Descansos",             tipo:"percepcion", grav:true},
  {clave:"PRIMA_DOM", nom:"Prima dominical",      tipo:"percepcion", grav:false},
  {clave:"FESTIVO",   nom:"Días festivos",         tipo:"percepcion", grav:true},
  {clave:"EXTRA",     nom:"Horas extra",           tipo:"percepcion", grav:false},
  {clave:"PROPINAS",  nom:"Propinas",              tipo:"percepcion", grav:true},
  {clave:"PRIMA_VAC", nom:"Prima vacacional",      tipo:"percepcion", grav:false},
  {clave:"VACAC",     nom:"Vacaciones",            tipo:"percepcion", grav:true},
  {clave:"AGUINALDO", nom:"Aguinaldo",             tipo:"percepcion", grav:false},
  {clave:"BONO",      nom:"Bono / incentivo",      tipo:"percepcion", grav:true},
  {clave:"FALTAS",    nom:"Faltas injustificadas", tipo:"deduccion",  grav:false},
  {clave:"PRESTAMO",  nom:"Préstamo / anticipo",   tipo:"deduccion",  grav:false},
  {clave:"HERRAM",    nom:"Herramientas de trabajo",tipo:"otro",      grav:false}
];

/* Tabla ISR mensual (LISR Art. 96). EDITABLE en Configuración.
   Verifica los valores con la tabla vigente del año en curso. */var ISR_DEFAULT = [
  {li:0.01,      ls:746.04,     cuota:0.00,      pct:1.92},
  {li:746.05,    ls:6332.05,    cuota:14.32,     pct:6.40},
  {li:6332.06,   ls:11128.01,   cuota:371.83,    pct:10.88},
  {li:11128.02,  ls:12935.82,   cuota:893.63,    pct:16.00},
  {li:12935.83,  ls:15487.71,   cuota:1182.88,   pct:17.92},
  {li:15487.72,  ls:31236.49,   cuota:1640.18,   pct:21.36},
  {li:31236.50,  ls:49233.00,   cuota:5004.12,   pct:23.52},
  {li:49233.01,  ls:93993.90,   cuota:9236.89,   pct:30.00},
  {li:93993.91,  ls:125325.20,  cuota:22665.17,  pct:32.00},
  {li:125325.21, ls:375975.61,  cuota:32691.18,  pct:34.00},
  {li:375975.62, ls:Infinity,   cuota:117912.32, pct:35.00}
];

/* Parámetros de finiquito (EDITABLES en Configuración).
   tipo: aguinaldo_prop | dias | pct_vac | dias_fijo | dias_year
   on:  si se incluye por defecto al calcular */
var FINIQUITO_DEFAULT = [
  {clave:"AGUINALDO", nom:"Aguinaldo proporcional",        tipo:"aguinaldo_prop", valor:15, on:true},
  {clave:"VACAC",     nom:"Vacaciones pendientes",         tipo:"dias",           valor:0,  on:true},
  {clave:"PRIMA_VAC", nom:"Prima vacacional",              tipo:"pct_vac",        valor:25, on:true},
  {clave:"DEVENGADO", nom:"Salarios devengados",           tipo:"dias",           valor:0,  on:false},
  {clave:"INDEM90",   nom:"Indemnización constitucional",  tipo:"dias_fijo",      valor:90, on:false},
  {clave:"DIAS20",    nom:"20 días por año",               tipo:"dias_year",      valor:20, on:false},
  {clave:"PRIMA_ANT", nom:"Prima de antigüedad",           tipo:"dias_year",      valor:12, on:false}
];

/* Periodos para la sección de Reportes */
var REP_PERIODOS = {
  semanal:{nom:"Semanal"}, catorcenal:{nom:"Catorcenal"}, mensual:{nom:"Mensual"},
  bimestral:{nom:"Bimestral"}, trimestral:{nom:"Trimestral"}
};

/* Reglas del día de descanso (EDITABLES en Configuración).
   regla: monto_fijo | promedio_horas
   - monto_fijo: paga "monto" por cada día de descanso asignado.
   - promedio_horas: (horas promedio por día trabajado en la semana) × pago por hora × días de descanso.
   incluir: si el concepto "Día de descanso" se agrega por defecto al recibo. */
var DESCANSO_DEFAULT = { regla:"promedio_horas", monto:0, incluir:false };
/* Día festivo: pago EXTRA por trabajar un día festivo. El sueldo ya cubre el día normal (1×),
   por lo que con pct=100 el día festivo queda pagado al doble; con 200% al triple (LFT Art. 75). */
var FESTIVO_DEFAULT = { pct:100, incluir:true, civicos:false };
var META_DEFAULT = {
  objetivoMes:0,
  totalFecha:0,
  conceptos:[
    {id:"meta-libros",nombre:"Total Libros",valor:0,parent:""},
    {id:"meta-cafeteria",nombre:"Total Cafetería",valor:0,parent:""},
    {id:"meta-bebidas",nombre:"Bebidas",valor:0,parent:"meta-cafeteria"},
    {id:"meta-alimentos",nombre:"Alimentos",valor:0,parent:"meta-cafeteria"},
    {id:"meta-postres",nombre:"Postres",valor:0,parent:"meta-cafeteria"}
  ]
};

var LEGAL_FIELDS_DEFAULT = [
  {id:"domicilio_completo", label:"Domicilio completo", type:"textarea", sensitive:true, docs:true},
  {id:"edad", label:"Edad", type:"number", sensitive:false, docs:true},
  {id:"fecha_nacimiento", label:"Fecha de nacimiento", type:"date", sensitive:true, docs:true},
  {id:"dias_vacaciones_anuales", label:"Días de vacaciones al año", type:"number", sensitive:false, docs:true},
  {id:"estado_civil", label:"Estado civil", type:"text", sensitive:false, docs:true},
  {id:"tipo_sangre", label:"Tipo de sangre", type:"text", sensitive:true, docs:true},
  {id:"contacto_emergencia", label:"Contacto de emergencia", type:"text", sensitive:true, docs:true},
  {id:"telefono_emergencia", label:"Telefono de emergencia", type:"tel", sensitive:true, docs:true},
  {id:"parentesco_emergencia", label:"Parentesco", type:"text", sensitive:false, docs:true},
  {id:"identificacion_oficial", label:"No. identificacion oficial", type:"text", sensitive:true, docs:true},
  {id:"banco", label:"Banco", type:"text", sensitive:true, docs:true},
  {id:"cuenta", label:"Cuenta", type:"text", sensitive:true, docs:true},
  {id:"clabe", label:"CLABE", type:"text", sensitive:true, docs:true}
];

/* ------------------------------------------------------------
   DÍAS FESTIVOS DE MÉXICO  (obligatorios LFT Art. 74 y cívicos)
   Se marcan en la tabla de horarios; NO aparecen en la imagen.
   ------------------------------------------------------------ */
function nthWeekday_(year,month,weekday,n){ // month 0-11, weekday 0=dom..6=sab
  var d=new Date(year,month,1), add=(weekday-d.getDay()+7)%7;
  return new Date(year,month,1+add+(n-1)*7);
}
function pascua_(year){ // algoritmo de Gauss (domingo de Pascua)
  var a=year%19,b=Math.floor(year/100),c=year%100,d=Math.floor(b/4),e=b%4,
      f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,
      i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),
      mes=Math.floor((h+l-7*m+114)/31),dia=((h+l-7*m+114)%31)+1;
  return new Date(year,mes-1,dia);
}
var _festCache={};
function festivosDe(year){
  if(_festCache[year])return _festCache[year];
  var map={};
  function set(d,nombre,tipo){map[fechaISO(d)]={nombre:nombre,tipo:tipo};}
  // Obligatorios (Art. 74 LFT)
  set(new Date(year,0,1),"Año Nuevo","obligatorio");
  set(nthWeekday_(year,1,1,1),"Día de la Constitución","obligatorio");      // 1er lunes feb
  set(nthWeekday_(year,2,1,3),"Natalicio de Benito Juárez","obligatorio");  // 3er lunes mar
  set(new Date(year,4,1),"Día del Trabajo","obligatorio");
  set(new Date(year,8,16),"Independencia de México","obligatorio");
  set(nthWeekday_(year,10,1,3),"Día de la Revolución","obligatorio");       // 3er lunes nov
  set(new Date(year,11,25),"Navidad","obligatorio");
  if(year%6===0) set(new Date(year,9,1),"Transmisión Poder Ejecutivo","obligatorio");
  // Cívicos / no obligatorios (de uso común)
  var jue=pascua_(year); jue.setDate(jue.getDate()-3);
  var vie=pascua_(year); vie.setDate(vie.getDate()-2);
  set(jue,"Jueves Santo","civico");
  set(vie,"Viernes Santo","civico");
  set(new Date(year,1,5),"Promulgación de la Constitución (cívico)","civico");
  set(new Date(year,2,21),"Natalicio de Juárez (cívico)","civico");
  set(new Date(year,4,5),"Batalla de Puebla","civico");
  set(new Date(year,4,10),"Día de las Madres","civico");
  set(new Date(year,10,2),"Día de Muertos","civico");
  set(new Date(year,11,12),"Día de la Virgen de Guadalupe","civico");
  set(new Date(year,11,24),"Nochebuena","civico");
  set(new Date(year,11,31),"Fin de Año","civico");
  _festCache[year]=map; return map;
}
function festivoDe(dISO){
  var y=+String(dISO).slice(0,4); if(!y)return null;
  return festivosDe(y)[dISO]||null;
}

/* ------------------------------------------------------------
   ESTADO
   ------------------------------------------------------------ */
var S = {
  tab:"pal",
  colaboradores:[],
  sucursales:[{id:"suc-centro", nombre:"Sucursal Centro", apertura:"08:00", cierre:"22:00",
            dias:[true,true,true,true,true,true,false], cobMin:1}],
  sucursalId:"suc-centro",
  config:{ isr:ISR_DEFAULT, imssPct:2.5, subsidio:0, salarioMin:278.80,
           empresa:"Lienzo Librería", razonSocial:"Lienzo Librería S.A. de C.V.",
           rfc:"", registroPatronal:"", domicilio:"",
           mostrar:{razonSocial:true, rfc:true, rp:true, domicilio:true},
           finiquito:FINIQUITO_DEFAULT.slice(), descanso:Object.assign({},DESCANSO_DEFAULT), festivo:Object.assign({},FESTIVO_DEFAULT),
           docFields:LEGAL_FIELDS_DEFAULT.slice(), docTemplates:[],
           palTasks:[], palManual:{}, palLog:{}, metaConfig:JSON.parse(JSON.stringify(META_DEFAULT)) },
  conceptos:CONCEPTOS_BASE.slice(),
  horarios:{},          // { "YYYY-MM-DD": { colId: { 0:[shift...], ... } } }
  notasDias:{},         // { "YYYY-MM-DD": "nota del día" }
  retardos:{},          // { "YYYY-MM-DD": { colId: {h,m,eReal,sReal,sDesc,eDesc} } }
  nominas:[],           // recibos guardados
  semanaActual:lunesDe(new Date()),
  colFiltro:"activos",  // filtro de colaboradores: activos | baja | todos
  adminSub:"colaboradores",
  metaSub:"marcadores",
  pedidosSub:"pedidos",
  recFiltro:"",         // filtro de histórico de recibos por colaborador
  recIni:"", recFin:"", // filtro por rango de fechas en Recibos
  repPeriodo:"mensual", repIni:"", repFin:"", repConcepto:"", repMesCal:fechaISO(new Date()).slice(0,7), // filtros de Reportes
  repSub:"nomina", repPalFecha:fechaISO(new Date()), repPalMes:fechaISO(new Date()).slice(0,7), repPalSemana:fechaISO(lunesDe(new Date())), repPalPeriodo:"dia", repPalDesde:fechaISO(new Date()), repPalHasta:fechaISO(new Date()), repPalCol:"", repPalTipo:"",
  pedidosData:{pedidos:[], solicitudes:[], incidencias:[], eventos:[], seqPedido:0, seqSolicitud:0, seqIncidencia:0, seqEvento:0},
  pedidosMes:fechaISO(new Date()).slice(0,7),
  eventosFecha:fechaISO(new Date()),
  pedRepTipo:"todos", pedRepModo:"mes", pedRepMes:fechaISO(new Date()).slice(0,7), pedRepDesde:fechaISO(new Date()), pedRepHasta:fechaISO(new Date()),
  incRepTipo:"todos", incRepModo:"mes", incRepMes:fechaISO(new Date()).slice(0,7), incRepDesde:fechaISO(new Date()), incRepHasta:fechaISO(new Date()),
  palFecha:fechaISO(new Date()),
  imgColsBySuc:{},
  imgAreasBySuc:{},
  auth:{horarios:false, admin:false, docs:false},   // secciones desbloqueadas en esta sesión
  sessions:{horarios:"", admin:"", docs:""},     // tokens de sesión del servidor
  loaded:false,                         // datos sensibles ya cargados
  palLoaded:false,
  pedidosLoaded:false,
  sync:{timer:null,busy:false,pending:false,last:0,saving:0},
  nomEmpId:null,
  colSub:"listado",
  docColId:"",
  docTplId:"",
  nomPeriodo:"semanal",
  nomSub:"recibos",            // subsección de Nómina: recibos | finiquitos | retardos
  retEmpId:null, retIni:"", retFin:"",  // filtros del ajuste de retardos
  aguiIni:"", aguiFin:"",
  nomDraft:null
};

/* Sucursal activa y utilidades de colaboradores */
function sucursalActiva(){
  var s=S.sucursales.filter(function(x){return x.id===S.sucursalId;})[0];
  return s||S.sucursales[0]||{nombre:"",apertura:"08:00",cierre:"22:00",dias:[true,true,true,true,true,true,false],cobMin:1};
}
function colActivo(c){return (c.estado||"activo")!=="baja";}
function colsActivos(){return S.colaboradores.filter(colActivo);}
function colsDeSucursal(){var su=sucursalActiva(), n=su.nombre, id=su.id;
  return colsActivos().filter(function(c){return !c.sucursal&&!c.sucursalId||c.sucursal===n||c.sucursal===id||c.sucursalId===id||c.sucursalId===n;});}
function fechaNacCol(c){
  var l=(c&&c.legal&&typeof c.legal==="object")?c.legal:{};
  return String(l.fecha_nacimiento||l.fechaNacimiento||c.fecha_nacimiento||"").slice(0,10);
}
function edadDesdeFecha(fn){
  if(!fn)return "";
  var d=new Date(fn+"T00:00:00");if(isNaN(d))return "";
  var h=new Date(), e=h.getFullYear()-d.getFullYear(), m=h.getMonth()-d.getMonth();
  if(m<0||(m===0&&h.getDate()<d.getDate()))e--;
  return e>=0?e:"";
}
function cumpleanosDe(dISO){
  var md=String(dISO||"").slice(5,10);
  if(!md)return [];
  return colsDeSucursal().filter(function(c){var fn=fechaNacCol(c);return fn&&fn.slice(5,10)===md;});
}
function horarioSucursalDia(day){
  var su=sucursalActiva(), h=(su.horariosDia&&su.horariosDia[day])||{};
  return {apertura:h.apertura||su.apertura||"08:00",cierre:h.cierre||su.cierre||"22:00"};
}
function turnoMinutos(sh){return sh&&sh.ini&&sh.fin?Math.max(0,minutos(sh.fin)-minutos(sh.ini)):0;}
function turnoDentroSucursal(sh,day){
  var h=horarioSucursalDia(day);
  return minutos(sh.ini)>=minutos(h.apertura)&&minutos(sh.fin)<=minutos(h.cierre);
}
function clasificarTurnoPorHorario(ini,fin,day){
  var h=horarioSucursalDia(day), dur=horasEntre(ini,fin), mIni=minutos(ini), mFin=minutos(fin), ap=minutos(h.apertura), ci=minutos(h.cierre);
  if(dur<4||dur>8)return "esp";
  var mat=mIni===ap, ves=mFin===ci, inter=mIni!==ap&&mFin!==ci&&mIni<12*60&&mFin>12*60&&dur>=5;
  var n=(mat?1:0)+(ves?1:0)+(inter?1:0);
  if(n!==1)return "esp";
  return mat?"mat":(ves?"ves":"int");
}
function modoHoras(vals){
  var freq={},best=0,bn=0;
  vals.forEach(function(v){v=Math.round(v*4)/4;if(v<=0)return;freq[v]=(freq[v]||0)+1;if(freq[v]>best||(freq[v]===best&&v>bn)){best=freq[v];bn=v;}});
  return bn;
}
function imgColsKey(){return "lienzo-img-cols-"+(S.sucursalId||"default");}
function imgColsSeleccionados(){
  S.imgColsBySuc=S.imgColsBySuc||{};
  if(!Object.prototype.hasOwnProperty.call(S.imgColsBySuc,S.sucursalId)){
    try{var raw=localStorage.getItem(imgColsKey());S.imgColsBySuc[S.sucursalId]=raw?JSON.parse(raw):null;}catch(e){S.imgColsBySuc[S.sucursalId]=null;}
  }
  var all=colsDeSucursal(), ids=S.imgColsBySuc[S.sucursalId];
  if(!Array.isArray(ids))return all;
  var set={};ids.forEach(function(id){set[id]=true;});
  var out=all.filter(function(c){return set[c.id];});
  return out.length?out:all;
}
function guardarImgColsSeleccionados(ids){
  var all=colsDeSucursal(), val=(ids&&ids.length<all.length)?ids:null;
  S.imgColsBySuc[S.sucursalId]=val;
  try{if(val)localStorage.setItem(imgColsKey(),JSON.stringify(val));else localStorage.removeItem(imgColsKey());}catch(e){}
}
function imgColsLabel(){
  var all=colsDeSucursal(), sel=imgColsSeleccionados();
  return sel.length===all.length?"Todos":(sel.length+"/"+all.length);
}
function imgAreasKey(){return "lienzo-img-areas-"+(S.sucursalId||"default");}
function imgAreasSeleccionadas(){
  S.imgAreasBySuc=S.imgAreasBySuc||{};
  if(!Object.prototype.hasOwnProperty.call(S.imgAreasBySuc,S.sucursalId)){
    try{var raw=localStorage.getItem(imgAreasKey());S.imgAreasBySuc[S.sucursalId]=raw?JSON.parse(raw):null;}catch(e){S.imgAreasBySuc[S.sucursalId]=null;}
  }
  var all=colsDeSucursal(),ids=S.imgAreasBySuc[S.sucursalId];
  if(!Array.isArray(ids))return all.map(function(c){return c.id;});
  var valid={};all.forEach(function(c){valid[c.id]=true;});
  return ids.filter(function(id){return valid[id];});
}
function guardarImgAreasSeleccionadas(ids){
  ids=Array.isArray(ids)?ids:[];S.imgAreasBySuc[S.sucursalId]=ids.slice();
  try{localStorage.setItem(imgAreasKey(),JSON.stringify(ids));}catch(e){}
}
function mostrarAreaEnImagen(colId){return imgAreasSeleccionadas().indexOf(colId)>=0;}
function imgAreasLabel(){var all=colsDeSucursal(),n=imgAreasSeleccionadas().length;return n===all.length?"Todos":(n? n+"/"+all.length:"Ninguno");}

/* ------------------------------------------------------------
   UTILIDADES
   ------------------------------------------------------------ */
function $(s,r){return (r||document).querySelector(s);}
function $$(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));}
function el(tag,attrs,html){var e=document.createElement(tag);if(attrs)for(var k in attrs){if(k==="class")e.className=attrs[k];else if(k==="html")e.innerHTML=attrs[k];else e.setAttribute(k,attrs[k]);}if(html!=null)e.innerHTML=html;return e;}
function uid(p){return (p||"id")+"-"+Math.random().toString(36).slice(2,9);}
function esc(s){return String(s==null?"":s).replace(/[&<>"]/g,function(c){return{"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c];});}
function money(n){n=Number(n)||0;return "$"+n.toLocaleString("es-MX",{minimumFractionDigits:2,maximumFractionDigits:2});}
function num2(n){return (Number(n)||0).toLocaleString("es-MX",{minimumFractionDigits:2,maximumFractionDigits:2});}
function pad(n){return n<10?"0"+n:""+n;}

function lunesDe(d){d=new Date(d);var dow=(d.getDay()+6)%7;d.setDate(d.getDate()-dow);d.setHours(0,0,0,0);return d;}
function fechaISO(d){d=new Date(d);return d.getFullYear()+"-"+pad(d.getMonth()+1)+"-"+pad(d.getDate());}
function sumaDias(d,n){d=new Date(d);d.setDate(d.getDate()+n);return d;}
function fechaLarga(d){d=(typeof d==="string"&&/^\d{4}-\d{2}-\d{2}/.test(d))?new Date(d.slice(0,10)+"T00:00:00"):new Date(d);return d.getDate()+"/"+pad(d.getMonth()+1)+"/"+d.getFullYear();}
/* Normaliza cualquier valor de fecha (Date, ISO con hora, etc.) a "YYYY-MM-DD" para <input type="date">. */
function fechaInput(v){
  if(v==null||v==="")return "";
  var s=String(v);
  if(/^\d{4}-\d{2}-\d{2}/.test(s))return s.slice(0,10);
  var d=new Date(v);
  return isNaN(d.getTime())?"":fechaISO(d);
}
function fechaTexto(d){d=new Date(d);var m=["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];return pad(d.getDate())+" de "+m[d.getMonth()]+" de "+d.getFullYear();}
function rangoSemana(lunes){var dom=sumaDias(lunes,6);var m=["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"];
  return lunes.getDate()+" "+m[lunes.getMonth()]+" – "+dom.getDate()+" "+m[dom.getMonth()]+" "+dom.getFullYear();}

function minutos(hhmm){var p=String(hhmm).split(":");return (+p[0])*60+(+p[1]||0);}
function horasEntre(ini,fin){var d=(minutos(fin)-minutos(ini))/60;return d>0?d:0;}
function horaDesdeMin(m){m=Math.max(0,Math.min(23*60+59,Math.round(m)));return pad(Math.floor(m/60))+":"+pad(m%60);}
function sumaHoras(hhmm,h){return horaDesdeMin(minutos(hhmm)+Math.round(h*60));}

/* Número a letras (pesos mexicanos) para "cantidad con letra" */
function numeroALetras(n){
  n=Math.round((Number(n)||0)*100)/100;
  var ent=Math.floor(n), cent=Math.round((n-ent)*100);
  var U=["","UNO","DOS","TRES","CUATRO","CINCO","SEIS","SIETE","OCHO","NUEVE","DIEZ","ONCE","DOCE","TRECE","CATORCE","QUINCE","DIECISÉIS","DIECISIETE","DIECIOCHO","DIECINUEVE","VEINTE"];
  var D=["","","VEINTI","TREINTA","CUARENTA","CINCUENTA","SESENTA","SETENTA","OCHENTA","NOVENTA"];
  var C=["","CIENTO","DOSCIENTOS","TRESCIENTOS","CUATROCIENTOS","QUINIENTOS","SEISCIENTOS","SETECIENTOS","OCHOCIENTOS","NOVECIENTOS"];
  function dec(x){if(x<=20)return U[x];if(x<30)return x===20?"VEINTE":"VEINTI"+U[x-20].toLowerCase().toUpperCase();
    var d=Math.floor(x/10),u=x%10;return D[d]+(u?" Y "+U[u]:"");}
  function cien(x){if(x===100)return "CIEN";var c=Math.floor(x/100),r=x%100;return (c?C[c]+(r?" ":""):"")+(r?dec(r):"");}
  function miles(x){if(x===0)return "CERO";var partes="";
    var millon=Math.floor(x/1000000);x=x%1000000;
    var miles=Math.floor(x/1000);var resto=x%1000;
    if(millon)partes+=(millon===1?"UN MILLÓN ":cien(millon)+" MILLONES ");
    if(miles)partes+=(miles===1?"MIL ":cien(miles)+" MIL ");
    if(resto)partes+=cien(resto);
    return partes.trim();}
  return miles(ent)+" PESOS "+pad(cent)+"/100 M.N.";
}

/* ------------------------------------------------------------
   CAPA DE DATOS  (Apps Script en vivo)
   ------------------------------------------------------------ */
var DataStore = {
  mode: "live",

  call:function(action, payload){
    payload=payload||{};
    // Respaldo/restauración pasan su sesión explícita (maestra recién autenticada).
    var esBackup=(action==="exportBackup"||action==="importBackup");
    var esHorario=(action==="saveHorario"||action==="saveNotasDias"||action==="deleteHorario"||action==="savePAL");
    var esAdmin=/^(saveColaborador|deleteColaborador|saveSucursales|saveSucursal|saveConfig|saveConceptos|savePasswords|saveNomina|deleteNomina|saveRetardos|uploadMetaAttachment)$/.test(action);
    // Para todo lo demás SIEMPRE recalcular la sesión vigente (nunca usar una embebida en el payload,
    // p.ej. un token viejo que pudo quedar dentro de config). El servidor valida el scope.
    if(esBackup){
      payload.session = payload.session || S.sessions.admin || "";
    } else if(esHorario){
      payload.session = S.sessions.horarios || S.sessions.admin || S.sessions.docs || "";
    } else if(esAdmin){
      payload.session = S.sessions.admin || "";
    } else {
      payload.session = S.sessions.admin || S.sessions.docs || S.sessions.horarios || "";
    }
    var url=CONFIG.apiUrl+"?action="+encodeURIComponent(action)+"&token="+encodeURIComponent(CONFIG.token);
    var opts={method:"POST", body:JSON.stringify(payload),
              headers:{"Content-Type":"text/plain;charset=utf-8"}}; // text/plain evita preflight CORS
    S.sync.saving=(S.sync.saving||0)+1;
    return fetch(url,opts).then(function(r){return r.json();}).then(function(d){
      if(d&&d.error){ toast(d.error==="sesion"?"Sesión no válida para guardar":"No se pudo guardar","err"); }
      return d;
    }).catch(function(e){ toast("Sin conexión con el servidor","err"); throw e;}).then(function(d){
      S.sync.saving=Math.max(0,(S.sync.saving||1)-1);
      if(S.sync.pending&&!edicionActiva()){S.sync.pending=false;setTimeout(function(){solicitarSyncVivo("guardado-finalizado",true);},120);}
      return d;
    },function(e){
      S.sync.saving=Math.max(0,(S.sync.saving||1)-1);
      throw e;
    });
  },

  callPublico:function(action,payload){
    payload=payload||{};
    var url=CONFIG.apiUrl+"?action="+encodeURIComponent(action)+"&token="+encodeURIComponent(CONFIG.token);
    return fetch(url,{method:"POST",body:JSON.stringify(payload),headers:{"Content-Type":"text/plain;charset=utf-8"}})
      .then(function(r){return r.json();})
      .then(function(d){if(d&&d.error){toast("No se pudo guardar","err");}return d;})
      .catch(function(e){toast("Sin conexión con el servidor","err");throw e;});
  },

  /* Autenticación server-side: envía la contraseña candidata; el servidor
     valida y devuelve un token de sesión. NUNCA recibe las contraseñas. */
  autenticar:function(scope, password){
    var url=CONFIG.apiUrl+"?action=auth&token="+encodeURIComponent(CONFIG.token);
    return fetch(url,{method:"POST",headers:{"Content-Type":"text/plain;charset=utf-8"},
      body:JSON.stringify({scope:scope, sucursal:S.sucursalId, password:password})})
      .then(function(r){return r.json();}).catch(function(e){toast("Sin conexión","err");throw e;});
  },

  /* Lista de sucursales (no sensible): permite elegir sucursal antes de autenticar. */
  cargarSucursales:function(){
    var url=CONFIG.apiUrl+"?action=branches&token="+encodeURIComponent(CONFIG.token);
    return fetch(url).then(function(r){return r.json();}).then(function(d){
      if(d&&d.sucursales&&d.sucursales.length){S.sucursales=d.sucursales;S.sucursalId=S.sucursales[0].id;}
      return true;
    }).catch(function(){ DataStore.mode="off"; pintarConn(); toast("Sin conexión con el servidor","err"); return false; });
  },

  /* Carga de datos sensibles. Sólo se invoca DESPUÉS de autenticar. */
  loadPAL:function(){
    var url=CONFIG.apiUrl+"?action=loadPAL&token="+encodeURIComponent(CONFIG.token);
    return fetch(url).then(function(r){return r.json();}).then(function(d){
      if(d.error){toast("No se pudo cargar PAL","err");return false;}
      aplicarPALData(d);
      guardarCachePublica("pal",d);
      return true;
    }).catch(function(){DataStore.mode="off";pintarConn();toast("No se pudo cargar PAL","err");return false;});
  },

  loadPedidos:function(){
    var url=CONFIG.apiUrl+"?action=loadPedidos&token="+encodeURIComponent(CONFIG.token);
    return fetch(url).then(function(r){return r.json();}).then(function(d){
      if(d.error){toast("No se pudieron cargar pedidos","err");return false;}
      aplicarPedidosData(d);
      guardarCachePublica("pedidos",d);
      return true;
    }).catch(function(){DataStore.mode="off";pintarConn();toast("No se pudieron cargar pedidos","err");return false;});
  },

  load:function(){
    var ses=encodeURIComponent(S.sessions.admin||S.sessions.docs||S.sessions.horarios||"");
    var url=CONFIG.apiUrl+"?action=loadAll&token="+encodeURIComponent(CONFIG.token)+"&session="+ses;
    return fetch(url).then(function(r){return r.json();}).then(function(d){
      if(d.error){ toast("Sesión no válida","err"); return false; }
      aplicarDatosCompletos(d);
      return true;
    }).catch(function(){ toast("No se pudieron cargar los datos","err"); return false; });
  },

  subirAdjuntoMeta:function(fileData){
    return this.call("uploadMetaAttachment",fileData);
  },
  cargarAdjuntoMeta:function(id){
    return this.call("loadMetaAttachment",{id:id});
  },
  guardarColab:function(c){ return this.call("saveColaborador",c).then(function(d){if(d&&d.ok){upsertColaboradorLocal(d.colaborador||c);refrescarDespuesColaborador();}return d;}); },
  borrarColab:function(id){ return this.call("deleteColaborador",{id:id}); },
  guardarSucursales:function(arr){ return this.call("saveSucursales",{sucursales:arr}); },
  guardarConfig:function(c){
    return this.call("saveConfig",configParaGuardar(c)).then(function(d){
      if(d&&!d.error){
        actualizarCachePALLocal();
        guardarCachePublica("pedidos",{sucursales:S.sucursales,pedidosData:S.pedidosData,incidenciaTipos:S.config.incidenciaTipos||[]});
      }
      return d;
    });
  },
  guardarConceptos:function(c){ return this.call("saveConceptos",{conceptos:c}); },
  guardarHorario:function(semana,data){ return this.call("saveHorario",{semana:semanaKey(semana),data:normalizarSemanaData(data)}); },
  borrarHorario:function(semana){ return this.call("deleteHorario",{semana:semana}); },
  guardarNotasDias:function(notas){ return this.call("saveNotasDias",{notas:notas}); },
  guardarRetardos:function(ret){ return this.call("saveRetardos",{retardos:ret}); },
  guardarPAL:function(){ return guardarPALAgrupado(); },
  guardarPedidos:function(){ ensurePedidosData(); return this.callPublico("savePedidos",{pedidosData:pedidosDataParaGuardar()}).then(function(d){if(d&&!d.error)guardarCachePublica("pedidos",{sucursales:S.sucursales,pedidosData:S.pedidosData,incidenciaTipos:S.config.incidenciaTipos||[]});return d;}); },
  guardarPasswords:function(pw){ return this.call("savePasswords",pw); },
  exportarRespaldo:function(session){ return this.call("exportBackup",{session:session}); },
  restaurarRespaldo:function(session,backup){ return this.call("importBackup",{session:session,backup:backup}); },
  guardarNomina:function(n){ return this.call("saveNomina",n); }
};

function confirmarRecargaConfig(msg,repaint){
  // El guardado ya persistió y el estado local (S.config) ya refleja el cambio:
  // repintar de inmediato es suficiente. Evitamos recargar TODO el servidor en
  // cada cambio (era la causa de la lentitud y de que una recarga fallida
  // revirtiera un guardado exitoso).
  if(typeof repaint==="function")repaint();
  if(msg)toast(msg,"ok");
  return Promise.resolve(true);
}
function guardarConfigConfirmado(msg,repaint){
  return DataStore.guardarConfig(S.config).then(function(d){
    if(!d||d.error)return false;
    return confirmarRecargaConfig(msg,repaint);
  }).catch(function(){return false;});
}
function guardarConceptosConfirmado(msg,repaint){
  return DataStore.guardarConceptos(S.conceptos).then(function(d){
    if(!d||d.error)return false;
    return confirmarRecargaConfig(msg,repaint);
  }).catch(function(){return false;});
}
function guardarSucursalesConfirmado(msg,repaint){
  return DataStore.guardarSucursales(S.sucursales).then(function(d){
    if(!d||d.error)return false;
    return confirmarRecargaConfig(msg,repaint);
  }).catch(function(){return false;});
}

var _palSaveTimer=null,_palSaveDeferred=null,_palSaveChain=Promise.resolve();
// Cadena para serializar los saveConfig: evita que guardados rápidos compitan
// y se pisen. Cada eslabón envía S.config COMPLETO al ejecutarse, así el último
// guardado siempre refleja el estado actual y no hace falta revertir con copias viejas.
var _cfgSaveChain=Promise.resolve();
function guardarConfigSerial(){
  _cfgSaveChain=_cfgSaveChain.catch(function(){}).then(function(){
    return DataStore.guardarConfig(S.config);
  });
  return _cfgSaveChain;
}
function guardarPALAgrupado(){
  ensurePALConfig();
  if(!_palSaveDeferred){
    _palSaveDeferred={};
    _palSaveDeferred.promise=new Promise(function(resolve,reject){_palSaveDeferred.resolve=resolve;_palSaveDeferred.reject=reject;});
  }
  clearTimeout(_palSaveTimer);
  _palSaveTimer=setTimeout(function(){
    var def=_palSaveDeferred;
    _palSaveDeferred=null;
    var payload={
      palManual:palManualParaGuardar(S.config.palManual||{}),
      palLog:JSON.parse(JSON.stringify(S.config.palLog||{}))
    };
    _palSaveChain=_palSaveChain.catch(function(){}).then(function(){
      return DataStore.callPublico("savePAL",payload).then(function(d){
        if(d&&!d.error)actualizarCachePALLocal();
        if(def&&def.resolve)def.resolve(d);
        return d;
      },function(e){
        if(def&&def.reject)def.reject(e);
        throw e;
      });
    });
  },260);
  return _palSaveDeferred.promise;
}

function palManualParaGuardar(src){
  var out={};
  Object.keys(src||{}).forEach(function(fecha){
    var dia=src[fecha]||{}, clean={};
    Object.keys(dia).forEach(function(colId){
      var arr=Array.isArray(dia[colId])?dia[colId].filter(Boolean):[];
      if(arr.length)clean[colId]=arr;
    });
    if(Object.keys(clean).length)out[fecha]=clean;
  });
  return out;
}

function semanaKey(k){
  if(!k)return "";
  k=String(k);
  if(/^\d{4}-\d{2}-\d{2}$/.test(k))return k;
  var d=new Date(k);
  return isNaN(d.getTime())?k:fechaISO(d);
}
function normalizarSemanaData(data){
  if(!data)return {};
  if(typeof data==="string"){try{data=JSON.parse(data);}catch(e){return {};}}
  var out={};
  Object.keys(data||{}).forEach(function(colId){
    var byDay=data[colId];
    if(!byDay||typeof byDay!=="object")return;
    Object.keys(byDay).forEach(function(di){
      var n=+di;
      if(isNaN(n)||n<0||n>6)return;
      var arr=byDay[di];
      if(!Array.isArray(arr)){
        if(arr&&typeof arr==="object")arr=Object.keys(arr).map(function(k){return arr[k];});
        else arr=[];
      }
      arr=arr.filter(function(sh){return sh&&typeof sh==="object";}).map(function(sh){
        if(!sh.id)sh.id=uid("sh");
        if(!sh.area)sh.area="OPERACION";
        return sh;
      });
      if(arr.length){
        if(!out[colId])out[colId]={};
        out[colId][String(n)]=arr;
      }
    });
  });
  return out;
}
function contarTurnosSemanaData(data){
  data=normalizarSemanaData(data);
  var n=0;
  Object.keys(data).forEach(function(c){
    Object.keys(data[c]||{}).forEach(function(d){n+=(data[c][d]||[]).length;});
  });
  return n;
}
function normalizarHorariosData(hor,descartarVacias){
  var out={};
  Object.keys(hor||{}).forEach(function(w){
    var k=semanaKey(w), data=normalizarSemanaData(hor[w]);
    if(!k)return;
    if(descartarVacias&&contarTurnosSemanaData(data)===0)return;
    if(!out[k])out[k]={};
    Object.keys(data).forEach(function(c){
      if(!out[k][c])out[k][c]={};
      Object.keys(data[c]).forEach(function(d){
        out[k][c][d]=(out[k][c][d]||[]).concat(data[c][d]||[]);
      });
    });
  });
  return out;
}

function mkShift(tipo,ov){var t=TURNOS[tipo]||{};
  if(t.especial)return Object.assign({id:uid("sh"),tipo:tipo,ini:"",fin:"",area:"OPERACION"},ov||{});
  return Object.assign({id:uid("sh"),tipo:tipo,ini:(ov&&ov.ini)||t.ini,fin:(ov&&ov.fin)||t.fin,area:"OPERACION"},ov||{});}

/* ------------------------------------------------------------
   GRÁFICOS / MARCA
   ------------------------------------------------------------ */
function logoMark(size,navy,red){ // recreación del libro + espiral del logo
  navy=navy||"#0E1B4D"; red=red||"#9E1B14"; size=size||44;
  return '<svg width="'+size+'" height="'+size+'" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">'+
    '<path d="M70 18 L92 24 L92 80 L70 86 Z" fill="'+navy+'"/>'+
    '<path d="M70 18 L92 24 L92 80 L70 86 Z" fill="none" stroke="#fff" stroke-width="2"/>'+
    '<path d="M70 18 L70 86 L46 80 L46 24 Z" fill="'+navy+'"/>'+
    '<path d="M46 50 a22 22 0 1 0 28 -20 a14 14 0 1 1 -16 16 a7 7 0 1 0 8 -8" fill="'+red+'" stroke="#fff" stroke-width="2.5" stroke-linejoin="round"/>'+
    '</svg>';
}
var ICON={
  check:'<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>',
  search:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.3-4.3"/></svg>',
  edit:'<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.1 2.1 0 0 1 3 3L12 15l-4 1 1-4z"/></svg>',
  x:'<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>',
  trash:'<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/></svg>',
  warn:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/><path d="M12 9v4M12 17h.01"/></svg>',
  info:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></svg>',
  users:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
  money:'<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2.5"/><path d="M6 12h.01M18 12h.01"/></svg>',
  back:'<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 14l-4-4 4-4"/><path d="M5 10h11a4 4 0 0 1 0 8h-1"/></svg>',
  userx:'<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M17 8l5 5M22 8l-5 5"/></svg>',
  doc:'<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M9 13h6M9 17h6"/></svg>',
  copy:'<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>',
  print:'<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9V2h12v7M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>',
  lock:'<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
  note:'<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>',
  wa:'<svg viewBox="0 0 24 24" width="17" height="17" fill="currentColor"><path d="M.057 24l1.687-6.163a11.867 11.867 0 0 1-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.82 11.82 0 0 1 8.413 3.488 11.82 11.82 0 0 1 3.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 0 1-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.82 9.82 0 0 0 1.51 5.26l-.999 3.648 3.978-1.207zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/></svg>',
  image:'<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="9" cy="9" r="2"/><path d="M21 15l-5-5L5 21"/></svg>',
  download:'<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="M7 10l5 5 5-5M12 15V3"/></svg>',
  chart:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M3 3v18h18"/><rect x="7" y="11" width="3" height="7"/><rect x="12" y="7" width="3" height="11"/><rect x="17" y="13" width="3" height="5"/></svg>',
  xls:'<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M9 13l6 6M15 13l-6 6"/></svg>'
};

/* ------------------------------------------------------------
   ARRANQUE
   ------------------------------------------------------------ */
function init(root){
  root=root||$("#lienzo-app");
  if(!root){console.warn("No se encontró #lienzo-app");return;}
  S.root=root;
  var markInner = IMG.header
    ? '<img src="'+IMG.header+'" alt="Lienzo Librería" class="mark-img-el">'
    : logoMark(30,"#fff","#9E1B14");
  root.innerHTML='<div class="app">'+
    '<div class="topbar"><div class="brand"><div class="mark'+(IMG.header?' has-img':'')+'">'+markInner+'</div>'+
      '<div><span class="eyebrow">Lienzo Librería</span><h1>Horarios y Nómina</h1></div></div>'+
      '<div class="spacer"></div>'+
      '<div class="suc-pick" id="sucPick"></div>'+
      '<button class="btn btn-sm lock-btn" id="lockBtn" title="Bloquear secciones">'+ICON.lock+' Bloquear</button>'+
      '<div id="conn"></div></div>'+
    '<button class="mobile-tab-btn" id="mobileTabBtn" type="button">PAL</button>'+
    '<nav class="tabs" role="tablist">'+
      '<button data-tab="pedidos">Registros</button>'+
      '<button data-tab="pal">PAL</button>'+
      '<button data-tab="insumos">Insumos</button>'+
      '<button data-tab="horarios">Horarios</button>'+
      '<button data-tab="meta">Indicadores</button>'+
      '<button data-tab="admin">Administración</button>'+
      '<button data-tab="config">Configuración</button>'+
    '</nav>'+
    '<div id="view"></div></div>'+
    '<div class="modal-bg" id="modal"></div>'+
    '<div class="toast-wrap" id="toasts"></div>'+
    '<div class="print-only" id="printarea"></div>';

  var brandTitle=$(".brand h1",root);if(brandTitle)brandTitle.textContent="Horarios";
  $$(".tabs button").forEach(function(b){b.addEventListener("click",function(){go(b.getAttribute("data-tab"));});});
  $("#mobileTabBtn").addEventListener("click",abrirMenuTabs);
  $("#lockBtn").addEventListener("click",bloquearSecciones);
  pintarConn();
  // Carga sólo la lista de sucursales (no sensible) para poder elegir antes de autenticar.
  DataStore.cargarSucursales().then(function(){
    pintarConn(); pintarSucPick(); go("pal");
    setTimeout(function(){ensurePedidosLoaded();},250);
    iniciarSincronizacionViva();
  });
}
var TAB_LABELS={pedidos:"Registros",pal:"PAL",meta:"Indicadores",insumos:"Insumos",horarios:"Horarios",admin:"Administración",config:"Configuración"};
function scopeDe(tab){ return (tab==="pedidos"||tab==="pal"||tab==="meta"||tab==="insumos")?"public":(tab==="horarios"?"horarios":"admin"); }
function actualizarTabMovil(){
  var b=$("#mobileTabBtn");if(b)b.textContent=TAB_LABELS[S.tab]||"Menú";
}
function abrirMenuTabs(){
  var tabs=["pedidos","pal","insumos","horarios","meta","admin","config"];
  var body='<div class="mobile-tab-list">'+tabs.map(function(t){return '<button type="button" class="btn '+(S.tab===t?'btn-primary':'')+'" data-mobile-tab="'+t+'">'+esc(TAB_LABELS[t])+'</button>';}).join("")+'</div>';
  modal("Ir a pestaña","Selecciona una sección del sistema.",body,null,'<button class="btn" id="tabMenuClose">Cerrar</button>');
  $("#tabMenuClose").addEventListener("click",cerrarModal);
  $$("[data-mobile-tab]").forEach(function(b){b.addEventListener("click",function(){var t=b.getAttribute("data-mobile-tab");cerrarModal();go(t);});});
}
function ensureLoaded(){
  if(S.loaded) return Promise.resolve(true);
  return DataStore.load().then(function(ok){ if(ok!==false){S.loaded=true; pintarSucPick();} return ok; });
}
var _palLoadPromise=null,_pedidosLoadPromise=null;
function cacheKeyPublica(tipo){return "lienzo-public-"+tipo+"-v2";}
function leerCachePublica(tipo){
  try{
    var raw=localStorage.getItem(cacheKeyPublica(tipo));if(!raw)return null;
    var box=JSON.parse(raw);
    if(!box||!box.data)return null;
    if(Date.now()-(box.at||0)>1000*60*30)return null;
    return box.data;
  }catch(e){return null;}
}
function guardarCachePublica(tipo,data){
  try{localStorage.setItem(cacheKeyPublica(tipo),JSON.stringify({at:Date.now(),data:data}));}catch(e){}
}
function aplicarPALData(d){
  if(d.colaboradores)aplicarColaboradoresPublicos(d.colaboradores);
  if(d.sucursales&&d.sucursales.length)S.sucursales=d.sucursales;
  if(S.sucursales.length&&!S.sucursales.some(function(x){return x.id===S.sucursalId;}))S.sucursalId=S.sucursales[0].id;
  if(d.config)S.config=Object.assign(S.config,d.config);
  ensureMetaConfig();
  ensurePALConfig();
  if(d.horarios)S.horarios=normalizarHorariosData(d.horarios,true);
}
function aplicarColaboradoresPublicos(cols){
  cols=Array.isArray(cols)?cols:[];
  if(!S.loaded){
    S.colaboradores=cols;
    return;
  }
  var byId={}, orden=[];
  S.colaboradores.forEach(function(c){
    if(!c||!c.id)return;
    byId[c.id]=Object.assign({},c);
    orden.push(c.id);
  });
  cols.forEach(function(c){
    if(!c||!c.id)return;
    if(!byId[c.id])orden.push(c.id);
    byId[c.id]=Object.assign({},byId[c.id]||{},c);
  });
  S.colaboradores=orden.map(function(id){return byId[id];}).filter(Boolean);
}
function aplicarColaboradoresRecibidos(cols){
  cols=Array.isArray(cols)?cols:[];
  if(!S.colaboradores.length){
    S.colaboradores=cols;
    return;
  }
  var byId={}, orden=[];
  S.colaboradores.forEach(function(c){
    if(!c||!c.id)return;
    byId[c.id]=Object.assign({},c);
    orden.push(c.id);
  });
  cols.forEach(function(c){
    if(!c||!c.id)return;
    if(!byId[c.id])orden.push(c.id);
    byId[c.id]=Object.assign({},byId[c.id]||{},c);
  });
  S.colaboradores=orden.map(function(id){return byId[id];}).filter(Boolean);
}
function upsertColaboradorLocal(c){
  if(!c||!c.id)return;
  var idx=-1;
  S.colaboradores.forEach(function(x,i){if(x&&x.id===c.id)idx=i;});
  if(idx>=0)S.colaboradores[idx]=Object.assign({},S.colaboradores[idx]||{},c);
  else S.colaboradores.push(c);
  S.nomDraft=null;
  actualizarCachePALLocal();
}
function refrescarDespuesColaborador(){
  if(S.tab==="admin"&&S.adminSub==="colaboradores"){
    var host=$("#colSubHost");
    if(host){
      if(S.colSub==="documentacion")renderColDocs(host);
      else if($("#colBody"))pintarColab($("#qCol")?$("#qCol").value:"");
      else renderColList(host);
    }
  }
  if($("#schedHost")&&S.tab==="horarios")pintarSemana();
  if(S.tab==="pal"&&$("#view")){var vp=$("#view");vp.innerHTML="";viewPAL(vp);}
  if(S.tab==="admin"&&S.adminSub==="nomina"&&$("#view")){var vn=$("#view");vn.innerHTML="";viewAdministracion(vn);}
}
function aplicarPedidosData(d){
  if(d.sucursales&&d.sucursales.length)S.sucursales=d.sucursales;
  if(d.pedidosData)S.pedidosData=normalizarPedidosData(d.pedidosData);
  if(d.incidenciaTipos)S.config.incidenciaTipos=d.incidenciaTipos;
}
function snapshotPALData(){
  return {colaboradores:S.colaboradores,sucursales:S.sucursales,config:{palTasks:S.config.palTasks||[],palSubareas:S.config.palSubareas||{},palManual:S.config.palManual||{},palLog:S.config.palLog||{},metaConfig:S.config.metaConfig||META_DEFAULT},horarios:S.horarios};
}
function actualizarCachePALLocal(){guardarCachePublica("pal",snapshotPALData());}
function refrescarVistaPublica(tab){
  pintarSucPick();
  if(tab==="pal"&&S.tab==="pal"){var vp=$("#view");vp.innerHTML="";viewPAL(vp);}
  if(tab==="pedidos"&&S.tab==="pedidos"){var vd=$("#view");vd.innerHTML="";viewPedidos(vd);}
  if(tab==="pedidos"&&S.tab==="admin"&&S.adminSub==="reporte"&&(S.repSub==="pedidos"||S.repSub==="incidencias"))go("admin");
}
function ensurePALLoaded(){
  if(S.palLoaded||S.loaded)return Promise.resolve(true);
  var cached=leerCachePublica("pal");
  if(cached){aplicarPALData(cached);S.palLoaded=true;pintarSucPick();}
  if(!_palLoadPromise){
    _palLoadPromise=DataStore.loadPAL().then(function(ok){
      _palLoadPromise=null;
      if(ok!==false){S.palLoaded=true;refrescarVistaPublica("pal");}
      return ok;
    });
  }
  return Promise.resolve(true);
}
function ensurePedidosLoaded(){
  if(S.pedidosLoaded)return Promise.resolve(true);
  var cached=leerCachePublica("pedidos");
  if(cached){aplicarPedidosData(cached);S.pedidosLoaded=true;pintarSucPick();}
  if(!_pedidosLoadPromise){
    _pedidosLoadPromise=DataStore.loadPedidos().then(function(ok){
      _pedidosLoadPromise=null;
      if(ok!==false){S.pedidosLoaded=true;refrescarVistaPublica("pedidos");}
      return ok;
    });
  }
  return Promise.resolve(true);
}
function bloquearSecciones(){
  // Bloquea todas las secciones restringidas (horarios, meta, administración, configuración, documentos).
  S.auth.admin=false; S.sessions.admin="";
  S.auth.horarios=false; S.sessions.horarios="";
  S.auth.docs=false; S.sessions.docs="";
  toast("Secciones bloqueadas","ok");
  go(S.tab);
}
function pintarSucPick(){
  var host=$("#sucPick");if(!host)return;
  if(S.sucursales.length<=1){host.innerHTML="";return;}
  host.innerHTML='<select id="sucSel" title="Sucursal activa">'+
    S.sucursales.map(function(s){return '<option value="'+s.id+'"'+(s.id===S.sucursalId?" selected":"")+'>'+esc(s.nombre)+'</option>';}).join("")+'</select>';
  $("#sucSel").addEventListener("change",function(){
    S.sucursalId=this.value; S.nomDraft=null;
    // cambiar de sucursal re-evalúa el acceso (las contraseñas son por sucursal)
    S.auth.horarios=false; S.auth.admin=false; S.auth.docs=false; S.sessions={horarios:"",admin:"",docs:""};
    go(S.tab);
  });
}
function pintarConn(){
  var c=$("#conn");if(!c)return;
  var map={live:["live","Conectado al servidor"],off:["off","Sin conexión con el servidor"]};
  var m=map[DataStore.mode]||map.off;
  c.className="conn "+m[0];c.innerHTML='<span class="dot"></span>'+m[1];
}
function edicionActiva(){
  if(S.sync&&S.sync.saving)return true;
  var modalAbierto=$("#modal.open");
  if(modalAbierto)return true;
  if(S._drag||S._dragCopy)return true;
  var a=document.activeElement;
  if(!a||a===document.body)return false;
  var tag=(a.tagName||"").toLowerCase();
  return tag==="input"||tag==="textarea"||tag==="select"||a.isContentEditable;
}
function repintarVistaSincronizada(){
  if(!$("#view")||edicionActiva())return;
  if(S.tab==="pedidos"){var vp=$("#view");vp.innerHTML="";viewPedidos(vp);return;}
  if(S.tab==="pal"){var vl=$("#view");vl.innerHTML="";viewPAL(vl);return;}
  if(S.tab==="meta"&&S.auth.horarios){var vm=$("#view");vm.innerHTML="";viewMeta(vm);return;}
  if(S.tab==="horarios"&&S.auth.horarios){var vh=$("#view");vh.innerHTML="";viewHorarios(vh);return;}
  if(S.tab==="admin"&&S.auth.admin){var va=$("#view");va.innerHTML="";viewAdministracion(va);return;}
  if(S.tab==="config"&&S.auth.admin){var vc=$("#view");vc.innerHTML="";viewConfig(vc);}
}
function aplicarDatosCompletos(d){
  if(d.colaboradores) aplicarColaboradoresRecibidos(d.colaboradores);
  if(d.sucursales&&d.sucursales.length){ S.sucursales=d.sucursales; }
  else if(d.sucursal){ var s=Object.assign(S.sucursales[0]||{},d.sucursal); if(!s.id)s.id="suc-centro"; S.sucursales=[s]; }
  if(S.sucursales.length&&!S.sucursales.some(function(x){return x.id===S.sucursalId;}))S.sucursalId=S.sucursales[0].id;
  if(d.config)        S.config=Object.assign(S.config,d.config);
  // Limpia tokens transitorios que pudieron quedar embebidos en config por una versión anterior.
  delete S.config.session; delete S.config.token; delete S.config.action;
  if(!S.config.mostrar) S.config.mostrar={razonSocial:true,rfc:true,rp:true,domicilio:true};
  if(!S.config.finiquito||!S.config.finiquito.length) S.config.finiquito=FINIQUITO_DEFAULT.slice();
  if(!S.config.descanso) S.config.descanso=Object.assign({},DESCANSO_DEFAULT);
  if(!S.config.festivo)  S.config.festivo=Object.assign({},FESTIVO_DEFAULT);
  ensureMetaConfig();
  ensurePALConfig();
  ensureDocsConfig();
  if(d.conceptos&&d.conceptos.length) S.conceptos=d.conceptos;
  if(d.horarios){
    var hor={};
    Object.keys(d.horarios).forEach(function(w){
      var dd=d.horarios[w]||{}, hasShift=false;
      for(var c in dd){ var byDay=dd[c]; if(!byDay||typeof byDay!=="object")continue;
        for(var di in byDay){ var arr=byDay[di]; if(arr&&arr.length){hasShift=true;break;} }
        if(hasShift)break; }
      if(hasShift)hor[w]=dd;
    });
    S.horarios=normalizarHorariosData(hor,true);
  }
  if(d.notasDias)     S.notasDias=d.notasDias;
  if(d.retardos)      S.retardos=d.retardos;
  if(d.nominas)       S.nominas=d.nominas;
}
function cargarDatosCompletosSilencioso(){
  var ses=encodeURIComponent(S.sessions.admin||S.sessions.docs||S.sessions.horarios||"");
  var url=CONFIG.apiUrl+"?action=loadAll&token="+encodeURIComponent(CONFIG.token)+"&session="+ses;
  return fetch(url).then(function(r){return r.json();}).then(function(d){
    if(d.error)return false;
    aplicarDatosCompletos(d);
    S.loaded=true;
    return true;
  });
}
function cargarPALSilencioso(){
  var url=CONFIG.apiUrl+"?action=loadPAL&token="+encodeURIComponent(CONFIG.token);
  return fetch(url).then(function(r){return r.json();}).then(function(d){
    if(d.error)return false;
    aplicarPALData(d);guardarCachePublica("pal",d);S.palLoaded=true;return true;
  });
}
function cargarPedidosSilencioso(){
  var url=CONFIG.apiUrl+"?action=loadPedidos&token="+encodeURIComponent(CONFIG.token);
  return fetch(url).then(function(r){return r.json();}).then(function(d){
    if(d.error)return false;
    aplicarPedidosData(d);guardarCachePublica("pedidos",d);S.pedidosLoaded=true;return true;
  });
}
function solicitarSyncVivo(origen,forzar){
  if(!S.root)return;
  if(document.hidden&&!forzar)return;
  if(edicionActiva()){S.sync.pending=true;return;}
  if(S.sync.busy)return;
  if(!forzar&&Date.now()-(S.sync.last||0)<12000)return;
  S.sync.busy=true;
  var tareas=[];
  if(S.loaded&&(S.auth.admin||S.auth.docs||S.auth.horarios))tareas.push(cargarDatosCompletosSilencioso());
  else{
    if(S.palLoaded||S.tab==="pal"||S.tab==="meta")tareas.push(cargarPALSilencioso());
    if(S.pedidosLoaded||S.tab==="pedidos"||(S.tab==="admin"&&S.adminSub==="reporte"))tareas.push(cargarPedidosSilencioso());
  }
  if(!tareas.length){S.sync.busy=false;return;}
  Promise.all(tareas).then(function(res){
    S.sync.last=Date.now();
    DataStore.mode=res.some(function(x){return x!==false;})?"live":DataStore.mode;
    pintarConn();pintarSucPick();repintarVistaSincronizada();
  }).catch(function(){DataStore.mode="off";pintarConn();}).then(function(){
    S.sync.busy=false;
    if(S.sync.pending&&!edicionActiva()){S.sync.pending=false;solicitarSyncVivo("pendiente",true);}
  });
}
function iniciarSincronizacionViva(){
  if(S.sync.timer)return;
  S.sync.timer=setInterval(function(){solicitarSyncVivo("periodica",false);},45000);
  document.addEventListener("visibilitychange",function(){if(!document.hidden)solicitarSyncVivo("visible",true);});
  window.addEventListener("focus",function(){solicitarSyncVivo("focus",true);});
  window.addEventListener("online",function(){solicitarSyncVivo("online",true);});
  document.addEventListener("input",function(){S.sync.pending=true;},true);
  document.addEventListener("change",function(){S.sync.pending=true;},true);
  document.addEventListener("focusout",function(){setTimeout(function(){if(S.sync.pending&&!edicionActiva()){S.sync.pending=false;solicitarSyncVivo("edicion-finalizada",true);}},250);},true);
}
function go(tab){
  if(tab==="colaboradores"||tab==="nomina"||tab==="recibos"||tab==="reporte"){S.adminSub=tab;tab="admin";}
  if(tab==="insumos"){
    window.location.href="https://www.lienzolibreria.com.mx/pages/requisicion";
    return;
  }
  S.tab=tab;
  $$(".tabs button").forEach(function(b){b.classList.toggle("active",b.getAttribute("data-tab")===tab);});
  actualizarTabMovil();
  var lb=$("#lockBtn"), top=$(".topbar");
  var anyUnlocked=!!(S.auth.admin||S.auth.horarios||S.auth.docs);
  if(lb)lb.style.display=anyUnlocked?"inline-flex":"none";
  if(top)top.classList.toggle("has-lock",anyUnlocked);
  var scope=scopeDe(tab);
  var v=$("#view");v.innerHTML="";v.classList.toggle("config-view",tab==="config"&&!!S.auth[scope]);
  if(tab==="pedidos"){ ensurePedidosLoaded().then(function(){viewPedidos(v);}); return; }
  if(tab==="pal"){ ensurePALLoaded().then(function(){viewPAL(v);}); return; }
  if(tab==="meta"){
    if(!S.auth.horarios){ renderLock(v,"meta","horarios"); return; }
    ensurePALLoaded().then(function(){viewMeta(v);}); return;
  }
  if(!S.auth[scope]){ renderLock(v,tab,scope); return; }
  if(tab==="horarios") viewHorarios(v);
  else if(tab==="admin"){
    if(S.loaded){ viewAdministracion(v); }
    else { ensureLoaded().then(function(){ if(S.tab==="admin"){ var vv=$("#view"); vv.innerHTML=""; viewAdministracion(vv); } }); }
  }
  else if(tab==="config"){
    if(S.loaded){ viewConfig(v); }
    else { ensureLoaded().then(function(){ if(S.tab==="config"){ var vc=$("#view"); vc.innerHTML=""; viewConfig(vc); } }); }
  }
}
function renderLock(v,tab,scope){
  var suc=sucursalActiva();
  var titulo=tab==="meta"?"Indicadores":(scope==="horarios"?"Horarios":"Sección administrativa");
  var hint=scope==="horarios"
    ? "Ingresa la contraseña de Encargado de "+esc(suc.nombre)+"."
    : "Ingresa la contraseña administrativa de "+esc(suc.nombre)+". Esta sección está restringida.";
  var card=el("div",{class:"card lock-card"});
  card.innerHTML='<div class="lock-ico">'+ICON.lock+'</div>'+
    '<h2>Acceso protegido · '+esc(titulo)+'</h2>'+
    '<p class="sub">'+hint+'</p>'+
    '<div class="lock-form">'+
      '<input type="password" id="lockPwd" placeholder="Contraseña" autocomplete="off">'+
      '<button class="btn btn-primary" id="lockGo">'+ICON.lock+' Entrar</button>'+
    '</div>'+
    '<p class="small lock-err" id="lockErr" style="display:none"></p>';
  v.appendChild(card);
  var pwd=$("#lockPwd"), btn=$("#lockGo"), err=$("#lockErr");
  function lockBtnLabel(){ btn.innerHTML=ICON.lock+" Entrar"; }
  function intentar(){
    var val=pwd.value||"";
    if(!val){pwd.focus();return;}
    var reset=btnValidando(btn,"Validando...");
    DataStore.autenticar(scope,val).then(function(r){
      if(r&&r.ok){
        S.auth[scope]=true; S.sessions[scope]=r.session||"sess";
        if(scope==="admin"||scope==="docs")S.loaded=false;
        ensureLoaded().then(function(){ go(tab); });
      }else{
        reset();lockBtnLabel();pwd.value="";
        err.style.display="block";err.textContent="Contraseña incorrecta.";
      }
    }).catch(function(){ reset();lockBtnLabel();
      err.style.display="block";err.textContent="No se pudo verificar. Revisa la conexión.";});
  }
  btn.addEventListener("click",intentar);
  pwd.addEventListener("keydown",function(e){if(e.key==="Enter")intentar();});
  setTimeout(function(){try{pwd.focus();}catch(e){}},50);
}

function viewAdministracion(v){
  S.adminSub=S.adminSub||"colaboradores";
  var tabs=el("div",{class:"subtabs admin-subtabs"},
    '<button data-adminsub="colaboradores" class="'+(S.adminSub==="colaboradores"?"active":"")+'">Colaboradores</button>'+
    '<button data-adminsub="nomina" class="'+(S.adminSub==="nomina"?"active":"")+'">Nómina</button>'+
    '<button data-adminsub="recibos" class="'+(S.adminSub==="recibos"?"active":"")+'">Recibos</button>'+
    '<button data-adminsub="reporte" class="'+(S.adminSub==="reporte"?"active":"")+'">Reporte</button>');
  v.appendChild(tabs);
  $$("#view [data-adminsub]").forEach(function(b){b.addEventListener("click",function(){S.adminSub=b.getAttribute("data-adminsub");go("admin");});});
  if(S.adminSub==="nomina")viewNomina(v);
  else if(S.adminSub==="recibos")viewRecibos(v);
  else if(S.adminSub==="reporte")viewReporte(v);
  else viewColaboradores(v);
}

/* ============================================================
   VISTA · COLABORADORES
   ============================================================ */
function viewColaboradores(v){
  var card=el("div",{class:"card"});
  card.innerHTML='<div class="card-head"><div><h2>Colaboradores</h2>'+
    '<p class="sub">Listado editable. El sueldo puede asignarse por hora, semana o mes.</p></div>'+
    '<button class="btn btn-primary" id="addCol">+ Nuevo colaborador</button></div>'+
    '<div class="search search-lg" style="width:100%;max-width:none;margin-bottom:16px"><span>'+ICON.search+'</span><input id="qCol" placeholder="Buscar por nombre o puesto…"></div>'+
    '<div class="row filtro-row" style="margin-bottom:14px">'+
      '<span class="lbl filtro-lbl">Mostrar</span>'+
      '<span class="chip2" data-f="activos">Activos</span>'+
      '<span class="chip2" data-f="baja">Baja</span>'+
      '<span class="chip2" data-f="todos">Todos</span>'+
    '</div>'+
    '<div class="table-wrap"><table class="data"><thead><tr>'+
    '<th>Nombre</th><th>Puesto</th><th>Sucursal</th><th>Sueldo</th><th>Tipo</th><th>Estado</th><th></th>'+
    '</tr></thead><tbody id="colBody"></tbody></table></div>';
  v.appendChild(card);
  $$("#view [data-f]").forEach(function(c){c.classList.toggle("active",c.getAttribute("data-f")===S.colFiltro);
    c.addEventListener("click",function(){S.colFiltro=c.getAttribute("data-f");
      $$("#view [data-f]").forEach(function(x){x.classList.toggle("active",x===c);});
      pintarColab($("#qCol")?$("#qCol").value:"");});});
  $("#addCol").addEventListener("click",function(){editarColab(null);});
  $("#qCol").addEventListener("input",function(){pintarColab(this.value);});
  pintarColab("");
}
function pintarColab(q){
  q=(q||"").toLowerCase();
  var tb=$("#colBody");tb.innerHTML="";
  var list=S.colaboradores.filter(function(c){
    var est=c.estado||"activo";
    if(S.colFiltro==="activos"&&est==="baja")return false;
    if(S.colFiltro==="baja"&&est!=="baja")return false;
    return !q||(c.nombre+" "+c.puesto).toLowerCase().indexOf(q)>=0;});
  if(!list.length){tb.innerHTML='<tr><td colspan="7"><div class="empty">'+ICON.users+'Sin colaboradores en este filtro.</div></td></tr>';return;}
  list.forEach(function(c){
    var baja=(c.estado||"activo")==="baja";
    var tr=el("tr");if(baja)tr.className="row-baja";
    tr.innerHTML='<td><b>'+esc(c.nombre)+'</b></td><td>'+esc(c.puesto||"—")+'</td><td>'+esc(c.sucursal||"—")+'</td>'+
      '<td class="tabular">'+money(c.sueldo)+'</td><td><span class="pill">'+TIPOS_SUELDO[c.tipoSueldo]+'</span></td>'+
      '<td>'+(baja?'<span class="badge-est baja">Baja</span>':'<span class="badge-est activo">Activo</span>')+'</td>'+
      '<td style="text-align:right;white-space:nowrap"></td>';
    var act=tr.lastChild;
    var be=el("button",{class:"iconbtn",title:"Editar"},ICON.edit);
    be.addEventListener("click",function(){editarColab(c);});
    act.appendChild(be);
    if(baja){
      var br=el("button",{class:"iconbtn ok",title:"Reingresar"},ICON.back);
      br.addEventListener("click",function(){reingresar(c,q);});act.appendChild(br);
    }else{
      var bb=el("button",{class:"iconbtn warn",title:"Dar de baja"},ICON.userx);
      bb.addEventListener("click",function(){darDeBaja(c,q);});act.appendChild(bb);
    }
    var bd=el("button",{class:"iconbtn danger",title:"Eliminar"},ICON.trash);
    bd.addEventListener("click",function(){confirmar("¿Eliminar a "+c.nombre+"?","Se quitará del sistema y de futuros horarios.",function(){
      S.colaboradores=S.colaboradores.filter(function(x){return x.id!==c.id;});
      DataStore.borrarColab(c.id);pintarColab(q);toast("Colaborador eliminado");});});
    act.appendChild(bd);
    tb.appendChild(tr);
  });
}
function darDeBaja(c,q){
  var body=campo("Fecha de baja","baja-fecha",fechaISO(new Date()),"date")+
    campo("Motivo","baja-motivo",c.bajaMotivo||"","text");
  modal("Dar de baja a "+c.nombre,"El colaborador queda inactivo, pero se conserva en el sistema.",body,function(){
    c.estado="baja";c.bajaFecha=$("#f-baja-fecha").value;c.bajaMotivo=$("#f-baja-motivo").value;
    DataStore.guardarColab(c);pintarColab(q);toast("Colaborador dado de baja","ok");
  });
}
function reingresar(c,q){
  var body=campo("Fecha de reingreso","rein-fecha",fechaISO(new Date()),"date")+
    '<label class="lbl" style="margin-top:6px">¿Actualizar fecha de ingreso al reingreso?</label>'+
    '<div class="row"><label class="check"><input type="checkbox" id="rein-upd" checked> Sí, usar el reingreso como nueva fecha de ingreso</label></div>';
  modal("Reingresar a "+c.nombre,"Vuelve a marcar al colaborador como activo. La fecha de reingreso se usa como antigüedad vigente para el aguinaldo.",body,function(){
    c.estado="activo";
    c.reingresoFecha=$("#f-rein-fecha").value;
    if($("#rein-upd").checked)c.ingreso=$("#f-rein-fecha").value;
    DataStore.guardarColab(c);pintarColab(q);toast("Colaborador reingresado","ok");
  });
}
function editarColab(c){
  var nuevo=!c; c=c||{id:uid("col"),tipoSueldo:"mes",sucursal:sucursalActiva().nombre,estado:"activo"};
  var sucOpts=S.sucursales.map(function(s){return '<option value="'+esc(s.nombre)+'"'+(s.nombre===(c.sucursal||sucursalActiva().nombre)?" selected":"")+'>'+esc(s.nombre)+'</option>';}).join("");
  var body='<div class="colab-form"><div class="colab-main-grid">'+
    campo("Nombre completo","nombre",c.nombre,"text")+
    campo("Puesto","puesto",c.puesto,"text")+
    campo("Departamento","depto",c.depto,"text")+
    '<div class="field"><label>Sucursal</label><select id="f-sucursal">'+sucOpts+'</select></div>'+
    campo("RFC","rfc",c.rfc,"text")+
    campo("CURP","curp",c.curp,"text")+
    campo("NSS","nss",c.nss,"text")+
    campo("Fecha de ingreso","ingreso",c.ingreso,"date")+
    '</div>'+
    '<div class="inline" style="margin-top:6px">'+
      '<div class="field"><label>Tipo de sueldo</label><select id="f-tipoSueldo">'+
        opts(TIPOS_SUELDO,c.tipoSueldo)+'</select></div>'+
      campo("Monto del sueldo","sueldo",c.sueldo,"number")+
      campo("Horas objetivo / semana","horasObjetivo",c.horasObjetivo,"number")+
    '</div>'+
    '<div class="field" style="margin-top:6px"><label>Notas del colaborador</label>'+
      '<textarea id="f-notas" rows="2" placeholder="Notas internas (se muestran sobre el colaborador en Horarios; no aparecen en la imagen)">'+esc(c.notas||"")+'</textarea></div>';
  modal(nuevo?"Nuevo colaborador":"Editar colaborador","Datos usados en horarios y nómina.",body,function(){
    ["nombre","puesto","depto","rfc","curp","nss","ingreso","sueldo","horasObjetivo"].forEach(function(k){
      var inp=$("#f-"+k);if(inp)c[k]=inp.type==="number"?(+inp.value||0):inp.value;});
    c.sucursal=$("#f-sucursal").value;
    c.tipoSueldo=$("#f-tipoSueldo").value;
    c.notas=$("#f-notas").value;
    if(!c.estado)c.estado="activo";
    if(!c.nombre){toast("Falta el nombre","err");return false;}
    if(nuevo)S.colaboradores.push(c);
    if($("#colBody"))pintarColab($("#qCol")?$("#qCol").value:"");
    else if($("#colSubHost"))renderColDocs($("#colSubHost"));
    DataStore.guardarColab(c).then(function(d){if(d&&!d.error)toast("Colaborador guardado","ok");});
    cerrarModal();
    return false;
  });
}

/* ============================================================
   VISTA · CONFIGURACIÓN (sucursal, conceptos, tablas)
   ============================================================ */
function viewConfig(v){
  var cf=S.config;
  // --- Sucursales (varias) ---
  var card1=el("div",{class:"card"});
  card1.innerHTML='<div class="card-head"><div><h2>Sucursales</h2>'+
    '<p class="sub">Agrega y administra varias sucursales. Cada una define su horario de operación; el sistema avisa si quedan espacios sin cubrir.</p></div>'+
    '<button class="btn btn-primary" id="addSuc">+ Nueva sucursal</button></div>'+
    '<div id="sucList"></div>';
  v.appendChild(card1);
  $("#addSuc").addEventListener("click",function(){editarSucursal(null);});
  pintarSucList();

  // Empresa
  var card0=el("div",{class:"card"});
  var mo=cf.mostrar||{razonSocial:true,rfc:true,rp:true,domicilio:true};
  function chk(id,on){return '<label class="check chk-incl"><input type="checkbox" id="'+id+'"'+(on?" checked":"")+'> Mostrar en recibo</label>';}
  card0.innerHTML='<h2>Datos de la empresa</h2><p class="sub">Aparecen en el encabezado de los recibos. Puedes elegir cuáles incluir.</p>'+
    '<div class="emp-field">'+campo("Razón social","cf-razon",cf.razonSocial||cf.empresa,"text")+chk("mo-razon",mo.razonSocial!==false)+'</div>'+
    '<div class="emp-field">'+campo("RFC","cf-rfc",cf.rfc,"text")+chk("mo-rfc",mo.rfc!==false)+'</div>'+
    '<div class="emp-field">'+campo("Registro patronal","cf-rp",cf.registroPatronal,"text")+chk("mo-rp",mo.rp!==false)+'</div>'+
    '<div class="emp-field">'+campo("Domicilio","cf-dom",cf.domicilio,"text")+chk("mo-dom",mo.domicilio!==false)+'</div>'+
    '<div class="btn-row" style="margin-top:14px"><button class="btn btn-primary" id="saveEmp">Guardar empresa</button></div>';
  v.appendChild(card0);
  $("#saveEmp").addEventListener("click",function(){
    cf.razonSocial=$("#f-cf-razon").value;cf.empresa=cf.razonSocial;
    cf.rfc=$("#f-cf-rfc").value;cf.registroPatronal=$("#f-cf-rp").value;cf.domicilio=$("#f-cf-dom").value;
    cf.mostrar={razonSocial:$("#mo-razon").checked,rfc:$("#mo-rfc").checked,rp:$("#mo-rp").checked,domicilio:$("#mo-dom").checked};
    guardarConfigConfirmado("Empresa guardada");});

  // Conceptos
  var card2=el("div",{class:"card"});
  card2.innerHTML='<div class="card-head"><div><h2>Conceptos de nómina</h2>'+
    '<p class="sub">Catálogo editable. No todos tienen que aparecer en cada recibo.</p></div>'+
    '<button class="btn btn-sm" id="addConc">+ Agregar concepto</button></div>'+
    '<div class="table-wrap"><table class="data"><thead><tr><th>Concepto</th><th>Tipo</th><th>Grava ISR</th><th></th></tr></thead><tbody id="concBody"></tbody></table></div>';
  v.appendChild(card2);
  $("#addConc").addEventListener("click",function(){
    S.conceptos.push({clave:uid("c").toUpperCase(),nom:"Nuevo concepto",tipo:"percepcion",grav:false});
    guardarConceptosConfirmado("Concepto guardado",pintarConceptos);});
  pintarConceptos();

  // PAL tareas
  ensurePALConfig();
  var cardPAL=el("div",{class:"card"});
  cardPAL.innerHTML='<div class="card-head"><div><h2>Actividades PAL</h2>'+
    '<p class="sub">Configura tareas de limpieza y rol de aseo. Todas se asignan desde Horarios: las diarias aparecen según el turno y el área del colaborador; las semanales en cualquier turno, una vez por semana.</p></div>'+
    '<button class="btn btn-sm" id="addPalTask">+ Agregar tarea</button></div>'+
    '<div id="palSubareasCfg" class="pal-subarea-cfg"></div>'+
    '<div class="table-wrap"><table class="data"><thead><tr><th>Tarea</th><th>Área</th><th>Subárea</th><th>Horario</th><th>Frecuencia</th><th>Estado</th><th></th></tr></thead><tbody id="palTaskBody"></tbody></table></div>';
  v.appendChild(cardPAL);
  $("#addPalTask").addEventListener("click",function(){editarPalTask(null);});
  pintarPalSubareas();
  pintarPalTasks();

  cardMetaConfig(v);
  cardIncidenciasConfig(v);

  // ISR / IMSS
  var card3=el("div",{class:"card"});
  card3.innerHTML='<h2>Impuestos y cuotas (editable)</h2>'+
    '<p class="sub">Cálculo simplificado. Verifica la tabla ISR y la cuota IMSS con la normativa vigente; los montos del recibo siempre se pueden ajustar a mano.</p>'+
    '<div class="inline">'+campo("IMSS obrero (% sobre gravado)","cf-imss",cf.imssPct,"number")+
    campo("Salario mínimo diario","cf-sm",cf.salarioMin,"number")+'</div>'+
    '<label class="lbl" style="margin-top:14px">Tabla ISR mensual · LISR Art. 96 (límites, cuota y % editables)</label>'+
    '<div class="table-wrap"><table class="data" id="isrTable"><thead><tr><th>Límite inferior</th><th>Límite superior</th><th>Cuota fija</th><th>% excedente</th><th></th></tr></thead><tbody id="isrBody"></tbody></table></div>'+
    '<div class="btn-row" style="margin-top:8px"><button class="btn btn-sm" id="addIsr">+ Agregar rango</button></div>'+
    '<div class="btn-row" style="margin-top:14px"><button class="btn btn-primary" id="saveTax">Guardar impuestos</button></div>'+
    '<div class="note"><span>'+ICON.info+'</span><div><b>Nota</b>Cálculo simplificado para control interno. Verifica la tabla ISR y la cuota IMSS con la normativa vigente del año en curso.</div></div>';
  v.appendChild(card3);
  pintarISR();
  var addIsr=$("#addIsr");if(addIsr)addIsr.addEventListener("click",function(){
    var last=S.config.isr[S.config.isr.length-1];if(last&&last.ls===Infinity)last.ls=last.li;
    S.config.isr.push({li:0,ls:Infinity,cuota:0,pct:0});guardarConfigConfirmado("Rango agregado",pintarISR);});
  $("#saveTax").addEventListener("click",function(){
    cf.imssPct=+$("#f-cf-imss").value||0;cf.salarioMin=+$("#f-cf-sm").value||0;
    guardarConfigConfirmado("Impuestos guardados",pintarISR);});

  // Finiquito (conceptos y valores editables)
  if(!cf.finiquito||!cf.finiquito.length)cf.finiquito=FINIQUITO_DEFAULT.slice();
  var card4=el("div",{class:"card"});
  card4.innerHTML='<h2>Finiquito (editable)</h2>'+
    '<p class="sub">Conceptos y valores base para el cálculo de finiquito. La columna “Incluir” marca los que vienen activados por defecto al calcular.</p>'+
    '<div class="table-wrap"><table class="data"><thead><tr><th>Concepto</th><th>Cálculo</th><th>Valor</th><th>Incluir</th><th></th></tr></thead><tbody id="fqBody"></tbody></table></div>'+
    '<div class="btn-row" style="margin-top:8px"><button class="btn btn-sm" id="addFq">+ Agregar concepto</button></div>'+
    '<div class="btn-row" style="margin-top:14px"><button class="btn btn-primary" id="saveFq">Guardar finiquito</button></div>'+
    '<div class="note"><span>'+ICON.info+'</span><div><b>Cálculo</b>aguinaldo&nbsp;prop. = diario × valor × (días del año / 365) · días = diario × valor · % vac = (vacaciones) × valor% · días fijo = diario × valor · días/año = diario × valor × años.</div></div>';
  v.appendChild(card4);
  pintarFiniquitoCfg();
  $("#addFq").addEventListener("click",function(){
    cf.finiquito.push({clave:uid("FQ").toUpperCase(),nom:"Nuevo concepto",tipo:"dias",valor:0,on:false});
    guardarConfigConfirmado("Concepto agregado",pintarFiniquitoCfg);});
  $("#saveFq").addEventListener("click",function(){guardarConfigConfirmado("Finiquito guardado",pintarFiniquitoCfg);});

  // Descansos (regla POR COLABORADOR + visibilidad desde Recibos)
  if(!cf.descanso)cf.descanso=Object.assign({},DESCANSO_DEFAULT);
  var dz=cf.descanso;
  var card5=el("div",{class:"card"});
  card5.innerHTML='<h2>Descansos</h2>'+
    '<p class="sub">La regla de cálculo se asigna por colaborador. El concepto se asigna en Horarios (tipo “Descanso”) y su visibilidad en cada recibo se controla desde la sección Recibos (como impuestos).</p>'+
    '<label class="check chk-incl"><input type="checkbox" id="dz-incluir"'+(dz.incluir?" checked":"")+'> Mostrar el concepto “Descansos” en los recibos por defecto</label>'+
    '<div class="note"><span>'+ICON.info+'</span><div><b>Promedio de horas</b>(horas asignadas en el horario − ajuste de retardos) ÷ días con horario asignado × sueldo por hora × descansos. <b>Monto fijo</b>: importe por descanso.</div></div>'+
    '<div class="table-wrap" style="margin-top:10px"><table class="data"><thead><tr><th>Colaborador</th><th>Regla de cálculo</th><th>Monto fijo (por día)</th></tr></thead><tbody id="dzBody"></tbody></table></div>'+
    '<div class="btn-row" style="margin-top:14px"><button class="btn btn-primary" id="saveDz">Guardar configuración de descansos</button></div>';
  v.appendChild(card5);
  pintarDescansoColabs();
  $("#dz-incluir").addEventListener("change",function(){dz.incluir=this.checked;});
  $("#saveDz").addEventListener("click",function(){
    S.colaboradores.forEach(function(c){if(c._dzDirty){delete c._dzDirty;DataStore.guardarColab(c);}});
    S.nomDraft=null;
    guardarConfigConfirmado("Configuración de descansos guardada",pintarDescansoColabs);
  });

  // Días festivos (pago extra automático, porcentaje configurable)
  if(!cf.festivo)cf.festivo=Object.assign({},FESTIVO_DEFAULT);
  var fz=cf.festivo;
  var cardF=el("div",{class:"card"});
  cardF.innerHTML='<h2>Días festivos</h2>'+
    '<p class="sub">Cuando un colaborador trabaja un día festivo, el sistema agrega automáticamente un pago extra por ese concepto. El sueldo ya cubre el día normal (1×), así que este concepto es solo la parte adicional. Su visibilidad en cada recibo se controla desde la sección Recibos (como impuestos).</p>'+
    '<div class="field" style="max-width:280px"><label>Porcentaje del pago extra (sobre el salario diario)</label>'+
      '<input type="number" step="1" min="0" id="fz-pct" value="'+(fz.pct!=null?fz.pct:100)+'"></div>'+
    '<label class="check chk-incl"><input type="checkbox" id="fz-incluir"'+(fz.incluir!==false?" checked":"")+'> Incluir el pago de día festivo en los recibos por defecto</label>'+
    '<label class="check chk-incl"><input type="checkbox" id="fz-civicos"'+(fz.civicos?" checked":"")+'> Contar también días cívicos (no solo los obligatorios de ley)</label>'+
    '<div class="note"><span>'+ICON.info+'</span><div><b>Cómo se calcula</b>salario diario × porcentaje × nº de festivos trabajados en el periodo. Con <b>100%</b> el día festivo queda pagado al doble (sueldo + extra); con <b>200%</b> al triple (LFT Art. 75). Solo cuentan los festivos obligatorios salvo que actives los cívicos.</div></div>'+
    '<div class="btn-row" style="margin-top:14px"><button class="btn btn-primary" id="saveFz">Guardar días festivos</button></div>';
  v.appendChild(cardF);
  $("#saveFz").addEventListener("click",function(){
    fz.pct=+$("#fz-pct").value||0;
    fz.incluir=$("#fz-incluir").checked;
    fz.civicos=$("#fz-civicos").checked;
    S.nomDraft=null;
    guardarConfigConfirmado("Días festivos guardado");
  });

  // Gestión de contraseñas (excepto la maestra)
  var card6=el("div",{class:"card access-passwords-card"});
  var sucs=S.sucursales;
  function pwRows(scope){
    return sucs.map(function(s){
      return '<div class="emp-field"><div class="field" style="flex:1"><label>'+esc(s.nombre)+'</label>'+
        '<input type="password" autocomplete="new-password" data-pw="'+scope+'" data-suc="'+s.id+'" placeholder="(sin cambios)"></div></div>';
    }).join("");
  }
  card6.innerHTML='<h2>Contraseñas de acceso</h2>'+
    '<p class="sub">Cambia las contraseñas por sucursal. Déjalas vacías para conservar la actual.</p>'+ 
    '<label class="lbl">Acceso a Horarios</label>'+pwRows("horarios")+
    '<label class="lbl" style="margin-top:8px">Acceso a secciones administrativas</label>'+pwRows("admin")+
    '<label class="lbl" style="margin-top:8px">Acceso a Documentacion</label>'+pwRows("docs")+
    '<div class="note"><span>'+ICON.lock+'</span><div><b>Seguridad</b>Ajusta las contraseñas solo de ser necesario. Solicita aprovacion y soporte técnico antes de cualquier cambio.</div></div>'+ 
    '<div class="btn-row" style="margin-top:14px"><button class="btn btn-primary" id="savePw">Guardar contraseñas</button></div>';
  v.appendChild(card6);
  $("#savePw").addEventListener("click",function(){
    var payload={horarios:{},admin:{},docs:{}},n=0;
    $$('#view input[data-pw]').forEach(function(inp){
      var val=(inp.value||"").trim();
      if(val){payload[inp.getAttribute("data-pw")][inp.getAttribute("data-suc")]=val;n++;}
    });
    if(!n){toast("Escribe al menos una contraseña nueva","err");return;}
    DataStore.guardarPasswords(payload).then(function(d){
      if(d&&d.ok){toast("Contraseñas actualizadas ("+(d.actualizadas||n)+")","ok");
        $$('#view input[data-pw]').forEach(function(i){i.value="";});}
      else toast("No se pudieron guardar","err");
    }).catch(function(){toast("Sin conexión con el servidor","err");});
  });

  var cardBackup=el("div",{class:"card backup-card"});
  cardBackup.innerHTML='<div class="card-head"><div><h2>Respaldo de la base de datos</h2><p class="sub">Descarga toda la información del sistema en un archivo de respaldo o restaura un respaldo anterior.</p></div></div><div class="note"><span>'+ICON.lock+'</span><div><b>Acceso maestro</b>Ambas operaciones solicitan contraseña. Al restaurar se reemplazara la base actual y el servidor guarda primero una copia privada.</div></div><div class="backup-actions"><button class="btn btn-primary" id="backupDownload">'+ICON.download+' Descargar respaldo</button><button class="btn" id="backupRestore">'+ICON.doc+' Restaurar respaldo</button></div>';
  v.appendChild(cardBackup);
  $("#backupDownload").addEventListener("click",abrirExportarRespaldo);
  $("#backupRestore").addEventListener("click",abrirRestaurarRespaldo);
}

function descargarJSON(nombre,obj){var blob=new Blob([JSON.stringify(obj,null,2)],{type:"application/json;charset=utf-8"}),url=URL.createObjectURL(blob),a=document.createElement("a");a.href=url;a.download=nombre;document.body.appendChild(a);a.click();a.remove();setTimeout(function(){URL.revokeObjectURL(url);},500);}
function nombreArchivoRespaldo(){var d=new Date(),p=function(n){return String(n).padStart(2,"0");};return "respaldo-lienzo-"+d.getFullYear()+p(d.getMonth()+1)+p(d.getDate())+"-"+p(d.getHours())+p(d.getMinutes())+p(d.getSeconds())+".json";}
function abrirExportarRespaldo(){
  modal("Descargar respaldo","La contraseña se valida únicamente en el servidor.",'<div class="field"><label>Contraseña maestra</label><input id="backupMasterPwd" type="password" autocomplete="current-password"></div>',function(){
    var pwd=valReq("#backupMasterPwd","Contraseña maestra");if(pwd==null)return false;var reset=btnValidando($("#mSave"),"Generando...");
    DataStore.autenticar("master",pwd).then(function(a){if(!a||!a.ok){toast("Contraseña maestra incorrecta","err");reset();return;}return DataStore.exportarRespaldo(a.session).then(function(r){if(!r||!r.ok||!r.backup){toast("No se pudo generar el respaldo","err");reset();return;}descargarJSON(nombreArchivoRespaldo(),r.backup);cerrarModal();toast("Respaldo descargado","ok");});}).catch(function(){toast("No se pudo generar el respaldo","err");reset();});
    return false;
  });
}
function leerArchivoTexto(file){return new Promise(function(resolve,reject){var reader=new FileReader();reader.onload=function(){resolve(String(reader.result||""));};reader.onerror=function(){reject(reader.error||new Error("No se pudo leer el archivo"));};reader.readAsText(file,"UTF-8");});}
function abrirRestaurarRespaldo(){
  var body='<div class="field"><label>Archivo de respaldo</label><input id="backupFile" type="file" accept=".json,application/json"></div><div class="field"><label>Contraseña maestra</label><input id="backupRestorePwd" type="password" autocomplete="current-password"></div><label class="check backup-confirm"><input id="backupConfirm" type="checkbox"> Entiendo que la información actual será reemplazada por el contenido del archivo.</label><div class="note warn"><span>'+ICON.info+'</span><div><b>Importante</b>El archivo se valida antes de realizar cambios. No cierres esta ventana mientras se completa la restauración.</div></div>';
  modal("Restaurar base de datos","Utiliza únicamente respaldos generados por este sistema.",body,function(){
    var input=$("#backupFile"),file=input&&input.files&&input.files[0],pwd=valReq("#backupRestorePwd","Contraseña maestra");if(!file){toast("Selecciona el archivo de respaldo","err");return false;}if(pwd==null)return false;if(!$("#backupConfirm").checked){toast("Confirma que deseas reemplazar la información","err");return false;}if(file.size>45*1024*1024){toast("El archivo excede 45 MB","err");return false;}
    var reset=btnValidando($("#mSave"),"Restaurando...");
    leerArchivoTexto(file).then(function(txt){var backup;try{backup=JSON.parse(txt);}catch(e){throw new Error("El archivo JSON no es válido");}if(!backup||backup.format!=="lienzo-horarios-backup")throw new Error("El archivo no es un respaldo válido");return DataStore.autenticar("master",pwd).then(function(a){if(!a||!a.ok)throw new Error("Contraseña maestra incorrecta");return DataStore.restaurarRespaldo(a.session,backup);});}).then(function(r){if(!r||!r.ok)throw new Error((r&&r.error)||"No se pudo restaurar");try{localStorage.removeItem(cacheKeyPublica("pal"));localStorage.removeItem(cacheKeyPublica("pedidos"));}catch(e){}cerrarModal();toast("Base de datos restaurada. Recargando...","ok");setTimeout(function(){window.location.reload();},1200);}).catch(function(e){toast(e&&e.message?e.message:"No se pudo restaurar el respaldo","err");reset();});
    return false;
  });
}

function incidenciaTipos(){
  if(!Array.isArray(S.config.incidenciaTipos)||!S.config.incidenciaTipos.length){
    S.config.incidenciaTipos=[
      {id:"merma",nombre:"Merma",activo:true},
      {id:"dano",nombre:"Daño",activo:true},
      {id:"faltante",nombre:"Faltante",activo:true},
      {id:"operativa",nombre:"Incidencia operativa",activo:true}
    ];
  }
  return S.config.incidenciaTipos;
}
function cardIncidenciasConfig(v){
  var card=el("div",{class:"card"});
  card.innerHTML='<div class="card-head"><div><h2>Clasificación de incidencias</h2><p class="sub">Administra los tipos disponibles al registrar incidencias o mermas de la sucursal.</p></div><button class="btn btn-sm" id="incTipoAdd">+ Agregar clasificación</button></div><div class="table-wrap"><table class="data"><thead><tr><th>Clasificación</th><th>Estado</th><th></th></tr></thead><tbody id="incTipoRows"></tbody></table></div><div class="btn-row" style="margin-top:14px"><button class="btn btn-primary" id="incTipoSave">Guardar clasificaciones</button></div>';
  v.appendChild(card);pintarIncidenciaTipos();
  $("#incTipoAdd").addEventListener("click",function(){incidenciaTipos().push({id:uid("inc-tipo"),nombre:"Nueva clasificación",activo:true});pintarIncidenciaTipos();});
  $("#incTipoSave").addEventListener("click",function(){
    $$("#incTipoRows tr").forEach(function(tr){var i=+tr.getAttribute("data-i"),t=incidenciaTipos()[i];if(!t)return;t.nombre=tr.querySelector("input[type=text]").value.trim()||"Clasificación";t.activo=tr.querySelector("input[type=checkbox]").checked;});
    guardarConfigConfirmado("Clasificaciones guardadas",pintarIncidenciaTipos);
  });
}
function pintarIncidenciaTipos(){
  var tb=$("#incTipoRows");if(!tb)return;var arr=incidenciaTipos();
  tb.innerHTML=arr.map(function(t,i){return '<tr data-i="'+i+'"><td><input type="text" value="'+esc(t.nombre||"")+'"></td><td><label class="check"><input type="checkbox" '+(t.activo!==false?"checked":"")+'> Activa</label></td><td style="text-align:right"><button class="iconbtn danger" data-inc-tipo-del="'+i+'" title="Eliminar">'+ICON.trash+'</button></td></tr>';}).join("");
  $$('[data-inc-tipo-del]').forEach(function(b){b.addEventListener("click",function(){var i=+b.getAttribute("data-inc-tipo-del"),id=arr[i]&&arr[i].id,used=(S.pedidosData.incidencias||[]).some(function(x){return x.tipo===id;});if(used){toast("La clasificación ya tiene incidencias; desactívala en lugar de eliminarla","err");return;}arr.splice(i,1);pintarIncidenciaTipos();});});
}

function pintarPalTasks(){
  var tb=$("#palTaskBody");if(!tb)return;ensurePALConfig();tb.innerHTML="";
  var arr=palTasks();
  if(!arr.length){tb.innerHTML='<tr><td colspan="7"><div class="empty">'+ICON.check+'Aun no hay actividades PAL configuradas.</div></td></tr>';return;}
  arr.forEach(function(t,i){
    var tr=el("tr");
    tr.innerHTML='<td><b>'+esc(t.nombre||"")+'</b></td><td>'+esc(palAreaNom(t.area))+'</td><td>'+esc(palSubareaNom(t.subarea))+'</td><td>'+esc(PAL_TURNOS[palTurnoKey(t.turno)]||t.turno||"")+'</td>'+
      '<td><span class="pill">'+esc((t.tipo||"diaria")==="semanal"?"Semanal":"Diaria")+'</span></td>'+
      '<td><span class="badge-est '+(t.activo===false?"baja":"activo")+'">'+(t.activo===false?"Inactiva":"Activa")+'</span></td>'+
      '<td style="text-align:right"><button class="iconbtn" data-pal-edit="'+i+'">'+ICON.edit+'</button><button class="iconbtn danger" data-pal-del="'+i+'">'+ICON.trash+'</button></td>';
    tb.appendChild(tr);
  });
  $$("[data-pal-edit]").forEach(function(b){b.addEventListener("click",function(){editarPalTask(+b.getAttribute("data-pal-edit"));});});
  $$("[data-pal-del]").forEach(function(b){b.addEventListener("click",function(){
    var i=+b.getAttribute("data-pal-del");
    confirmar("Eliminar actividad","La configuracion se quitara. Los historiales ya registrados se conservan por clave.",function(){
      var bak=S.config.palTasks.slice();
      S.config.palTasks.splice(i,1);
      guardarConfigConfirmado("Actividad eliminada",pintarPalTasks).then(function(ok){
        if(ok){}
        else {S.config.palTasks=bak;pintarPalTasks();}
      }).catch(function(){S.config.palTasks=bak;pintarPalTasks();});
    });
  });});
}
function pintarPalSubareas(){
  var host=$("#palSubareasCfg");if(!host)return;ensurePALConfig();
  var areas=["OPERACION","ADMINISTRACION"], cfg=palSubareasConfig();
  host.innerHTML='<div class="pal-subarea-head"><b>Subáreas PAL</b><span>Agrega subáreas dentro de cada área general. Se usan en el horario y en la asignación de actividades.</span></div>'+
    '<div class="pal-subarea-grid">'+areas.map(function(a){
      var items=(cfg[a]||[]).map(function(s,i){return '<span class="pal-subarea-chip">'+esc(s)+' <button type="button" data-pal-sub-del="'+a+'" data-i="'+i+'">×</button></span>';}).join("");
      return '<div class="pal-subarea-box"><h3>'+esc(PAL_AREAS[a])+'</h3><div class="pal-subarea-list">'+items+'</div>'+
        '<div class="pal-subarea-add"><input placeholder="Nueva subárea" data-pal-sub-new="'+a+'"><button type="button" class="btn btn-sm" data-pal-sub-add="'+a+'">Agregar</button></div></div>';
    }).join("")+'</div>';
  $$("[data-pal-sub-add]").forEach(function(b){b.addEventListener("click",function(){
    var a=b.getAttribute("data-pal-sub-add"), inp=$('[data-pal-sub-new="'+a+'"]'), val=(inp.value||"").trim();
    if(!val)return;
    cfg[a]=cfg[a]||[];
    if(cfg[a].indexOf(val)>=0){inp.value="";return;}
    cfg[a].push(val); inp.value="";
    pintarPalSubareas();
    guardarConfigSerial().then(function(d){
      toast((d&&!d.error)?"Subárea guardada":"No se pudo guardar; reintenta",(d&&!d.error)?"ok":"err");
    }).catch(function(){toast("Sin conexión con el servidor","err");});
  });});
  $$("[data-pal-sub-del]").forEach(function(b){b.addEventListener("click",function(){
    var a=b.getAttribute("data-pal-sub-del"), i=+b.getAttribute("data-i");
    if(!Array.isArray(cfg[a]))return;
    cfg[a].splice(i,1);
    pintarPalSubareas();
    guardarConfigSerial().then(function(d){
      toast((d&&!d.error)?"Subárea eliminada":"No se pudo guardar; reintenta",(d&&!d.error)?"ok":"err");
    }).catch(function(){toast("Sin conexión con el servidor","err");});
  });});
}
function editarPalTask(i){
  ensurePALConfig();
  var t=i!=null?Object.assign({},S.config.palTasks[i]):{id:uid("pal").toUpperCase(),nombre:"",turno:"mat",tipo:"diaria",area:"OPERACION",subarea:"",activo:true};
  var body=campo("Nombre de la tarea","pal-nombre",t.nombre,"text")+
    '<div class="grid-2"><div class="field"><label>Área</label><select id="pal-area">'+
      Object.keys(PAL_AREAS).map(function(k){return '<option value="'+k+'"'+(k===palAreaKey(t.area)?" selected":"")+'>'+PAL_AREAS[k]+'</option>';}).join("")+'</select></div>'+
    '<div class="field"><label>Subárea</label><select id="pal-subarea"></select></div>'+
    '<div class="field"><label>Horario</label><select id="pal-turno">'+
      Object.keys(PAL_TURNOS).map(function(k){return '<option value="'+k+'"'+(k===palTurnoKey(t.turno)?" selected":"")+'>'+PAL_TURNOS[k]+'</option>';}).join("")+'</select></div>'+
    '<div class="field"><label>Frecuencia</label><select id="pal-tipo"><option value="diaria"'+((t.tipo||"diaria")==="diaria"?" selected":"")+'>Diaria automatica</option><option value="semanal"'+(t.tipo==="semanal"?" selected":"")+'>Semanal manual</option></select></div></div>'+
    '<label class="check chk-incl"><input type="checkbox" id="pal-activo"'+(t.activo!==false?" checked":"")+'> Actividad activa</label>';
  modal(i!=null?"Editar actividad PAL":"Nueva actividad PAL","Las diarias se ofrecen según el turno; las semanales en cualquier turno (una vez por semana). Todo se asigna desde la celda del horario.",body,function(){
    t.nombre=$("#f-pal-nombre").value.trim();t.area=$("#pal-area").value;t.subarea=$("#pal-subarea").value;t.turno=$("#pal-turno").value;t.tipo=$("#pal-tipo").value;t.activo=$("#pal-activo").checked;
    if(!t.nombre){toast("Falta el nombre de la tarea","err");return false;}
    var bak=S.config.palTasks.slice(), btn=$("#mSave"), reset=btn?btnValidando(btn,"Guardando..."):function(){};
    if(i!=null)S.config.palTasks[i]=t;else S.config.palTasks.push(t);
    guardarConfigConfirmado("Actividad guardada",pintarPalTasks).then(function(ok){
      reset();
      if(ok)cerrarModal();
      else {S.config.palTasks=bak;pintarPalTasks();}
    }).catch(function(){reset();S.config.palTasks=bak;pintarPalTasks();});
    return false;
  });
  function fillTaskSubareas(){
    var a=$("#pal-area").value, sel=$("#pal-subarea"), cur=palSubareaKey(t.subarea);
    var opts=['<option value="">General</option>'];
    if(a!=="TODAS")palSubareas(a).forEach(function(s){opts.push('<option value="'+esc(s)+'"'+(s===cur?' selected':'')+'>'+esc(s)+'</option>');});
    sel.innerHTML=opts.join("");
    if(a==="TODAS"){sel.value="";sel.disabled=true;}else sel.disabled=false;
  }
  $("#pal-area").addEventListener("change",function(){t.subarea="";fillTaskSubareas();});
  fillTaskSubareas();
}

function pintarDescansoColabs(){
  var tb=$("#dzBody");if(!tb)return;tb.innerHTML="";
  var lista=colsBranchTodos();
  if(!lista.length){tb.innerHTML='<tr><td colspan="3"><div class="empty">Sin colaboradores en esta sucursal.</div></td></tr>';return;}
  lista.forEach(function(c){
    var rg=reglaDescanso(c);
    var tr=el("tr");
    tr.innerHTML='<td><b>'+esc(c.nombre)+'</b></td>'+
      '<td><select data-col="'+c.id+'" data-k="descansoRegla" style="padding:6px 9px">'+
        '<option value="promedio_horas"'+(rg.regla==="promedio_horas"?" selected":"")+'>Promedio de horas (− retardos)</option>'+
        '<option value="monto_fijo"'+(rg.regla==="monto_fijo"?" selected":"")+'>Monto fijo por día</option>'+
      '</select></td>'+
      '<td><input type="number" step="0.01" data-col="'+c.id+'" data-k="descansoMonto" value="'+(c.descansoMonto!=null?c.descansoMonto:(rg.monto||0))+'" style="padding:6px 9px;max-width:120px"></td>';
    tb.appendChild(tr);
  });
  $$("#dzBody select,#dzBody input").forEach(function(inp){
    inp.addEventListener("change",function(){
      var c=S.colaboradores.filter(function(x){return x.id===inp.getAttribute("data-col");})[0];if(!c)return;
      var k=inp.getAttribute("data-k");
      c[k]=inp.type==="number"?(+inp.value||0):inp.value;c._dzDirty=true;S.nomDraft=null;
    });
  });
}
var FQ_TIPOS={aguinaldo_prop:"Aguinaldo prop.", dias:"Días", pct_vac:"% vacaciones", dias_fijo:"Días fijo", dias_year:"Días por año"};
function pintarFiniquitoCfg(){
  var tb=$("#fqBody");if(!tb)return;tb.innerHTML="";
  var arr=S.config.finiquito;
  arr.forEach(function(it,i){
    var tr=el("tr");
    tr.innerHTML='<td><input value="'+esc(it.nom)+'" data-i="'+i+'" data-k="nom" style="padding:6px 9px"></td>'+
      '<td><select data-i="'+i+'" data-k="tipo" style="padding:6px 9px">'+opts(FQ_TIPOS,it.tipo)+'</select></td>'+
      '<td><input type="number" step="0.01" value="'+(it.valor||0)+'" data-i="'+i+'" data-k="valor" style="padding:6px 9px;max-width:90px"></td>'+
      '<td style="text-align:center"><input type="checkbox" '+(it.on?"checked":"")+' data-i="'+i+'" data-k="on"></td>'+
      '<td style="text-align:right"></td>';
    var bd=el("button",{class:"iconbtn danger"},ICON.trash);
    bd.addEventListener("click",function(){arr.splice(i,1);guardarConfigConfirmado("Concepto eliminado",pintarFiniquitoCfg);});
    tr.lastChild.appendChild(bd);tb.appendChild(tr);
  });
  $$("#fqBody input,#fqBody select").forEach(function(inp){
    inp.addEventListener("change",function(){var i=+inp.getAttribute("data-i"),k=inp.getAttribute("data-k");
      var val=inp.type==="checkbox"?inp.checked:(inp.type==="number"?(+inp.value||0):inp.value);
      S.config.finiquito[i][k]=val;guardarConfigConfirmado("",pintarFiniquitoCfg);});
  });
}
function pintarConceptos(){
  var tb=$("#concBody");if(!tb)return;tb.innerHTML="";
  S.conceptos.forEach(function(c,i){
    var tr=el("tr");
    tr.innerHTML='<td><input value="'+esc(c.nom)+'" data-i="'+i+'" data-k="nom" style="padding:6px 9px"></td>'+
      '<td><select data-i="'+i+'" data-k="tipo" style="padding:6px 9px">'+opts({percepcion:"Percepción",deduccion:"Deducción",otro:"Otro pago"},c.tipo)+'</select></td>'+
      '<td><input type="checkbox" '+(c.grav?"checked":"")+' data-i="'+i+'" data-k="grav"></td>'+
      '<td style="text-align:right"></td>';
    var bd=el("button",{class:"iconbtn danger"},ICON.trash);
    bd.addEventListener("click",function(){S.conceptos.splice(i,1);guardarConceptosConfirmado("Concepto eliminado",pintarConceptos);});
    tr.lastChild.appendChild(bd);tb.appendChild(tr);
  });
  $$("#concBody input,#concBody select").forEach(function(inp){
    inp.addEventListener("change",function(){var i=+inp.getAttribute("data-i"),k=inp.getAttribute("data-k");
      S.conceptos[i][k]=inp.type==="checkbox"?inp.checked:inp.value;guardarConceptosConfirmado("",pintarConceptos);});});
}
function pintarISR(){
  var tb=$("#isrBody");if(!tb)return;tb.innerHTML="";
  S.config.isr.forEach(function(r,i){
    var tr=el("tr");
    var lsVal=(r.ls===Infinity||r.ls===null||r.ls==="")?"":r.ls;
    tr.innerHTML='<td><input type="number" step="0.01" value="'+r.li+'" data-i="'+i+'" data-k="li" style="padding:6px 9px"></td>'+
      '<td><input type="number" step="0.01" value="'+lsVal+'" placeholder="En adelante" data-i="'+i+'" data-k="ls" style="padding:6px 9px"></td>'+
      '<td><input type="number" step="0.01" value="'+r.cuota+'" data-i="'+i+'" data-k="cuota" style="padding:6px 9px"></td>'+
      '<td><input type="number" step="0.01" value="'+r.pct+'" data-i="'+i+'" data-k="pct" style="padding:6px 9px"></td>'+
      '<td style="text-align:right"></td>';
    var bd=el("button",{class:"iconbtn danger",title:"Eliminar fila"},ICON.trash);
    bd.addEventListener("click",function(){S.config.isr.splice(i,1);guardarConfigConfirmado("Rango eliminado",pintarISR);});
    tr.lastChild.appendChild(bd);
    tb.appendChild(tr);
  });
  $$("#isrBody input").forEach(function(inp){inp.addEventListener("change",function(){
    var i=+inp.getAttribute("data-i"),k=inp.getAttribute("data-k");
    if(k==="ls"&&inp.value==="")S.config.isr[i].ls=Infinity;
    else S.config.isr[i][k]=+inp.value||0;
    guardarConfigConfirmado("",pintarISR);});});
}

/* ---- Sucursales (varias) ---- */
function pintarSucList(){
  var host=$("#sucList");if(!host)return;host.innerHTML="";
  S.sucursales.forEach(function(s){
    var nCol=S.colaboradores.filter(function(c){return c.sucursal===s.nombre;}).length;
    var diasTxt=DIAS_CORTO.filter(function(d,i){return s.dias[i];}).join(" · ")||"—";
    var box=el("div",{class:"suc-card"});
    box.innerHTML='<div class="suc-main"><div><div class="suc-name">'+esc(s.nombre)+
      (s.id===S.sucursalId?' <span class="pill pill-on">activa</span>':'')+'</div>'+
      '<div class="small">'+s.apertura+'–'+s.cierre+' · '+diasTxt+' · cobertura mín. '+s.cobMin+' · '+nCol+' colaborador(es)</div></div>'+
      '<div class="suc-act"></div></div>';
    var act=box.querySelector(".suc-act");
    if(s.id!==S.sucursalId){var ba=el("button",{class:"btn btn-sm"},"Activar");
      ba.addEventListener("click",function(){S.sucursalId=s.id;pintarSucPick();pintarSucList();});act.appendChild(ba);}
    var be=el("button",{class:"iconbtn",title:"Editar"},ICON.edit);
    be.addEventListener("click",function(){editarSucursal(s);});act.appendChild(be);
    if(S.sucursales.length>1){var bd=el("button",{class:"iconbtn danger",title:"Eliminar"},ICON.trash);
      bd.addEventListener("click",function(){confirmar("¿Eliminar "+s.nombre+"?","Los colaboradores quedarán sin sucursal asignada.",function(){
        S.sucursales=S.sucursales.filter(function(x){return x.id!==s.id;});
        if(S.sucursalId===s.id)S.sucursalId=S.sucursales[0].id;
        guardarSucursalesConfirmado("Sucursal eliminada",function(){pintarSucPick();pintarSucList();});});});
      act.appendChild(bd);}
    host.appendChild(box);
  });
}
function editarSucursal(s){
  var nuevo=!s; s=s||{id:uid("suc"),nombre:"",apertura:"08:00",cierre:"22:00",dias:[true,true,true,true,true,true,false],cobMin:1};
  var dias=s.dias.slice();
  var horariosDia=Object.assign({},s.horariosDia||{});
  function diaHoraRow(d,i){
    var h=horariosDia[i]||{};
    return '<div class="suc-day-hours" data-suc-day="'+i+'"><label class="check"><input type="checkbox" data-su-dia="'+i+'"'+(dias[i]?" checked":"")+'> '+d+'</label>'+
      '<input type="time" data-su-ap="'+i+'" value="'+esc(h.apertura||s.apertura||"08:00")+'">'+
      '<input type="time" data-su-ci="'+i+'" value="'+esc(h.cierre||s.cierre||"22:00")+'"></div>';
  }
  var body='<div class="suc-form">'+
    campo("Nombre de la sucursal","su-nombre",s.nombre,"text")+
    campo("Apertura","su-apertura",s.apertura,"time")+
    campo("Cierre","su-cierre",s.cierre,"time")+
    '</div>'+
    '<label class="lbl suc-days-lbl">Horario por día</label><div class="suc-day-hours-head"><span>Día</span><span>Apertura</span><span>Cierre</span></div><div class="suc-day-hours-list">'+DIAS.map(diaHoraRow).join("")+'</div>'+
    '<div class="suc-cover">'+campo("Cobertura mínima (colaboradores por hora)","su-cobMin",s.cobMin,"number")+'</div>';
  modal(nuevo?"Nueva sucursal":"Editar sucursal","Horario de operación usado para detectar huecos de cobertura.",body,function(){
    var bak=JSON.parse(JSON.stringify(S.sucursales)), btn=$("#mSave"), reset=btn?btnValidando(btn,"Guardando..."):function(){};
    s.nombre=$("#f-su-nombre").value;s.apertura=$("#f-su-apertura").value;s.cierre=$("#f-su-cierre").value;
    s.cobMin=+$("#f-su-cobMin").value||1;s.dias=dias;s.horariosDia={};
    for(var i=0;i<7;i++)s.horariosDia[i]={apertura:($('[data-su-ap="'+i+'"]')||{}).value||s.apertura,cierre:($('[data-su-ci="'+i+'"]')||{}).value||s.cierre};
    if(!s.nombre){reset();toast("Falta el nombre","err");return false;}
    if(nuevo)S.sucursales.push(s);
    guardarSucursalesConfirmado("Sucursal guardada",function(){pintarSucPick();pintarSucList();}).then(function(ok){
      reset();
      if(ok)cerrarModal();
      else{S.sucursales=bak;pintarSucPick();pintarSucList();}
    }).catch(function(){reset();S.sucursales=bak;pintarSucPick();pintarSucList();});
    return false;
  });
  var sm=$("#modal .modal");if(sm)sm.classList.add("suc-modal");
  $$("[data-su-dia]").forEach(function(ch){ch.addEventListener("change",function(){dias[+ch.getAttribute("data-su-dia")]=ch.checked;});});
}

/* ============================================================
   VISTA · HORARIOS
   ============================================================ */
/* ============================================================
   PAL - tareas de limpieza y rol de aseo
   ============================================================ */
var PAL_TURNOS={mat:"Matutino",ves:"Vespertino",int:"Intermedio",esp:"Especial"};
var PAL_AREAS={OPERACION:"Operación",ADMINISTRACION:"Administración",TODAS:"Todas"};
var PAL_SUBAREAS_DEFAULT={OPERACION:["Piso","Barra","Baños","Exterior"],ADMINISTRACION:["Administración"]};
function palDefaultTasks(){
  var defs=[
    ["PAL-AP-01","Limpiar dispensador de agua","mat","diaria"],
    ["PAL-AP-02","Limpiar y organizar todos los frascos de insumos","mat","diaria"],
    ["PAL-AP-03","Limpiar la parte exterior del congelador","mat","diaria"],
    ["PAL-AP-04","Desinfectar superficies de trabajo","mat","diaria"],
    ["PAL-AP-05","Revisar y limpiar refrigeradores","mat","diaria"],
    ["PAL-AP-06","Lavar utensilios y recipientes","mat","diaria"],
    ["PAL-AP-07","Barrer las instalaciones","mat","diaria"],
    ["PAL-AP-08","Limpiar y organizar mesas y sillas","mat","diaria"],
    ["PAL-AP-09","Limpiar y desinfectar inodoros","mat","diaria"],
    ["PAL-AP-10","Limpiar lavamanos y grifería","mat","diaria"],
    ["PAL-AP-11","Reponer papel higiénico y jabón","mat","diaria"],
    ["PAL-AP-12","Trapear el piso","mat","diaria"],
    ["PAL-AP-13","Limpiar espejos","mat","diaria"],
    ["PAL-AP-14","Vaciar el bote de basura","mat","diaria"],
    ["PAL-AP-15","Barrer zona exterior de la banqueta que da a la calle, y la banqueta interna que da al estacionamiento","mat","diaria"],
    ["PAL-AP-16","Retirar hojas y suciedad del frente y del estacionamiento","mat","diaria"],
    ["PAL-AP-17","Regar la planta del estacionamiento","mat","diaria"],
    ["PAL-IN-01","Limpiar y desinfectar inodoros","int","diaria"],
    ["PAL-IN-02","Limpiar lavamanos y grifería","int","diaria"],
    ["PAL-IN-03","Revisar papel higiénico y jabón para manos","int","diaria"],
    ["PAL-IN-04","Trapear el piso","int","diaria"],
    ["PAL-IN-05","Vaciar el bote de basura","int","diaria"],
    ["PAL-IN-06","Barrer zonas de tráfico alto","int","diaria"],
    ["PAL-IN-07","Limpiar mesas y sillas","int","diaria"],
    ["PAL-IN-08","Lavar jarras y tazas acumuladas","int","diaria"],
    ["PAL-IN-09","Limpiar y acomodar la superficie de la barra y el mostrador","int","diaria"],
    ["PAL-IN-10","Lavar utensilios y recipientes usados","int","diaria"],
    ["PAL-VE-01","Desinfectar superficies de trabajo","ves","diaria"],
    ["PAL-VE-02","Lavar utensilios y recipientes del día","ves","diaria"],
    ["PAL-VE-03","Barrer y trapear el piso","ves","diaria"],
    ["PAL-VE-04","Limpiar refrigeradores por dentro y por fuera","ves","diaria"],
    ["PAL-VE-05","Retirar basura y cambiar bolsa","ves","diaria"],
    ["PAL-VE-06","Limpieza de la máquina de espresso","ves","diaria"],
    ["PAL-VE-07","Lavar y guardar todas las tazas y utensilios","ves","diaria"],
    ["PAL-VE-08","Desinfectar y cubrir la barra","ves","diaria"],
    ["PAL-VE-09","Limpiar el molino de café por el exterior","ves","diaria"],
    ["PAL-VE-10","Limpiar la parte exterior del congelador","ves","diaria"],
    ["PAL-VE-11","Barrer todo el piso","ves","diaria"],
    ["PAL-VE-12","Trapear el piso al cerrar","ves","diaria"],
    ["PAL-VE-13","Limpiar todas las mesas y sillas","ves","diaria"],
    ["PAL-VE-14","Limpiar puertas de cristal, de baño y trastienda y espejos","ves","diaria"],
    ["PAL-VE-15","Limpiar y desinfectar inodoros","ves","diaria"],
    ["PAL-VE-16","Limpiar lavamanos y grifería","ves","diaria"],
    ["PAL-VE-17","Trapear el piso","ves","diaria"],
    ["PAL-VE-18","Vaciar el bote de basura","ves","diaria"],
    ["PAL-VE-19","Barrer banqueta exterior e interna","ves","diaria"],
    ["PAL-VE-20","Retirar hojas y suciedad del frente y del estacionamiento","ves","diaria"],
    ["PAL-SE-01","Limpieza profunda interior de refrigeradores","mat","semanal"],
    ["PAL-SE-02","Limpiar estantes y repisas","mat","semanal"],
    ["PAL-SE-03","Limpiar molino de café por el exterior","mat","semanal"],
    ["PAL-SE-04","Descarchar el congelador","mat","semanal"],
    ["PAL-SE-05","Limpiar puertas de cristal, de baño y trastienda y espejos","mat","semanal"],
    ["PAL-SE-06","Limpiar lámparas y paredes","mat","semanal"],
    ["PAL-SE-07","Desinfección profunda de todos los accesorios","mat","semanal"],
    ["PAL-SE-08","Barrer y limpiar el piso","mat","semanal"],
    ["PAL-SE-09","Acomodar libros en su sección correspondiente","mat","semanal"]
  ];
  return defs.map(function(d){return {id:d[0],nombre:d[1],turno:d[2],tipo:d[3],area:"OPERACION",activo:true};});
}
function palTurnoKey(v){
  v=String(v||"").toLowerCase().trim();
  var map={mat:"mat",matutino:"mat",morning:"mat",ves:"ves",vespertino:"ves",int:"int",intermedio:"int",esp:"esp",especial:"esp"};
  return map[v]||v;
}
function palAreaKey(v){
  v=String(v||"OPERACION").toUpperCase().trim();
  var map={OP:"OPERACION",OPERACION:"OPERACION","OPERACIÓN":"OPERACION",ADMIN:"ADMINISTRACION",ADMINISTRACION:"ADMINISTRACION","ADMINISTRACIÓN":"ADMINISTRACION",TODAS:"TODAS",TODOS:"TODAS",ALL:"TODAS"};
  return map[v]||"OPERACION";
}
function palAreaNom(v){return PAL_AREAS[palAreaKey(v)]||PAL_AREAS.OPERACION;}
function palAreaCompatible(taskArea,shiftArea){
  var a=palAreaKey(taskArea), s=palAreaKey(shiftArea);
  return a==="TODAS"||a===s;
}
function palSubareasConfig(){
  ensurePALConfig();
  return S.config.palSubareas;
}
function palSubareas(area){
  var a=palAreaKey(area);
  if(a==="TODAS")return [];
  var cfg=palSubareasConfig();
  return (cfg[a]||[]).filter(Boolean);
}
function palSubareaKey(v){return String(v||"").trim();}
function palSubareaNom(v){return palSubareaKey(v)||"General";}
function palSubareaCompatible(task,shift){
  return palAreaCompatible(task&&task.area,shift&&shift.area);
}
function palSubFilterValue(v){return palSubareaKey(v)||"__GENERAL__";}
function palSubFromFilter(v){return v==="__GENERAL__"?"":v;}
function palSubareaOptionsFromTasks(tasks){
  var seen={}, out=[];
  (tasks||[]).forEach(function(t){
    var k=palSubFilterValue(t.subarea);
    if(!seen[k]){seen[k]=true;out.push({key:k,nom:palSubareaNom(t.subarea)});}
  });
  return out.sort(function(a,b){return a.nom.localeCompare(b.nom,"es");});
}
function palTipoTarea(t){return String((t&&t.tipo)||"diaria").toLowerCase()==="semanal"?"semanal":"diaria";}
function ensurePALConfig(){
  S.config=S.config||{};
  if(!Array.isArray(S.config.palTasks))S.config.palTasks=[];
  if(!S.config.palSubareas||typeof S.config.palSubareas!=="object")S.config.palSubareas=JSON.parse(JSON.stringify(PAL_SUBAREAS_DEFAULT));
  Object.keys(PAL_SUBAREAS_DEFAULT).forEach(function(k){
    // Solo inicializa con defaults si el área NUNCA se ha configurado.
    // NO re-agregamos defaults a un array existente, para que las
    // eliminaciones del usuario permanezcan (antes reaparecían).
    if(!Array.isArray(S.config.palSubareas[k]))S.config.palSubareas[k]=PAL_SUBAREAS_DEFAULT[k].slice();
  });
  S.config.palTasks.forEach(function(t){if(t&&!t.area)t.area="OPERACION";if(t&&t.subarea==null)t.subarea="";});
  var existing={};S.config.palTasks.forEach(function(t){if(t&&t.id)existing[t.id]=true;});
  palDefaultTasks().forEach(function(t){if(!existing[t.id])S.config.palTasks.push(t);});
  if(!S.config.palManual||typeof S.config.palManual!=="object")S.config.palManual={};
  if(!S.config.palLog||typeof S.config.palLog!=="object")S.config.palLog={};
}
function palTasks(){ensurePALConfig();return S.config.palTasks;}
function palActivas(){return palTasks().filter(function(t){return t&&t.activo!==false;});}
function palTaskById(id){return palTasks().filter(function(t){return t.id===id;})[0]||null;}
function fechaLocal(dISO){return new Date(String(dISO)+"T00:00:00");}
function dayIndexISO(dISO){return (fechaLocal(dISO).getDay()+6)%7;}
function semanaDeFechaISO(dISO){return fechaISO(lunesDe(fechaLocal(dISO)));}
function turnosColFecha(colId,dISO){
  var k=semanaDeFechaISO(dISO), di=dayIndexISO(dISO);
  var week=S.horarios[k]||S.horarios[semanaKey(k)]||{};
  week=normalizarSemanaData(week);
  var arr=(((week||{})[colId]||{})[di]||[]), map={};
  arr.forEach(function(sh){
    if((sh.area||"OPERACION")!=="OPERACION")return;
    var key=palTurnoKey(sh.tipo||sh.turno||sh.nombre||sh.nom);
    if(PAL_TURNOS[key])map[key]=true;
  });
  return map;
}
function shiftsColFecha(colId,dISO){
  var k=semanaDeFechaISO(dISO), di=dayIndexISO(dISO);
  var week=S.horarios[k]||S.horarios[semanaKey(k)]||{};
  week=normalizarSemanaData(week);
  return (((week||{})[colId]||{})[di]||[]).filter(function(sh){return sh&&sh.ini&&sh.fin&&!((TURNOS[sh.tipo]||{}).especial);});
}
function areasColFecha(colId,dISO){
  var map={};
  shiftsColFecha(colId,dISO).forEach(function(sh){map[palAreaKey(sh.area||"OPERACION")]=true;});
  return map;
}
function subareasColFecha(colId,dISO){
  var map={};
  shiftsColFecha(colId,dISO).forEach(function(sh){
    var a=palAreaKey(sh.area||"OPERACION"), s=palSubareaKey(sh.subarea);
    if(s)map[a+"|"+s]=true;
  });
  return map;
}
function palTaskDisponibleDia(task,colId,dISO){
  var turno=palTurnoKey(task&&task.turno);
  return shiftsColFecha(colId,dISO).some(function(sh){
    return PAL_TURNOS[palTurnoKey(sh.tipo)]&&palTurnoKey(sh.tipo)===turno&&palSubareaCompatible(task,sh);
  });
}
function palTaskAreaDisponible(task,colId,dISO){
  return shiftsColFecha(colId,dISO).some(function(sh){return palSubareaCompatible(task,sh);});
}
function palManualDia(dISO){
  ensurePALConfig();
  S.config.palManual[dISO]=S.config.palManual[dISO]||{};
  return S.config.palManual[dISO];
}
function palManualCol(dISO,colId){
  var m=palManualDia(dISO);
  m[colId]=Array.isArray(m[colId])?m[colId]:[];
  return m[colId];
}
function palTareaAsociadaATurno(task,shift){
  if(!task||!shift)return false;
  return palTipoTarea(task)==="diaria"&&palTurnoKey(task.turno)===palTurnoKey(shift.tipo)&&palSubareaCompatible(task,shift);
}
function palQuitarIds(dISO,colId,ids){
  ids=(ids||[]).filter(Boolean);if(!ids.length)return false;
  var arr=palManualCol(dISO,colId), keep=arr.filter(function(id){return ids.indexOf(id)<0;});
  if(keep.length===arr.length)return false;
  palManualDia(dISO)[colId]=keep;return true;
}
function palAgregarIds(dISO,colId,ids){
  ids=(ids||[]).filter(Boolean);if(!ids.length)return false;
  var arr=palManualCol(dISO,colId), changed=false;
  ids.forEach(function(id){if(arr.indexOf(id)<0){arr.push(id);changed=true;}});
  return changed;
}
function palIdsDeTurno(dISO,colId,shift){
  return palManualCol(dISO,colId).filter(function(id){return palTareaAsociadaATurno(palTaskById(id),shift);});
}
function palIdsSemanales(dISO,colId){
  return palManualCol(dISO,colId).filter(function(id){return palTipoTarea(palTaskById(id))==="semanal";});
}
function palGuardarSiCambio(changed){
  if(changed)DataStore.guardarPAL().catch(function(){});
  return changed;
}
function palSincronizarTurnoMovido(oldCol,oldDay,newCol,newDay,shift,sourceEmpty){
  var oldISO=fechaISO(sumaDias(S.semanaActual,oldDay)), newISO=fechaISO(sumaDias(S.semanaActual,newDay));
  var ids=palIdsDeTurno(oldISO,oldCol,shift);
  if(sourceEmpty)ids=ids.concat(palIdsSemanales(oldISO,oldCol));
  if(!ids.length)return false;
  var changed=palQuitarIds(oldISO,oldCol,ids);
  changed=palAgregarIds(newISO,newCol,ids)||changed;
  return palGuardarSiCambio(changed);
}
function palSincronizarTurnoQuitado(colId,day,shift,cellEmpty){
  var dISO=fechaISO(sumaDias(S.semanaActual,day));
  var ids=palIdsDeTurno(dISO,colId,shift);
  if(cellEmpty)ids=ids.concat(palIdsSemanales(dISO,colId));
  return palGuardarSiCambio(palQuitarIds(dISO,colId,ids));
}
function palSincronizarTurnoEditado(colId,day,oldShift,newShift){
  if(!oldShift||!newShift)return false;
  if(palTurnoKey(oldShift.tipo)===palTurnoKey(newShift.tipo)&&palAreaKey(oldShift.area)===palAreaKey(newShift.area))return false;
  var dISO=fechaISO(sumaDias(S.semanaActual,day));
  return palGuardarSiCambio(palQuitarIds(dISO,colId,palIdsDeTurno(dISO,colId,oldShift)));
}
function palColTieneAsignacion(dISO,colId,taskId){return palManualCol(dISO,colId).indexOf(taskId)>=0;}
function palSemanaDias(dISO){var lun=lunesDe(fechaLocal(dISO)),a=[];for(var i=0;i<7;i++)a.push(fechaISO(sumaDias(lun,i)));return a;}
function diaCortoDe(dISO){return DIAS_CORTO[dayIndexISO(dISO)]+" "+fechaLocal(dISO).getDate();}
/* Devuelve la fecha (ISO) donde una actividad semanal ya está asignada a un colaborador esa semana, o null. */
function palSemanalAsignadaEnSemana(dISO,colId,taskId){
  var dias=palSemanaDias(dISO);
  for(var i=0;i<dias.length;i++){
    var t=palTaskById(taskId);
    if(palManualCol(dias[i],colId).indexOf(taskId)>=0 && t && palTaskAreaDisponible(t,colId,dias[i]))return dias[i];
  }
  return null;
}
function palKey(dISO,colId,taskId,tipo){return [dISO,colId,taskId,tipo||""].join("|");}
function palLog(key){
  ensurePALConfig();
  S.config.palLog[key]=S.config.palLog[key]||{done:false,at:"",history:[]};
  if(!Array.isArray(S.config.palLog[key].history))S.config.palLog[key].history=[];
  return S.config.palLog[key];
}
function palAsignacionesFecha(dISO){
  ensurePALConfig();
  var out=[], active=palActivas(), cols=colsPALOperativos(dISO), covered={};
  cols.forEach(function(c){
    var types=turnosColFecha(c.id,dISO), trabaja=Object.keys(types).length>0;
    palManualCol(dISO,c.id).forEach(function(id){
      var t=palTaskById(id); if(!t||t.activo===false)return;
      var tipo=palTipoTarea(t);
      // Se muestra solo si el colaborador está realmente programado ese día:
      // diaria exige trabajar el turno correspondiente; semanal exige tener algún turno ese día.
      if(tipo==="diaria"){ if(!palTaskDisponibleDia(t,c.id,dISO))return; }
      else { if(!trabaja||!palTaskAreaDisponible(t,c.id,dISO))return; }
      covered[t.id]=true;
      var key=palKey(dISO,c.id,t.id,tipo), log=palLog(key);
      out.push({key:key,fecha:dISO,col:c,task:t,tipo:tipo,done:!!log.done,at:log.at||"",history:log.history||[]});
    });
  });
  var unassigned=active.filter(function(t){return !covered[t.id];}).length;
  return {items:out,unassigned:unassigned};
}
function palPorColaborador(dISO){
  var data=palAsignacionesFecha(dISO), by={};
  colsPALOperativos(dISO).forEach(function(c){by[c.id]={col:c,items:[],total:0,done:0};});
  data.items.forEach(function(a){
    if(!by[a.col.id])by[a.col.id]={col:a.col,items:[],total:0,done:0};
    by[a.col.id].items.push(a);by[a.col.id].total++;if(a.done)by[a.col.id].done++;
  });
  return {by:by,unassigned:data.unassigned,items:data.items};
}
function colsPALOperativos(dISO){
  return colsDeSucursal().filter(function(c){return Object.keys(turnosColFecha(c.id,dISO)).length>0;});
}
function palNombreVisible(c,dISO){
  var cols=colsPALOperativos(dISO), baseMap={};
  cols.forEach(function(x){var b=nombreCorto(x.nombre).toLowerCase();baseMap[b]=(baseMap[b]||0)+1;});
  var base=nombreCorto(c.nombre), p=String(c.nombre||"").trim().split(/\s+/).filter(Boolean);
  if(baseMap[base.toLowerCase()]>1&&p.length>2)return p[0]+" "+(p[1]||"").charAt(0)+". "+p[p.length-2];
  return base;
}
function palToggle(key,on){
  var l=palLog(key), now=new Date().toISOString();
  l.done=!!on;l.at=on?now:"";l.history.push({at:now,done:!!on});
  DataStore.guardarPAL().then(function(d){if(d&&!d.error)toast(on?"Tarea completada":"Check-in retirado","ok");});
}
function palRango(){
  var desde=S.repPalDesde||S.repPalFecha||fechaISO(new Date());
  var hasta=S.repPalHasta||desde;
  if(desde>hasta){var tmp=desde;desde=hasta;hasta=tmp;}
  var out=[], d=fechaLocal(desde), end=fechaLocal(hasta);
  while(d<=end){out.push(fechaISO(d));d.setDate(d.getDate()+1);}
  return out;
}
function palFiltrado(){
  var fechas=palRango(), items=[], unassigned=0;
  fechas.forEach(function(f){
    var d=palAsignacionesFecha(f);unassigned+=d.unassigned;
    d.items.forEach(function(a){
      if(S.repPalCol&&a.col.id!==S.repPalCol)return;
      if(S.repPalTipo&&a.tipo!==S.repPalTipo)return;
      items.push(a);
    });
  });
  return {items:items,unassigned:unassigned};
}

function ensureMetaConfig(){
  S.config=S.config||{};
  if(!S.config.metaConfig||typeof S.config.metaConfig!=="object")S.config.metaConfig=JSON.parse(JSON.stringify(META_DEFAULT));
  var mc=S.config.metaConfig;
  if(!Array.isArray(mc.conceptos))mc.conceptos=JSON.parse(JSON.stringify(META_DEFAULT.conceptos));
  if(!Array.isArray(mc.anuncios))mc.anuncios=[];
  META_DEFAULT.conceptos.forEach(function(def){
    if(!mc.conceptos.some(function(x){return x.id===def.id;}))mc.conceptos.push(Object.assign({},def));
  });
  mc.objetivoMes=Number(mc.objetivoMes)||0;mc.totalFecha=Number(mc.totalFecha)||0;
  return mc;
}
function configParaGuardar(cfg){
  var out=JSON.parse(JSON.stringify(cfg||{}));
  // Nunca persistir campos transitorios que pudieron quedar embebidos en config.
  delete out.session; delete out.token; delete out.action;
  // Las asignaciones PAL y los pedidos tienen su propio guardado (savePAL/savePedidos);
  // no enviarlos en saveConfig para que una config no pise esas asignaciones/registros.
  delete out.palManual; delete out.palLog; delete out.pedidosData;
  var anns=out.metaConfig&&Array.isArray(out.metaConfig.anuncios)?out.metaConfig.anuncios:[];
  anns.forEach(function(a){
    if(a&&a.adjunto&&a.adjunto.dataUrl)delete a.adjunto.dataUrl;
    (a&&a.adjuntos||[]).forEach(function(ad){if(ad&&ad.dataUrl)delete ad.dataUrl;});
  });
  return out;
}
function metaConcepto(id){
  var mc=ensureMetaConfig();
  return mc.conceptos.filter(function(x){return x.id===id;})[0]||{valor:0};
}
function metaMarkerHTML(it,children){
  children=children||[];
  var head='<span>'+esc(it.nombre||"Marcador")+'</span><b>'+money(it.valor||0)+'</b>';
  if(!children.length) return '<div class="meta-small meta-flat">'+head+'</div>';
  var body='<div class="meta-breakdown">'+children.map(function(x){return '<p><span>'+esc(x.nombre)+'</span><b>'+money(x.valor||0)+'</b></p>';}).join("")+'</div>';
  return '<details class="meta-small"><summary>'+head+'</summary>'+body+'</details>';
}
function anuncioPrioridad(a){
  var p=(a&&a.prioridad)||"normal";
  return p==="urgente"?3:(p==="alta"?2:1);
}
function anuncioFecha(a){
  var f=a&&a.updatedAt&&a.updatedAt!==a.createdAt?a.updatedAt:a.createdAt;
  return fechaInput(f)||"";
}
function anuncioFechaOrden(a){
  var fechas=[a&&a.updatedAt,a&&a.createdAt].filter(Boolean).map(function(f){
    var t=Date.parse(f);
    return isNaN(t)?0:t;
  });
  return fechas.length?Math.max.apply(Math,fechas):0;
}
function anuncioAdjuntoHTML(a){
  var ad=anuncioAdjuntos(a)[0];
  if(!ad||(!ad.dataUrl&&!ad.id))return "";
  if(ad.dataUrl&&(ad.type||"").indexOf("image/")===0)return '<button class="ann-file ann-file-img" data-ann-view="'+esc(a.id)+'"><img class="ann-no-open" draggable="false" src="'+esc(ad.dataUrl)+'" alt="'+esc(ad.name||"Imagen")+'"><span>'+esc(ad.name||"Imagen adjunta")+'</span></button>';
  return '<button class="ann-file" data-ann-view="'+esc(a.id)+'">'+ICON.doc+'<span>'+esc(ad.name||"Documento adjunto")+'</span></button>';
}
function anuncioAdjuntos(a){
  if(!a)return [];
  if(Array.isArray(a.adjuntos))return a.adjuntos.filter(Boolean);
  return a.adjunto?[a.adjunto]:[];
}
function renderAnuncios(){
  var mc=ensureMetaConfig();
  var arr=(mc.anuncios||[]).filter(function(a){return a&&a.activo!==false;}).sort(function(a,b){
    var f=anuncioFechaOrden(b)-anuncioFechaOrden(a);
    if(f)return f;
    return anuncioPrioridad(b)-anuncioPrioridad(a);
  });
  if(!arr.length)return '<section class="ann-section"><div class="ann-head"><h3>Anuncios</h3></div><div class="ann-board ann-empty">Sin anuncios publicados.</div></section>';
  return '<section class="ann-section"><div class="ann-head"><h3>Anuncios</h3></div><div class="ann-board">'+arr.map(function(a){
    var changed=a.updatedAt&&a.updatedAt!==a.createdAt;
    var nAdj=anuncioAdjuntos(a).length;
    return '<article class="ann-note ann-summary ann-'+esc(a.prioridad||"normal")+'" data-ann-open="'+esc(a.id)+'" role="button" tabindex="0">'+
      '<div class="ann-pin"></div><div class="ann-top"><span>'+esc((a.prioridad||"normal").toUpperCase())+'</span><time>'+esc(changed?"Actualizado "+anuncioFecha(a):"Creado "+anuncioFecha(a))+'</time></div>'+
      '<h4>'+esc(a.titulo||"Anuncio")+'</h4>'+
      (nAdj?'<span class="ann-count">'+nAdj+' adjunto'+(nAdj===1?"":"s")+'</span>':'')+
    '</article>';
  }).join("")+'</div></section>';
}
function enlazarAnunciosMeta(){
  $$("[data-ann-open]").forEach(function(b){
    function open(){abrirAnuncioDetalle(b.getAttribute("data-ann-open"));}
    b.addEventListener("click",open);
    b.addEventListener("keydown",function(ev){if(ev.key==="Enter"||ev.key===" "){ev.preventDefault();open();}});
  });
  $$("[data-ann-view]").forEach(function(b){b.addEventListener("click",function(){verAnuncioAdjunto(b.getAttribute("data-ann-view"));});});
  $$("[data-ann-print]").forEach(function(b){b.addEventListener("click",function(){imprimirAnuncio(b.getAttribute("data-ann-print"));});});
  bloquearImagenesAnuncio($("#view"));
}
function anuncioPorId(id){
  var mc=ensureMetaConfig();
  return (mc.anuncios||[]).filter(function(a){return a&&a.id===id;})[0]||null;
}
function bloquearImagenesAnuncio(root){
  $$(".ann-no-open",root||document).forEach(function(img){
    img.setAttribute("draggable","false");
    img.addEventListener("contextmenu",function(ev){ev.preventDefault();});
    img.addEventListener("dragstart",function(ev){ev.preventDefault();});
    img.addEventListener("auxclick",function(ev){ev.preventDefault();});
    img.addEventListener("mousedown",function(ev){if(ev.button===1)ev.preventDefault();});
  });
}
function anuncioImagenSimpleHTML(ad){
  return '<button type="button" class="ann-img-open" data-ann-img-open title="Clic para ampliar">'+
    '<img class="ann-no-open" draggable="false" src="'+esc(ad.dataUrl)+'" alt="'+esc(ad.name||"Imagen")+'">'+
    '</button>';
}
function anuncioImagenZoomHTML(ad){
  return '<div class="ann-zoom ann-zoom-full" data-ann-zoom>'+
    '<div class="ann-zoom-tools">'+
      '<button type="button" class="btn btn-sm" data-ann-zoom-out>-</button>'+
      '<span data-ann-zoom-label>100%</span>'+
      '<button type="button" class="btn btn-sm" data-ann-zoom-in>+</button>'+
      '<button type="button" class="btn btn-sm" data-ann-zoom-reset>Restablecer</button>'+
      '<button type="button" class="btn btn-sm" data-ann-zoom-close>Cerrar</button>'+
    '</div>'+
    '<div class="ann-zoom-stage"><img class="ann-no-open" draggable="false" src="'+esc(ad.dataUrl)+'" alt="'+esc(ad.name||"Imagen")+'"></div>'+
    '</div>';
}
function abrirImagenAnuncioPantalla(ad){
  if(!ad||!ad.dataUrl)return;
  var modalRoot=$("#modal");
  if(!modalRoot)return;
  var prev=modalRoot.querySelector(".ann-lightbox");
  if(prev)prev.remove();
  var layer=document.createElement("div");
  layer.className="ann-lightbox";
  layer.innerHTML='<div class="ann-lightbox-panel">'+anuncioImagenZoomHTML(ad)+'</div>';
  modalRoot.appendChild(layer);
  activarZoomImagenAnuncio(layer);
  var close=layer.querySelector("[data-ann-zoom-close]");
  if(close)close.addEventListener("click",function(ev){ev.stopPropagation();layer.remove();});
  layer.addEventListener("click",function(ev){if(ev.target===layer)layer.remove();});
}
function activarZoomImagenAnuncio(root){
  $$("[data-ann-zoom]",root||document).forEach(function(box){
    if(box.getAttribute("data-zoom-ready")==="1")return;
    box.setAttribute("data-zoom-ready","1");
    var img=box.querySelector("img"), stage=box.querySelector(".ann-zoom-stage"), label=box.querySelector("[data-ann-zoom-label]");
    var scale=1;
    var full=box.classList&&box.classList.contains("ann-zoom-full");
    function naturalWidth(){
      return img&&img.naturalWidth?img.naturalWidth:900;
    }
    function naturalHeight(){
      return img&&img.naturalHeight?img.naturalHeight:600;
    }
    function centerStage(){
      if(!stage)return;
      stage.scrollLeft=Math.max(0,(stage.scrollWidth-stage.clientWidth)/2);
      stage.scrollTop=Math.max(0,(stage.scrollHeight-stage.clientHeight)/2);
    }
    function apply(){
      if(!img)return;
      var oldLeft=stage?stage.scrollLeft:0, oldTop=stage?stage.scrollTop:0;
      var oldW=stage?Math.max(1,stage.scrollWidth):1, oldH=stage?Math.max(1,stage.scrollHeight):1;
      scale=Math.max(1,Math.min(4,scale));
      img.style.transform="";
      img.style.width=full||scale>1?(naturalWidth()*scale)+"px":"";
      img.style.height=full||scale>1?(naturalHeight()*scale)+"px":"";
      img.style.maxWidth=full||scale>1?"none":"100%";
      img.style.maxHeight=full||scale>1?"none":"62vh";
      img.style.cursor=full?"grab":"zoom-in";
      if(label)label.textContent=Math.round(scale*100)+"%";
      if(stage&&scale>1){
        stage.scrollLeft=(oldLeft+stage.clientWidth/2)*(stage.scrollWidth/oldW)-stage.clientWidth/2;
        stage.scrollTop=(oldTop+stage.clientHeight/2)*(stage.scrollHeight/oldH)-stage.clientHeight/2;
      }else if(full){
        setTimeout(centerStage,30);
      }
    }
    var bin=box.querySelector("[data-ann-zoom-in]");
    var bout=box.querySelector("[data-ann-zoom-out]");
    var br=box.querySelector("[data-ann-zoom-reset]");
    if(bin)bin.addEventListener("click",function(ev){ev.stopPropagation();scale+=.25;apply();});
    if(bout)bout.addEventListener("click",function(ev){ev.stopPropagation();scale-=.25;apply();});
    if(br)br.addEventListener("click",function(ev){ev.stopPropagation();scale=1;apply();setTimeout(centerStage,30);});
    if(img)img.addEventListener("click",function(ev){
      ev.stopPropagation();
    });
    if(img&&img.complete)apply();else if(img)img.addEventListener("load",function(){apply();setTimeout(centerStage,30);});
    apply();
  });
}
function verAnuncioAdjunto(id){
  var a=anuncioPorId(id), ad=anuncioAdjuntos(a)[0];
  if(!ad)return;
  if(!ad.dataUrl&&ad.id){
    DataStore.cargarAdjuntoMeta(ad.id).then(function(d){
      if(d&&d.ok){ad.dataUrl=d.dataUrl;ad.type=d.type||ad.type;ad.name=d.name||ad.name;verAnuncioAdjunto(id);}
      else toast("No se pudo abrir el adjunto","err");
    }).catch(function(){});
    return;
  }
  if(!ad.dataUrl)return;
  var body=(ad.type||"").indexOf("image/")===0?anuncioImagenSimpleHTML(ad):'<iframe class="ann-preview-doc" src="'+esc(ad.dataUrl)+'" title="'+esc(ad.name||"Documento")+'"></iframe>';
  modal(ad.name||"Adjunto",a.titulo||"",body,null,'<button class="btn" id="annClose">Cerrar</button>');
  $("#annClose").addEventListener("click",cerrarModal);
  var cm=$("#modal .modal");if(cm)cm.classList.add("ann-preview-modal");
  bloquearImagenesAnuncio($("#modal"));
  var openImg=$("#modal [data-ann-img-open]");
  if(openImg)openImg.addEventListener("click",function(ev){ev.stopPropagation();abrirImagenAnuncioPantalla(ad);});
}
function cargarAdjuntoAnuncio(ad,cb){
  if(!ad){cb(null);return;}
  if(ad.dataUrl){cb(ad);return;}
  if(!ad.id){cb(ad);return;}
  DataStore.cargarAdjuntoMeta(ad.id).then(function(d){
    if(d&&d.ok){ad.dataUrl=d.dataUrl;ad.type=d.type||ad.type;ad.name=d.name||ad.name;cb(ad);}
    else{toast("No se pudo abrir el adjunto","err");cb(null);}
  }).catch(function(){cb(null);});
}
function abrirAnuncioDetalle(id){
  var a=anuncioPorId(id);if(!a)return;
  var ads=anuncioAdjuntos(a), first=ads[0]||null;
  var changed=a.updatedAt&&a.updatedAt!==a.createdAt;
  var body='<div class="ann-detail">'+
    '<div class="ann-detail-meta"><span class="ann-priority">'+esc((a.prioridad||"normal").toUpperCase())+'</span><time>'+esc(changed?"Actualizado "+anuncioFecha(a):"Creado "+anuncioFecha(a))+'</time></div>'+
    '<p class="ann-detail-text">'+esc(a.texto||"Sin detalle.")+'</p>'+
    (ads.length?'<div class="ann-carousel"><div id="annMediaHost" class="ann-media-host">Cargando...</div><div class="ann-carousel-foot"><button class="btn btn-sm" id="annPrev">Anterior</button><span id="annMediaCount"></span><button class="btn btn-sm" id="annNext">Siguiente</button></div></div>':'')+
    '</div>';
  modal(a.titulo||"Anuncio","",body,null,'<button class="btn" id="annClose">Cerrar</button>'+(a.imprimible?'<button class="btn btn-primary" id="annPrintDetail">'+ICON.print+' Imprimir</button>':''));
  $("#annClose").addEventListener("click",cerrarModal);
  var pr=$("#annPrintDetail");if(pr)pr.addEventListener("click",function(){imprimirAnuncio(id);});
  var cm=$("#modal .modal");if(cm)cm.classList.add("ann-detail-modal");
  if(!ads.length)return;
  var idx=0;
  function renderMedia(){
    var host=$("#annMediaHost"), count=$("#annMediaCount");if(!host)return;
    count.textContent=(idx+1)+" / "+ads.length;
    host.innerHTML="Cargando...";
    cargarAdjuntoAnuncio(ads[idx],function(ad){
      if(!ad){host.innerHTML='<div class="empty">No se pudo cargar el adjunto.</div>';return;}
      if((ad.type||"").indexOf("image/")===0)host.innerHTML=anuncioImagenSimpleHTML(ad);
      else host.innerHTML='<iframe src="'+esc(ad.dataUrl)+'" title="'+esc(ad.name||"Documento")+'"></iframe>';
      bloquearImagenesAnuncio(host);
      var openImg=host.querySelector("[data-ann-img-open]");
      if(openImg)openImg.addEventListener("click",function(ev){ev.stopPropagation();abrirImagenAnuncioPantalla(ad);});
    });
  }
  $("#annPrev").addEventListener("click",function(){idx=(idx+ads.length-1)%ads.length;renderMedia();});
  $("#annNext").addEventListener("click",function(){idx=(idx+1)%ads.length;renderMedia();});
  renderMedia();
}
function imprimirAnuncio(id){
  var a=anuncioPorId(id);
  if(!a||!a.imprimible){toast("Este anuncio no esta autorizado para impresion","err");return;}
  var ad=anuncioAdjuntos(a)[0]||{};
  if(ad.id&&!ad.dataUrl){
    DataStore.cargarAdjuntoMeta(ad.id).then(function(d){
      if(d&&d.ok){ad.dataUrl=d.dataUrl;ad.type=d.type||ad.type;imprimirAnuncio(id);}
      else toast("No se pudo cargar el adjunto","err");
    }).catch(function(){});
    return;
  }
  var html='<div class="rep-print"><h2 style="font-family:Space Grotesk">'+esc(a.titulo||"Anuncio")+'</h2><p>'+esc(anuncioFecha(a))+'</p><p>'+esc(a.texto||"")+'</p>';
  if(ad.dataUrl&&(ad.type||"").indexOf("image/")===0)html+='<img style="max-width:100%;margin-top:18px" src="'+esc(ad.dataUrl)+'">';
  html+='</div>';
  var area=$("#printarea");area.className="print-only";area.innerHTML=html;setPrintPageStyle("carta");printIsolado();
}
function viewMeta(v){
  var mc=ensureMetaConfig(), obj=Number(mc.objetivoMes)||0, total=Number(mc.totalFecha)||0, pct=obj?Math.round(total/obj*100):0;
  var libros=metaConcepto("meta-libros"), cafe=metaConcepto("meta-cafeteria");
  var extras=mc.conceptos.filter(function(x){return !x.parent&&x.id!=="meta-libros"&&x.id!=="meta-cafeteria";});
  var card=el("div",{class:"card meta-card"});
  S.metaSub=S.metaSub||"marcadores";
  var subtabs='<div class="subtabs meta-subtabs"><button data-metasub="marcadores" class="'+(S.metaSub!=="anuncios"?"active":"")+'">Meta</button><button data-metasub="anuncios" class="'+(S.metaSub==="anuncios"?"active":"")+'">Anuncios</button></div>';
  var markers='<div class="meta-hero">'+
    '<div><span>Meta del mes</span><b>'+money(obj)+'</b></div>'+
    '<div><span>Total hasta la fecha</span><b>'+money(total)+'</b></div>'+
    '<div><span>% de alcance</span><b>'+pct+'%</b></div>'+
    '</div>'+
    '<div class="meta-progress"><i style="width:'+Math.max(0,Math.min(100,pct))+'%"></i></div>'+
    '<div class="meta-small-grid">'+
    metaMarkerHTML(libros,mc.conceptos.filter(function(x){return x.parent===libros.id;}))+
    metaMarkerHTML(cafe,mc.conceptos.filter(function(x){return x.parent===cafe.id;}))+
    extras.map(function(x){return metaMarkerHTML(x,mc.conceptos.filter(function(ch){return ch.parent===x.id;}));}).join("")+
    '</div>';
  card.innerHTML='<div class="card-head"><div><h2>Indicadores</h2><p class="sub">Seguimiento de indicadores clave del mes.</p></div></div>'+
    subtabs+
    '<div class="meta-subhost">'+(S.metaSub==="anuncios"?renderAnuncios():markers)+'</div>';
  v.appendChild(card);
  $$("#view [data-metasub]").forEach(function(b){b.addEventListener("click",function(){S.metaSub=b.getAttribute("data-metasub");go("meta");});});
  enlazarAnunciosMeta();
}
function pedirHorariosUnlockMeta(ok){
  if(S.auth.horarios){ok();return;}
  modal("Acceso de horarios","Ingresa la contraseña de Encargado de "+esc(sucursalActiva().nombre)+".",'<div class="field"><label>Contraseña</label><input type="password" id="metaPwd" autocomplete="current-password"></div>',function(){
    var pwd=$("#metaPwd").value;
    return DataStore.autenticar("horarios",pwd).then(function(r){
      if(r&&r.ok){S.auth.horarios=true;S.sessions.horarios=r.session||"";cerrarModal();ok();return false;}
      toast("Contraseña incorrecta","err");return false;
    }).catch(function(){toast("No se pudo verificar","err");return false;});
  });
}
function cardMetaConfig(v){
  ensureMetaConfig();
  var card=el("div",{class:"card"});
  card.innerHTML='<div class="card-head"><div><h2>Indicadores y Anuncios</h2><p class="sub">Captura la meta y administra los anuncios publicados en la pestaña Indicadores.</p></div></div><div id="metaCfgHost"></div>';
  v.appendChild(card);
  pintarMetaConfig();
}
function pintarMetaConfig(){
  var host=$("#metaCfgHost");if(!host)return;
  var mc=ensureMetaConfig();
  host.innerHTML='<div class="grid-2">'+campo("Meta del mes","meta-obj",mc.objetivoMes,"number")+campo("Total hasta la fecha","meta-total",mc.totalFecha,"number")+'</div>'+
    '<div class="table-wrap"><table class="data"><thead><tr><th>Marcador</th><th>Valor</th><th>Jerarquía</th><th></th></tr></thead><tbody id="metaRows"></tbody></table></div>'+
    '<div class="btn-row" style="margin-top:10px"><button class="btn btn-sm" id="metaAdd">+ Agregar marcador</button><button class="btn btn-primary" id="metaSave">Guardar marcadores</button></div>'+
    '<div class="config-block ann-config"><div class="card-head"><div><h3>Anuncios</h3><p class="sub">Publica textos, imágenes o documentos visibles en Indicadores.</p></div><div class="actions"><button class="btn btn-sm" id="annBirthday">Cumpleaños</button><button class="btn btn-sm" id="annAdd">+ Nuevo anuncio</button></div></div><div id="annCfgRows"></div></div>';
  pintarMetaRows();
  pintarAnunciosConfig();
  $("#metaAdd").addEventListener("click",function(){mc.conceptos.push({id:uid("meta"),nombre:"Nuevo marcador",valor:0,parent:""});pintarMetaRows();});
  $("#annAdd").addEventListener("click",function(){editarAnuncioConfig(-1);});
  $("#annBirthday").addEventListener("click",generarAnuncioCumpleanos);
  $("#metaSave").addEventListener("click",function(){
    var btn=$("#metaSave"), reset=btn?btnValidando(btn,"Guardando..."):function(){};
    mc.objetivoMes=+$("#f-meta-obj").value||0;mc.totalFecha=+$("#f-meta-total").value||0;
    $$("#metaRows tr").forEach(function(tr){
      var i=+tr.getAttribute("data-i"), it=mc.conceptos[i];if(!it)return;
      it.nombre=tr.querySelector('[data-k="nombre"]').value.trim()||"Marcador";
      it.valor=+tr.querySelector('[data-k="valor"]').value||0;
      it.parent=tr.querySelector('[data-k="parent"]').value||"";
    });
    guardarConfigConfirmado("Marcadores guardados",pintarMetaConfig).then(function(){reset();}).catch(function(){reset();});
  });
}
function pintarMetaRows(){
  var tb=$("#metaRows"), mc=ensureMetaConfig();if(!tb)return;
  tb.innerHTML=mc.conceptos.map(function(it,i){
    var opts='<option value="">Principal</option>'+mc.conceptos.filter(function(x){return x.id!==it.id;}).map(function(x){return '<option value="'+esc(x.id)+'"'+(it.parent===x.id?' selected':'')+'>'+esc(x.nombre)+'</option>';}).join("");
    return '<tr data-i="'+i+'"><td><input data-k="nombre" value="'+esc(it.nombre||"")+'"></td><td><input type="number" step="0.01" data-k="valor" value="'+(it.valor||0)+'"></td><td><select data-k="parent">'+opts+'</select></td><td style="text-align:right"><button class="iconbtn danger" data-meta-del="'+i+'">'+ICON.trash+'</button></td></tr>';
  }).join("");
  $$("[data-meta-del]").forEach(function(b){b.addEventListener("click",function(){mc.conceptos.splice(+b.getAttribute("data-meta-del"),1);pintarMetaRows();});});
}
function pintarAnunciosConfig(){
  var host=$("#annCfgRows"), mc=ensureMetaConfig();if(!host)return;
  var arr=mc.anuncios||[];
  if(!arr.length){host.innerHTML='<div class="empty">No hay anuncios configurados.</div>';return;}
  host.innerHTML='<div class="ann-cfg-list">'+arr.map(function(a,i){
    return '<div class="ann-cfg-row"><div><b>'+esc(a.titulo||"Anuncio")+'</b><span>'+esc((a.prioridad||"normal").toUpperCase())+' · '+(a.activo===false?"Oculto":"Publicado")+' · '+esc(anuncioFecha(a)||"Sin fecha")+'</span></div><div class="actions"><button class="iconbtn" data-ann-edit="'+i+'">'+ICON.edit+'</button><button class="iconbtn danger" data-ann-del="'+i+'">'+ICON.trash+'</button></div></div>';
  }).join("")+'</div>';
  $$("[data-ann-edit]").forEach(function(b){b.addEventListener("click",function(){editarAnuncioConfig(+b.getAttribute("data-ann-edit"));});});
  $$("[data-ann-del]").forEach(function(b){b.addEventListener("click",function(){
    var i=+b.getAttribute("data-ann-del");
    confirmar("Eliminar anuncio","Se quitará de la pestaña Indicadores.",function(){
      var bak=mc.anuncios.slice();
      mc.anuncios.splice(i,1);
      guardarConfigConfirmado("Anuncio eliminado",pintarAnunciosConfig).then(function(ok){if(!ok){mc.anuncios=bak;pintarAnunciosConfig();}}).catch(function(){mc.anuncios=bak;pintarAnunciosConfig();});
    });
  });});
}
function generarAnuncioCumpleanos(){
  var mc=ensureMetaConfig(), hoy=new Date(), mes=hoy.getMonth(), anio=hoy.getFullYear();
  var meses=["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"];
  var rows=colsDeSucursal().filter(function(c){
    var fn=fechaNacCol(c);return fn&&+fn.slice(5,7)===mes+1;
  }).sort(function(a,b){return fechaNacCol(a).slice(8,10).localeCompare(fechaNacCol(b).slice(8,10));});
  if(!rows.length){toast("No hay cumpleaños capturados para este mes","err");return;}
  var detalle=rows.map(function(c){
    var fn=fechaNacCol(c), dia=String(+fn.slice(8,10));
    return dia+" de "+meses[mes]+": "+nombreCorto(c.nombre);
  }).join("\n");
  mc.anuncios.push({
    id:uid("ann"),
    titulo:"Cumpleaños de "+meses[mes].charAt(0).toUpperCase()+meses[mes].slice(1),
    texto:"Celebramos a nuestros compañeros cumpleañeros del mes:\n\n"+detalle+"\n\n¡Feliz cumpleaños!",
    prioridad:"alta",
    activo:true,
    imprimible:true,
    createdAt:new Date(anio,mes,1).toISOString(),
    updatedAt:new Date().toISOString()
  });
  guardarConfigConfirmado("Anuncio de cumpleaños creado",pintarAnunciosConfig);
}
function editarAnuncioConfig(idx){
  var mc=ensureMetaConfig(), nuevo=idx<0;
  var base=nuevo?{id:uid("ann"),titulo:"",texto:"",prioridad:"normal",activo:true,imprimible:false,createdAt:"",updatedAt:""}:Object.assign({},mc.anuncios[idx]);
  var adjuntos=anuncioAdjuntos(base).map(function(x){return Object.assign({},x);}), leyendo=false, filePayloads=[];
  function adjuntosActualesHTML(){
    if(!adjuntos.length)return '<div class="ann-attachments-empty">Sin adjuntos actuales.</div>';
    return adjuntos.map(function(ad,i){
      return '<div class="ann-attachment-row" data-ann-adj-row="'+i+'">'+
        '<div><b>'+esc(ad.name||"archivo")+'</b><span>'+esc(ad.type||"Archivo adjunto")+'</span></div>'+
        '<button type="button" class="btn btn-sm danger" data-ann-adj-del="'+i+'">Eliminar</button>'+
        '</div>';
    }).join("");
  }
  var body='<div class="ann-form">'+
    campo("Titulo","ann-title",base.titulo||"","text")+
    '<div class="grid-2"><div class="field"><label>Prioridad</label><select id="ann-prio"><option value="normal"'+((base.prioridad||"normal")==="normal"?" selected":"")+'>Normal</option><option value="alta"'+(base.prioridad==="alta"?" selected":"")+'>Alta</option><option value="urgente"'+(base.prioridad==="urgente"?" selected":"")+'>Urgente</option></select></div>'+
    '<div class="field"><label>Adjuntos</label><input id="ann-file" type="file" accept="image/*,.pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" multiple></div></div>'+
    '<div class="ann-attachments" id="ann-adjuntos"><div class="ann-attachments-title">Adjuntos actuales</div><div id="ann-adj-list">'+adjuntosActualesHTML()+'</div></div>'+
    '<div class="field"><label>Texto del anuncio</label><textarea id="ann-text" rows="5">'+esc(base.texto||"")+'</textarea></div>'+
    '<label class="check"><input id="ann-active" type="checkbox" '+(base.activo!==false?"checked":"")+'> Publicado</label>'+
    '<label class="check"><input id="ann-printable" type="checkbox" '+(base.imprimible?"checked":"")+'> Autorizar impresion</label>'+
    '<div class="doc-note" id="ann-file-status">'+(adjuntos.length?'Puedes eliminar adjuntos actuales o agregar nuevos archivos.':'Sin adjuntos')+'</div>'+
    '</div>';
  modal(nuevo?"Nuevo anuncio":"Editar anuncio","Se mostrará en Indicadores dentro de Anuncios.",body,function(){
    if(leyendo){toast("Espera a que termine de cargar el archivo","err");return false;}
    var now=new Date().toISOString();
    base.titulo=$("#f-ann-title").value.trim()||"Anuncio";
    base.texto=$("#ann-text").value.trim();
    base.prioridad=$("#ann-prio").value||"normal";
    base.activo=$("#ann-active").checked;
    base.imprimible=$("#ann-printable").checked;
    if(!base.createdAt)base.createdAt=now;
    base.updatedAt=now;
    var btn=$("#mSave"), reset=btn?btnValidando(btn,filePayloads.length?"Subiendo...":"Guardando..."):function(){};
    function guardar(){
      delete base.adjunto;
      base.adjuntos=adjuntos;
      var bak=mc.anuncios.slice();
      if(nuevo)mc.anuncios.push(base);else mc.anuncios[idx]=base;
      guardarConfigConfirmado("Anuncio guardado",pintarAnunciosConfig).then(function(d){
        reset();
        if(d){cerrarModal();}
        else{mc.anuncios=bak;pintarAnunciosConfig();}
      }).catch(function(){mc.anuncios=bak;pintarAnunciosConfig();reset();});
    }
    if(filePayloads.length){
      var pendientes=filePayloads.slice(), nuevos=[];
      function subirSiguiente(){
        if(!pendientes.length){adjuntos=adjuntos.concat(nuevos);guardar();return;}
        DataStore.subirAdjuntoMeta(pendientes.shift()).then(function(d){
          if(d&&d.ok){nuevos.push({id:d.id,name:d.name,type:d.type,size:d.size,createdAt:d.createdAt});subirSiguiente();}
          else{reset();toast("No se pudo subir un adjunto","err");}
        }).catch(function(){reset();});
      }
      subirSiguiente();
    }else guardar();
    return false;
  });
  var file=$("#ann-file"), status=$("#ann-file-status");
  function pintarAdjuntosActuales(){
    var list=$("#ann-adj-list");if(!list)return;
    list.innerHTML=adjuntosActualesHTML();
    $$("[data-ann-adj-del]",list).forEach(function(b){
      b.addEventListener("click",function(){
        var i=+b.getAttribute("data-ann-adj-del");
        adjuntos.splice(i,1);
        pintarAdjuntosActuales();
        if(status)status.textContent=adjuntos.length?"Adjunto eliminado. Guarda el anuncio para confirmar el cambio.":"Sin adjuntos actuales. Guarda el anuncio para confirmar el cambio.";
      });
    });
  }
  pintarAdjuntosActuales();
  file.addEventListener("change",function(){
    var files=Array.prototype.slice.call(file.files||[]);if(!files.length)return;
    if(files.some(function(f){return f.size>2500000;})){toast("Cada archivo debe pesar menos de 2.5 MB","err");file.value="";return;}
    leyendo=true;filePayloads=[];status.textContent="Cargando "+files.length+" adjunto(s)...";
    var i=0;
    function readNext(){
      if(i>=files.length){leyendo=false;status.textContent="Adjuntos listos para subir: "+files.map(function(f){return f.name;}).join(", ");return;}
      var f=files[i++], r=new FileReader();
      r.onload=function(){filePayloads.push({name:f.name,type:f.type||"application/octet-stream",dataUrl:r.result});readNext();};
      r.onerror=function(){leyendo=false;toast("No se pudo leer un archivo","err");status.textContent=adjuntos.length?"Puedes eliminar adjuntos actuales o agregar nuevos archivos.":"Sin adjuntos";};
      r.readAsDataURL(f);
    }
    readNext();
  });
  var cm=$("#modal .modal");if(cm)cm.classList.add("ann-edit-modal");
}

function viewHorarios(v){
  var card=el("div",{class:"card"});
  card.innerHTML='<div class="card-head"><div><h2>Horario semanal</h2>'+
    '<p class="sub">Haz clic en una celda para crear o editar horarios de Colaboradores; puedes arrastrar los turnos entre días.</p></div></div>'+
    '<div class="week-toolbar">'+
      '<div class="week-nav">'+
        '<button class="btn btn-sm" id="wPrev">‹ Anterior</button>'+
        '<span class="week-label" id="wLabel"></span>'+
        '<button class="btn btn-sm" id="wNext">Siguiente ›</button>'+
        '<button class="btn btn-sm" id="wToday">Esta semana</button>'+
      '</div>'+
      '<div class="week-actions">'+
        '<button class="btn btn-sm" id="noteDateBtn">'+ICON.note+' Nota Rápida</button>'+
        '<button class="btn btn-sm" id="imgSel">'+ICON.image+' Imagen del horario</button>'+
        '<button class="btn btn-sm" id="imgColsSel">'+ICON.users+' Colaboradores: <span id="imgColsLbl">Todos</span></button>'+
        '<button class="btn btn-sm" id="imgAreasSel">'+ICON.info+' Mostrar área: <span id="imgAreasLbl">Todos</span></button>'+
        '<button class="btn btn-sm btn-ok" id="saveSem">Guardar horario</button>'+
        '<button class="btn btn-sm" id="histSel"></button>'+
      '</div>'+
    '</div>'+
    '<div class="legend">'+
      '<span><i class="lg-mat"></i> Matutino</span><span><i class="lg-ves"></i> Vespertino</span>'+
      '<span><i class="lg-int"></i> Intermedio</span><span><i class="lg-esp"></i> Especial</span>'+
      '<span><i class="lg-descanso"></i> Descanso</span><span><i class="lg-cumpleanos"></i> Cumpleaños</span><span><i class="lg-vacaciones"></i> Vacaciones</span><span><i class="lg-permiso"></i> Permiso</span>'+
      '<span class="lg-sep"><i class="lg-festob"></i> Festivo oblig.</span><span><i class="lg-festciv"></i> Festivo cívico</span></div>'+
    '<div id="schedHost"></div>'+
    '<div id="coverHost"></div>';
  v.appendChild(card);
  $("#wPrev").addEventListener("click",function(){S.semanaActual=sumaDias(S.semanaActual,-7);pintarSemana();});
  $("#wNext").addEventListener("click",function(){S.semanaActual=sumaDias(S.semanaActual,7);pintarSemana();});
  $("#wToday").addEventListener("click",function(){S.semanaActual=lunesDe(new Date());pintarSemana();});
  $("#histSel").addEventListener("click",abrirHistorial);
  $("#noteDateBtn").addEventListener("click",abrirNotaPorFecha);
  $("#imgSel").addEventListener("click",abrirSelectorImagenes);
  $("#imgColsSel").addEventListener("click",abrirSelectorColsImagen);
  $("#imgAreasSel").addEventListener("click",abrirSelectorAreasImagen);
  $("#saveSem").addEventListener("click",function(){
    var b=this,k=fechaISO(S.semanaActual);b.disabled=true;b.textContent="Guardando…";
    DataStore.guardarHorario(k,semanaData()).then(function(d){
      b.disabled=false;b.textContent="Guardar horario";
      if(d&&!d.error)toast("Horario guardado","ok");
    }).catch(function(){b.disabled=false;b.textContent="Guardar horario";});
  });
  pintarSemana();
}
function semanaData(){
  var k=semanaKey(fechaISO(S.semanaActual));
  if(!S.horarios[k])S.horarios[k]={};
  S.horarios[k]=normalizarSemanaData(S.horarios[k]);
  return S.horarios[k];
}
function pintarSemana(){
  var k=fechaISO(S.semanaActual);
  $("#wLabel").textContent=rangoSemana(S.semanaActual);
  var il=$("#imgColsLbl");if(il)il.textContent=imgColsLabel();
  var ia=$("#imgAreasLbl");if(ia)ia.textContent=imgAreasLabel();
  var hechas=Object.keys(S.horarios).filter(function(w){return turnosDeSemana(w)>0;}).length;
  $("#histSel").textContent="Historial ("+hechas+")";
  var host=$("#schedHost");host.innerHTML="";
  var data=semanaData();

  var notesRail=el("div",{class:"sched-notes"});
  notesRail.appendChild(el("div",{class:"sched-note-spacer"},""));
  var su=sucursalActiva();
  DIAS_CORTO.forEach(function(d,i){
    var f=sumaDias(S.semanaActual,i);
    var fISO=fechaISO(f);
    var nota=S.notasDias[fISO]||"";
    var tip=nota||"Agregar nota al dia";
    var slot=el("div",{class:"sched-note-slot"});
    slot.innerHTML='<span class="dnote-ico'+(nota?" on":"")+'" data-dnote="'+fISO+'" data-tip="'+esc(tip)+'">'+ICON.note+'</span>';
    notesRail.appendChild(slot);
  });
  var wrap=el("div",{class:"sched"});
  wrap.appendChild(notesRail);
  var tbl=el("table");
  // encabezado
  var thead=el("thead");var trh=el("tr");
  trh.appendChild(el("th",{class:"col-emp"},"Colaborador"));
  DIAS_CORTO.forEach(function(d,i){
    var f=sumaDias(S.semanaActual,i);
    var fISO=fechaISO(f);
    var abierto=su.dias[i];
    var fest=festivoDe(fISO);
    var nota=S.notasDias[fISO]||"";
    var bdays=cumpleanosDe(fISO), bdayNames=bdays.map(function(c){return nombreCorto(c.nombre);});
    var cls=(fest?(fest.tipo==="obligatorio"?"festivo-ob":"festivo-civ"):"")+(bdays.length?" bday":"");
    var th=el("th",{class:cls,title:bdays.length?("Cumpleaños: "+bdayNames.join(", ")):""});
    var html=d+'<span class="dnum">'+f.getDate()+(abierto?"":" ·cerr")+'</span>';
    if(fest)html+='<span class="festivo-tag" title="'+esc(fest.nombre)+'">'+esc(fest.nombre)+'</span>';
    if(bdays.length)html+='<span class="birthday-tag" title="Cumpleaños: '+esc(bdayNames.join(", "))+'">Cumple: '+esc(bdayNames.join(", "))+'</span>';
    th.innerHTML=html;
    trh.appendChild(th);
  });
  thead.appendChild(trh);tbl.appendChild(thead);

  var tb=el("tbody");
  var emps=colsDeSucursal();
  if(!emps.length){
    var tr=el("tr");var td=el("td",{colspan:8});td.innerHTML='<div class="empty">'+ICON.users+'Agrega colaboradores activos en '+esc(su.nombre)+' para armar el horario.</div>';
    tr.appendChild(td);tb.appendChild(tr);
  }
  emps.forEach(function(c){
    var tr=el("tr");
    if(!data[c.id])data[c.id]={};
    var emp=el("td",{class:"col-emp","data-initials":inicialesNombre(c.nombre)});
    var tot=horasColab(data[c.id]);
    var obj=c.horasObjetivo||0;
    var cls=obj?(tot>obj?"over":(tot<obj?"under":"")):"";
    emp.innerHTML='<div class="name">'+nombreHorarioHTML(c.nombre)+
      (c.notas?' <span class="cnote-ico" data-cnote="'+c.id+'" data-tip="'+esc(c.notas)+'">'+ICON.note+'</span>':'')+
      '</div><div class="role">'+esc(c.puesto||"")+'</div>'+
      '<div class="hrs"><span class="tot-pill '+cls+'">'+tot.toFixed(1)+' h'+(obj?" / "+obj:"")+'</span></div>';
    tr.appendChild(emp);
    for(var d=0;d<7;d++){
      var td=el("td");
      var cell=el("div",{class:"daycell"+(su.dias[d]?"":" closed"),"data-col":c.id,"data-day":d});
      var shifts=data[c.id][d]||[];
      if(shifts.length)cell.classList.add("has-shifts");
      shifts.forEach(function(sh){cell.appendChild(shiftEl(c.id,d,sh));});
      if(shifts.length){cell.appendChild(dayCopyHandle(c.id,d));}
      if(shifts.length&&palActivas().length){
        var pb=el("button",{class:"pal-cell-task","data-pal-col":c.id,"data-pal-day":d},"Actividades");
        pb.addEventListener("click",function(ev){ev.stopPropagation();asignarPALDesdeHorario(this.getAttribute("data-pal-col"),+this.getAttribute("data-pal-day"));});
        cell.appendChild(pb);
      }
      if(su.dias[d]){
        if(shifts.length<2)cell.appendChild(el("div",{class:"add"},"+"));
        habilitarCelda(cell,c.id,d);
      }
      td.appendChild(cell);tr.appendChild(td);
    }
    tb.appendChild(tr);
  });
  tbl.appendChild(tb);wrap.appendChild(tbl);host.appendChild(wrap);
  $$("#schedHost [data-dnote]").forEach(function(b){b.addEventListener("click",function(ev){
    ev.stopPropagation();editarNotaDia(b.getAttribute("data-dnote"));});});
  $$("#schedHost [data-cnote]").forEach(function(b){b.addEventListener("click",function(ev){
    ev.stopPropagation();verNotaColab(b.getAttribute("data-cnote"));});});
  pintarCobertura(data);
}
function nombreHorarioHTML(nombre){
  var p=String(nombre||"").trim().split(/\s+/).filter(Boolean);
  if(p.length<=2)return '<span class="nombres">'+esc(p.join(" "))+'</span>';
  var cut=Math.ceil(p.length/2);
  return '<span class="nombres">'+esc(p.slice(0,cut).join(" "))+'</span><span class="apellidos">'+esc(p.slice(cut).join(" "))+'</span>';
}
function inicialesNombre(nombre){
  var p=String(nombre||"").trim().split(/\s+/).filter(Boolean);
  if(!p.length)return "";
  return p.slice(0,4).map(function(x){return x.charAt(0).toUpperCase();}).join("");
}
function editarNotaDia(fISO){
  var actual=S.notasDias[fISO]||"";
  var fest=festivoDe(fISO);
  var sub=fechaLarga(fISO)+(fest?" · "+fest.nombre:"");
  var body='<div class="field"><label>Nota del día (uso interno)</label>'+
    '<textarea id="dn-txt" rows="3" placeholder="Ej. inventario, junta, entrega de proveedor…">'+esc(actual)+'</textarea></div>'+
    '<p class="small" style="color:var(--muted)">Esta nota es solo para el sistema; no aparece en la imagen del horario.</p>';
  modal("Nota del día",sub,body,function(){
    var t=$("#dn-txt").value.trim();
    if(t)S.notasDias[fISO]=t; else delete S.notasDias[fISO];
    DataStore.guardarNotasDias(S.notasDias);pintarSemana();toast("Nota guardada","ok");
  },actual?'<button class="btn btn-danger btn-sm" id="dn-del">Quitar nota</button>':"");
  var del=$("#dn-del");if(del)del.addEventListener("click",function(){
    delete S.notasDias[fISO];DataStore.guardarNotasDias(S.notasDias);cerrarModal();pintarSemana();toast("Nota eliminada");});
}
function abrirNotaPorFecha(){
  var hoy=fechaISO(new Date());
  var body='<div class="field"><label>Fecha</label><input id="dn-fecha-directa" type="date" value="'+hoy+'"></div><div class="field"><label>Nota del día (uso interno)</label><textarea id="dn-txt-directo" rows="4" placeholder="Ej. inventario, junta, entrega de proveedor…">'+esc(S.notasDias[hoy]||"")+'</textarea></div><p class="small" style="color:var(--muted)">La fecha puede pertenecer a cualquier semana. Deja el texto vacío para quitar una nota existente.</p>';
  modal("Nota por fecha","Agrega o modifica una nota sin cambiar la semana visible.",body,function(){
    var f=$("#dn-fecha-directa").value,t=$("#dn-txt-directo").value.trim();
    if(!f){toast("Selecciona una fecha","err");return false;}
    if(t)S.notasDias[f]=t;else delete S.notasDias[f];
    DataStore.guardarNotasDias(S.notasDias).then(function(d){if(d&&!d.error)toast(t?"Nota guardada":"Nota eliminada","ok");});
    pintarSemana();
  });
  $("#dn-fecha-directa").addEventListener("change",function(){$("#dn-txt-directo").value=S.notasDias[this.value]||"";});
}
function verNotaColab(colId){
  var c=S.colaboradores.filter(function(x){return x.id===colId;})[0];if(!c)return;
  var body='<p style="white-space:pre-wrap;margin:0 0 8px">'+esc(c.notas||"—")+'</p>'+
    '<p class="small" style="color:var(--muted)">Edita esta nota desde la sección Colaboradores.</p>';
  modal("Nota · "+c.nombre,c.puesto||"",body,null,'<button class="btn" id="cn-ok">Cerrar</button>');
  var ok=$("#cn-ok");if(ok)ok.addEventListener("click",cerrarModal);
}
function shiftEl(colId,day,sh){
  var t=TURNOS[sh.tipo]||{};
  var e=el("div",{class:"shift "+sh.tipo,draggable:"true","data-id":sh.id});
  var info=t.especial
    ? '<span class="t">'+(t.nom||"—")+'</span>'
    : '<span class="t">'+(t.nom||"Turno")+'</span><span class="h">'+sh.ini+'–'+sh.fin+'</span>';
  e.innerHTML='<div class="sh-info">'+info+'</div>'+
    '<div class="sh-acts">'+
      '<button class="sh-btn" data-act="edit">'+ICON.edit+'</button>'+
      '<button class="sh-btn" data-act="del">'+ICON.x+'</button>'+
    '</div>';
  e.querySelector('[data-act="edit"]').addEventListener("click",function(ev){ev.stopPropagation();editarTurno(colId,day,sh);});
  e.querySelector('[data-act="del"]').addEventListener("click",function(ev){ev.stopPropagation();eliminarTurno(colId,day,sh.id);});
  e.querySelector(".sh-info").addEventListener("click",function(ev){ev.stopPropagation();editarTurno(colId,day,sh);});
  e.addEventListener("dragstart",function(ev){
    S._drag={colId:colId,day:day,id:sh.id};e.classList.add("dragging");
    ev.dataTransfer.effectAllowed="move";try{ev.dataTransfer.setData("text/plain",sh.id);}catch(x){}});
  e.addEventListener("dragend",function(){e.classList.remove("dragging");S._drag=null;});
  return e;
}
function dayCopyHandle(colId,day){
  var b=el("button",{class:"day-copy-handle",type:"button",draggable:"true",title:"Arrastra para copiar el horario completo de este día"});
  b.innerHTML=ICON.copy;
  b.addEventListener("click",function(ev){ev.preventDefault();ev.stopPropagation();});
  b.addEventListener("dragstart",function(ev){
    ev.stopPropagation();S._drag=null;S._dragCopy={colId:colId,day:day};b.classList.add("dragging");
    ev.dataTransfer.effectAllowed="copy";try{ev.dataTransfer.setData("text/plain","copy-day:"+colId+":"+day);}catch(x){}
  });
  b.addEventListener("dragend",function(){b.classList.remove("dragging");S._dragCopy=null;});
  return b;
}
function eliminarTurno(colId,day,id){
  var data=semanaData();var arr=(data[colId]&&data[colId][day])||[];
  var old=arr.filter(function(s){return s.id===id;})[0];
  data[colId][day]=arr.filter(function(s){return s.id!==id;});
  if(old)palSincronizarTurnoQuitado(colId,day,old,!data[colId][day].length);
  pintarSemana();
  DataStore.guardarHorario(fechaISO(S.semanaActual),semanaData()).catch(function(){});
  toast("Asignación eliminada");
}
function validarTurnosColDia(arr,candidato,ignoreId){
  var base=(arr||[]).filter(function(s){return s&&s.id!==ignoreId;});
  if(candidato)base=base.concat([candidato]);
  if(base.length>2)return "Máximo 2 turnos por día por colaborador";
  var seen={};
  for(var i=0;i<base.length;i++){
    var key=palTurnoKey(base[i].tipo);
    if(seen[key])return "Ese turno ya está asignado ese día";
    seen[key]=true;
  }
  return "";
}
function turnosSemanaCol(colId,weekKey,ignoreId){
  var data=S.horarios[semanaKey(weekKey)]||{}, out=[];
  Object.keys((data[colId]||{})).forEach(function(d){(data[colId][d]||[]).forEach(function(s){if(s&&s.id!==ignoreId)out.push(s);});});
  return out;
}
function contarTipoSemana(colId,weekKey,tipo,ignoreId){
  return turnosSemanaCol(colId,weekKey,ignoreId).filter(function(s){return s.tipo===tipo;}).length;
}
function fechaTurno(day){return fechaISO(sumaDias(S.semanaActual,day));}
function contarTipoAnio(colId,tipo,year,ignoreId){
  var n=0;
  Object.keys(S.horarios||{}).forEach(function(w){
    var data=S.horarios[w]||{};
    Object.keys((data[colId]||{})).forEach(function(d){
      var f=fechaISO(sumaDias(new Date(w+"T00:00:00"),+d));
      if(+f.slice(0,4)!==+year)return;
      (data[colId][d]||[]).forEach(function(s){if(s&&s.id!==ignoreId&&s.tipo===tipo)n++;});
    });
  });
  return n;
}
function periodoVacacional(c,fechaISOBase){
  var ing=c.ingreso||fechaISOBase, f=fechaLocal(fechaISOBase), y=f.getFullYear();
  var m=+ing.slice(5,7)-1, d=+ing.slice(8,10)||1;
  var start=new Date(y,m,d);if(f<start)start=new Date(y-1,m,d);
  var end=new Date(start);end.setFullYear(end.getFullYear()+1);end.setDate(end.getDate()-1);
  return {inicio:fechaISO(start),fin:fechaISO(end)};
}
function diasVacacionesPermitidos(c){
  var l=(c&&c.legal&&typeof c.legal==="object")?c.legal:{};
  return Number(l.dias_vacaciones_anuales||c.diasVacacionesAnuales||12)||12;
}
function vacacionesUsadasPeriodo(c,periodo,ignoreId){
  var n=0;
  Object.keys(S.horarios||{}).forEach(function(w){
    var data=S.horarios[w]||{};
    Object.keys((data[c.id]||{})).forEach(function(d){
      var f=fechaISO(sumaDias(new Date(w+"T00:00:00"),+d));
      if(f<periodo.inicio||f>periodo.fin)return;
      (data[c.id][d]||[]).forEach(function(s){if(s&&s.id!==ignoreId&&s.tipo==="vacaciones")n++;});
    });
  });
  return n;
}
function validarAsignacionHorario(colId,day,candidato,ignoreId,dayIgnoreId){
  var data=semanaData();if(!data[colId])data[colId]={};if(!data[colId][day])data[colId][day]=[];
  var msg=validarTurnosColDia(data[colId][day],candidato,dayIgnoreId===undefined?ignoreId:dayIgnoreId);if(msg)return msg;
  if(candidato.area==="OPERACION"&&candidato.ini&&candidato.fin&&!sucursalActiva().dias[day])return "El área operación solo puede asignarse en días abiertos de la sucursal";
  if(candidato.area==="OPERACION"&&candidato.ini&&candidato.fin&&!turnoDentroSucursal(candidato,day))return "El horario de operación debe estar dentro del horario de sucursal";
  if(candidato.tipo==="descanso"&&contarTipoSemana(colId,fechaISO(S.semanaActual),"descanso",ignoreId)>=1)return "Solo puede asignarse un día de descanso por semana";
  if(candidato.tipo==="cumpleanos"&&contarTipoAnio(colId,"cumpleanos",fechaTurno(day).slice(0,4),ignoreId)>=1)return "El día de cumpleaños solo puede asignarse una vez al año";
  if(candidato.tipo==="vacaciones"){
    var c=S.colaboradores.find(function(x){return x.id===colId;});
    if(!c)return "";
    var per=periodoVacacional(c,fechaTurno(day)), lim=diasVacacionesPermitidos(c);
    if(lim&&vacacionesUsadasPeriodo(c,per,ignoreId)>=lim)return "El colaborador ya alcanzó sus días de vacaciones del periodo";
  }
  return "";
}
function habilitarCelda(cell,colId,day){
  cell.addEventListener("click",function(){
    var data=semanaData(), turnos=((data[colId]||{})[day]||[]);
    if(turnos.length>=2)return;
    editarTurno(colId,day,null);
  });
  cell.addEventListener("dragover",function(ev){ev.preventDefault();cell.classList.add(S._dragCopy?"copy-drop":"drop");});
  cell.addEventListener("dragleave",function(){cell.classList.remove("drop","copy-drop");});
  cell.addEventListener("drop",function(ev){
    ev.preventDefault();cell.classList.remove("drop","copy-drop");
    if(S._dragCopy){copiarHorarioDia(S._dragCopy,colId,day);return;}
    var dr=S._drag;if(!dr)return;
    var data=semanaData();
    var arr=(data[dr.colId]&&data[dr.colId][dr.day])||[];
    var idx=arr.findIndex(function(s){return s.id===dr.id;});
    if(idx<0){S._drag=null;return;}
    if(dr.colId===colId&&dr.day===day){S._drag=null;return;}
    var sh=arr[idx];
    if(!data[colId])data[colId]={};if(!data[colId][day])data[colId][day]=[];
    var msg=validarAsignacionHorario(colId,day,sh,sh.id,null);
    if(msg){S._drag=null;toast(msg,"err");return;}
    sh=arr.splice(idx,1)[0];
    data[colId][day].push(sh);
    if(dr.colId!==colId||dr.day!==day)palSincronizarTurnoMovido(dr.colId,dr.day,colId,day,sh,!arr.length);
    S._drag=null;
    S.horarios[semanaKey(fechaISO(S.semanaActual))]=normalizarSemanaData(data);
    pintarSemana();
    DataStore.guardarHorario(fechaISO(S.semanaActual),semanaData()).catch(function(){});
  });
}
function copiarHorarioDia(origen,colId,day){
  var data=semanaData();
  if(origen.colId===colId&&origen.day===day){S._dragCopy=null;return;}
  var source=((data[origen.colId]||{})[origen.day]||[]).slice();
  if(!source.length){S._dragCopy=null;return;}
  if(!data[colId])data[colId]={};if(!data[colId][day])data[colId][day]=[];
  var original=data[colId][day].slice(), msg="";
  for(var i=0;i<source.length;i++){
    var copia=Object.assign({},source[i],{id:uid("sh")});
    msg=validarAsignacionHorario(colId,day,copia,null,null);
    if(msg)break;
    data[colId][day].push(copia);
  }
  S._dragCopy=null;
  if(msg){data[colId][day]=original;toast(msg,"err");return;}
  S.horarios[semanaKey(fechaISO(S.semanaActual))]=normalizarSemanaData(data);
  pintarSemana();
  DataStore.guardarHorario(fechaISO(S.semanaActual),semanaData()).then(function(d){
    if(d&&!d.error)toast("Horario copiado","ok");
  }).catch(function(){});
}
function editarTurno(colId,day,sh){
  var nuevo=!sh, hDia=horarioSucursalDia(day);
  sh=sh||mkShift("mat",{ini:hDia.apertura,fin:sumaHoras(hDia.apertura,8),area:"OPERACION"});
  if(!sh.area)sh.area="OPERACION";
  var oldShift=nuevo?null:{id:sh.id,tipo:sh.tipo,ini:sh.ini,fin:sh.fin,area:sh.area};
  var body='<div class="field"><label>Tipo</label><select id="t-tipo">'+
      Object.keys(TURNOS).map(function(k){return '<option value="'+k+'"'+(k===sh.tipo?" selected":"")+'>'+TURNOS[k].nom+'</option>';}).join("")+'</select></div>'+
    '<div class="field"><label>Área</label><select id="t-area"><option value="OPERACION"'+((sh.area||"OPERACION")==="OPERACION"?" selected":"")+'>OPERACION</option><option value="ADMINISTRACION"'+(sh.area==="ADMINISTRACION"?" selected":"")+'>ADMINISTRACION</option></select></div>'+
    '<div id="t-horas">'+
      '<div class="inline">'+campo("Entrada","t-ini",sh.ini,"time")+campo("Salida","t-fin",sh.fin,"time")+'</div>'+
      '<div class="small" id="t-dur" style="margin-top:6px"></div><div class="small" id="t-auto" style="margin-top:4px;color:var(--muted)"></div>'+
    '</div>';
  var extra=nuevo?"":'<button class="btn btn-danger btn-sm" id="t-del">Quitar</button>';
  modal((nuevo?"Nueva asignación · ":"Editar · ")+DIAS[day],S.colaboradores.find(function(c){return c.id===colId;}).nombre,body,function(){
    var tipo=$("#t-tipo").value, esp=TURNOS[tipo].especial, area=$("#t-area").value||"OPERACION";
    var candidato={id:sh.id,tipo:tipo,ini:"",fin:"",area:area};
    if(esp){ candidato.ini=""; candidato.fin=""; }
    else{
      candidato.ini=$("#f-t-ini").value;candidato.fin=$("#f-t-fin").value;
      if(horasEntre(candidato.ini,candidato.fin)<=0){toast("La salida debe ser mayor que la entrada","err");return false;}
      candidato.tipo=clasificarTurnoPorHorario(candidato.ini,candidato.fin,day);
    }
    var data=semanaData();if(!data[colId])data[colId]={};if(!data[colId][day])data[colId][day]=[];
    var msg=validarAsignacionHorario(colId,day,candidato,nuevo?null:sh.id);
    if(msg){toast(msg,"err");return false;}
    sh.tipo=candidato.tipo;sh.ini=candidato.ini;sh.fin=candidato.fin;sh.area=candidato.area;
    if(nuevo)data[colId][day].push(sh);
    else palSincronizarTurnoEditado(colId,day,oldShift,sh);
    S.horarios[semanaKey(fechaISO(S.semanaActual))]=normalizarSemanaData(data);
    pintarSemana();
    DataStore.guardarHorario(fechaISO(S.semanaActual),semanaData()).then(function(dd){
      if(dd&&!dd.error)toast("Asignación guardada","ok");
    }).catch(function(){});
  },extra);
  var sel=$("#t-tipo"), areaSel=$("#t-area");
  function defaultsForTipo(tipo){
    var h=horarioSucursalDia(day);
    if(tipo==="mat")return {ini:h.apertura,fin:sumaHoras(h.apertura,8)};
    if(tipo==="ves")return {ini:sumaHoras(h.cierre,-8),fin:h.cierre};
    if(tipo==="int")return {ini:sumaHoras(h.apertura,3),fin:sumaHoras(h.apertura,9)};
    if(tipo==="esp")return {ini:h.apertura,fin:h.cierre};
    return {ini:"",fin:""};
  }
  function refrescaTipo(){
    var t=TURNOS[sel.value];
    $("#t-horas").style.display=t.especial?"none":"block";
    if(!t.especial){ if($("#f-t-ini").value==="")$("#f-t-ini").value=defaultsForTipo(sel.value).ini; if($("#f-t-fin").value==="")$("#f-t-fin").value=defaultsForTipo(sel.value).fin; dur(); }
  }
  function dur(){var h=horasEntre($("#f-t-ini").value,$("#f-t-fin").value), auto=h>0?clasificarTurnoPorHorario($("#f-t-ini").value,$("#f-t-fin").value,day):sel.value;$("#t-dur").textContent=h>0?h.toFixed(1)+" horas":"";$("#t-auto").textContent=h>0?"Se guardará como: "+(TURNOS[auto]||{}).nom:"";}
  sel.addEventListener("change",function(){var t=TURNOS[sel.value], df=defaultsForTipo(sel.value);if(!t.especial){$("#f-t-ini").value=df.ini;$("#f-t-fin").value=df.fin;}refrescaTipo();});
  areaSel.addEventListener("change",dur);
  $("#f-t-ini").addEventListener("input",dur);$("#f-t-fin").addEventListener("input",dur);refrescaTipo();
  if(!nuevo){$("#t-del").addEventListener("click",function(){
    var data=semanaData();var arr=data[colId][day]||[];
    data[colId][day]=arr.filter(function(s){return s.id!==sh.id;});
    palSincronizarTurnoQuitado(colId,day,sh,!data[colId][day].length);
    cerrarModal();pintarSemana();
    DataStore.guardarHorario(fechaISO(S.semanaActual),semanaData()).catch(function(){});
    toast("Asignación eliminada");});}
}
function horasColab(porDia){var t=0;for(var d in porDia)(porDia[d]||[]).forEach(function(s){t+=horasEntre(s.ini,s.fin);});return t;}

/* Cobertura: por cada día abierto revisa hora por hora si hay cobMin colaboradores */
function pintarCobertura(data){
  var host=$("#coverHost");host.innerHTML="";
  var su=sucursalActiva();
  var emps=colsDeSucursal();
  var faltantes=[];
  var card=el("div");card.style.marginTop="16px";
  var grid=el("div",{class:"grid-3"});
  DIAS.forEach(function(dn,d){
    if(!su.dias[d])return;
    var hd=horarioSucursalDia(d), ap=minutos(hd.apertura),ci=minutos(hd.cierre);
    var totalSlots=Math.max(1,(ci-ap)/60),cubiertos=0,huecos=[];
    for(var m=ap;m<ci;m+=60){
      var n=0;
      emps.forEach(function(c){
        ((data[c.id]||{})[d]||[]).forEach(function(s){if(minutos(s.ini)<=m&&minutos(s.fin)>=m+60)n++;});});
      if(n>=su.cobMin)cubiertos++; else huecos.push(Math.floor(m/60)+":00");
    }
    var pct=Math.round(cubiertos/totalSlots*100);
    var gap=pct<100;
    if(gap)faltantes.push(dn+" ("+huecos.join(", ")+")");
    var box=el("div",{class:"card"});box.style.margin="0";box.style.padding="14px";
    box.innerHTML='<div style="display:flex;justify-content:space-between"><b style="font-family:Space Grotesk">'+dn+'</b>'+
      '<span class="small">'+pct+'%</span></div>'+
      '<div class="coverage"><span class="cov-bar'+(gap?" gap":"")+'"><i style="width:'+pct+'%"></i></span></div>'+
      (gap?'<div class="small" style="margin-top:6px;color:var(--accent)">Sin cubrir: '+huecos.join(", ")+'</div>':'<div class="small" style="margin-top:6px;color:var(--ok)">Cobertura completa</div>');
    grid.appendChild(box);
  });
  card.appendChild(grid);host.appendChild(card);
  if(faltantes.length){
    var n=el("div",{class:"note warn"});
    n.innerHTML='<span>'+ICON.warn+'</span><div><b>Faltan espacios por asignar</b>Revisa la cobertura mínima ('+su.cobMin+' por hora) en: '+esc(faltantes.join(" · "))+'</div>';
    host.appendChild(n);
  }else if(emps.length){
    var ok=el("div",{class:"note ok"});
    ok.innerHTML='<span>'+ICON.check.replace(/#fff/g,"currentColor")+'</span><div><b>Horario completo</b>Todo el horario de operación tiene cobertura.</div>';
    host.appendChild(ok);
  }
}
var _gtimer=null;
function guardarSemanaDebounce(k,data){clearTimeout(_gtimer);_gtimer=setTimeout(function(){DataStore.guardarHorario(k,data);},900);}

/* ---- Imagen del horario (sin puesto ni horas) + compartir WhatsApp ---- */
var TURNO_COLOR={mat:"#1B6FB0",ves:"#C2620B",int:"#1B8A4B",esp:"#6B4BA3",descanso:"#5A6173",cumpleanos:"#B98900",vacaciones:"#0F766E",permiso:"#8A6D1F"};
/* Primer nombre + primer apellido (para la imagen del horario) */
function nombreCorto(full){
  var p=String(full||"").trim().split(/\s+/);
  if(p.length<=1)return p[0]||"";
  if(p.length===2)return p[0]+" "+p[1];
  // asume: nombre(s) ... apellido apellido -> primer token + penúltimo
  return p[0]+" "+p[p.length-2];
}
function horarioSVG(){
  var su=sucursalActiva(), emps=imgColsSeleccionados(), data=semanaData();
  var colW=150, dayW=118, rowH=64, headH=86, padB=18;
  var W=colW+dayW*7, H=headH+rowH*Math.max(1,emps.length)+padB;
  function esc2(s){return String(s==null?"":s).replace(/[&<>]/g,function(c){return{"&":"&amp;","<":"&lt;",">":"&gt;"}[c];});}
  var s='<svg xmlns="http://www.w3.org/2000/svg" width="'+W+'" height="'+H+'" viewBox="0 0 '+W+' '+H+'" font-family="Inter, Arial, sans-serif">';
  s+='<rect width="'+W+'" height="'+H+'" fill="#ffffff"/>';
  // título
  s+='<text x="20" y="30" font-size="20" font-weight="700" fill="#0E1B4D">Lienzo Librería · '+esc2(su.nombre)+'</text>';
  s+='<text x="20" y="52" font-size="13" fill="#6A7088">Horario semanal · '+esc2(rangoSemana(S.semanaActual))+'</text>';
  var y0=64;
  // encabezados de día
  s+='<rect x="0" y="'+y0+'" width="'+W+'" height="'+(headH-y0)+'" fill="#0E1B4D"/>';
  s+='<text x="14" y="'+(y0+15)+'" font-size="11" font-weight="700" fill="#ffffff">COLABORADOR</text>';
  for(var i=0;i<7;i++){
    var fx=colW+dayW*i, f=sumaDias(S.semanaActual,i), ab=su.dias[i];
    s+='<text x="'+(fx+10)+'" y="'+(y0+15)+'" font-size="11" font-weight="700" fill="'+(ab?"#ffffff":"#9aa0bd")+'">'+DIAS_CORTO[i]+' '+f.getDate()+(ab?"":" ·cerr")+'</text>';
  }
  var GRID="#C9CDD9";
  // filas
  emps.forEach(function(c,ri){
    var ry=headH+ri*rowH;
    if(ri%2)s+='<rect x="0" y="'+ry+'" width="'+W+'" height="'+rowH+'" fill="#F3F5FA"/>';
    s+='<text x="14" y="'+(ry+26)+'" font-size="13" font-weight="600" fill="#161A2E">'+esc2(nombreCorto(c.nombre))+'</text>';
    for(var d=0;d<7;d++){
      var cx=colW+dayW*d;
      var shifts=(data[c.id]||{})[d]||[];
      var sy=ry+12;
      shifts.forEach(function(sh){
        var t=TURNOS[sh.tipo]||{};
        var col=TURNO_COLOR[sh.tipo]||"#1B6FB0";
        s+='<rect x="'+(cx+8)+'" y="'+sy+'" width="'+(dayW-16)+'" height="20" rx="5" fill="'+col+'"/>';
        var etiqueta=t.especial?(t.nom||"—"):(sh.ini+"–"+sh.fin);
        s+='<text x="'+(cx+dayW/2)+'" y="'+(sy+14)+'" font-size="10.5" font-weight="600" fill="#ffffff" text-anchor="middle">'+esc2(etiqueta)+'</text>';
        sy+=24;
      });
    }
    // división horizontal (gris)
    s+='<line x1="0" y1="'+(ry+rowH)+'" x2="'+W+'" y2="'+(ry+rowH)+'" stroke="'+GRID+'" stroke-width="1"/>';
  });
  // divisiones verticales (gris) — incluye la columna de colaborador
  s+='<line x1="0" y1="'+headH+'" x2="0" y2="'+(H-padB)+'" stroke="'+GRID+'" stroke-width="1"/>';
  for(var v2=0;v2<=7;v2++){var vx=colW+dayW*v2;s+='<line x1="'+vx+'" y1="'+headH+'" x2="'+vx+'" y2="'+(H-padB)+'" stroke="'+GRID+'" stroke-width="1"/>';}
  // marco exterior y línea bajo el encabezado
  s+='<line x1="0" y1="'+headH+'" x2="'+W+'" y2="'+headH+'" stroke="'+GRID+'" stroke-width="1.5"/>';
  s+='<rect x="0.5" y="'+(y0+0.5)+'" width="'+(W-1)+'" height="'+(H-padB-y0-1)+'" fill="none" stroke="'+GRID+'" stroke-width="1.5"/>';
  s+='</svg>';
  return {svg:s, w:W, h:H};
}
function horarioSVG(){
  var su=sucursalActiva(), emps=imgColsSeleccionados(), data=semanaData();
  var colW=150, dayW=118, y0=64, headerH=24, headH=y0+headerH, padB=8;
  function rowHeight(c){
    var maxSh=0,step=mostrarAreaEnImagen(c.id)?34:24;
    for(var d=0;d<7;d++)maxSh=Math.max(maxSh,((data[c.id]||{})[d]||[]).length);
    return Math.max(54,maxSh*step+18);
  }
  var rowHs=emps.map(rowHeight);
  var bodyH=rowHs.reduce(function(a,b){return a+b;},0)||54;
  var W=colW+dayW*7, H=headH+bodyH+padB;
  function esc2(s){return String(s==null?"":s).replace(/[&<>]/g,function(c){return{"&":"&amp;","<":"&lt;",">":"&gt;"}[c];});}
  var s='<svg xmlns="http://www.w3.org/2000/svg" width="'+W+'" height="'+H+'" viewBox="0 0 '+W+' '+H+'" font-family="Inter, Arial, sans-serif">';
  s+='<rect width="'+W+'" height="'+H+'" fill="#ffffff"/>';
  s+='<text x="20" y="30" font-size="20" font-weight="700" fill="#0E1B4D">Lienzo Libreria · '+esc2(su.nombre)+'</text>';
  s+='<text x="20" y="52" font-size="13" fill="#6A7088">Horario semanal · '+esc2(rangoSemana(S.semanaActual))+'</text>';
  s+='<rect x="0" y="'+y0+'" width="'+W+'" height="'+headerH+'" fill="#0E1B4D"/>';
  s+='<text x="'+(colW/2)+'" y="'+(y0+headerH/2)+'" font-size="11" font-weight="700" fill="#ffffff" text-anchor="middle" dominant-baseline="middle">COLABORADOR</text>';
  for(var i=0;i<7;i++){
    var fx=colW+dayW*i, f=sumaDias(S.semanaActual,i), ab=su.dias[i];
    s+='<text x="'+(fx+dayW/2)+'" y="'+(y0+headerH/2)+'" font-size="11" font-weight="700" fill="'+(ab?"#ffffff":"#9aa0bd")+'" text-anchor="middle" dominant-baseline="middle">'+DIAS_CORTO[i]+' '+f.getDate()+(ab?"":" ·cerr")+'</text>';
  }
  var GRID="#9EA7BA", ry=headH;
  emps.forEach(function(c,ri){
    var rowH=rowHs[ri]||54,showArea=mostrarAreaEnImagen(c.id),shiftH=showArea?30:20,shiftStep=showArea?34:24;
    if(ri%2)s+='<rect x="0" y="'+ry+'" width="'+W+'" height="'+rowH+'" fill="#F3F5FA"/>';
    s+='<text x="'+(colW/2)+'" y="'+(ry+rowH/2)+'" font-size="13" font-weight="600" fill="#161A2E" text-anchor="middle" dominant-baseline="middle">'+esc2(nombreCorto(c.nombre))+'</text>';
    for(var d=0;d<7;d++){
      var cx=colW+dayW*d, shifts=(data[c.id]||{})[d]||[];
      var blockH=shifts.length?shifts.length*shiftStep-(shiftStep-shiftH):0;
      var sy=ry+(rowH-blockH)/2;
      shifts.forEach(function(sh){
        var t=TURNOS[sh.tipo]||{}, col=TURNO_COLOR[sh.tipo]||"#1B6FB0";
        var etiqueta=t.especial?(t.nom||"-"):(sh.ini+"-"+sh.fin);
        s+='<rect x="'+(cx+8)+'" y="'+sy+'" width="'+(dayW-16)+'" height="'+shiftH+'" rx="5" fill="'+col+'"/>';
        s+='<text x="'+(cx+dayW/2)+'" y="'+(sy+(showArea?9:10))+'" font-size="10.5" font-weight="600" fill="#ffffff" text-anchor="middle" dominant-baseline="middle">'+esc2(etiqueta)+'</text>';
        if(showArea)s+='<text x="'+(cx+dayW/2)+'" y="'+(sy+21)+'" font-size="7.2" font-weight="700" fill="#ffffff" opacity=".92" text-anchor="middle" dominant-baseline="middle">'+esc2(palAreaNom(sh.area||"OPERACION"))+'</text>';
        sy+=shiftStep;
      });
    }
    s+='<line x1="0" y1="'+(ry+rowH)+'" x2="'+W+'" y2="'+(ry+rowH)+'" stroke="'+GRID+'" stroke-width="1.4"/>';
    ry+=rowH;
  });
  var tableBottom=H-padB;
  s+='<line x1="0" y1="'+y0+'" x2="0" y2="'+tableBottom+'" stroke="'+GRID+'" stroke-width="1.4"/>';
  for(var v2=0;v2<=7;v2++){var vx=colW+dayW*v2;s+='<line x1="'+vx+'" y1="'+y0+'" x2="'+vx+'" y2="'+tableBottom+'" stroke="'+GRID+'" stroke-width="1.4"/>';}
  s+='<line x1="0" y1="'+headH+'" x2="'+W+'" y2="'+headH+'" stroke="'+GRID+'" stroke-width="1.8"/>';
  s+='<rect x="0.8" y="'+(y0+0.8)+'" width="'+(W-1.6)+'" height="'+(tableBottom-y0-1.6)+'" fill="none" stroke="'+GRID+'" stroke-width="1.8"/>';
  s+='</svg>';
  return {svg:s, w:W, h:H};
}
function svgToPng(svgStr,w,h){
  return new Promise(function(resolve,reject){
    try{
      var canvas=document.createElement("canvas");
      var scale=2; canvas.width=w*scale; canvas.height=h*scale;
      var ctx=canvas.getContext("2d");
      var img=new Image();
      var blob=new Blob([svgStr],{type:"image/svg+xml;charset=utf-8"});
      var url=(window.URL||window.webkitURL).createObjectURL(blob);
      img.onload=function(){
        ctx.setTransform(scale,0,0,scale,0,0);
        ctx.drawImage(img,0,0);
        (window.URL||window.webkitURL).revokeObjectURL(url);
        canvas.toBlob(function(b){resolve({blob:b,dataURL:canvas.toDataURL("image/png")});},"image/png");
      };
      img.onerror=function(e){reject(e);};
      img.src=url;
    }catch(e){reject(e);}
  });
}
function abrirSelectorImagenes(){
  var body='<div class="grid-2 img-choice-grid">'+
    '<button class="btn btn-primary" id="imgHorario">'+ICON.image+' Horario</button>'+
    '<button class="btn btn-primary" id="imgTareas">'+ICON.check+' Actividades</button></div>';
  modal("Generar imagen","Selecciona el contenido que quieres descargar o compartir.",body,null,'<button class="btn" id="imgSelClose">Cerrar</button>');
  $("#imgSelClose").addEventListener("click",cerrarModal);
  $("#imgHorario").addEventListener("click",function(){cerrarModal();abrirImagenHorario();});
  $("#imgTareas").addEventListener("click",function(){cerrarModal();abrirImagenPAL();});
}
function abrirSelectorColsImagen(){
  var all=colsDeSucursal(), sel=imgColsSeleccionados(), set={};
  sel.forEach(function(c){set[c.id]=true;});
  var body=all.length?'<div class="img-col-tools"><button class="btn btn-sm" id="imgColsAll">Todos</button><button class="btn btn-sm" id="imgColsNone">Limpiar</button></div>'+
    '<div class="img-col-list">'+all.map(function(c){
      return '<label class="check"><input type="checkbox" data-img-col="'+esc(c.id)+'"'+(set[c.id]?' checked':'')+'> <span>'+esc(c.nombre)+'</span></label>';
    }).join("")+'</div>':'<div class="empty">'+ICON.users+'No hay colaboradores activos en esta sucursal.</div>';
  modal("Colaboradores Para Imagen","Define quién aparece en las imágenes de horario y actividades.",body,function(){
    var ids=[];$$("[data-img-col]").forEach(function(ch){if(ch.checked)ids.push(ch.getAttribute("data-img-col"));});
    if(!ids.length){toast("Selecciona al menos un colaborador","err");return false;}
    guardarImgColsSeleccionados(ids);pintarSemana();toast("Selección guardada","ok");
  });
  var allBtn=$("#imgColsAll"), noneBtn=$("#imgColsNone");
  if(allBtn)allBtn.addEventListener("click",function(e){e.preventDefault();$$("[data-img-col]").forEach(function(ch){ch.checked=true;});});
  if(noneBtn)noneBtn.addEventListener("click",function(e){e.preventDefault();$$("[data-img-col]").forEach(function(ch){ch.checked=false;});});
}
function abrirSelectorAreasImagen(){
  var all=colsDeSucursal(), ids=imgAreasSeleccionadas(), set={};ids.forEach(function(id){set[id]=true;});
  var body=all.length?'<div class="img-col-tools"><button class="btn btn-sm" id="imgAreasAll">Todos</button><button class="btn btn-sm" id="imgAreasNone">Ninguno</button></div><div class="img-col-list">'+all.map(function(c){return '<label class="check"><input type="checkbox" data-img-area="'+esc(c.id)+'"'+(set[c.id]?' checked':'')+'> <span>'+esc(c.nombre)+'</span></label>';}).join("")+'</div>':'<div class="empty">'+ICON.users+'No hay colaboradores activos en esta sucursal.</div>';
  modal("Área Visible En La Imagen","Selecciona a qué colaboradores se les mostrará el área de cada turno.",body,function(){var selected=[];$$("[data-img-area]").forEach(function(ch){if(ch.checked)selected.push(ch.getAttribute("data-img-area"));});guardarImgAreasSeleccionadas(selected);pintarSemana();toast("Visibilidad de áreas guardada","ok");});
  var allBtn=$("#imgAreasAll"),noneBtn=$("#imgAreasNone");
  if(allBtn)allBtn.addEventListener("click",function(e){e.preventDefault();$$("[data-img-area]").forEach(function(ch){ch.checked=true;});});
  if(noneBtn)noneBtn.addEventListener("click",function(e){e.preventDefault();$$("[data-img-area]").forEach(function(ch){ch.checked=false;});});
}
function abrirImagenHorario(){
  if(!imgColsSeleccionados().length){toast("No hay colaboradores seleccionados","err");return;}
  var g=horarioSVG();
  var body='<p class="small" style="margin-bottom:10px">Imagen del horario de <b>'+esc(sucursalActiva().nombre)+'</b> · '+esc(rangoSemana(S.semanaActual))+'.</p>'+
    '<div class="img-prev" id="imgPrev"><div class="empty"><span class="spin"></span></div></div>';
  modal("Imagen del horario","Para descargar o compartir.",body,null,
    '<button class="btn" id="imgDl">'+ICON.download+' Descargar</button>'+
    '<button class="btn btn-ok" id="imgWa">'+ICON.wa+' WhatsApp</button>'+
    '<button class="btn" id="imgClose">Cerrar</button>');
  var m=$("#modal .modal");if(m)m.style.maxWidth="760px";
  $("#imgClose").addEventListener("click",cerrarModal);
  var pngData=null, pngBlob=null, fname="horario-"+fechaISO(S.semanaActual)+".png";
  svgToPng(g.svg,g.w,g.h).then(function(res){
    pngData=res.dataURL; pngBlob=res.blob;
    var p=$("#imgPrev");if(p)p.innerHTML='<img src="'+pngData+'" alt="Horario" style="width:100%;border:1px solid var(--line);border-radius:8px">';
  }).catch(function(){var p=$("#imgPrev");if(p)p.innerHTML='<div class="note warn"><span>'+ICON.warn+'</span><div>No se pudo generar la imagen en este navegador.</div></div>';});
  $("#imgDl").addEventListener("click",function(){
    if(!pngData){toast("Generando imagen…");return;}
    var a=document.createElement("a");a.href=pngData;a.download=fname;document.body.appendChild(a);a.click();a.remove();
  });
  $("#imgWa").addEventListener("click",function(){
    if(!pngBlob){toast("Generando imagen…");return;}
    var texto="Horario "+sucursalActiva().nombre+" · "+rangoSemana(S.semanaActual);
    var file=null;
    try{ file=new File([pngBlob],fname,{type:"image/png"}); }catch(e){}
    if(file && navigator.canShare && navigator.canShare({files:[file]})){
      navigator.share({files:[file], title:"Horario", text:texto}).catch(function(){});
    }else{
      // Respaldo: descarga la imagen y abre WhatsApp con el texto para adjuntarla.
      var a=document.createElement("a");a.href=pngData;a.download=fname;document.body.appendChild(a);a.click();a.remove();
      window.open("https://wa.me/?text="+encodeURIComponent(texto+" (adjunta la imagen descargada)"),"_blank");
    }
  });
}

function palAvatar(c,index){
  var p=String(c.nombre||"?").trim().split(/\s+/), txt=((p[0]||"?")[0]||"")+((p[1]||"")[0]||"");
  var colors=["#C2620B","#1B8A4B","#9E1B14","#6B4BA3","#B98900","#0F766E","#B0301C","#7A6817","#A23E72","#4F7A35","#A4512A","#7B3F8C","#C04F72","#657A1F","#A65F00","#287565"];
  var ix=Math.max(0,Number(index)||0), color=colors[ix%colors.length];
  if(ix>=colors.length){
    var hue=[28,145,4,276,44,171,345,78,320,104,18,292,335,90,35,158][ix%16];
    color="hsl("+hue+" 62% "+(34+(Math.floor(ix/16)%4)*5)+"%)";
  }
  return '<span class="pal-av" style="background:'+color+'">'+esc(txt.toUpperCase())+'</span>';
}
function horaCorta(iso){
  if(!iso)return "";
  var d=new Date(iso);return isNaN(d.getTime())?"":pad(d.getHours())+":"+pad(d.getMinutes());
}
function palFechaVisible(dISO){return fechaLarga(fechaLocal(dISO));}
function viewPAL(v){
  ensurePALConfig();
  if(!S.palFecha)S.palFecha=fechaISO(new Date());
  var card=el("div",{class:"card pal-card"});
  card.innerHTML='<div class="card-head"><div><h2>PAL</h2>'+
    '<p class="sub">Participacion del equipo, check-in de tareas y rol de aseo del dia.</p></div>'+
    '<div class="pal-date-row"><div class="field pal-date"><label>Seleccionar Día</label><input type="date" id="palFecha" value="'+esc(S.palFecha)+'"></div>'+
    '<button class="btn pal-today" id="palToday" type="button">Este Día</button></div></div>'+
    '<div id="palBody"></div>';
  v.appendChild(card);
  $("#palFecha").addEventListener("change",function(){S.palFecha=this.value||fechaISO(new Date());pintarPAL();});
  $("#palToday").addEventListener("click",function(){S.palFecha=fechaISO(new Date());$("#palFecha").value=S.palFecha;pintarPAL();});
  var zonas=palZonasActivas();
  var cardAseo=el("div",{class:"card"});
  cardAseo.innerHTML='<div class="card-head"><div><h2 style="font-size:20px;line-height:1.2">Formato de verificación de aseo</h2>'+
    '<p class="sub">Impresión de checklist de zonas.</p></div></div>'+
    '<div class="aseo-print-row"><div class="field"><label>Zona</label><select id="aseoZona">'+
      '<option value="__all__">Todas las zonas</option>'+
      zonas.map(function(z){return '<option value="'+esc(z)+'">'+esc(z)+'</option>';}).join("")+
    '</select></div>'+
    '<button class="btn btn-primary" id="aseoPrint">'+ICON.print+' Imprimir formato</button></div>';
  v.appendChild(cardAseo);
  $("#aseoPrint").addEventListener("click",function(){imprimirFormatoAseo($("#aseoZona")?$("#aseoZona").value:"__all__");});
  pintarPAL();
}
function pintarPAL(){
  var host=$("#palBody");if(!host)return;
  if(!S.palLoaded&&_palLoadPromise){host.innerHTML='<div class="empty"><span class="spin"></span><br>Cargando PAL...</div>';return;}
  var dISO=S.palFecha||fechaISO(new Date()), P=palPorColaborador(dISO), ids=Object.keys(P.by);
  S.palOpenIds=S.palOpenIds||{};
  var html='<h3 class="pal-title">Participacion del equipo - '+esc(palFechaVisible(dISO))+'</h3>'+
    '<div class="pal-summary-list">'+ids.map(function(id,index){
      var p=P.by[id];return '<div class="pal-team-row">'+palAvatar(p.col,index)+'<b>'+esc(palNombreVisible(p.col,dISO))+'</b><span class="pal-task-count"><b>'+p.total+'</b> Tareas Asignadas</span></div>';
    }).join("")+'</div>'+
    '<h3 class="pal-title">Actividades por colaborador - '+esc(palFechaVisible(dISO))+'</h3>';
  if(!palActivas().length)html+='<div class="empty">'+ICON.info+'Configura actividades PAL en Configuracion para empezar.</div>';
  html+='<div class="pal-activity-list">'+ids.map(function(id,index){
    var p=P.by[id], rows=p.items.map(function(a){
      return '<label class="pal-task-row"><input type="checkbox" data-pal="'+esc(a.key)+'"'+(a.done?" checked":"")+'>'+
        '<span><b>'+esc(a.task.nombre)+'</b><small>'+esc(palSubareaNom(a.task.subarea))+' · '+esc(PAL_TURNOS[palTurnoKey(a.task.turno)]||a.task.turno)+' · '+esc(a.tipo)+'</small></span></label>';
    }).join("") || '<div class="pal-empty">Sin Tareas Asignadas Aun.</div>';
    return '<details class="pal-person" data-pal-person="'+esc(id)+'"'+(S.palOpenIds[id]?' open':'')+'><summary>'+palAvatar(p.col,index)+'<b>'+esc(palNombreVisible(p.col,dISO))+'</b>'+ 
      '<span class="pal-task-count"><b>'+p.done+'/'+p.total+'</b> Tareas Asignadas</span><button class="btn btn-sm btn-primary" data-pal-print="'+esc(id)+'">'+ICON.print+' Imprimir</button></summary>'+
      '<div class="pal-person-body">'+rows+'</div></details>';
  }).join("")+'</div>';
  host.innerHTML=html;
  $$(".pal-person").forEach(function(d){d.addEventListener("toggle",function(){S.palOpenIds[d.getAttribute("data-pal-person")]=d.open;});});
  $$("[data-pal]").forEach(function(ch){ch.addEventListener("change",function(){
    S.palOpenIds={};$$(".pal-person").forEach(function(d){S.palOpenIds[d.getAttribute("data-pal-person")]=d.open;});
    palToggle(ch.getAttribute("data-pal"),ch.checked);pintarPAL();
  });});
  $$("[data-pal-print]").forEach(function(b){b.addEventListener("click",function(ev){ev.preventDefault();imprimirPALColaborador(b.getAttribute("data-pal-print"),dISO);});});
}
function imprimirPALColaborador(colId,dISO){
  var P=palPorColaborador(dISO).by[colId];if(!P)return;
  var su=sucursalActiva();
  var razon=(S.config&&S.config.empresa&&(S.config.empresa.razonSocial||S.config.empresa.empresa))||"Lienzo Librería";
  var todos=P.items.map(function(a){
    return '<div class="tk-todo"><span class="tk-box"></span><span class="tk-task">'+esc(a.task.nombre)+'</span></div>';
  }).join("")||'<div class="center" style="font-size:10px;margin:10px 0">Sin actividades asignadas</div>';
  var cab='<div class="tk-brand">'+
    (IMG.recibo?'<img src="'+IMG.recibo+'" alt="'+esc(razon)+'" class="tk-logo" onerror="this.style.display=\'none\';this.nextSibling.style.display=\'block\'">':"")+
    '<div class="tk-brand-name"'+(IMG.recibo?' style="display:none"':"")+'>'+esc(razon)+'</div></div>';
  var html='<div class="thermal-page"><div class="ticket pal-ticket">'+
    cab+
    '<div class="center" style="font-weight:700;font-size:11px;letter-spacing:.04em">ACTIVIDADES DEL DÍA</div>'+
    '<div class="center" style="font-weight:700;font-size:12.5px;margin-top:2px">'+esc(P.col.nombre||"")+'</div>'+
    '<div class="center" style="font-size:9.5px">'+esc(su.nombre)+' · '+esc(palFechaVisible(dISO))+'</div>'+
    '<hr>'+
    '<div class="tk-todos">'+todos+'</div>'+
    '<hr><div class="center" style="font-size:9px;margin-top:8px">Marca cada actividad al realizarla</div>'+
  '</div></div>';
  var area=$("#printarea");area.className="print-only print-termica";area.innerHTML=html;setPrintPageStyle("termica");window.print();
}
/* ============================================================
   FORMATO DE VERIFICACIÓN DE ASEO (checklist físico por zona)
   No es por colaborador: es una hoja en blanco por zona para
   verificar físicamente las tareas realizadas y firmarlas.
   ============================================================ */
var ASEO_TURNO_LABEL={mat:"APERTURA",int:"MEDIODIA",ves:"CIERRE",esp:"ESPECIAL"};
var ASEO_TURNO_ORDEN={mat:0,int:1,ves:2,esp:3};
function aseoTurnoLabel(t){
  if(t&&t.tipo==="semanal")return "SEMANAL";
  return ASEO_TURNO_LABEL[palTurnoKey(t&&t.turno)]||String(PAL_TURNOS[palTurnoKey(t&&t.turno)]||"TURNO").toUpperCase();
}
function palZonasActivas(){
  var seen={},out=[];
  palActivas().forEach(function(t){var z=palSubareaNom(t.subarea);if(!seen[z]){seen[z]=true;out.push(z);}});
  out.sort(function(a,b){return String(a).localeCompare(String(b),"es");});
  return out;
}
/* Agrupa actividades activas de una zona por nombre: cada nombre es una actividad
   con una o más filas (una por turno). El badge "Nx al día" se deriva de cuántos
   turnos diarios distintos tiene registrada la misma actividad. */
function aseoActividadesZona(zona){
  var tasks=palActivas().filter(function(t){return palSubareaNom(t.subarea)===zona;});
  var grupos=[],idx={};
  tasks.forEach(function(t){
    var nom=t.nombre||"";
    if(idx[nom]==null){idx[nom]=grupos.length;grupos.push({nombre:nom,filas:[]});}
    grupos[idx[nom]].filas.push({turno:t.turno,tipo:t.tipo,label:aseoTurnoLabel(t)});
  });
  grupos.forEach(function(g){
    g.filas.sort(function(a,b){
      var oa=a.tipo==="semanal"?9:(ASEO_TURNO_ORDEN[palTurnoKey(a.turno)]||0);
      var ob=b.tipo==="semanal"?9:(ASEO_TURNO_ORDEN[palTurnoKey(b.turno)]||0);
      return oa-ob;
    });
    var diarias={};g.filas.forEach(function(f){if(f.tipo!=="semanal")diarias[palTurnoKey(f.turno)]=true;});
    var n=Object.keys(diarias).length;
    g.badge=n>1?(n+"x al día"):"";
  });
  return grupos;
}
function folioAseo(){
  var s="ABCDEFGHJKLMNPQRSTUVWXYZ23456789", out="";
  for(var i=0;i<6;i++)out+=s.charAt(Math.floor(Math.random()*s.length));
  return "FVA-"+out;
}
function formatoAseoZonaHTML(zona,folio){
  var su=sucursalActiva();
  var razon=(S.config&&S.config.empresa&&(S.config.empresa.razonSocial||S.config.empresa.empresa))||"Lienzo Librería";
  var grupos=aseoActividadesZona(zona), n=0, body="";
  grupos.forEach(function(g){
    var span=g.filas.length;
    g.filas.forEach(function(f,i){
      n++;
      body+='<tr>';
      if(i===0){
        body+='<td class="az-num" rowspan="'+span+'">'+n+'</td>'+
              '<td class="az-act" rowspan="'+span+'"><div class="az-act-name">'+esc(g.nombre)+'</div>'+(g.badge?'<span class="az-badge">'+esc(g.badge)+'</span>':'')+'</td>';
      }
      body+='<td class="az-turno">'+esc(f.label)+'</td>'+
            '<td class="az-chk"><span class="az-box"></span></td>'+
            '<td class="az-hora"></td><td class="az-nom"></td><td class="az-firma"></td><td class="az-vb"></td></tr>';
    });
  });
  if(!grupos.length)body='<tr><td colspan="8" style="text-align:center;padding:18px">Sin actividades configuradas para esta zona.</td></tr>';
  return '<div class="aseo-page">'+
    '<div class="az-head"><div class="az-head-l"><div class="az-zona">'+esc(zona)+'</div><div class="az-sub">FORMATO DE VERIFICACIÓN DE ASEO</div></div>'+
      '<div class="az-head-r"><div class="az-store">'+esc(su.nombre)+'</div><div class="az-store-sub">'+esc(razon)+' · Plan de Aseo</div></div></div>'+
    '<div class="az-fields"><div class="az-frow"><span class="az-flabel">Fecha:</span><span class="az-fline"></span></div>'+
      '<div class="az-frow az-frow-2col"><div class="az-fcell"><span class="az-flabel">1.- Encargado de Turno:</span><span class="az-fline"></span></div>'+
        '<div class="az-fcell"><span class="az-flabel">2.- Encargado de Turno:</span><span class="az-fline"></span></div></div></div>'+
    '<div class="az-nota">Nota: Las actividades marcadas con "Nx al día" se realizan en varios turnos y pueden ser ejecutadas por diferentes colaboradores. Cada colaborador registra su nombre, hora y firma en la fila del turno correspondiente.</div>'+
    '<table class="az-table"><colgroup><col class="az-col-num"><col class="az-col-act"><col class="az-col-turno"><col class="az-col-chk"><col class="az-col-hora"><col class="az-col-nom"><col class="az-col-firma"><col class="az-col-vb"></colgroup><thead><tr><th>#</th><th>ACTIVIDAD</th><th>TURNO</th><th>REALIZADA</th><th>HORA</th><th>NOMBRE COLABORADOR</th><th>FIRMA COLABORADOR</th><th>V.B. ENCARGADO</th></tr></thead><tbody>'+body+'</tbody></table>'+
    '<div class="az-sign"><div class="az-sign-line"></div><div class="az-sign-cap">FIRMA DE SUPERVISIÓN / AUDITORÍA</div><div class="az-sign-sub">Nombre, cargo y fecha</div></div>'+
    '<div class="az-obs"><div class="az-obs-cap">OBSERVACIONES GENERALES</div><div class="az-obs-box"></div></div>'+
    '<div class="az-foot">Folio: '+esc(folio||folioAseo())+' · Formato generado el '+esc(fechaLarga(fechaISO(new Date())))+' · Zona: '+esc(zona)+' · '+esc(su.nombre)+' – Plan de Aseo</div>'+
  '</div>';
}
function imprimirFormatoAseo(zonaSel){
  var zonas=(zonaSel==="__all__"||!zonaSel)?palZonasActivas():[zonaSel];
  if(!zonas.length){toast("No hay zonas con actividades configuradas","err");return;}
  var folio=folioAseo();
  var html=zonas.map(function(z){return formatoAseoZonaHTML(z,folio);}).join("");
  var area=$("#printarea");area.className="print-only print-aseo";area.innerHTML=html;setPrintPageStyle("aseo");printIsolado();
}
function palSVG(){
  var su=sucursalActiva(), cols=imgColsSeleccionados(), start=S.semanaActual;
  var colW=160, dayW=128, minRowH=78, y0=64, headerH=26, lineH=9.2, W=colW+dayW*7;
  function esc2(s){return String(s==null?"":s).replace(/[&<>]/g,function(c){return{"&":"&amp;","<":"&lt;",">":"&gt;"}[c];});}
  function wrapSVGText(txt,maxChars){
    var words=String(txt||"").trim().split(/\s+/).filter(Boolean), lines=[], line="";
    words.forEach(function(w){
      var test=line?line+" "+w:w;
      if(test.length>maxChars&&line){lines.push(line);line=w;}
      else line=test;
    });
    if(line)lines.push(line);
    return lines.length?lines:[""];
  }
  function cellLines(c,d){
    var fISO=fechaISO(sumaDias(start,d)), items=palPorColaborador(fISO).by[c.id];
    var joined=(items?items.items:[]).map(function(a){return a.task.nombre;}).join(", ");
    var wrapped=wrapSVGText(joined,24);
    return wrapped.map(function(line,li){return {text:line,justify:wrapped.length>1&&li<wrapped.length-1&&line.length>9};});
  }
  var rowInfo=cols.map(function(c){
    var cells=[], maxLines=1;
    for(var d=0;d<7;d++){var lines=cellLines(c,d);cells[d]=lines;maxLines=Math.max(maxLines,lines.length);}
    return {cells:cells,h:Math.max(minRowH,maxLines*lineH+18)};
  });
  var bodyH=rowInfo.reduce(function(a,r){return a+r.h;},0)||minRowH;
  var H=y0+headerH+bodyH+10;
  var s='<svg xmlns="http://www.w3.org/2000/svg" width="'+W+'" height="'+H+'" viewBox="0 0 '+W+' '+H+'" font-family="Inter, Arial, sans-serif">';
  s+='<rect width="'+W+'" height="'+H+'" fill="#ffffff"/>';
  s+='<text x="20" y="30" font-size="20" font-weight="700" fill="#0E1B4D">Actividades - '+esc2(su.nombre)+'</text>';
  s+='<text x="20" y="52" font-size="13" fill="#6A7088">'+esc2(rangoSemana(start))+'</text>';
  s+='<rect x="0" y="'+y0+'" width="'+W+'" height="'+headerH+'" fill="#0E1B4D"/>';
  s+='<text x="'+(colW/2)+'" y="'+(y0+headerH/2)+'" font-size="11" font-weight="700" fill="#fff" text-anchor="middle" dominant-baseline="middle">COLABORADOR</text>';
  for(var d=0;d<7;d++){var fx=colW+dayW*d, f=sumaDias(start,d);s+='<text x="'+(fx+dayW/2)+'" y="'+(y0+headerH/2)+'" font-size="11" font-weight="700" fill="#fff" text-anchor="middle" dominant-baseline="middle">'+DIAS_CORTO[d]+' '+f.getDate()+'</text>';}
  var ry=y0+headerH, GRID="#9EA7BA";
  cols.forEach(function(c,ri){
    var rowH=(rowInfo[ri]&&rowInfo[ri].h)||minRowH;
    if(ri%2)s+='<rect x="0" y="'+ry+'" width="'+W+'" height="'+rowH+'" fill="#F3F5FA"/>';
    s+='<text x="'+(colW/2)+'" y="'+(ry+rowH/2)+'" font-size="12.5" font-weight="700" fill="#161A2E" text-anchor="middle" dominant-baseline="middle">'+esc2(nombreCorto(c.nombre))+'</text>';
    for(var d=0;d<7;d++){
      var cx=colW+dayW*d, clipId="palclip-"+ri+"-"+d, lines=(rowInfo[ri]&&rowInfo[ri].cells[d])||[{text:"",justify:false}];
      var startY=ry+(rowH-(lines.length||1)*lineH)/2+7;
      s+='<clipPath id="'+clipId+'"><rect x="'+(cx+3)+'" y="'+(ry+3)+'" width="'+(dayW-6)+'" height="'+(rowH-6)+'"/></clipPath>';
      s+='<g clip-path="url(#'+clipId+')">';
      lines.forEach(function(line,li){
        s+='<text x="'+(cx+9)+'" y="'+(startY+li*lineH)+'" font-size="7.3" fill="#6A7088" text-anchor="start"'+(line.justify?' textLength="'+(dayW-18)+'" lengthAdjust="spacing"':"")+'>'+esc2(line.text)+'</text>';
      });
      s+='</g>';
    }
    s+='<line x1="0" y1="'+(ry+rowH)+'" x2="'+W+'" y2="'+(ry+rowH)+'" stroke="'+GRID+'" stroke-width="1.3"/>';ry+=rowH;
  });
  for(var v=0;v<=7;v++){var x=colW+dayW*v;s+='<line x1="'+x+'" y1="'+y0+'" x2="'+x+'" y2="'+(H-10)+'" stroke="'+GRID+'" stroke-width="1.3"/>';}
  s+='<rect x=".8" y="'+(y0+.8)+'" width="'+(W-1.6)+'" height="'+(H-y0-10)+'" fill="none" stroke="'+GRID+'" stroke-width="1.6"/></svg>';
  return {svg:s,w:W,h:H};
}
function abrirImagenPAL(){
  if(!imgColsSeleccionados().length){toast("No hay colaboradores seleccionados","err");return;}
  var g=palSVG();
  var body='<p class="small" style="margin-bottom:10px">Imagen de actividades de <b>'+esc(sucursalActiva().nombre)+'</b> - '+esc(rangoSemana(S.semanaActual))+'.</p>'+
    '<div class="img-prev" id="imgPrev"><div class="empty"><span class="spin"></span></div></div>';
  modal("Imagen de actividades","Para descargar o compartir.",body,null,
    '<button class="btn" id="imgDl">'+ICON.download+' Descargar</button>'+
    '<button class="btn btn-ok" id="imgWa">'+ICON.wa+' WhatsApp</button>'+
    '<button class="btn" id="imgClose">Cerrar</button>');
  var m=$("#modal .modal");if(m)m.style.maxWidth="760px";
  $("#imgClose").addEventListener("click",cerrarModal);
  var pngData=null, pngBlob=null, fname="actividades-"+fechaISO(S.semanaActual)+".png";
  svgToPng(g.svg,g.w,g.h).then(function(res){pngData=res.dataURL;pngBlob=res.blob;var p=$("#imgPrev");if(p)p.innerHTML='<img src="'+pngData+'" alt="Actividades" style="width:100%;border:1px solid var(--line);border-radius:8px">';});
  $("#imgDl").addEventListener("click",function(){if(!pngData){toast("Generando imagen");return;}var a=document.createElement("a");a.href=pngData;a.download=fname;document.body.appendChild(a);a.click();a.remove();});
  $("#imgWa").addEventListener("click",function(){
    if(!pngBlob){toast("Generando imagen");return;}
    var texto="Actividades "+sucursalActiva().nombre+" - "+rangoSemana(S.semanaActual), file=null;
    try{file=new File([pngBlob],fname,{type:"image/png"});}catch(e){}
    if(file&&navigator.canShare&&navigator.canShare({files:[file]}))navigator.share({files:[file],title:"Actividades",text:texto}).catch(function(){});
    else{var a=document.createElement("a");a.href=pngData;a.download=fname;document.body.appendChild(a);a.click();a.remove();window.open("https://wa.me/?text="+encodeURIComponent(texto+" (adjunta la imagen descargada)"),"_blank");}
  });
}
function asignarPALDesdeHorario(colId,day){
  var dISO=fechaISO(sumaDias(S.semanaActual,day));
  var c=S.colaboradores.filter(function(x){return x.id===colId;})[0], types=turnosColFecha(colId,dISO);
  var shiftsDia=shiftsColFecha(colId,dISO);
  var typesAll={};
  shiftsDia.forEach(function(sh){var k=palTurnoKey(sh.tipo);if(PAL_TURNOS[k])typesAll[k]=true;});
  var turnosTxt=Object.keys(typesAll).filter(function(k){return typesAll[k];}).map(function(k){return PAL_TURNOS[k];}).join(", ");
  var actuales=palManualCol(dISO,colId);
  // Diarias: solo las que coinciden con el turno trabajado ese día.
  var diarias=palActivas().filter(function(t){return palTipoTarea(t)==="diaria" && palTaskDisponibleDia(t,colId,dISO);});
  // Semanales: cualquier turno, pero una sola vez por semana por colaborador.
  var semanales=palActivas().filter(function(t){return palTipoTarea(t)==="semanal" && palTaskAreaDisponible(t,colId,dISO);});
  function diaCheck(t){
    var sub=palSubFilterValue(t.subarea);
    return '<label class="check pal-task-choice" data-pal-task-row data-pal-kind="diaria" data-pal-sub="'+esc(sub)+'"><input type="checkbox" data-pal-task="'+esc(t.id)+'" data-pal-kind="diaria" data-pal-subarea="'+esc(sub)+'"'+(actuales.indexOf(t.id)>=0?" checked":"")+'> <span class="pal-task-name">'+esc(t.nombre)+' <small>· '+esc(palSubareaNom(t.subarea))+'</small></span></label>';
  }
  function semCheck(t){
    var sub=palSubFilterValue(t.subarea);
    var enDia=palSemanalAsignadaEnSemana(dISO,colId,t.id);
    if(enDia&&enDia!==dISO){
      return '<label class="check pal-task-choice pal-task-locked" data-pal-task-row data-pal-kind="semanal" data-pal-sub="'+esc(sub)+'"><input type="checkbox" disabled checked> <span class="pal-task-name">'+esc(t.nombre)+' <small>· '+esc(palSubareaNom(t.subarea))+' · ya asignada esta semana ('+esc(diaCortoDe(enDia))+')</small></span></label>';
    }
    return '<label class="check pal-task-choice" data-pal-task-row data-pal-kind="semanal" data-pal-sub="'+esc(sub)+'"><input type="checkbox" data-pal-task="'+esc(t.id)+'" data-pal-kind="semanal" data-pal-subarea="'+esc(sub)+'"'+(actuales.indexOf(t.id)>=0?" checked":"")+'> <span class="pal-task-name">'+esc(t.nombre)+' <small>· '+esc(palSubareaNom(t.subarea))+'</small></span></label>';
  }
  function list(arr,fn,empty){return arr.length?'<div class="pal-check-list">'+arr.map(fn).join("")+'</div>':'<div class="pal-empty">'+empty+'</div>';}
  function controls(kind,arr){
    var opts=palSubareaOptionsFromTasks(arr);
    if(!opts.length)return "";
    var lbl=kind==="diaria"?"diarias":"semanales";
    return '<div class="pal-assign-tools" data-pal-tools="'+kind+'">'+
      '<div class="pal-subarea-filter"><label>Subárea</label><select data-pal-filter="'+kind+'"><option value="">Todas</option>'+opts.map(function(o){return '<option value="'+esc(o.key)+'">'+esc(o.nom)+'</option>';}).join("")+'</select></div>'+
      '<div class="pal-bulk-actions"><button type="button" class="btn btn-sm" data-pal-check-all="'+kind+'">Asignar '+lbl+' visibles</button><button type="button" class="btn btn-sm" data-pal-clear-all="'+kind+'">Desmarcar '+lbl+' visibles</button></div>'+
    '</div>';
  }
  var emptyDaily=turnosTxt?"No hay actividades diarias configuradas para este turno.":"El colaborador no tiene turno de trabajo este día (descanso o sin turno).";
  var body='<div class="type-help pal-assign-help"><span>Las actividades diarias disponibles cambian según el turno del colaborador. Las actividades semanales se pueden asignar en cualquier turno, pero solo una vez por semana por colaborador.</span></div>'+
    '<div class="pal-assign-section" data-pal-section="diaria"><h3 class="form-section-title">Actividades diarias del turno'+(turnosTxt?' · '+esc(turnosTxt):'')+'</h3>'+controls("diaria",diarias)+list(diarias,diaCheck,emptyDaily)+'</div>'+
    '<div class="pal-assign-section" data-pal-section="semanal"><h3 class="form-section-title">Actividades semanales</h3>'+controls("semanal",semanales)+list(semanales,semCheck,"No hay actividades semanales configuradas.")+'</div>';
  modal("Asignar actividades",((c&&c.nombre)||"")+" - "+palFechaVisible(dISO),body,function(){
    var reset=btnValidando($("#mSave"),"Guardando...");
    var bakManual=JSON.parse(JSON.stringify(S.config.palManual||{}));
    var arr=[];$$("[data-pal-task]").forEach(function(ch){if(ch.checked)arr.push(ch.getAttribute("data-pal-task"));});
    if(arr.length)palManualDia(dISO)[colId]=arr;
    else{
      var dia=palManualDia(dISO);
      delete dia[colId];
      if(!Object.keys(dia).length)delete S.config.palManual[dISO];
    }
    DataStore.guardarPAL().then(function(d){
      reset();
      if(d&&!d.error){toast("Tareas asignadas","ok");cerrarModal();pintarSemana();}
      else{S.config.palManual=bakManual;}
    }).catch(function(){S.config.palManual=bakManual;reset();});
    return false;
  });
  var cm=$("#modal .modal");if(cm)cm.classList.add("pal-assign-modal");
  function applyPalFilter(kind){
    var sel=$('[data-pal-filter="'+kind+'"]'), val=sel?sel.value:"";
    $$('[data-pal-task-row][data-pal-kind="'+kind+'"]').forEach(function(row){
      row.style.display=(!val||row.getAttribute("data-pal-sub")===val)?"":"none";
    });
  }
  $$("[data-pal-filter]").forEach(function(sel){sel.addEventListener("change",function(){applyPalFilter(sel.getAttribute("data-pal-filter"));});});
  $$("[data-pal-check-all]").forEach(function(b){b.addEventListener("click",function(e){
    e.preventDefault();
    var kind=b.getAttribute("data-pal-check-all"), sel=$('[data-pal-filter="'+kind+'"]'), val=sel?sel.value:"";
    $$('[data-pal-task][data-pal-kind="'+kind+'"]').forEach(function(ch){
      if(!val||ch.getAttribute("data-pal-subarea")===val)ch.checked=true;
    });
  });});
  $$("[data-pal-clear-all]").forEach(function(b){b.addEventListener("click",function(e){
    e.preventDefault();
    var kind=b.getAttribute("data-pal-clear-all"), sel=$('[data-pal-filter="'+kind+'"]'), val=sel?sel.value:"";
    $$('[data-pal-task][data-pal-kind="'+kind+'"]').forEach(function(ch){
      if(!val||ch.getAttribute("data-pal-subarea")===val)ch.checked=false;
    });
  });});
}
function turnosDeSemana(w){return contarTurnosSemanaData(S.horarios[semanaKey(w)]||S.horarios[w]||{});}
function semanasVaciasHistorial(){return Object.keys(S.horarios).filter(function(w){return turnosDeSemana(w)===0;});}
function limpiarHistorialVacias(){
  var vac=semanasVaciasHistorial();
  vac.forEach(function(w){ delete S.horarios[w]; DataStore.borrarHorario(w).catch(function(){}); });
  return vac.length;
}
function abrirHistorial(){
  var weeks=Object.keys(S.horarios).sort().reverse();
  var vacias=semanasVaciasHistorial().length;
  var body=weeks.length?'<div class="table-wrap"><table class="data"><thead><tr><th>Semana</th><th>Turnos</th><th></th></tr></thead><tbody>'+
    weeks.map(function(w){
      var n=turnosDeSemana(w);
      return '<tr'+(n===0?' class="row-off"':'')+'><td>'+rangoSemana(new Date(w+"T00:00:00"))+'</td><td>'+n+' turnos'+(n===0?' · vacía':'')+'</td>'+
        '<td style="text-align:right"><button class="btn btn-sm" data-w="'+w+'">Ver</button></td></tr>';
    }).join("")+'</tbody></table></div>':'<div class="empty">Aún no hay semanas guardadas.</div>';
  var foot=(vacias?'<button class="btn" id="limpHist">Limpiar '+vacias+' vacía(s)</button>':'')+'<button class="btn" id="closeHist">Cerrar</button>';
  modal("Historial de horarios","Semanas registradas en el sistema. Las semanas sin turnos asignados se pueden limpiar.",body,null,foot);
  $$("#modal [data-w]").forEach(function(b){b.addEventListener("click",function(){
    S.semanaActual=new Date(b.getAttribute("data-w")+"T00:00:00");cerrarModal();pintarSemana();});});
  var lh=$("#limpHist");if(lh)lh.addEventListener("click",function(){
    var n=limpiarHistorialVacias();
    cerrarModal();pintarSemana();
    toast(n?("Se limpiaron "+n+" semana(s) vacía(s)"):"No había semanas vacías","ok");
  });
  var ch=$("#closeHist");if(ch)ch.addEventListener("click",cerrarModal);
}

/* ============================================================
   VISTA · NÓMINA
   ============================================================ */
function viewNomina(v){
  var card=el("div",{class:"card"});
  card.innerHTML='<div class="card-head"><div><h2>Nómina</h2>'+
    '<p class="sub">Genera recibos de nómina y finiquitos, y captura el ajuste de retardos por colaborador.</p></div></div>'+
    '<div class="subtabs">'+
      '<button data-sub="recibos">Recibos</button>'+
      '<button data-sub="finiquitos">Finiquitos</button>'+
      '<button data-sub="retardos">Ajuste de retardos</button>'+
    '</div>'+
    '<div id="nomSubHost"></div>';
  v.appendChild(card);
  $$("#view [data-sub]").forEach(function(b){
    b.classList.toggle("active",b.getAttribute("data-sub")===S.nomSub);
    b.addEventListener("click",function(){S.nomSub=b.getAttribute("data-sub");
      $$("#view [data-sub]").forEach(function(x){x.classList.toggle("active",x===b);});
      pintarNomSub();});
  });
  pintarNomSub();
}
function pintarNomSub(){
  var host=$("#nomSubHost");if(!host)return;host.innerHTML="";
  if(S.nomSub==="finiquitos")subFiniquitos(host);
  else if(S.nomSub==="retardos")subRetardos(host);
  else subRecibosNom(host);
}
function subRecibosNom(host){
  host.innerHTML='<div class="nom-toolbar">'+
      '<div class="nt-group">'+
        '<span class="lbl">Periodo base</span>'+
        '<div class="nt-chips">'+
        Object.keys(PERIODOS).map(function(p){return '<span class="chip2" data-p="'+p+'">'+PERIODOS[p].nom+'</span>';}).join("")+
        '</div>'+
      '</div>'+
      '<div class="nt-group nt-right">'+
        campoInline("Inicio por defecto","nom-ini",fechaISO(S.semanaActual),"date")+
        '<button class="btn btn-sm" id="prnAll">Imprimir todos</button>'+
      '</div>'+
    '</div>'+
    '<div class="nom-grid"><div><label class="lbl">Colaboradores activos</label><div class="emp-list" id="empList"></div></div>'+
    '<div id="nomDetail"></div></div>';
  $$("#nomSubHost [data-p]").forEach(function(c){c.classList.toggle("active",c.getAttribute("data-p")===S.nomPeriodo);
    c.addEventListener("click",function(){S.nomPeriodo=c.getAttribute("data-p");S.nomDraft=null;
      $$("#nomSubHost [data-p]").forEach(function(x){x.classList.toggle("active",x===c);});recalcular();});});
  $("#nom-ini").addEventListener("change",function(){S.nomDraft=null;recalcular();});
  $("#prnAll").addEventListener("click",function(){imprimirTodos();});
  var lista=colsDeSucursal();
  if((!S.nomEmpId||!lista.some(function(c){return c.id===S.nomEmpId;}))&&lista[0])S.nomEmpId=lista[0].id;
  pintarEmpList();
  recalcular();
}
function colsBranchTodos(){
  var su=sucursalActiva(), n=su.nombre, id=su.id;
  return S.colaboradores.filter(function(c){return !c.sucursal&&!c.sucursalId||c.sucursal===n||c.sucursal===id||c.sucursalId===id||c.sucursalId===n;});
}
function subFiniquitos(host){
  host.innerHTML='<p class="sub" style="margin:2px 0 12px">Selecciona un colaborador (incluye dados de baja) y calcula su finiquito. Al guardarlo aparece en Recibos.</p>'+
    '<div class="nom-grid"><div><label class="lbl">Colaboradores</label><div class="emp-list" id="finList"></div></div>'+
    '<div id="nomDetail"></div></div>';
  var lista=colsBranchTodos();
  var fl=$("#finList");
  if(!lista.length){fl.innerHTML='<div class="empty">Sin colaboradores en esta sucursal.</div>';}
  lista.forEach(function(c){
    var it=el("div",{class:"emp-item"+(c.id===S.nomEmpId?" active":"")});
    var ini=c.nombre.split(" ").slice(0,2).map(function(w){return w[0];}).join("");
    it.innerHTML='<div class="av">'+esc(ini)+'</div><div><div class="nm">'+esc(c.nombre)+
      (c.estado==="baja"?' <span class="badge-est baja" style="font-size:9px">baja</span>':'')+
      '</div><div class="rl">'+esc(c.puesto||"")+'</div></div>';
    it.addEventListener("click",function(){S.nomEmpId=c.id;abrirFiniquito(c);});
    fl.appendChild(it);
  });
  if(S.nomDraft&&S.nomDraft.tipoDoc==="finiquito"&&S.nomEmpId===S.nomDraft.colId)recalcular();
  else $("#nomDetail").innerHTML='<div class="empty">'+ICON.doc+'Elige un colaborador para calcular su finiquito.</div>';
}

/* ---- Ajuste de retardos + reporte ---- */
function regRet(colId,fISO){
  if(!S.retardos[fISO])S.retardos[fISO]={};
  if(!S.retardos[fISO][colId])S.retardos[fISO][colId]={h:0,m:0,eReal:"",sReal:"",sDesc:"",eDesc:"",manualDif:null,falta:false};
  return S.retardos[fISO][colId];
}
function horarioAsignadoTxt(colId,fISO){
  var f=new Date(fISO+"T00:00:00"),lun=lunesDe(f),k=fechaISO(lun),di=(f.getDay()+6)%7;
  var arr=((S.horarios[k]||{})[colId]||{})[di]||[];
  if(!arr.length)return "—";
  return arr.map(function(s){var t=TURNOS[s.tipo]||{};return t.especial?t.nom:(s.ini+"–"+s.fin);}).join(" / ");
}
function turnosAsignadosDia(colId,fISO){
  var f=new Date(fISO+"T00:00:00"),lun=lunesDe(f),k=fechaISO(lun),di=(f.getDay()+6)%7;
  return (((S.horarios[k]||{})[colId]||{})[di]||[]).filter(function(s){return s&&s.ini&&s.fin&&!((TURNOS[s.tipo]||{}).especial);});
}
function descansoTurnoMin(min){return min>=480?40:(min>0?20:0);}
function asignadoMinDia(colId,fISO){
  var t=0;turnosAsignadosDia(colId,fISO).forEach(function(s){var m=horasEntre(s.ini,s.fin)*60;t+=Math.max(0,m-descansoTurnoMin(m));});return t;
}
function regRetTurno(colId,fISO,i){
  var r=regRet(colId,fISO);r.turnos=r.turnos||{};
  if(!r.turnos[i])r.turnos[i]={h:0,m:0,eReal:"",sReal:"",sDesc:"",eDesc:"",manualDif:null,falta:false};
  return r.turnos[i];
}
function valorManualDif(r){
  return r&&r.manualDif!==""&&r.manualDif!=null&&!isNaN(Number(r.manualDif))?Number(r.manualDif):null;
}
function realMinDia(r){
  if(r&&r.falta)return 0;
  if(r&&!r.eReal&&!r.sReal)return 0;
  if(!r.eReal||!r.sReal)return null;
  var w=minutos(r.sReal)-minutos(r.eReal);
  if(r.sDesc&&r.eDesc)w-=Math.max(0,minutos(r.eDesc)-minutos(r.sDesc));
  else w-=descansoTurnoMin(w);
  return w;
}
function diferenciaMinTurno(sh,r){
  var real=realMinDia(r), asig=Math.max(0,horasEntre(sh.ini,sh.fin)*60-descansoTurnoMin(horasEntre(sh.ini,sh.fin)*60));
  if(r&&r.falta)return -asig;
  var manual=valorManualDif(r);if(manual!=null)return manual;
  if(r&&!r.eReal&&!r.sReal)return 0;
  if(real==null){var rm=(Number(r.h)||0)*60+(Number(r.m)||0);return rm?-rm:0;}
  return real-asig;
}
function diferenciaMinDia(colId,fISO){
  var turnos=turnosAsignadosDia(colId,fISO);
  if(turnos.length){
    var total=0;turnos.forEach(function(sh,i){total+=diferenciaMinTurno(sh,regRetTurno(colId,fISO,i));});return total;
  }
  var r=regRet(colId,fISO),real=realMinDia(r);
  if(real==null){var rm=(Number(r.h)||0)*60+(Number(r.m)||0);return rm?-rm:0;}
  return real-asignadoMinDia(colId,fISO);
}
function fmtDifMin(min){
  var s=min<0?"−":(min>0?"+":"");var a=Math.abs(min);
  return s+Math.floor(a/60)+"h "+(a%60)+"m";
}
function horasFmtMin(min){return ((Number(min)||0)/60).toFixed(2)+" h";}
function ajusteRetardosMinPeriodo(colId,iniISO,dias){
  var ini=new Date((iniISO||fechaISO(inicioPeriodo()))+"T00:00:00"),tot=0;
  for(var i=0;i<dias;i++)tot+=diferenciaMinDia(colId,fechaISO(sumaDias(ini,i)));
  return tot;
}
function retardoDeduccionMinPeriodo(colId,iniISO,dias){
  return Math.max(0,-ajusteRetardosMinPeriodo(colId,iniISO,dias));
}
function retardoExtraMinPeriodo(colId,iniISO,dias){
  return Math.max(0,ajusteRetardosMinPeriodo(colId,iniISO,dias));
}
function setRetardoSinDiferencia(colId,iniISO,finISO,k){
  diasDeRango(iniISO,finISO).forEach(function(fISO){
    var turnos=turnosAsignadosDia(colId,fISO);
    if(!turnos.length)return;
    turnos.forEach(function(sh,i){
      var r=regRetTurno(colId,fISO,i);
      if(k==="eReal")r.eReal=sh.ini||"";
      if(k==="sReal")r.sReal=sh.fin||"";
      r.falta=false;
      r.manualDif=null;
    });
  });
  S.nomDraft=null;pintarRetTabla();
}
function subRetardos(host){
  if(!S.retIni||!S.retFin){S.retIni=fechaISO(S.semanaActual);S.retFin=fechaISO(sumaDias(S.semanaActual,6));}
  var lista=colsBranchTodos();
  if(!S.retEmpId||!lista.some(function(c){return c.id===S.retEmpId;}))S.retEmpId=(lista[0]||{}).id||null;
  host.innerHTML='<div class="ret-panel">'+
    '<div class="ret-filters">'+
      '<div class="ret-filter-main"><div class="field"><label>Colaborador</label><select id="retCol">'+
        lista.map(function(c){return '<option value="'+c.id+'"'+(c.id===S.retEmpId?" selected":"")+'>'+esc(c.nombre)+'</option>';}).join("")+'</select></div>'+
      '<div class="field"><label>Desde</label><input type="date" id="retIni" value="'+esc(S.retIni)+'"></div>'+
      '<div class="field"><label>Hasta</label><input type="date" id="retFin" value="'+esc(S.retFin)+'"></div>'+
      '<button class="btn btn-sm" id="retPdf">'+ICON.doc+' PDF</button>'+
      '<button class="btn btn-sm" id="retXls">'+ICON.xls+' Excel</button></div>'+
      '<div class="ret-filter-secondary">'+
      '<button class="btn btn-sm ret-nodiff" id="retNoEnt">Sin Diferencia Entrada</button>'+
      '<button class="btn btn-sm ret-nodiff" id="retNoSal">Sin Diferencia Salida</button></div>'+
    '</div>'+
    '<div id="retHost"></div>'+
    '<div class="ret-savebar"><button class="btn btn-ok" id="retSave">Guardar retardos</button></div>';
  $("#retCol").addEventListener("change",function(){S.retEmpId=this.value;pintarRetTabla();});
  $("#retIni").addEventListener("change",function(){S.retIni=this.value;pintarRetTabla();});
  $("#retFin").addEventListener("change",function(){S.retFin=this.value;pintarRetTabla();});
  $("#retSave").addEventListener("click",function(){var b=this;b.disabled=true;b.textContent="Guardando…";
    DataStore.guardarRetardos(S.retardos).then(function(d){b.disabled=false;b.textContent="Guardar";
      if(d&&!d.error)toast("Retardos guardados","ok");}).catch(function(){b.disabled=false;b.textContent="Guardar";});});
  $("#retNoEnt").addEventListener("click",function(){setRetardoSinDiferencia(S.retEmpId,S.retIni,S.retFin,"eReal");});
  $("#retNoSal").addEventListener("click",function(){setRetardoSinDiferencia(S.retEmpId,S.retIni,S.retFin,"sReal");});
  $("#retPdf").addEventListener("click",exportarRetardosPDF);
  $("#retXls").addEventListener("click",exportarRetardosXLS);
  pintarRetTabla();
}
function diasDeRango(iniISO,finISO){
  var a=new Date(iniISO+"T00:00:00"),b=new Date(finISO+"T00:00:00"),out=[];
  if(b<a)return out;
  for(var d=new Date(a);d<=b;d.setDate(d.getDate()+1))out.push(fechaISO(d));
  return out;
}
function pintarRetTabla(){
  var host=$("#retHost");if(!host)return;
  var c=S.colaboradores.filter(function(x){return x.id===S.retEmpId;})[0];
  if(!c){host.innerHTML='<div class="empty">Selecciona un colaborador.</div>';return;}
  var dias=diasDeRango(S.retIni,S.retFin);
  if(!dias.length){host.innerHTML='<div class="empty">Rango de fechas no válido.</div>';return;}
  var rows="",totDif=0,totAsig=0,totReal=0;
  dias.forEach(function(fISO){
    var turnos=turnosAsignadosDia(c.id,fISO);
    if(!turnos.length)turnos=[{ini:"",fin:""}];
    turnos.forEach(function(sh,i){
      var r=turnosAsignadosDia(c.id,fISO).length?regRetTurno(c.id,fISO,i):regRet(c.id,fISO);
      var asig=sh.ini?Math.max(0,horasEntre(sh.ini,sh.fin)*60-descansoTurnoMin(horasEntre(sh.ini,sh.fin)*60)):asignadoMinDia(c.id,fISO);
      var real=sh.ini?realMinDia(r):realMinDia(r);
      if(real==null)real=Math.max(0,asig+diferenciaMinTurno(sh,r));
      var dif=sh.ini?diferenciaMinTurno(sh,r):diferenciaMinDia(c.id,fISO);
      totDif+=dif;totAsig+=asig;totReal+=Math.max(0,real||0);
      rows+='<tr><td class="small">'+fechaLarga(fISO)+(turnos.length>1?'<div class="small">Turno '+(i+1)+'</div>':'')+'</td>'+
        '<td class="small">'+esc(sh.ini?sh.ini+"–"+sh.fin:"—")+'</td>'+
        tdTime(fISO,"eReal",r.eReal,i)+tdTime(fISO,"sReal",r.sReal,i)+
        tdTime(fISO,"sDesc",r.sDesc,i)+tdTime(fISO,"eDesc",r.eDesc,i)+
        '<td class="tabular">'+horasFmtMin(asig)+'</td><td class="tabular">'+horasFmtMin(real)+'</td>'+
        '<td><div class="ret-hm"><input type="number" class="ret-n ret-dif" data-f="'+fISO+'" data-i="'+i+'" data-k="manualDif" value="'+dif+'" title="Minutos; negativos descuentan, positivos pagan">'+
        '<b>'+fmtDifMin(dif)+'</b></div></td></tr>';
    });
  });
  host.innerHTML='<div class="table-wrap"><table class="data ret-table"><thead><tr>'+
    '<th>Día</th><th>Horario Asignado</th><th>Entrada Real</th><th>Salida Real</th><th>Salida Descanso</th><th>Entrada Descanso</th><th>Horas Asignadas</th><th>Horas Reales</th><th>Diferencia Real</th>'+
    '</tr></thead><tbody>'+rows+
    '<tr class="ret-tot"><td colspan="6" style="text-align:right;font-weight:700">Total general</td>'+
    '<td class="tabular" style="font-weight:700">'+horasFmtMin(totAsig)+'</td>'+
    '<td class="tabular" style="font-weight:700">'+horasFmtMin(totReal)+'</td>'+
    '<td class="tabular" style="font-weight:700">'+fmtDifMin(totDif)+'</td></tr>'+
    '</tbody></table></div>';
  $$("#retHost input[data-f]").forEach(function(inp){
    inp.addEventListener("change",function(){
      var r=regRet(S.retEmpId,inp.getAttribute("data-f")),k=inp.getAttribute("data-k");
      if(inp.hasAttribute("data-i"))r=regRetTurno(S.retEmpId,inp.getAttribute("data-f"),inp.getAttribute("data-i"));
      r[k]=inp.type==="checkbox"?inp.checked:(inp.type==="number"?(inp.value===""?null:(+inp.value||0)):inp.value);
      if(k==="eReal"||k==="sReal"||k==="sDesc"||k==="eDesc")r.manualDif=null;
      S.nomDraft=null;pintarRetTabla();
    });
  });
}
function tdTime(fISO,k,val,i){return '<td><input type="time" class="ret-t" data-f="'+fISO+'"'+(i!=null?' data-i="'+i+'"':'')+' data-k="'+k+'" value="'+esc(val||"")+'"></td>';}
function retardoFilas(){
  var c=S.colaboradores.filter(function(x){return x.id===S.retEmpId;})[0];if(!c)return {nombre:"",filas:[],total:0,totalAsig:0,totalReal:0};
  var dias=diasDeRango(S.retIni,S.retFin),filas=[],tot=0,totAsig=0,totReal=0;
  dias.forEach(function(fISO){
    var turnos=turnosAsignadosDia(c.id,fISO);if(!turnos.length)turnos=[{ini:"",fin:""}];
    turnos.forEach(function(sh,i){
      var r=sh.ini?regRetTurno(c.id,fISO,i):regRet(c.id,fISO),asig=sh.ini?Math.max(0,horasEntre(sh.ini,sh.fin)*60-descansoTurnoMin(horasEntre(sh.ini,sh.fin)*60)):asignadoMinDia(c.id,fISO);
      var real=realMinDia(r),dif=sh.ini?diferenciaMinTurno(sh,r):diferenciaMinDia(c.id,fISO);
      if(real==null)real=Math.max(0,asig+dif);
      tot+=dif;totAsig+=asig;totReal+=Math.max(0,real||0);
      filas.push({dia:fechaLarga(fISO)+(turnos.length>1?" · Turno "+(i+1):""),asignado:sh.ini?sh.ini+"–"+sh.fin:"—",eReal:r.eReal||"",sReal:r.sReal||"",sDesc:r.sDesc||"",eDesc:r.eDesc||"",asig:horasFmtMin(asig),real:horasFmtMin(real),dif:fmtDifMin(dif)});
    });
  });
  return {nombre:c.nombre,filas:filas,total:fmtDifMin(tot),totalAsig:horasFmtMin(totAsig),totalReal:horasFmtMin(totReal)};
}
function printIsolado(){
  var area=$("#printarea");
  if(!area){window.print();return;}
  var parent=area.parentNode, next=area.nextSibling;
  try{document.body.appendChild(area);}catch(e){}
  document.body.classList.add("printing-iso");
  if(document.documentElement)document.documentElement.classList.add("printing-iso");
  var restored=false;
  function restore(){
    if(restored)return;restored=true;
    document.body.classList.remove("printing-iso");
    if(document.documentElement)document.documentElement.classList.remove("printing-iso");
    try{ if(next&&next.parentNode===parent){parent.insertBefore(area,next);} else if(parent){parent.appendChild(area);} }catch(e){}
    try{window.removeEventListener("afterprint",restore);}catch(e){}
  }
  try{window.addEventListener("afterprint",restore);}catch(e){}
  setTimeout(restore,5000);
  window.print();
  setTimeout(restore,0);
}
function exportarRetardosPDF(){
  var R=retardoFilas();if(!R.filas.length){toast("Sin datos","err");return;}
  var rows=R.filas.map(function(f){return '<tr><td>'+esc(R.nombre)+'</td><td>'+esc(f.dia)+'</td><td>'+esc(f.asignado)+'</td><td>'+esc(f.eReal)+'</td><td>'+esc(f.sReal)+'</td><td>'+esc(f.sDesc)+'</td><td>'+esc(f.eDesc)+'</td><td>'+esc(f.asig)+'</td><td>'+esc(f.real)+'</td><td style="text-align:right">'+esc(f.dif)+'</td></tr>';}).join("");
  var html='<div class="rep-print ret-print">'+
    '<div class="ret-print-head">'+
      '<div class="ret-print-logo"><img src="'+LIENZO_IMG_RECIBO+'" alt="Lienzo Librería"></div>'+
      '<div class="ret-print-meta">'+
        '<h2 style="font-family:Space Grotesk">REPORTE DE ENTRADAS Y SALIDAS</h2>'+
        '<h3>'+esc(R.nombre)+'</h3>'+
        '<p>Periodo: '+esc(fechaLarga(S.retIni))+' a '+esc(fechaLarga(S.retFin))+'</p>'+
      '</div>'+
    '</div>'+
    '<table style="width:100%;border-collapse:collapse"><thead><tr><th>Colaborador</th><th>Día</th><th>Horario Asignado</th><th>Entrada Real</th><th>Salida Real</th><th>Salida Descanso</th><th>Entrada Descanso</th><th>Horas Asignadas</th><th>Horas Reales</th><th style="text-align:right">Diferencia</th></tr></thead>'+
    '<tbody>'+rows+'</tbody><tfoot><tr><td colspan="7" style="text-align:right;font-weight:700">Total general</td><td>'+esc(R.totalAsig)+'</td><td>'+esc(R.totalReal)+'</td><td style="text-align:right;font-weight:700">'+esc(R.total)+'</td></tr></tfoot></table>'+
    '<div class="ret-print-firma">____________________________<br>Firma del colaborador</div></div>';
  var area=$("#printarea");area.className="print-only print-retardos";area.innerHTML=html;setPrintPageStyle("retardos");printIsolado();
}
function exportarRetardosXLS(){
  var R=retardoFilas();if(!R.filas.length){toast("Sin datos","err");return;}
  var rows=R.filas.map(function(f){return '<tr><td>'+esc(R.nombre)+'</td><td>'+esc(f.dia)+'</td><td>'+esc(f.asignado)+'</td><td>'+esc(f.eReal)+'</td><td>'+esc(f.sReal)+'</td><td>'+esc(f.sDesc)+'</td><td>'+esc(f.eDesc)+'</td><td>'+esc(f.asig)+'</td><td>'+esc(f.real)+'</td><td>'+esc(f.dif)+'</td></tr>';}).join("");
  var tabla='<h2>REPORTE DE ENTRADAS Y SALIDAS</h2><table><thead><tr><th>Colaborador</th><th>Día</th><th>Horario Asignado</th><th>Entrada Real</th><th>Salida Real</th><th>Salida Descanso</th><th>Entrada Descanso</th><th>Horas Asignadas</th><th>Horas Reales</th><th>Diferencia</th></tr></thead><tbody>'+rows+'<tr><td colspan="7">Total general</td><td>'+esc(R.totalAsig)+'</td><td>'+esc(R.totalReal)+'</td><td>'+esc(R.total)+'</td></tr><tr><td colspan="10" style="height:60px;text-align:center">Firma del colaborador: ____________________________</td></tr></tbody></table>';
  var xls='<html xmlns:x="urn:schemas-microsoft-com:office:excel"><head><meta charset="utf-8"></head><body>'+tabla+'</body></html>';
  var blob=new Blob(["\ufeff"+xls],{type:"application/vnd.ms-excel"});
  var url=(window.URL||window.webkitURL).createObjectURL(blob);
  var a=document.createElement("a");a.href=url;a.download="retardos-"+(R.nombre||"colaborador").replace(/\s+/g,"_")+".xls";document.body.appendChild(a);a.click();a.remove();
  setTimeout(function(){(window.URL||window.webkitURL).revokeObjectURL(url);},1500);
  toast("Archivo .xls generado","ok");
}

function pintarEmpList(){
  var host=$("#empList");if(!host)return;host.innerHTML="";
  var lista=colsDeSucursal();
  if(!lista.length){host.innerHTML='<div class="empty">Sin colaboradores activos en esta sucursal.</div>';return;}
  lista.forEach(function(c){
    var it=el("div",{class:"emp-item"+(c.id===S.nomEmpId?" active":"")});
    var ini=c.nombre.split(" ").slice(0,2).map(function(w){return w[0];}).join("");
    it.innerHTML='<div class="av">'+esc(ini)+'</div><div><div class="nm">'+esc(c.nombre)+'</div><div class="rl">'+esc(c.puesto||"")+'</div></div>';
    it.addEventListener("click",function(){
      S.nomEmpId=c.id;S.nomDraft=null;
      pintarEmpList();recalcular();
    });
    host.appendChild(it);
  });
}

/* ---- Motor de cálculo ---- */
function diasDelPeriodo(){return PERIODOS[S.nomPeriodo].dias;}
function inicioPeriodo(){return new Date(($("#nom-ini")?$("#nom-ini").value:fechaISO(S.semanaActual))+"T00:00:00");}
function diasEntre(iniISO,finISO){var a=new Date(iniISO+"T00:00:00"),b=new Date(finISO+"T00:00:00");
  return Math.max(1,Math.round((b-a)/86400000)+1);}

function horasTrabajadasPeriodo(colId,iniISO,dias){
  var ini=new Date((iniISO||fechaISO(inicioPeriodo()))+"T00:00:00"), total=0;
  for(var i=0;i<dias;i++){
    var f=sumaDias(ini,i), k=fechaISO(lunesDe(f)), di=(f.getDay()+6)%7;
    (((S.horarios[k]||{})[colId]||{})[di]||[]).forEach(function(s){
      if(s.ini&&s.fin&&!((TURNOS[s.tipo]||{}).especial))total+=horasEntre(s.ini,s.fin);
    });
  }
  return total;
}
function sueldoBasePeriodo(c,dias,iniBaseISO){
  dias=dias||diasDelPeriodo();
  var iniISO=iniBaseISO||fechaISO(inicioPeriodo());
  if(c.tipoSueldo==="hora"){
    // Horas asignadas NETAS: el tiempo de descanso NO cuenta como laborado.
    var iniN=new Date(iniISO+"T00:00:00"), netMin=0;
    for(var i=0;i<dias;i++){ netMin += asignadoMinDia(c.id, fechaISO(sumaDias(iniN,i))); }
    // Ajuste de retardos: días sin capturar no penalizan (diferencia 0); solo restan los déficits capturados.
    var ajuste=ajusteRetardosMinPeriodo(c.id,iniISO,dias);
    var horas=Math.max(0,(netMin+Math.min(0,ajuste))/60);
    return (c.sueldo||0)*horas;
  }
  if(c.tipoSueldo==="semana") return (c.sueldo||0)*(dias/7);
  // mensual -> diario = mes/30
  return (c.sueldo||0)*(dias/30);
}
function pagoHora(c){
  var hs=c.horasObjetivo||48;
  if(c.tipoSueldo==="hora") return c.sueldo||0;
  if(c.tipoSueldo==="semana") return (c.sueldo||0)/(hs||1);
  return (c.sueldo||0)/((hs||48)*4.345); // mensual
}
/* Retardos: minutos por día/colaborador y suma del periodo */
function retardoMinDia(colId,fISO){
  return Math.max(0,-diferenciaMinDia(colId,fISO));
}
function retardosMinPeriodo(colId,iniISO,dias){
  return retardoDeduccionMinPeriodo(colId,iniISO,dias);
}
/* Escanea el periodo: cuenta días de descanso, días con turno real, horas y retardos */
function escanearPeriodo(colId,iniISO,dias){
  var ini=new Date((iniISO||fechaISO(inicioPeriodo()))+"T00:00:00");
  var nDesc=0,nCumple=0,nPermiso=0,diasConTurno=0,horas=0,retMin=0;
  for(var i=0;i<dias;i++){
    var f=sumaDias(ini,i), lun=lunesDe(f), k=fechaISO(lun), di=(f.getDay()+6)%7; // 0=lunes
    var arr=((S.horarios[k]||{})[colId]||{})[di]||[];
    retMin+=retardoMinDia(colId,fechaISO(f));
    var tieneTurno=false;
    arr.forEach(function(s){
      if(s.tipo==="descanso")nDesc++;
      else if(s.tipo==="cumpleanos")nCumple++;
      else if(s.tipo==="permiso")nPermiso++;
      else { tieneTurno=true; horas+=horasEntre(s.ini,s.fin); }
    });
    if(tieneTurno)diasConTurno++;
  }
  return {nDesc:nDesc,nCumple:nCumple,nPermiso:nPermiso,diasConTurno:diasConTurno,horas:horas,retMin:retMin};
}
/* Regla de descanso POR COLABORADOR (con respaldo a la configuración global) */
function reglaDescanso(c){
  var g=S.config.descanso||DESCANSO_DEFAULT;
  return {
    regla: c.descansoRegla || g.regla || "promedio_horas",
    monto: (c.descansoMonto!=null? c.descansoMonto : (g.monto||0))
  };
}
function montoDescanso(c,iniISO,dias){
  var rg=reglaDescanso(c);
  var ini=new Date((iniISO||fechaISO(inicioPeriodo()))+"T00:00:00"), end=sumaDias(ini,dias-1);
  var total=0,nDesc=0,partes=[];
  for(var w=lunesDe(ini);w<=end;w=sumaDias(w,7)){
    var wh=0,wret=0,wdias=0,wdesc=0;
    for(var d=0;d<7;d++){
      var f=sumaDias(w,d);if(f<ini||f>end)continue;
      var fISO=fechaISO(f), k=fechaISO(lunesDe(f)), di=(f.getDay()+6)%7, arr=((S.horarios[k]||{})[c.id]||{})[di]||[];
      var tiene=false;
      arr.forEach(function(s){
        if(s.tipo==="descanso")wdesc++;
        else if(s.ini&&s.fin&&!((TURNOS[s.tipo]||{}).especial)){tiene=true;wh+=horasEntre(s.ini,s.fin);}
      });
      if(tiene)wdias++;
      wret+=retardoMinDia(c.id,fISO)/60;
    }
    if(!wdesc)continue;
    nDesc+=wdesc;
    if(rg.regla==="monto_fijo"){
      total+=(rg.monto||0)*wdesc;
      partes.push(money(rg.monto||0)+" × "+wdesc);
    }else{
      var avg=wdias?Math.max(0,(wh-wret)/wdias):0;
      total+=avg*pagoHora(c)*wdesc;
      partes.push("sem "+fechaISO(w)+": "+avg.toFixed(2)+"h × "+wdesc);
    }
  }
  if(!nDesc)return {n:0,total:0,detalle:"sin descansos"};
  return {n:nDesc,total:Math.round(total*100)/100,detalle:partes.join(" · ")};
}
function horasDiaSemana(colId,weekKey){
  var data=(S.horarios[semanaKey(weekKey)]||{})[colId]||{}, out=[];
  for(var d=0;d<7;d++){
    var h=0;
    (data[d]||[]).forEach(function(s){if(s.ini&&s.fin&&!((TURNOS[s.tipo]||{}).especial))h+=horasEntre(s.ini,s.fin);});
    if(h>0)out.push(h);
  }
  return out;
}
function montoCumpleanos(c,iniISO,dias){
  var ini=new Date((iniISO||fechaISO(inicioPeriodo()))+"T00:00:00"), n=0,total=0;
  for(var i=0;i<dias;i++){
    var f=sumaDias(ini,i), k=fechaISO(lunesDe(f)), di=(f.getDay()+6)%7;
    (((S.horarios[k]||{})[c.id]||{})[di]||[]).forEach(function(s){
      if(s.tipo==="cumpleanos"){
        n++;
        total+=(modoHoras(horasDiaSemana(c.id,k))||0)*pagoHora(c);
      }
    });
  }
  return {n:n,total:Math.round(total*100)/100};
}
/* Día festivo: pago EXTRA por cada festivo trabajado en el periodo.
   total = salario diario × (pct/100) × nº de festivos trabajados.
   Solo cuenta festivos obligatorios salvo que la configuración active los cívicos. */
function montoFestivo(c,iniISO,dias){
  var cfg=S.config.festivo||FESTIVO_DEFAULT;
  var pct=(cfg.pct!=null?cfg.pct:100);
  var ini=new Date((iniISO||fechaISO(inicioPeriodo()))+"T00:00:00");
  var n=0,nombres=[];
  for(var i=0;i<dias;i++){
    var f=sumaDias(ini,i), lun=lunesDe(f), k=fechaISO(lun), di=(f.getDay()+6)%7;
    var fes=festivoDe(fechaISO(f));
    if(!fes)continue;
    if(fes.tipo!=="obligatorio" && !cfg.civicos)continue;
    var arr=((S.horarios[k]||{})[c.id]||{})[di]||[];
    var trabajo=false;
    arr.forEach(function(s){ if(s.ini&&s.fin&&!((TURNOS[s.tipo]||{}).especial))trabajo=true; });
    if(trabajo){ n++; nombres.push(fes.nombre); }
  }
  var diario=diarioDe(c);
  var total=diario*(pct/100)*n;
  return {n:n,total:Math.round(total*100)/100,pct:pct,nombres:nombres,
    detalle:n?(money(diario)+" × "+pct+"% × "+n+" festivo(s)"):"sin festivos trabajados"};
}
function horasDomingoPeriodo(colId,iniISO,dias){
  var ini=new Date((iniISO||fechaISO(inicioPeriodo()))+"T00:00:00"), h=0;
  for(var i=0;i<dias;i++){
    var f=sumaDias(ini,i);if(f.getDay()!==0)continue;
    var k=fechaISO(lunesDe(f)), di=(f.getDay()+6)%7, arr=((S.horarios[k]||{})[colId]||{})[di]||[];
    arr.forEach(function(s){if(s.ini&&s.fin&&!((TURNOS[s.tipo]||{}).especial))h+=horasEntre(s.ini,s.fin);});
  }
  return h;
}
function montoPrimaDominical(c,iniISO,dias){
  var h=horasDomingoPeriodo(c.id,iniISO,dias), total=h*pagoHora(c)*0.25;
  return {horas:h,total:Math.round(total*100)/100};
}
function horasPorDiaPrevias(colId,fechaISOBase,n){
  var out=[], end=fechaLocal(fechaISOBase);
  for(var i=1;i<=n;i++){
    var f=sumaDias(end,-i), k=fechaISO(lunesDe(f)), di=(f.getDay()+6)%7, h=0;
    (((S.horarios[k]||{})[colId]||{})[di]||[]).forEach(function(s){if(s.ini&&s.fin&&!((TURNOS[s.tipo]||{}).especial))h+=horasEntre(s.ini,s.fin);});
    if(h>0)out.push(h);
  }
  return out;
}
function vacacionesPeriodo(c,iniISO,dias){
  var ini=new Date((iniISO||fechaISO(inicioPeriodo()))+"T00:00:00"), n=0,total=0;
  for(var i=0;i<dias;i++){
    var f=sumaDias(ini,i), fISO=fechaISO(f), k=fechaISO(lunesDe(f)), di=(f.getDay()+6)%7;
    (((S.horarios[k]||{})[c.id]||{})[di]||[]).forEach(function(s){
      if(s.tipo==="vacaciones"){
        n++;
        var moda=modoHoras(horasPorDiaPrevias(c.id,fISO,15))||8;
        total+=moda*pagoHora(c);
      }
    });
  }
  return {n:n,total:Math.round(total*100)/100};
}
function horasEfectivasSemana(colId,weekKey){
  var data=(S.horarios[semanaKey(weekKey)]||{})[colId]||{}, h=0, ret=0;
  for(var d=0;d<7;d++){
    var fISO=fechaISO(sumaDias(new Date(semanaKey(weekKey)+"T00:00:00"),d));
    (data[d]||[]).forEach(function(s){if(s.ini&&s.fin&&!((TURNOS[s.tipo]||{}).especial))h+=horasEntre(s.ini,s.fin);});
    ret+=retardoMinDia(colId,fISO)/60;
  }
  return Math.max(0,h-ret);
}
function montoHorasExtra(c,iniISO,dias){
  var extra=retardoExtraMinPeriodo(c.id,iniISO,dias)/60, total=0, hn=0,hd=0,ht=0;
  var dob=Math.min(extra,9), tri=Math.max(0,extra-9);
  hd=dob;ht=tri;total=dob*pagoHora(c)*2+tri*pagoHora(c)*3;
  return {normal:hn,doble:hd,triple:ht,total:Math.round(total*100)/100};
}
function diasLaboradosAguinaldo(c,year){
  var start=new Date(year,0,1), end=new Date(year,11,31), ing=c.ingreso?fechaLocal(c.ingreso):start;
  if(ing>start)start=ing;
  var baja=c.bajaFecha?fechaLocal(c.bajaFecha):null;if(baja&&baja<end)end=baja;
  var dias=Math.max(0,diasEntre(fechaISO(start),fechaISO(end))), permisos=0;
  for(var d=new Date(start);d<=end;d=sumaDias(d,1)){
    var k=fechaISO(lunesDe(d)), di=(d.getDay()+6)%7;
    (((S.horarios[k]||{})[c.id]||{})[di]||[]).forEach(function(s){if(s.tipo==="permiso")permisos++;});
  }
  return Math.max(0,dias-permisos);
}
function periodoAguinaldoDefault(c,fechaPagoISO){
  var fin=fechaPagoISO||fechaISO(new Date()), y=+fin.slice(0,4), ene=fechaISO(new Date(y,0,1));
  var ingreso=String((c&&c.ingreso)||"").slice(0,10);
  var reing=String((c&&c.reingresoFecha)||"").slice(0,10);
  // Reconoce el reingreso: si reingresó después del ingreso original, esa es la antigüedad vigente.
  var efectivo=(reing&&reing>ingreso)?reing:ingreso;
  var ini=(efectivo&&+efectivo.slice(0,4)===y)?efectivo:ene;
  return {ini:ini,fin:fin};
}
function aguinaldoPermitido(c,fechaPagoISO){
  var fin=fechaPagoISO||fechaISO(new Date()), pago=fechaLocal(fin);
  return !S.nominas.some(function(r){
    if(r.colId!==c.id)return false;
    var f=r.fecha||r.fin||r.createdAt||"";if(!f)return false;
    var d=fechaLocal(String(f).slice(0,10));if(isNaN(d.getTime()))return false;
    var tiene=(r.lineas||r.per||[]).some(function(l){return l.clave==="AGUINALDO"||/aguinaldo/i.test(l.nom||"");});
    return tiene&&Math.abs((pago-d)/86400000)<183;
  });
}
function montoAguinaldo(c,fechaPagoISO,iniISO,finISO){
  var per=periodoAguinaldoDefault(c,fechaPagoISO);
  iniISO=iniISO||per.ini;finISO=finISO||per.fin;
  var dias=diasEntre(iniISO,finISO), asignados=0, permisos=0, horas=0, diasHoras=0;
  for(var i=0;i<dias;i++){
    var f=fechaLocal(iniISO);f.setDate(f.getDate()+i);
    var k=fechaISO(lunesDe(f)), di=(f.getDay()+6)%7, arr=((S.horarios[k]||{})[c.id]||{})[di]||[], tiene=false, hDia=0;
    arr.forEach(function(s){
      if(s.tipo==="permiso")permisos++;
      if(s.ini&&s.fin&&!((TURNOS[s.tipo]||{}).especial)){tiene=true;hDia+=horasEntre(s.ini,s.fin);}
      else if(s.tipo==="descanso"||s.tipo==="cumpleanos"||s.tipo==="vacaciones")tiene=true;
    });
    if(tiene)asignados++;
    if(hDia>0){horas+=hDia;diasHoras++;}
  }
  var promedio=diasHoras?horas/diasHoras:0;
  // Días del periodo (calendario) menos permisos especiales; el promedio es por día trabajado.
  var total=(15/365)*Math.max(0,dias-permisos)*promedio*pagoHora(c);
  return Math.round(total*100)/100;
}
function recalcularAguinaldoDraft(d){
  if(!d||!d.lineas)return;
  var c=S.colaboradores.find(function(x){return x.id===d.colId;});if(!c)return;
  d.aguiInicio=d.aguiInicio||periodoAguinaldoDefault(c,d.fin||fechaISO(new Date())).ini;
  d.aguiFin=d.aguiFin||periodoAguinaldoDefault(c,d.fin||fechaISO(new Date())).fin;
  d.lineas.forEach(function(l){
    if(l.clave==="AGUINALDO"||/aguinaldo/i.test(l.nom||"")){
      l.monto=montoAguinaldo(c,d.aguiFin,d.aguiInicio,d.aguiFin);
    }
  });
}
function calcISR(gravadoPeriodo,dias){
  dias=dias||diasDelPeriodo();
  var mensual=gravadoPeriodo*(30/dias);          // a base mensual
  var r=null;for(var i=0;i<S.config.isr.length;i++){var x=S.config.isr[i];if(mensual>=x.li&&mensual<=x.ls){r=x;break;}}
  if(!r)r=S.config.isr[S.config.isr.length-1];
  var isrMensual=r.cuota+(mensual-r.li)*(r.pct/100);
  isrMensual=Math.max(0,isrMensual-(S.config.subsidio||0));
  return isrMensual*(dias/30);                     // de vuelta al periodo
}

function construirDraft(){
  var c=S.colaboradores.find(function(x){return x.id===S.nomEmpId;});
  if(!c)return null;
  // borrador de finiquito en curso para este colaborador
  if(S.nomDraft&&S.nomDraft.colId===S.nomEmpId&&S.nomDraft.tipoDoc==="finiquito")return S.nomDraft;
  var dias=diasDelPeriodo();
  var iniISO=fechaISO(inicioPeriodo());
  var finISO=fechaISO(sumaDias(inicioPeriodo(),dias-1));
  // reutiliza el borrador editado del mismo empleado/periodo
  var key=c.id+"|"+S.nomPeriodo+"|"+iniISO;
  if(S.nomDraft&&S.nomDraft._key===key)return S.nomDraft;

  var base=sueldoBasePeriodo(c,dias);
  var hrs=horasTrabajadasPeriodo(c.id,iniISO,dias);
  var lineas=[{clave:"SUELDO",nom:"Sueldo",tipo:"percepcion",grav:true,monto:Math.round(base*100)/100,fijo:true}];
  // Descansos (percepción) — visibilidad controlada desde Recibos (descansoIncluir)
  var dsc=montoDescanso(c,iniISO,dias);
  if(dsc.total>0)lineas.push({clave:"DESCANSO",nom:"Descansos",tipo:"percepcion",grav:true,monto:dsc.total,fijo:true,_descanso:true});
  var cumple=montoCumpleanos(c,iniISO,dias);
  if(cumple.total>0)lineas.push({clave:"CUMPLE",nom:"Cumpleaños ("+cumple.n+" día)",tipo:"percepcion",grav:true,monto:cumple.total,fijo:true,_cumpleanos:true});
  // Día festivo (percepción) — pago extra por trabajar festivo; el sueldo ya cubre el día normal
  var fst=montoFestivo(c,iniISO,dias);
  if(fst.total>0)lineas.push({clave:"FESTIVO",nom:"Día festivo (pago extra "+fst.pct+"%)",tipo:"percepcion",grav:true,monto:fst.total,fijo:true,_festivo:true});
  var pd=montoPrimaDominical(c,iniISO,dias);
  if(pd.total>0)lineas.push({clave:"PRIMA_DOM",nom:"Prima dominical ("+pd.horas.toFixed(1)+" h)",tipo:"percepcion",grav:false,monto:pd.total,fijo:true,_primaDom:true});
  var vac=vacacionesPeriodo(c,iniISO,dias);
  if(vac.total>0){
    lineas.push({clave:"VACAC",nom:"Vacaciones ("+vac.n+" día(s))",tipo:"percepcion",grav:true,monto:vac.total,fijo:true,_vacaciones:true});
    lineas.push({clave:"PRIMA_VAC",nom:"Prima vacacional",tipo:"percepcion",grav:false,monto:Math.round(vac.total*0.25*100)/100,fijo:true,_primaVac:true});
  }
  var ext=montoHorasExtra(c,iniISO,dias);
  if(ext.total>0)lineas.push({clave:"EXTRA",nom:"Horas extra (N "+ext.normal.toFixed(1)+" / D "+ext.doble.toFixed(1)+" / T "+ext.triple.toFixed(1)+")",tipo:"percepcion",grav:false,monto:ext.total,fijo:true,_extra:true});
  // Retardos (deducción) — opcional, controlada desde Recibos (retardosIncluir)
  var retMin=retardosMinPeriodo(c.id,iniISO,dias);
  var retMonto=Math.round((retMin/60)*pagoHora(c)*100)/100;
  if(retMonto>0)lineas.push({clave:"RETARDOS",nom:"Retardos ("+Math.floor(retMin/60)+"h "+(retMin%60)+"m)",tipo:"deduccion",monto:retMonto,fijo:true,_retardo:true});
  var descCfg=S.config.descanso||DESCANSO_DEFAULT;
  var festCfg=S.config.festivo||FESTIVO_DEFAULT;
  var draft={
    _key:key, colId:c.id, periodo:S.nomPeriodo, tipoDoc:"nomina",
    inicio:iniISO, fin:finISO, dias:dias, horas:hrs,
    lineas:lineas, isrAuto:true, imssAuto:true, isr:0, imss:0,
    isrIncluir:true, imssIncluir:true,
    descansoIncluir:(descCfg.incluir!==false), festivoIncluir:(festCfg.incluir!==false), retardosIncluir:false,
    primaDomIncluir:true, extraIncluir:true,
    aguiInicio:periodoAguinaldoDefault(c,finISO).ini, aguiFin:periodoAguinaldoDefault(c,finISO).fin
  };
  S.nomDraft=draft;
  return draft;
}
function totales(d){
  var per=0,perGrav=0,ded=0,otros=0;
  d.lineas.forEach(function(l){
    if(l._descanso && d.descansoIncluir===false) return;
    if(l._festivo  && d.festivoIncluir===false) return;
    if(l._primaDom && d.primaDomIncluir===false) return;
    if(l._extra && d.extraIncluir===false) return;
    if(l._retardo  && d.retardosIncluir!==true) return;
    var m=Number(l.monto)||0;
    if(l.tipo==="percepcion"){per+=m;if(l.grav)perGrav+=m;}
    else if(l.tipo==="deduccion")ded+=m;
    else otros+=m;
  });
  d.isr=d.isrAuto?Math.round(calcISR(perGrav,d.dias)*100)/100:(Number(d.isr)||0);
  d.imss=d.imssAuto?Math.round(perGrav*(S.config.imssPct/100)*100)/100:(Number(d.imss)||0);
  if(d.isrIncluir!==false)ded+=d.isr;
  if(d.imssIncluir!==false)ded+=d.imss;
  var neto=per-ded+otros;
  return {per:per,perGrav:perGrav,ded:ded,otros:otros,neto:neto,isr:d.isr,imss:d.imss};
}
function recalcular(){
  pintarEmpList();
  var host=$("#nomDetail");if(!host)return;
  var d=construirDraft();
  if(!d){host.innerHTML='<div class="empty">Selecciona un colaborador.</div>';return;}
  var c=S.colaboradores.find(function(x){return x.id===d.colId;});
  recalcularAguinaldoDraft(d);
  var t=totales(d);

  host.innerHTML='';
  var head=el("div");
  var esFin=d.tipoDoc==="finiquito";
  var tieneAgui=!esFin&&(d.lineas||[]).some(function(l){return l.clave==="AGUINALDO"||/aguinaldo/i.test(l.nom||"");});
  head.innerHTML='<div style="display:flex;justify-content:space-between;align-items:flex-start;flex-wrap:wrap;gap:10px">'+
    '<div><div class="d2">'+esc(c.nombre)+(esFin?' <span class="pill pill-fin">Finiquito</span>':'')+'</div>'+
    '<div class="small">'+esc(c.puesto||"")+' · '+(esFin?"Liquidación":PERIODOS[d.periodo].nom)+' · '+d.dias+' días</div></div>'+
    '<div style="text-align:right"><div class="small">Horas del periodo</div><div class="num">'+d.horas.toFixed(1)+'</div></div></div>'+
    '<div class="per-dates">'+
      '<div class="field"><label>Inicio del periodo</label><input type="date" id="d-ini" value="'+esc(d.inicio)+'"></div>'+
      '<div class="field"><label>Fin del periodo</label><input type="date" id="d-fin" value="'+esc(d.fin)+'"></div>'+
    '</div>'+
    (tieneAgui?'<div class="agui-filter agui-inline"><span class="lbl">Filtro Aguinaldo</span>'+
      '<div class="field"><label>Inicio</label><input type="date" id="d-agui-ini" value="'+esc(d.aguiInicio||"")+'"></div>'+
      '<div class="field"><label>Final</label><input type="date" id="d-agui-fin" value="'+esc(d.aguiFin||"")+'"></div>'+
    '</div>':'');
  host.appendChild(head);

  // grupos
  ["percepcion","deduccion","otro"].forEach(function(tp){
    var titulos={percepcion:"Percepciones",deduccion:"Deducciones",otro:"Otros pagos"};
    var g=el("div",{class:"concept-group"});
    g.innerHTML='<span class="gtitle">'+titulos[tp]+'</span>';
    var tbl=el("table",{class:"concept-table"});
    var body=el("tbody");
    // ISR/IMSS automáticos como filas especiales en deducciones
    d.lineas.forEach(function(l,idx){
      if(l.tipo!==tp)return;
      var esp=l._descanso?"descanso":(l._retardo?"retardo":(l._festivo?"festivo":(l._primaDom?"primaDom":(l._extra?"extra":""))));
      if(esp){
        var incl=esp==="descanso"?(d.descansoIncluir!==false):(esp==="festivo"?(d.festivoIncluir!==false):(esp==="retardo"?(d.retardosIncluir===true):(esp==="primaDom"?(d.primaDomIncluir!==false):(d.extraIncluir!==false))));
        var tag=esp==="descanso"?"auto":(esp==="festivo"?"festivo":(esp==="retardo"?"retardos":"auto"));
        var tr=el("tr");if(!incl)tr.className="row-off";
        tr.innerHTML='<td style="width:55%"><label class="check chk-mini"><input type="checkbox" data-inclesp="'+esp+'"'+(incl?" checked":"")+'> <span style="font-weight:600">'+esc(nomConceptoVisible(l))+' <span class="auto-tag">'+tag+'</span></span></label></td>'+
          '<td><input type="number" step="0.01" value="'+(l.monto||0)+'" data-idx="'+idx+'" data-f="monto" style="text-align:right"></td>'+
          '<td style="width:34px"></td>';
        body.appendChild(tr);return;
      }
      var tr=el("tr");
      tr.innerHTML='<td style="width:55%"><input value="'+esc(l.nom)+'" '+(l.fijo?"disabled":"")+' data-idx="'+idx+'" data-f="nom"></td>'+
        '<td><input type="number" step="0.01" value="'+(l.monto||0)+'" data-idx="'+idx+'" data-f="monto" style="text-align:right"></td>'+
        '<td style="width:34px;text-align:right"></td>';
      if(!l.fijo){var bd=el("button",{class:"iconbtn danger"},ICON.trash);
        bd.addEventListener("click",function(){d.lineas.splice(idx,1);recalcular();});tr.lastChild.appendChild(bd);}
      body.appendChild(tr);
    });
    if(tp==="deduccion"){
      body.appendChild(filaAuto("ISR",d.isr,"isr",d.isrIncluir!==false));
      body.appendChild(filaAuto("IMSS",d.imss,"imss",d.imssIncluir!==false));
    }
    tbl.appendChild(body);g.appendChild(tbl);
    // agregar concepto
    var add=el("div",{class:"add-concept"});
    var sel=el("select");sel.innerHTML='<option value="">+ Agregar '+titulos[tp].toLowerCase()+'…</option>'+
      S.conceptos.filter(function(x){return x.tipo===tp;}).map(function(x){return '<option value="'+x.clave+'">'+esc(nomConceptoVisible(x))+'</option>';}).join("")+
      '<option value="__libre">Otro (línea libre)</option>';
    sel.style.maxWidth="260px";
    sel.addEventListener("change",function(){
      if(!sel.value)return;
      if(sel.value==="__libre"){d.lineas.push({clave:uid("l"),nom:"Concepto",tipo:tp,grav:false,monto:0});}
      else{var con=S.conceptos.find(function(x){return x.clave===sel.value;});
        d.lineas.push({clave:con.clave,nom:nomConceptoVisible(con),tipo:tp,grav:con.grav,monto:montoSugerido(con,c,d)});}
      recalcular();
    });
    add.appendChild(sel);g.appendChild(add);
    host.appendChild(g);
  });

  // enlazar inputs de conceptos y montos
  $$("#nomDetail .concept-table input[type=number],#nomDetail .concept-table input[type=text],#nomDetail .concept-table input:not([type])").forEach(function(inp){
    inp.addEventListener("input",function(){
      var idx=inp.getAttribute("data-idx"),f=inp.getAttribute("data-f");
      if(idx!=null){d.lineas[idx][f]=inp.type==="number"?(+inp.value||0):inp.value;
        if(f==="monto"){if(d.lineas[idx].fijo)d.sueldoManual=true;actualizarTotales(d);}}
      else if(inp.getAttribute("data-auto")){var a=inp.getAttribute("data-auto");
        d[a+"Auto"]=false;d[a]=+inp.value||0;actualizarTotales(d);}
    });
  });
  // toggles de inclusión ISR/IMSS
  $$("#nomDetail .concept-table input[data-incl]").forEach(function(chk){
    chk.addEventListener("change",function(){
      var a=chk.getAttribute("data-incl");d[a+"Incluir"]=chk.checked;recalcular();
    });
  });
  // toggles de inclusión de Descansos / Retardos (visibilidad desde Recibos)
  $$("#nomDetail .concept-table input[data-inclesp]").forEach(function(chk){
    chk.addEventListener("change",function(){
      var a=chk.getAttribute("data-inclesp");
      if(a==="descanso")d.descansoIncluir=chk.checked; else if(a==="festivo")d.festivoIncluir=chk.checked; else if(a==="retardo")d.retardosIncluir=chk.checked; else if(a==="primaDom")d.primaDomIncluir=chk.checked; else if(a==="extra")d.extraIncluir=chk.checked;
      recalcular();
    });
  });
  // fechas del periodo por colaborador
  var di=$("#d-ini"),df=$("#d-fin");
  function aplicarFechas(){
    var iniISO=di.value||d.inicio, finISO=df.value||d.fin;
    if(new Date(finISO)<new Date(iniISO)){toast("El fin no puede ser anterior al inicio","err");df.value=d.fin;return;}
    d.inicio=iniISO;d.fin=finISO;d.dias=diasEntre(iniISO,finISO);
    d.horas=horasTrabajadasPeriodo(d.colId,iniISO,d.dias);
    if(!d.sueldoManual){var l0=d.lineas.filter(function(x){return x.fijo;})[0];
      if(l0)l0.monto=Math.round(sueldoBasePeriodo(c,d.dias,d.inicio)*100)/100;}
    recalcular();
  }
  if(di)di.addEventListener("change",aplicarFechas);
  if(df)df.addEventListener("change",aplicarFechas);
  var dai=$("#d-agui-ini"),daf=$("#d-agui-fin");
  function aplicarAgui(){
    if(dai&&dai.value)d.aguiInicio=dai.value;
    if(daf&&daf.value)d.aguiFin=daf.value;
    recalcularAguinaldoDraft(d);
    recalcular();
  }
  if(dai)dai.addEventListener("change",aplicarAgui);
  if(daf)daf.addEventListener("change",aplicarAgui);

  // totales
  var box=el("div",{class:"totbox"});
  box.innerHTML=
    rowTot("Total percepciones",t.per)+
    rowTot("Total otros pagos",t.otros)+
    rowTot("Total deducciones",t.ded)+
    '<div class="row grand"><span>Neto a pagar</span><b>'+money(t.neto)+'</b></div>';
  host.appendChild(box);

  var foot=el("div",{class:"btn-row nom-actions"});
  var lblDoc=esFin?"finiquito":"recibo";
  foot.innerHTML='<button class="btn btn-primary" id="verRecibo">Vista previa del '+lblDoc+'</button>'+
    '<button class="btn" id="prnMC">Imprimir media carta</button>'+
    '<button class="btn" id="prnFull">Imprimir hoja completa</button>'+
    '<button class="btn" id="prnTK">Imprimir térmica 80 mm</button>'+
    '<button class="btn btn-ok" id="guardarNom">Guardar '+lblDoc+'</button>';
  host.appendChild(foot);
  $("#verRecibo").addEventListener("click",function(){previewRecibo(d);});
  $("#prnMC").addEventListener("click",function(){guardarRecibo(reciboData(d));imprimir([d],"mediacarta");});
  $("#prnFull").addEventListener("click",function(){guardarRecibo(reciboData(d));imprimir([d],"completa");});
  $("#prnTK").addEventListener("click",function(){guardarRecibo(reciboData(d));imprimir([d],"termica");});
  $("#guardarNom").addEventListener("click",function(){
    var b=this;b.disabled=true;b.textContent="Guardando…";
    guardarRecibo(reciboData(d)).then(function(dd){
      b.disabled=false;b.textContent="Guardar "+lblDoc;
      if(dd&&!dd.error)toast((esFin?"Finiquito":"Recibo")+" guardado","ok");
    }).catch(function(){b.disabled=false;b.textContent="Guardar "+lblDoc;});});
}
function filaAuto(nom,val,clave,incluir){
  var tr=el("tr");if(!incluir)tr.className="row-off";
  tr.innerHTML='<td><label class="check chk-mini"><input type="checkbox" data-incl="'+clave+'"'+(incluir?" checked":"")+'> <span style="font-weight:600">'+nom+' <span class="auto-tag">auto</span></span></label></td>'+
    '<td><input type="number" step="0.01" value="'+(Math.round(val*100)/100)+'" data-auto="'+clave+'"'+(incluir?"":" disabled")+' style="text-align:right"></td><td></td>';
  return tr;
}
function rowTot(lbl,val){return '<div class="row"><span>'+lbl+'</span><b class="tabular">'+money(val)+'</b></div>';}
function actualizarTotales(d){
  var t=totales(d);
  var box=$("#nomDetail .totbox");if(!box)return;
  box.innerHTML=rowTot("Total percepciones",t.per)+rowTot("Total otros pagos",t.otros)+
    rowTot("Total deducciones",t.ded)+'<div class="row grand"><span>Neto a pagar</span><b>'+money(t.neto)+'</b></div>';
}
function montoSugerido(con,c,d){
  // sugerencias automáticas según normativa (editable)
  var diario = c.tipoSueldo==="mes"?(c.sueldo/30): c.tipoSueldo==="semana"?(c.sueldo/7):(c.sueldo*8);
  if(con.clave==="PRIMA_DOM"){
    return montoPrimaDominical(c,d.inicio||fechaISO(inicioPeriodo()),d.dias).total;
  }
  if(con.clave==="DESCANSO"){
    return montoDescanso(c, fechaISO(inicioPeriodo()), d.dias).total;
  }
  if(con.clave==="FESTIVO"){
    return montoFestivo(c, fechaISO(inicioPeriodo()), d.dias).total;
  }
  if(con.clave==="AGUINALDO"){
    d.aguiInicio=d.aguiInicio||periodoAguinaldoDefault(c,d.fin||fechaISO(new Date())).ini;
    d.aguiFin=d.aguiFin||periodoAguinaldoDefault(c,d.fin||fechaISO(new Date())).fin;
    if(!aguinaldoPermitido(c,d.aguiFin)){toast("Aguinaldo no disponible: ya hay un pago en los últimos 6 meses","err");return 0;}
    return montoAguinaldo(c,d.aguiFin,d.aguiInicio,d.aguiFin);
  }
  if(con.clave==="PRIMA_VAC") return Math.round(vacacionesPeriodo(c,d.inicio||fechaISO(inicioPeriodo()),d.dias).total*0.25*100)/100;
  if(con.clave==="EXTRA") return montoHorasExtra(c,d.inicio||fechaISO(inicioPeriodo()),d.dias).total;
  return 0;
}

/* ============================================================
   RECIBOS · datos, vista previa, impresión
   ============================================================ */
function reciboData(d){
  var c=S.colaboradores.find(function(x){return x.id===d.colId;});
  var t=totales(d);
  var per=d.lineas.filter(function(l){return l.tipo==="percepcion" && !(l._descanso&&d.descansoIncluir===false) && !(l._festivo&&d.festivoIncluir===false) && !(l._primaDom&&d.primaDomIncluir===false) && !(l._extra&&d.extraIncluir===false);})
            .map(function(l){return {nom:nomConceptoVisible(l),monto:l.monto,fijo:l.fijo};});
  var ded=d.lineas.filter(function(l){return l.tipo==="deduccion" && !(l._retardo&&d.retardosIncluir!==true);})
            .map(function(l){return {nom:nomConceptoVisible(l),monto:l.monto};});
  var otros=d.lineas.filter(function(l){return l.tipo==="otro";})
            .map(function(l){return {nom:nomConceptoVisible(l),monto:l.monto};});
  if(d.isrIncluir!==false)ded.push({nom:"ISR",monto:d.isr});
  if(d.imssIncluir!==false)ded.push({nom:"IMSS",monto:d.imss});
  if(!d._folio)d._folio="LL-"+Date.now().toString().slice(-8)+"-"+Math.floor(Math.random()*90+10);
  if(!d._id)d._id=uid("nom");
  // snapshot de la empresa (para que el histórico no cambie si luego editas la config)
  var emp=JSON.parse(JSON.stringify(S.config));
  return {
    id:d._id, folio:d._folio, tipoDoc:d.tipoDoc||"nomina",
    colId:c.id, colaborador:JSON.parse(JSON.stringify(c)), empresa:emp,
    periodo:(d.tipoDoc==="finiquito"?"Finiquito":PERIODOS[d.periodo].nom),
    inicio:d.inicio, fin:d.fin, dias:d.dias, horas:d.horas,
    per:per, ded:ded, otros:otros,
    totPer:t.per, totDed:t.ded, totOtros:t.otros, neto:t.neto, fecha:fechaISO(new Date())
  };
}
function nomConceptoVisible(l){
  if(!l)return "";
  if(l.clave==="DESCANSO"||l._descanso)return "Descansos";
  var n=String(l.nom||"");
  return /d[ií]a[s]? de descanso/i.test(n)? "Descansos" : n;
}
function guardarRecibo(rec){
  var i=S.nominas.map(function(n){return n.folio;}).indexOf(rec.folio);
  if(i>=0)S.nominas[i]=rec; else S.nominas.push(rec);
  return DataStore.guardarNomina(rec);
}
function previewRecibo(d){
  var r=reciboData(d);
  var body='<div style="display:flex;gap:6px;margin-bottom:12px"><button class="chip2 active" id="vMC">Media carta</button><button class="chip2" id="vTK">Térmica 80 mm</button></div>'+
    '<div id="recPrev">'+reciboMediaCartaHTML(r)+'</div>';
  modal("Vista previa del recibo","Folio "+r.folio,body,null,'<button class="btn" id="cerrarPrev">Cerrar</button>');
  var m=$("#modal .modal");if(m)m.style.maxWidth="640px";
  $("#vMC").addEventListener("click",function(){$("#vMC").classList.add("active");$("#vTK").classList.remove("active");$("#recPrev").innerHTML=reciboMediaCartaHTML(r);});
  $("#vTK").addEventListener("click",function(){$("#vTK").classList.add("active");$("#vMC").classList.remove("active");$("#recPrev").innerHTML=reciboTicketHTML(r);});
  $("#cerrarPrev").addEventListener("click",cerrarModal);
}

function lineasTabla(arr){
  return arr.filter(function(l){return (Number(l.monto)||0)!==0||l.fijo;}).map(function(l){
    return '<tr><td>'+esc(nomConceptoVisible(l))+'</td><td class="n">'+num2(l.monto)+'</td></tr>';}).join("");
}
function reciboMediaCartaHTML(r){
  var c=r.colaborador;
  var emp=r.empresa||{};
  var mo=emp.mostrar||{razonSocial:true,rfc:true,rp:true,domicilio:true};
  var razon=emp.razonSocial||emp.empresa||"Lienzo Librería";
  var titulo=r.tipoDoc==="finiquito"?"Finiquito / Liquidación":"Recibo de Nómina";
  var logo = IMG.recibo
    ? '<img src="'+IMG.recibo+'" alt="'+esc(razon)+'" class="r-logo-img">'
    : '<span class="lm">'+logoMark(40)+'</span><span class="lt">'+esc(razon)+'</span>';
  // datos del patrón según lo que se elija mostrar
  var pat="";
  if(mo.razonSocial!==false)pat+=dl("Razón social",razon);
  if(mo.rfc!==false)pat+=dl("RFC",emp.rfc||"—");
  if(mo.rp!==false)pat+=dl("Registro patronal",emp.registroPatronal||"—");
  if(mo.domicilio!==false&&emp.domicilio)pat+=dl("Domicilio",emp.domicilio);
  if(!pat)pat=dl("Razón social",razon);
  return '<div class="receipt">'+
    '<div class="r-head">'+
      '<div class="r-logo">'+logo+'</div>'+
      '<div class="r-doc"><div class="badge">'+titulo+'</div>'+
        '<div class="meta">Folio: '+esc(r.folio)+'<br>Fecha: '+fechaLarga(r.fecha)+'</div></div>'+
    '</div>'+
    '<div class="r-body">'+
      '<div class="r-cols">'+
        '<div><div class="r-sect-title">Patrón</div><div class="r-data" style="grid-template-columns:1fr">'+
          pat+'</div></div>'+
        '<div><div class="r-sect-title">Trabajador</div><div class="r-data" style="grid-template-columns:1fr">'+
          dl("Nombre",c.nombre)+dl("Puesto",c.puesto||"—")+
          dl("Fecha de ingreso",c.ingreso?fechaLarga(c.ingreso):"—")+
          dl("RFC",c.rfc||"—")+dl("CURP",c.curp||"—")+dl("NSS",c.nss||"—")+'</div></div>'+
      '</div>'+
      '<hr class="r-div">'+
      '<div class="r-data" style="margin-top:8px;grid-template-columns:1fr 1fr 1fr">'+
        dl("Periodo",r.periodo)+dl("Inicio",fechaLarga(r.inicio))+dl("Fin",fechaLarga(r.fin))+
        dl("Días pagados",r.dias)+dl("Horas",(r.horas||0).toFixed(1))+dl("Depto.",c.depto||"—")+'</div>'+
      '<div class="r-cols" style="margin-top:12px">'+
        '<div><div class="r-sect-title">Percepciones</div><table class="r-table"><thead><tr><th>Concepto</th><th style="text-align:right">Importe</th></tr></thead><tbody>'+
          lineasTabla(r.per)+'</tbody></table></div>'+
        '<div><div class="r-sect-title">Deducciones</div><table class="r-table"><thead><tr><th>Concepto</th><th style="text-align:right">Importe</th></tr></thead><tbody>'+
          lineasTabla(r.ded)+'</tbody></table></div>'+
      '</div>'+
      (r.otros.length?'<div style="margin-top:10px"><div class="r-sect-title">Otros pagos</div><table class="r-table"><tbody>'+lineasTabla(r.otros)+'</tbody></table></div>':'')+
      '<div class="r-tot">'+
        '<div class="row"><span>Total percepciones</span><b>'+money(r.totPer)+'</b></div>'+
        (r.totOtros?'<div class="row"><span>Total otros pagos</span><b>'+money(r.totOtros)+'</b></div>':'')+
        '<div class="row"><span>Total deducciones</span><b>'+money(r.totDed)+'</b></div>'+
        '<div class="row grand"><span>Neto a pagar</span><b>'+money(r.neto)+'</b></div>'+
      '</div>'+
      '<div class="r-letra"><b>Cantidad con letra:</b> '+numeroALetras(r.neto)+'</div>'+
      '<div class="r-foot">Recibí de '+esc(razon)+' la cantidad indicada por concepto de '+(r.tipoDoc==="finiquito"?"finiquito":"pago de nómina")+' del periodo señalado.<br><br>____________________________<br>Firma del trabajador</div>'+
    '</div></div>';
}
function dl(k,v){return '<div><span>'+esc(k)+'</span><b>'+esc(v)+'</b></div>';}

function reciboTicketHTML(r){
  var c=r.colaborador;
  var emp=r.empresa||{};
  var razon=emp.razonSocial||emp.empresa||"Lienzo Librería";
  function ln(a,b){return '<div class="ln"><span>'+esc(a)+'</span><span class="n">'+esc(b)+'</span></div>';}
  var cab = '<div class="tk-brand">'+
    (IMG.recibo?'<img src="'+IMG.recibo+'" alt="'+esc(razon)+'" class="tk-logo" onerror="this.style.display=\'none\';this.nextSibling.style.display=\'block\'">':"")+
    '<div class="tk-brand-name"'+(IMG.recibo?' style="display:none"':"")+'>'+esc(razon)+'</div>'+
    '</div>';
  return '<div class="ticket">'+
    cab+
    '<div class="center" style="font-size:10px">'+(r.tipoDoc==="finiquito"?"Finiquito / Liquidación":"Recibo de nómina")+'</div>'+
    '<hr>'+
    '<div style="font-size:10.5px">'+
      ln("Folio:",r.folio)+ln("Fecha:",fechaLarga(r.fecha))+
      ln("Trabajador:","")+'<div style="font-weight:700">'+esc(c.nombre)+'</div>'+
      ln("Puesto:",c.puesto||"—")+ln("Ingreso:",c.ingreso?fechaLarga(c.ingreso):"—")+ln("Periodo:",r.periodo)+
      ln("Del:",fechaLarga(r.inicio))+ln("Al:",fechaLarga(r.fin))+ln("Días:",r.dias)+ln("Horas:",(Number(r.horas)||0).toFixed(1))+
    '</div><hr>'+
    '<div class="center" style="font-weight:700;font-size:10px">PERCEPCIONES</div>'+
    r.per.filter(function(l){return Number(l.monto)||l.fijo;}).map(function(l){return ln(nomConceptoVisible(l),num2(l.monto));}).join("")+
    '<hr><div class="center" style="font-weight:700;font-size:10px">DEDUCCIONES</div>'+
    r.ded.filter(function(l){return Number(l.monto);}).map(function(l){return ln(nomConceptoVisible(l),num2(l.monto));}).join("")+
    (r.otros.length?'<hr><div class="center" style="font-weight:700;font-size:10px">OTROS PAGOS</div>'+r.otros.filter(function(l){return Number(l.monto);}).map(function(l){return ln(nomConceptoVisible(l),num2(l.monto));}).join(""):'')+
    '<hr>'+
    ln("Percepciones:",money(r.totPer))+ln("Deducciones:",money(r.totDed))+(r.totOtros?ln("Otros:",money(r.totOtros)):"")+
    '<div class="ln grand" style="margin-top:4px"><span>NETO:</span><span class="n">'+money(r.neto)+'</span></div>'+
    '<div style="font-size:9.5px;margin-top:6px">'+numeroALetras(r.neto)+'</div>'+
    '<hr><div class="center" style="font-size:9px;margin-top:14px">_______________________<br>Firma del trabajador</div>'+
    '</div>';
}

/* ---- Impresión ---- */
function imprimir(drafts,formato){
  imprimirRecibos(drafts.map(reciboData),formato);
}
function imprimirRecibos(recs,formato){
  var area=$("#printarea");
  setPrintPageStyle(formato);
  if(formato==="termica"){
    area.className="print-only print-termica";
    area.innerHTML=recs.map(function(r){return '<div class="thermal-page">'+reciboTicketHTML(r)+'</div>';}).join("");
  }else if(formato==="completa"){
    // Hoja completa: un recibo por hoja carta (tamaño cómodo, para recibos largos)
    area.className="print-only print-completa";
    area.innerHTML=recs.map(function(r){return '<div class="full-page">'+reciboMediaCartaHTML(r)+'</div>';}).join("");
  }else{
    // Media carta: dos recibos por hoja carta
    area.className="print-only print-mediacarta";
    var html="",i;
    for(i=0;i<recs.length;i+=2){
      html+='<div class="sheet"><div class="half">'+reciboMediaCartaHTML(recs[i])+'</div>';
      if(recs[i+1])html+='<div class="half half-b">'+reciboMediaCartaHTML(recs[i+1])+'</div>';
      html+='</div>';
    }
    area.innerHTML=html;
  }
  if(formato==="termica"){window.print();}else{printIsolado();}
}
function setPrintPageStyle(formato){
  var old=$("#thermalPrintPage");
  if(old)old.remove();
  var oldPedidos=$("#pedidosPrintPage");
  if(oldPedidos)oldPedidos.remove();
  var oldRet=$("#retardosPrintPage");
  if(oldRet)oldRet.remove();
  var oldAseo=$("#aseoPrintPage");
  if(oldAseo)oldAseo.remove();
  if(formato==="aseo"){
    var sa=document.createElement("style");
    sa.id="aseoPrintPage";
    sa.textContent=[
      "@media print{",
      "@page{size:A4 landscape;margin:11mm}",
      ".print-aseo{color:#0E1B4D;font-family:Arial,Helvetica,sans-serif}",
      ".print-aseo .aseo-page:not(:last-child){page-break-after:always}",
      ".print-aseo .az-head{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:2px solid #0E1B4D;padding-bottom:6px;margin:0 0 8px}",
      ".print-aseo .az-zona{font-size:22px;font-weight:800;letter-spacing:.02em;text-transform:uppercase}",
      ".print-aseo .az-sub{font-size:9.5px;color:#6b7280;letter-spacing:.08em}",
      ".print-aseo .az-head-r{text-align:right}",
      ".print-aseo .az-store{font-size:16px;font-weight:800;text-transform:uppercase}",
      ".print-aseo .az-store-sub{font-size:9px;color:#C2620B}",
      ".print-aseo .az-fields{margin:18px 0 20px}",
      ".print-aseo .az-frow{display:flex;align-items:flex-end;margin-bottom:18px}",
      ".print-aseo .az-frow:last-child{margin-bottom:0}",
      ".print-aseo .az-flabel{font-size:11.5px;white-space:nowrap;margin-right:8px}",
      ".print-aseo .az-fline{flex:1;border-bottom:1.2px solid #0E1B4D;height:0;min-width:40px}",
      ".print-aseo .az-frow-2col{gap:50px}",
      ".print-aseo .az-fcell{flex:1;display:flex;align-items:flex-end;min-width:0}",
      ".print-aseo .az-nota{font-size:8.5px;color:#475569;border:1px solid #e5e7eb;border-radius:6px;padding:6px 9px;margin-bottom:10px}",
      ".print-aseo .az-table{width:100%;border-collapse:collapse;table-layout:fixed;font-size:9px}",
      ".print-aseo .az-table th{background:#0E1B4D;color:#fff;font-size:10.5px;font-weight:800;text-transform:uppercase;letter-spacing:.03em;padding:7px 4px;border:1px solid #0E1B4D;-webkit-print-color-adjust:exact;print-color-adjust:exact}",
      ".print-aseo .az-table td{border:1px solid #cbd5e1;padding:5px 5px;vertical-align:middle;height:24px}",
      ".print-aseo tbody tr{page-break-inside:avoid}",
      ".print-aseo .az-col-num{width:3%}",
      ".print-aseo .az-col-act{width:42%}",
      ".print-aseo .az-col-turno{width:8%}",
      ".print-aseo .az-col-chk{width:7%}",
      ".print-aseo .az-col-hora{width:8%}",
      ".print-aseo .az-col-nom{width:13%}",
      ".print-aseo .az-col-firma{width:11%}",
      ".print-aseo .az-col-vb{width:8%}",
      ".print-aseo .az-num{text-align:center;color:#64748b;padding-left:1px;padding-right:1px;white-space:nowrap}",
      ".print-aseo .az-act{white-space:normal;word-break:break-word;overflow-wrap:anywhere;text-align:justify}",
      ".print-aseo .az-act-name{font-weight:700;color:#0E1B4D;white-space:normal;word-break:break-word;overflow-wrap:anywhere;text-align:justify}",
      ".print-aseo .az-badge{display:inline-block;background:#C2620B;color:#fff;font-size:7.5px;font-weight:700;border-radius:4px;padding:1px 6px;margin-top:3px;-webkit-print-color-adjust:exact;print-color-adjust:exact}",
      ".print-aseo .az-turno{text-align:center;font-weight:700;color:#334155}",
      ".print-aseo .az-chk{text-align:center}",
      ".print-aseo .az-box{display:inline-block;width:12px;height:12px;border:1.5px solid #334155;border-radius:2px}",
      ".print-aseo .az-sign{text-align:center;margin-top:72px}",
      ".print-aseo .az-sign-line{width:62%;max-width:620px;margin:0 auto;border-bottom:1.4px solid #0E1B4D;height:0}",
      ".print-aseo .az-sign-cap{font-weight:700;font-size:9.5px;margin-top:6px}",
      ".print-aseo .az-sign-sub{font-size:8px;color:#6b7280}",
      ".print-aseo .az-obs{margin-top:18px}",
      ".print-aseo .az-obs-cap{font-size:9px;font-weight:700;letter-spacing:.06em;margin-bottom:4px}",
      ".print-aseo .az-obs-box{border:2.4px solid #475569;border-radius:6px;height:140px}",
      ".print-aseo .az-foot{margin-top:12px;text-align:center;font-size:7.5px;color:#94a3b8}",
      "}"
    ].join("");
    document.head.appendChild(sa);
    return;
  }
  if(formato==="pedidos"){
    var sp=document.createElement("style");
    sp.id="pedidosPrintPage";
    sp.textContent=[
      "@media print{",
      "@page{size:A4 landscape;margin:7mm}",
      "html,body{width:297mm!important;min-width:0!important;height:auto!important;margin:0!important;padding:0!important;overflow:hidden!important}",
      "body *{overflow:visible!important}",
      "#printarea.print-pedidos{display:block!important;position:absolute!important;left:0!important;top:0!important;width:283mm!important;max-width:283mm!important;margin:0!important;padding:0!important;overflow:hidden!important}",
      "#printarea.print-pedidos *{box-sizing:border-box!important}",
      ".print-pedidos .rep-print{width:100%!important;max-width:100%!important;margin:0!important;padding:0!important;overflow:hidden!important;font-family:Arial,sans-serif;color:#000}",
      ".print-pedidos h2{font-size:14px;margin:0 0 3px;line-height:1.15}",
      ".print-pedidos p{font-size:9px;margin:0 0 6px;line-height:1.2}",
      ".print-pedidos .ped-print-table{width:100%!important;max-width:100%!important;border-collapse:collapse!important;table-layout:fixed!important;font-size:6.6px!important;line-height:1.12!important;page-break-inside:auto!important;overflow:hidden!important}",
      ".print-pedidos .ped-print-table th,.print-pedidos .ped-print-table td{border:1px solid #777!important;padding:2.2px 2px!important;text-align:left!important;vertical-align:top!important;white-space:normal!important;overflow:hidden!important;overflow-wrap:anywhere!important;word-break:break-word!important}",
      ".print-pedidos .ped-print-table th{background:#111b4d!important;color:#fff!important;-webkit-print-color-adjust:exact;print-color-adjust:exact}",
      ".print-pedidos .ped-print-table tr{page-break-inside:avoid!important}",
      ".print-pedidos .ped-print-table th:nth-child(1),.print-pedidos .ped-print-table td:nth-child(1){width:6%}",
      ".print-pedidos .ped-print-table th:nth-child(2),.print-pedidos .ped-print-table td:nth-child(2){width:8%}",
      ".print-pedidos .ped-print-table th:nth-child(3),.print-pedidos .ped-print-table td:nth-child(3){width:13%}",
      ".print-pedidos .ped-print-table th:nth-child(4),.print-pedidos .ped-print-table td:nth-child(4){width:12%}",
      ".print-pedidos .ped-print-table th:nth-child(5),.print-pedidos .ped-print-table td:nth-child(5){width:11%}",
      ".print-pedidos .ped-print-table th:nth-child(6),.print-pedidos .ped-print-table td:nth-child(6){width:7%}",
      ".print-pedidos .ped-print-table th:nth-child(7),.print-pedidos .ped-print-table td:nth-child(7){width:10%}",
      ".print-pedidos .ped-print-table th:nth-child(8),.print-pedidos .ped-print-table td:nth-child(8){width:9%}",
      ".print-pedidos .ped-print-table th:nth-child(9),.print-pedidos .ped-print-table td:nth-child(9){width:8%}",
      ".print-pedidos .ped-print-table th:nth-child(10),.print-pedidos .ped-print-table td:nth-child(10){width:8%}",
      ".print-pedidos .ped-print-table th:nth-child(11),.print-pedidos .ped-print-table td:nth-child(11){width:8%}",
      "}"
    ].join("");
    document.head.appendChild(sp);
    return;
  }
  if(formato==="retardos"){
    var sr=document.createElement("style");
    sr.id="retardosPrintPage";
    sr.textContent=[
      "@media print{",
      "@page{size:A4 landscape;margin:9mm}",
      "html{background:#fff!important}",
      "body.printing-iso{margin:0!important;padding:0!important;background:#fff!important;height:auto!important}",
      "body.printing-iso>*{display:none!important}",
      "body.printing-iso>#printarea{display:block!important}",
      "#printarea.print-retardos{position:static!important;display:block!important;width:100%!important;max-width:100%!important;margin:0!important;padding:0!important;color:#000;font-family:Arial,sans-serif;visibility:visible!important}",
      "#printarea.print-retardos *{visibility:visible!important}",
      ".print-retardos .rep-print{width:100%!important;max-width:100%!important;margin:0!important;padding:0!important}",
      ".print-retardos .ret-print-head{display:flex!important;justify-content:space-between!important;align-items:flex-start!important;gap:16px;margin:0 0 6px}",
      ".print-retardos .ret-print-logo img{max-width:42mm!important;height:auto!important;display:block!important}",
      ".print-retardos .ret-print-meta{text-align:right!important}",
      ".print-retardos .ret-print-meta h2{font-size:13px;margin:0 0 2px}",
      ".print-retardos .ret-print-meta h3{font-size:11px;margin:0 0 2px}",
      ".print-retardos .ret-print-meta p{font-size:9px;margin:0}",
      ".print-retardos table{width:100%!important;max-width:100%!important;border-collapse:collapse!important;table-layout:fixed!important;font-size:8.5px!important}",
      ".print-retardos thead{display:table-header-group!important}",
      ".print-retardos tr{page-break-inside:avoid!important}",
      ".print-retardos th,.print-retardos td{border:1px solid #888!important;padding:2px 3px!important;text-align:center!important;white-space:normal!important;overflow-wrap:anywhere!important;word-break:break-word!important}",
      ".print-retardos th{background:#0E1B4D!important;color:#fff!important;-webkit-print-color-adjust:exact;print-color-adjust:exact}",
      ".print-retardos tfoot td{border-top:2px solid #333!important;font-weight:700}",
      ".print-retardos .ret-print-firma{margin-top:10px;text-align:center;font-size:9px}",
      "}"
    ].join("");
    document.head.appendChild(sr);
    return;
  }
  if(formato!=="termica")return;
  var st=document.createElement("style");
  st.id="thermalPrintPage";
  st.textContent="@media print{@page{size:80mm auto;margin:0}html,body{width:80mm!important;margin:0!important;padding:0!important}#printarea.print-termica{width:80mm!important;margin:0!important;padding:0!important;display:block!important}.print-termica .thermal-page{width:80mm!important;margin:0!important;padding:0!important;display:flex!important;justify-content:center!important;box-sizing:border-box!important}.print-termica .thermal-page:not(:last-child){page-break-after:always}.print-termica .ticket{width:76mm!important;margin:0!important;padding:1.5mm 0 2mm!important;box-sizing:border-box!important}.print-termica .ticket hr{width:100%!important}.print-termica .ticket .tk-logo{max-width:66mm!important;width:auto!important}}";
  document.head.appendChild(st);
}
function imprimirTodos(){
  var lista=colsDeSucursal();
  if(!lista.length){toast("No hay colaboradores activos","err");return;}
  var body='<p class="small" style="margin-bottom:14px">Se generará un recibo por colaborador activo de <b>'+esc(sucursalActiva().nombre)+'</b> para el periodo seleccionado ('+PERIODOS[S.nomPeriodo].nom+'). En media carta se imprimen dos recibos por hoja.</p>'+
    '<div class="field"><label>Formato de impresión</label><select id="fmtAll"><option value="mediacarta">Media carta (2 por hoja)</option><option value="completa">Hoja completa (1 por hoja)</option><option value="termica">Térmica 80 mm</option></select></div>'+
    '<label class="check" style="margin-top:8px"><input type="checkbox" id="guardarAll" checked> Guardar todos los recibos en el histórico</label>';
  modal("Imprimir todos los recibos","Un documento con todos los colaboradores.",body,function(){
    var fmt=$("#fmtAll").value, guardar=$("#guardarAll").checked;
    var oldEmp=S.nomEmpId, oldDraft=S.nomDraft;
    var recs=lista.map(function(c){
      S.nomEmpId=c.id;S.nomDraft=null;
      var draft=construirDraft();
      var rec=reciboData(draft);
      if(guardar)guardarRecibo(rec);
      return rec;
    });
    S.nomEmpId=oldEmp;S.nomDraft=oldDraft;
    cerrarModal();setTimeout(function(){imprimirRecibos(recs,fmt);},150);
  },null,"Generar");
}

/* ============================================================
   FINIQUITO / LIQUIDACIÓN
   ============================================================ */
function diarioDe(c){
  return c.tipoSueldo==="mes"?(c.sueldo/30): c.tipoSueldo==="semana"?(c.sueldo/7):(c.sueldo*8);
}
function fqParam(clave,campoNom){
  var arr=(S.config.finiquito||FINIQUITO_DEFAULT);
  var it=arr.filter(function(x){return x.clave===clave;})[0];
  return it?it[campoNom]:undefined;
}
function abrirFiniquito(c){
  var hoy=fechaISO(new Date());
  var ingreso=c.ingreso||hoy, baja=c.bajaFecha||hoy;
  var diario=Math.round(diarioDe(c)*100)/100;
  var fq=S.config.finiquito||FINIQUITO_DEFAULT;
  function on(clave){var it=fq.filter(function(x){return x.clave===clave;})[0];return it&&it.on;}
  var body='<div class="grid-2">'+
    campo("Fecha de ingreso","fq-ing",ingreso,"date")+
    campo("Fecha de baja","fq-baja",baja,"date")+
    campo("Salario diario","fq-diario",diario,"number")+
    campo("Días de aguinaldo por año","fq-agui",fqParam("AGUINALDO","valor")||15,"number")+
    campo("Días de vacaciones pendientes","fq-vac",fqParam("VACAC","valor")||0,"number")+
    campo("Prima vacacional (%)","fq-pvac",fqParam("PRIMA_VAC","valor")||25,"number")+
    campo("Días devengados por pagar","fq-dev",fqParam("DEVENGADO","valor")||0,"number")+
    '</div>'+
    '<label class="lbl" style="margin-top:10px">Indemnizaciones (si aplica despido)</label>'+
    '<div class="row" style="flex-direction:column;align-items:flex-start;gap:6px">'+
      '<label class="check"><input type="checkbox" id="fq-90"'+(on("INDEM90")?" checked":"")+'> Indemnización constitucional ('+(fqParam("INDEM90","valor")||90)+' días)</label>'+
      '<label class="check"><input type="checkbox" id="fq-20"'+(on("DIAS20")?" checked":"")+'> '+(fqParam("DIAS20","valor")||20)+' días por año trabajado</label>'+
      '<label class="check"><input type="checkbox" id="fq-prima"'+(on("PRIMA_ANT")?" checked":"")+'> Prima de antigüedad ('+(fqParam("PRIMA_ANT","valor")||12)+' días por año)</label>'+
    '</div>'+
    '<div class="note"><span>'+ICON.info+'</span><div><b>Nota</b>Montos sugeridos (parámetros editables en Configuración › Finiquito) y ajustables a mano. El finiquito quedará disponible en Nómina para revisar, imprimir y guardar; al guardarlo aparece en Recibos.</div></div>';
  modal("Finiquito · "+c.nombre,"Cálculo de partes proporcionales y, en su caso, indemnización.",body,function(){
    var ing=$("#f-fq-ing").value, bj=$("#f-fq-baja").value;
    var di=+$("#f-fq-diario").value||0;
    var diasAgui=+$("#f-fq-agui").value||0, diasVac=+$("#f-fq-vac").value||0;
    var pvac=+$("#f-fq-pvac").value||0, dev=+$("#f-fq-dev").value||0;
    if(new Date(bj)<new Date(ing)){toast("La baja no puede ser anterior al ingreso","err");return false;}
    var msDia=86400000;
    var anios=Math.max(0,(new Date(bj)-new Date(ing))/(365.25*msDia));
    var inicioAnio=new Date(new Date(bj).getFullYear(),0,1);
    var diasAnio=Math.max(0,Math.round((new Date(bj)-inicioAnio)/msDia)+1);
    var d90=fqParam("INDEM90","valor")||90, d20=fqParam("DIAS20","valor")||20, dant=fqParam("PRIMA_ANT","valor")||12;
    var lineas=[];
    function add(nom,monto){if(monto>0)lineas.push({clave:uid("fq"),nom:nom,tipo:"percepcion",grav:false,monto:Math.round(monto*100)/100});}
    if(dev>0) add((fqParam("DEVENGADO","nom")||"Salarios devengados"), di*dev);
    add((fqParam("AGUINALDO","nom")||"Aguinaldo proporcional"), di*diasAgui*(diasAnio/365));
    var montoVac=di*diasVac;
    add((fqParam("VACAC","nom")||"Vacaciones pendientes"), montoVac);
    add((fqParam("PRIMA_VAC","nom")||"Prima vacacional"), montoVac*(pvac/100));
    if($("#fq-90").checked) add((fqParam("INDEM90","nom")||"Indemnización constitucional"), di*d90);
    if($("#fq-20").checked) add((fqParam("DIAS20","nom")||"20 días por año"), di*d20*anios);
    if($("#fq-prima").checked) add((fqParam("PRIMA_ANT","nom")||"Prima de antigüedad"), di*dant*anios);
    if(!lineas.length){toast("No hay conceptos con importe","err");return false;}
    var draft={
      colId:c.id, tipoDoc:"finiquito", periodo:"finiquito",
      inicio:ing, fin:bj, dias:diasEntre(ing,bj),
      horas:0, lineas:lineas,
      isrAuto:true, imssAuto:false, isr:0, imss:0,
      isrIncluir:false, imssIncluir:false, sueldoManual:true
    };
    S.nomDraft=draft; S.nomEmpId=c.id;
    cerrarModal(); go("nomina");
    toast("Finiquito calculado · revísalo, imprime y guarda","ok");
    return false;
  },null);
}

/* ============================================================
   VISTA · RECIBOS (histórico de nómina y finiquitos)
   ============================================================ */
function viewRecibos(v){
  var card=el("div",{class:"card"});
  card.innerHTML='<div class="card-head"><div><h2>Recibos generados</h2>'+
    '<p class="sub">Histórico de recibos de nómina y finiquitos guardados. Se conservan aunque cambien los datos del colaborador.</p></div>'+
    '<div class="btn-row"><button class="btn btn-sm" id="recPrnAll">'+ICON.print+' Imprimir todos</button></div></div>'+
    '<div class="rec-filters">'+
      '<div class="field rec-person"><label>Colaborador</label>'+
        '<select id="recCol"><option value="">Todos los colaboradores</option>'+
        S.colaboradores.map(function(c){return '<option value="'+c.id+'"'+(c.id===S.recFiltro?" selected":"")+'>'+esc(c.nombre)+'</option>';}).join("")+'</select></div>'+
      '<div class="field rec-date"><label>Desde</label><input type="date" id="recIni" value="'+esc(S.recIni)+'"></div>'+
      '<div class="field rec-date"><label>Hasta</label><input type="date" id="recFin" value="'+esc(S.recFin)+'"></div>'+
      '<button class="btn btn-sm" id="recClear">Limpiar fechas</button>'+
    '</div>'+
    '<div id="recHost"></div>';
  v.appendChild(card);
  $("#recCol").addEventListener("change",function(){S.recFiltro=this.value;pintarRecibos();});
  $("#recIni").addEventListener("change",function(){S.recIni=this.value;pintarRecibos();});
  $("#recFin").addEventListener("change",function(){S.recFin=this.value;pintarRecibos();});
  $("#recClear").addEventListener("click",function(){S.recIni="";S.recFin="";go("recibos");});
  $("#recPrnAll").addEventListener("click",function(){
    var l=recibosFiltrados();
    if(!l.length){toast("No hay recibos en el filtro","err");return;}
    var body='<p class="small" style="margin-bottom:12px">Se imprimirán <b>'+l.length+'</b> recibo(s) del filtro actual. En media carta van dos por hoja.</p>'+
      '<div class="field"><label>Formato</label><select id="recFmt"><option value="mediacarta">Media carta (2 por hoja)</option><option value="completa">Hoja completa (1 por hoja)</option><option value="termica">Térmica 80 mm</option></select></div>';
    modal("Imprimir todos los recibos","Recibos del histórico filtrado.",body,function(){
      var fmt=$("#recFmt").value;cerrarModal();setTimeout(function(){imprimirRecibos(l,fmt);},120);
    },null,"Imprimir");
  });
  pintarRecibos();
}
function recibosFiltrados(){
  return S.nominas.slice().filter(function(r){
    if(S.recFiltro&&r.colId!==S.recFiltro)return false;
    var f=r.inicio||r.fecha||"";
    if(S.recIni&&f<S.recIni)return false;
    if(S.recFin&&f>S.recFin)return false;
    return true;
  }).sort(function(a,b){return (b.fecha||"").localeCompare(a.fecha||"");});
}
function pintarRecibos(){
  var host=$("#recHost");if(!host)return;
  var list=recibosFiltrados();
  if(!list.length){host.innerHTML='<div class="empty">'+ICON.doc+'No hay recibos para el filtro seleccionado. Genera uno desde Nómina.</div>';return;}
  var tbl=el("div",{class:"table-wrap"});
  tbl.innerHTML='<table class="data"><thead><tr><th>Folio</th><th>Colaborador</th><th>Tipo</th><th>Periodo</th><th>Inicio–Fin</th><th>Neto</th><th></th></tr></thead><tbody id="recBody"></tbody></table>';
  host.innerHTML="";host.appendChild(tbl);
  var tb=$("#recBody");
  list.forEach(function(r){
    var tr=el("tr");
    var nombre=(r.colaborador&&r.colaborador.nombre)||"—";
    tr.innerHTML='<td class="tabular">'+esc(r.folio)+'</td><td><b>'+esc(nombre)+'</b></td>'+
      '<td>'+(r.tipoDoc==="finiquito"?'<span class="badge-est fin">Finiquito</span>':'<span class="pill">Nómina</span>')+'</td>'+
      '<td>'+esc(r.periodo||"—")+'</td>'+
      '<td class="small">'+fechaLarga(r.inicio)+' – '+fechaLarga(r.fin)+'</td>'+
      '<td class="tabular"><b>'+money(r.neto)+'</b></td>'+
      '<td style="text-align:right;white-space:nowrap"></td>';
    var act=tr.lastChild;
    var bv=el("button",{class:"iconbtn",title:"Ver"},ICON.doc);
    bv.addEventListener("click",function(){previewReciboObj(r);});act.appendChild(bv);
    var bm=el("button",{class:"iconbtn",title:"Imprimir media carta"},ICON.print);
    bm.addEventListener("click",function(){imprimirRecibos([r],"mediacarta");});act.appendChild(bm);
    var bt=el("button",{class:"iconbtn",title:"Imprimir térmica 80 mm"},ICON.print);
    bt.style.opacity="0.65";
    bt.addEventListener("click",function(){imprimirRecibos([r],"termica");});act.appendChild(bt);
    var bd=el("button",{class:"iconbtn danger",title:"Eliminar del histórico"},ICON.trash);
    bd.addEventListener("click",function(){confirmar("¿Eliminar el recibo "+r.folio+"?","Se quitará del histórico.",function(){
      S.nominas=S.nominas.filter(function(x){return x.folio!==r.folio;});
      DataStore.call("deleteNomina",{folio:r.folio});pintarRecibos();toast("Recibo eliminado");});});
    act.appendChild(bd);
    tb.appendChild(tr);
  });
}
function previewReciboObj(r){
  var body='<div style="display:flex;gap:6px;margin-bottom:12px"><button class="chip2 active" id="vMC">Media carta</button><button class="chip2" id="vTK">Térmica 80 mm</button></div>'+
    '<div id="recPrev">'+reciboMediaCartaHTML(r)+'</div>';
  modal("Recibo "+r.folio,(r.colaborador&&r.colaborador.nombre)||"",body,null,'<button class="btn" id="cerrarPrev">Cerrar</button>');
  var m=$("#modal .modal");if(m)m.style.maxWidth="640px";
  $("#vMC").addEventListener("click",function(){$("#vMC").classList.add("active");$("#vTK").classList.remove("active");$("#recPrev").innerHTML=reciboMediaCartaHTML(r);});
  $("#vTK").addEventListener("click",function(){$("#vTK").classList.add("active");$("#vMC").classList.remove("active");$("#recPrev").innerHTML=reciboTicketHTML(r);});
  $("#cerrarPrev").addEventListener("click",cerrarModal);
}

/* ============================================================
   VISTA · REPORTE  (total + gráfica + desglose + exportación)
   ============================================================ */
var MESES_AB=["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"];
function bucketDe(dISO, periodo){
  var d=new Date((dISO||fechaISO(new Date()))+"T00:00:00");
  var y=d.getFullYear(), mo=d.getMonth();
  if(periodo==="mensual") return {key:y+"-"+pad(mo+1), label:MESES_AB[mo]+" "+y, order:y*100+mo};
  if(periodo==="bimestral"){var b=Math.floor(mo/2);return {key:y+"-B"+b, label:MESES_AB[b*2]+"–"+MESES_AB[Math.min(11,b*2+1)]+" "+y, order:y*100+b};}
  if(periodo==="trimestral"){var q=Math.floor(mo/3);return {key:y+"-T"+q, label:"T"+(q+1)+" "+y, order:y*100+q};}
  if(periodo==="catorcenal"){var blk=Math.floor((d.getTime()/86400000)/14);var ini=new Date(blk*14*86400000);var fin=new Date((blk*14+13)*86400000);
    return {key:"C"+blk, label:ini.getDate()+" "+MESES_AB[ini.getMonth()]+"–"+fin.getDate()+" "+MESES_AB[fin.getMonth()], order:blk};}
  // semanal
  var lun=lunesDe(d);return {key:"S"+fechaISO(lun), label:lun.getDate()+" "+MESES_AB[lun.getMonth()], order:Math.floor(lun.getTime()/86400000)};
}
function datosReporte(){
  var recs=S.nominas.filter(function(r){
    var f=r.inicio||r.fecha||"";
    if(S.repIni&&f<S.repIni)return false;
    if(S.repFin&&f>S.repFin)return false;
    return true;
  });
  var buckets={}, porColab={}, total=0;
  recs.forEach(function(r){
    var b=bucketDe(r.inicio||r.fecha, S.repPeriodo);
    var neto=Number(r.neto)||0; total+=neto;
    if(!buckets[b.key])buckets[b.key]={label:b.label,order:b.order,total:0};
    buckets[b.key].total+=neto;
    var cid=r.colId||"?", cn=(r.colaborador&&r.colaborador.nombre)||"—";
    if(!porColab[cid])porColab[cid]={nombre:cn,total:0,filas:{}};
    porColab[cid].total+=neto;
    if(!porColab[cid].filas[b.key])porColab[cid].filas[b.key]={label:b.label,order:b.order,total:0};
    porColab[cid].filas[b.key].total+=neto;
  });
  var arr=Object.keys(buckets).map(function(k){return buckets[k];}).sort(function(a,b){return a.order-b.order;});
  return {total:total, buckets:arr, porColab:porColab, n:recs.length};
}
function lineasReporteRecibo(r){
  var out=[];
  function add(arr,tipo){(arr||[]).forEach(function(l){out.push({nom:l.nom||"Sin concepto",tipo:tipo,monto:Number(l.monto)||0});});}
  add(r.per,"Percepción"); add(r.ded,"Deducción"); add(r.otros,"Otro pago");
  return out;
}
function conceptosReporteOptions(){
  var seen={}, arr=[];
  S.nominas.forEach(function(r){lineasReporteRecibo(r).forEach(function(l){
    var k=l.nom;
    if(!seen[k]){seen[k]=true;arr.push(k);}
  });});
  return arr.sort(function(a,b){return a.localeCompare(b);});
}
function valorReporteRecibo(r){
  if(!S.repConcepto)return Number(r.neto)||0;
  return lineasReporteRecibo(r).filter(function(l){return l.nom===S.repConcepto;})
    .reduce(function(a,l){return a+(Number(l.monto)||0);},0);
}
function totalMesCalendarioReporte(){
  var mes=S.repMesCal||fechaISO(new Date()).slice(0,7), n=0, total=0;
  S.nominas.forEach(function(r){
    var f=(r.inicio||r.fecha||"").slice(0,7);
    if(f===mes){n++;total+=Number(r.neto)||0;}
  });
  return {mes:mes,total:total,n:n};
}
function datosReporte(){
  var recs=S.nominas.filter(function(r){
    var f=r.inicio||r.fecha||"";
    if(S.repIni&&f<S.repIni)return false;
    if(S.repFin&&f>S.repFin)return false;
    if(S.repConcepto&&valorReporteRecibo(r)===0)return false;
    return true;
  });
  var buckets={}, porColab={}, total=0;
  recs.forEach(function(r){
    var b=bucketDe(r.inicio||r.fecha, S.repPeriodo);
    var val=valorReporteRecibo(r); total+=val;
    if(!buckets[b.key])buckets[b.key]={label:b.label,order:b.order,total:0};
    buckets[b.key].total+=val;
    var cid=r.colId||"?", cn=(r.colaborador&&r.colaborador.nombre)||"—";
    if(!porColab[cid])porColab[cid]={nombre:cn,total:0,filas:{},conceptos:{}};
    porColab[cid].total+=val;
    if(!porColab[cid].filas[b.key])porColab[cid].filas[b.key]={label:b.label,order:b.order,total:0,conceptos:{}};
    porColab[cid].filas[b.key].total+=val;
    lineasReporteRecibo(r).forEach(function(l){
      if(S.repConcepto&&l.nom!==S.repConcepto)return;
      if(!porColab[cid].conceptos[l.nom])porColab[cid].conceptos[l.nom]={nom:l.nom,tipo:l.tipo,total:0};
      if(!porColab[cid].filas[b.key].conceptos[l.nom])porColab[cid].filas[b.key].conceptos[l.nom]={nom:l.nom,tipo:l.tipo,total:0};
      porColab[cid].conceptos[l.nom].total+=l.monto;
      porColab[cid].filas[b.key].conceptos[l.nom].total+=l.monto;
    });
  });
  var arr=Object.keys(buckets).map(function(k){return buckets[k];}).sort(function(a,b){return a.order-b.order;});
  return {total:total,buckets:arr,porColab:porColab,n:recs.length};
}
function viewReporte(v){
  var card=el("div",{class:"card"});
  card.innerHTML='<div class="card-head"><div><h2>Reporte de nómina</h2>'+
    '<p class="sub">Total pagado y evolución por periodo, con desglose por colaborador. Filtra por periodo y rango de fechas.</p></div>'+
    '<div class="btn-row"><button class="btn btn-sm" id="repPdf">'+ICON.doc+' PDF</button>'+
      '<button class="btn btn-sm" id="repXls">'+ICON.xls+' Excel (.xls)</button></div></div>'+
    '<div class="rep-filters">'+
      '<div class="field rep-period"><label>Periodo</label><select id="repPer">'+
        Object.keys(REP_PERIODOS).map(function(p){return '<option value="'+p+'"'+(p===S.repPeriodo?" selected":"")+'>'+REP_PERIODOS[p].nom+'</option>';}).join("")+'</select></div>'+
      '<div class="field rep-concept"><label>Concepto</label><select id="repConcepto"><option value="">Todos los conceptos</option>'+
        conceptosReporteOptions().map(function(c){return '<option value="'+esc(c)+'"'+(c===S.repConcepto?" selected":"")+'>'+esc(c)+'</option>';}).join("")+'</select></div>'+
      '<div class="field rep-date"><label>Desde</label><input type="date" id="repIni" value="'+esc(S.repIni)+'"></div>'+
      '<div class="field rep-date"><label>Hasta</label><input type="date" id="repFin" value="'+esc(S.repFin)+'"></div>'+
      '<div class="field rep-month"><label>Mes calendario</label><input type="month" id="repMesCal" value="'+esc(S.repMesCal)+'"></div>'+
      '<button class="btn btn-sm" id="repClear">Limpiar</button>'+
    '</div>'+
    '<div id="repBody"></div>';
  v.appendChild(card);
  $("#repPer").addEventListener("change",function(){S.repPeriodo=this.value;pintarReporte();});
  $("#repConcepto").addEventListener("change",function(){S.repConcepto=this.value;pintarReporte();});
  $("#repIni").addEventListener("change",function(){S.repIni=this.value;pintarReporte();});
  $("#repFin").addEventListener("change",function(){S.repFin=this.value;pintarReporte();});
  $("#repMesCal").addEventListener("change",function(){S.repMesCal=this.value;pintarReporte();});
  $("#repClear").addEventListener("click",function(){S.repIni="";S.repFin="";S.repConcepto="";go("reporte");});
  $("#repPdf").addEventListener("click",exportarReportePDF);
  $("#repXls").addEventListener("click",exportarReporteXLS);
  pintarReporte();
}
function pintarReporte(){
  var host=$("#repBody");if(!host)return;
  var R=datosReporte();
  var html='<div class="rep-score"><div class="score-card"><div class="score-lbl">Total de nómina (filtro actual)</div>'+
    '<div class="score-val">'+money(R.total)+'</div>'+
    '<div class="score-sub">'+R.n+' recibo(s) · '+REP_PERIODOS[S.repPeriodo].nom.toLowerCase()+'</div></div></div>';
  html+='<div class="rep-chart">'+chartSVG(R.buckets)+'</div>';
  // desglose por colaborador (desplegable)
  html+='<h3 class="rep-h3">Detalle por colaborador</h3>';
  var ids=Object.keys(R.porColab);
  if(!ids.length){ html+='<div class="empty">'+ICON.chart+'No hay recibos en el rango seleccionado.</div>'; }
  else{
    ids.sort(function(a,b){return R.porColab[b].total-R.porColab[a].total;});
    ids.forEach(function(cid){
      var p=R.porColab[cid];
      var filas=Object.keys(p.filas).map(function(k){return p.filas[k];}).sort(function(a,b){return a.order-b.order;});
      html+='<details class="rep-det"><summary><span class="rep-name">'+esc(p.nombre)+'</span>'+
        '<span class="rep-tot">'+money(p.total)+'</span></summary>'+
        '<table class="data rep-table"><thead><tr><th>Periodo</th><th>Colaborador</th><th style="text-align:right">Monto Total</th></tr></thead><tbody>'+
        filas.map(function(f){return '<tr><td>'+esc(f.label)+'</td><td>'+esc(p.nombre)+'</td><td class="tabular" style="text-align:right">'+money(f.total)+'</td></tr>';}).join("")+
        '</tbody></table></details>';
    });
  }
  host.innerHTML=html;
}
function chartSVG(buckets){
  if(!buckets.length)return '<div class="empty">'+ICON.chart+'Sin datos para graficar.</div>';
  var W=Math.max(420, buckets.length*86+60), H=240, padL=54, padB=42, padT=14;
  var max=Math.max.apply(null,buckets.map(function(b){return b.total;}));max=max||1;
  var bw=(W-padL-16)/buckets.length, gw=bw*0.6, plotH=H-padB-padT;
  var s='<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 '+W+' '+H+'" font-family="Inter,Arial,sans-serif" class="bars">';
  // grid + eje Y (4 líneas)
  for(var i=0;i<=4;i++){var gy=padT+plotH*(i/4),val=max*(1-i/4);
    s+='<line x1="'+padL+'" y1="'+gy+'" x2="'+W+'" y2="'+gy+'" stroke="#E3E6F0" stroke-width="1"/>';
    s+='<text x="'+(padL-8)+'" y="'+(gy+4)+'" font-size="9.5" fill="#6A7088" text-anchor="end">'+Math.round(val).toLocaleString("es-MX")+'</text>';}
  buckets.forEach(function(b,idx){
    var x=padL+idx*bw+(bw-gw)/2, h=plotH*(b.total/max), y=padT+plotH-h;
    s+='<rect x="'+x+'" y="'+y+'" width="'+gw+'" height="'+Math.max(1,h)+'" rx="4" fill="#0E1B4D"><title>'+esc(b.label)+': '+money(b.total)+'</title></rect>';
    s+='<text x="'+(x+gw/2)+'" y="'+(y-5)+'" font-size="9.5" font-weight="700" fill="#0E1B4D" text-anchor="middle">'+Math.round(b.total).toLocaleString("es-MX")+'</text>';
    s+='<text x="'+(padL+idx*bw+bw/2)+'" y="'+(H-padB+16)+'" font-size="10" fill="#161A2E" text-anchor="middle">'+esc(b.label)+'</text>';
  });
  s+='</svg>';
  return s;
}
function reporteFilas(){
  var R=datosReporte(), out=[];
  Object.keys(R.porColab).forEach(function(cid){var p=R.porColab[cid];
    var filas=Object.keys(p.filas).map(function(k){return p.filas[k];}).sort(function(a,b){return a.order-b.order;});
    filas.forEach(function(f){out.push({periodo:f.label, colaborador:p.nombre, monto:f.total, order:f.order});});});
  out.sort(function(a,b){return a.order-b.order||a.colaborador.localeCompare(b.colaborador);});
  return {filas:out, total:R.total};
}
function exportarReportePDF(){
  var R=reporteFilas();
  if(!R.filas.length){toast("No hay datos para exportar","err");return;}
  var rows=R.filas.map(function(f){return '<tr><td>'+esc(f.periodo)+'</td><td>'+esc(f.colaborador)+'</td><td style="text-align:right">'+money(f.monto)+'</td></tr>';}).join("");
  var rango=(S.repIni||"inicio")+" a "+(S.repFin||"hoy");
  var html='<div class="rep-print"><h2 style="font-family:Space Grotesk">Reporte de nómina · Lienzo Librería</h2>'+
    '<p>Periodo: '+REP_PERIODOS[S.repPeriodo].nom+' · Rango: '+esc(rango)+'</p>'+
    '<table class="r-table" style="width:100%;border-collapse:collapse"><thead><tr><th>Periodo</th><th>Colaborador</th><th style="text-align:right">Monto Total</th></tr></thead>'+
    '<tbody>'+rows+'</tbody><tfoot><tr><td></td><td style="text-align:right;font-weight:700">Total</td><td style="text-align:right;font-weight:700">'+money(R.total)+'</td></tr></tfoot></table></div>';
  var area=$("#printarea");area.className="print-only print-reporte";area.innerHTML=html;setPrintPageStyle("reporte");
  printIsolado();
}
function exportarReporteXLS(){
  var R=reporteFilas();
  if(!R.filas.length){toast("No hay datos para exportar","err");return;}
  var rows=R.filas.map(function(f){return '<tr><td>'+esc(f.periodo)+'</td><td>'+esc(f.colaborador)+'</td><td>'+(Number(f.monto)||0).toFixed(2)+'</td></tr>';}).join("");
  var tabla='<table><thead><tr><th>Periodo</th><th>Colaborador</th><th>Monto Total</th></tr></thead><tbody>'+rows+
    '<tr><td></td><td>Total</td><td>'+(Number(R.total)||0).toFixed(2)+'</td></tr></tbody></table>';
  var xls='<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="utf-8"></head><body>'+tabla+'</body></html>';
  var blob=new Blob(["\ufeff"+xls],{type:"application/vnd.ms-excel"});
  var url=(window.URL||window.webkitURL).createObjectURL(blob);
  var a=document.createElement("a");a.href=url;a.download="reporte-nomina.xls";document.body.appendChild(a);a.click();a.remove();
  setTimeout(function(){(window.URL||window.webkitURL).revokeObjectURL(url);},1500);
  toast("Archivo .xls generado","ok");
}

function montoReporteFirmado(c){
  var m=Number(c&&c.total!=null?c.total:c&&c.monto)||0;
  var t=String(c&&c.tipo||"").toLowerCase();
  return t.indexOf("dedu")===0||t.indexOf("impuesto")===0?-Math.abs(m):Math.abs(m);
}

function moneySigned(n){
  n=Number(n)||0;
  return (n<0?"-":"+")+money(Math.abs(n));
}

function datosReporteColumnas(){
  var R=datosReporte(), colsSeen={}, cols=[], filas=[];
  Object.keys(R.porColab).forEach(function(cid){
    Object.keys(R.porColab[cid].conceptos||{}).forEach(function(k){
      if(!colsSeen[k]){colsSeen[k]=true;cols.push(k);}
    });
  });
  cols.sort(function(a,b){return a.localeCompare(b);});
  Object.keys(R.porColab).forEach(function(cid){
    var p=R.porColab[cid], row={colaborador:p.nombre,total:p.total,conceptos:{}};
    cols.forEach(function(c){row.conceptos[c]=0;});
    Object.keys(p.conceptos||{}).forEach(function(k){row.conceptos[k]=montoReporteFirmado(p.conceptos[k]);});
    filas.push(row);
  });
  filas.sort(function(a,b){return b.total-a.total||a.colaborador.localeCompare(b.colaborador);});
  return {cols:cols,filas:filas,total:R.total};
}

function viewReporte(v){
  var card=el("div",{class:"card"});
  card.innerHTML='<div class="card-head"><div><h2>Reporte de n&oacute;mina</h2>'+
    '<p class="sub">Total pagado y evoluci&oacute;n por periodo, con desglose por colaborador. Filtra por periodo, concepto y rango de fechas.</p></div>'+
    '<div class="btn-row"><button class="btn btn-sm" id="repPdf">'+ICON.doc+' PDF</button>'+
      '<button class="btn btn-sm" id="repXls">'+ICON.xls+' Excel (.xls)</button></div></div>'+
    '<div class="rep-filters">'+
      '<div class="rep-filter-line rep-filter-main">'+
        '<div class="field rep-period"><label>Periodo</label><select id="repPer">'+
          Object.keys(REP_PERIODOS).map(function(p){return '<option value="'+p+'"'+(p===S.repPeriodo?" selected":"")+'>'+REP_PERIODOS[p].nom+'</option>';}).join("")+'</select></div>'+
        '<div class="field rep-concept"><label>Concepto</label><select id="repConcepto"><option value="">Todos los conceptos</option>'+
          conceptosReporteOptions().map(function(c){return '<option value="'+esc(c)+'"'+(c===S.repConcepto?" selected":"")+'>'+esc(c)+'</option>';}).join("")+'</select></div>'+
        '<div class="field rep-month"><label>Mes calendario</label><input type="month" id="repMesCal" value="'+esc(S.repMesCal)+'"></div>'+
      '</div>'+
      '<div class="rep-filter-line rep-filter-dates">'+
        '<div class="field rep-date"><label>Desde</label><input type="date" id="repIni" value="'+esc(S.repIni)+'"></div>'+
        '<div class="field rep-date"><label>Hasta</label><input type="date" id="repFin" value="'+esc(S.repFin)+'"></div>'+
        '<button class="btn btn-sm" id="repClear">Limpiar</button>'+
      '</div>'+
    '</div>'+
    '<div id="repBody"></div>';
  v.appendChild(card);
  $("#repPer").addEventListener("change",function(){S.repPeriodo=this.value;pintarReporte();});
  $("#repConcepto").addEventListener("change",function(){S.repConcepto=this.value;pintarReporte();});
  $("#repIni").addEventListener("change",function(){S.repIni=this.value;pintarReporte();});
  $("#repFin").addEventListener("change",function(){S.repFin=this.value;pintarReporte();});
  $("#repMesCal").addEventListener("change",function(){S.repMesCal=this.value;pintarReporte();});
  $("#repClear").addEventListener("click",function(){S.repIni="";S.repFin="";S.repConcepto="";go("reporte");});
  $("#repPdf").addEventListener("click",exportarReportePDF);
  $("#repXls").addEventListener("click",exportarReporteXLS);
  pintarReporte();
}

function pintarReporte(){
  var host=$("#repBody");if(!host)return;
  var R=datosReporte(), M=totalMesCalendarioReporte();
  var concepto=S.repConcepto||"Todos los conceptos";
  var mesTxt=M.mes?new Date(M.mes+"-01T00:00:00").toLocaleDateString("es-MX",{month:"long",year:"numeric"}):"Mes no seleccionado";
  var html='<div class="rep-score"><div class="score-card"><div class="score-lbl">Total de n&oacute;mina (filtro actual)</div>'+
    '<div class="score-val">'+money(R.total)+'</div>'+
    '<div class="score-sub">'+R.n+' recibo(s) &middot; '+REP_PERIODOS[S.repPeriodo].nom.toLowerCase()+' &middot; '+esc(concepto)+'</div></div>'+
    '<div class="score-card score-month"><div class="score-lbl">Total mes calendario</div>'+
    '<div class="score-val">'+money(M.total)+'</div>'+
    '<div class="score-sub">'+esc(mesTxt)+' &middot; '+M.n+' recibo(s)</div></div></div>';
  html+='<div class="rep-chart">'+chartSVG(R.buckets)+'</div>';
  html+='<h3 class="rep-h3">Detalle por colaborador</h3>';
  var ids=Object.keys(R.porColab);
  if(!ids.length){ html+='<div class="empty">'+ICON.chart+'No hay recibos en el rango seleccionado.</div>'; }
  else{
    ids.sort(function(a,b){return R.porColab[b].total-R.porColab[a].total;});
    ids.forEach(function(cid){
      var p=R.porColab[cid];
      var filas=Object.keys(p.filas).map(function(k){return p.filas[k];}).sort(function(a,b){return a.order-b.order;});
      var resumen=Object.keys(p.conceptos||{}).map(function(k){return p.conceptos[k];}).sort(function(a,b){return a.tipo.localeCompare(b.tipo)||a.nom.localeCompare(b.nom);});
      var detalle=[];
      filas.forEach(function(f){
        var conceptos=Object.keys(f.conceptos||{}).map(function(k){return f.conceptos[k];}).sort(function(a,b){return a.tipo.localeCompare(b.tipo)||a.nom.localeCompare(b.nom);});
        if(!conceptos.length){detalle.push('<tr><td>'+esc(f.label)+'</td><td>Neto</td><td>Total</td><td class="tabular" style="text-align:right">'+money(f.total)+'</td></tr>');return;}
        conceptos.forEach(function(c){detalle.push('<tr><td>'+esc(f.label)+'</td><td>'+esc(c.nom)+'</td><td>'+esc(c.tipo)+'</td><td class="tabular" style="text-align:right">'+moneySigned(montoReporteFirmado(c))+'</td></tr>');});
      });
      html+='<details class="rep-det"><summary><span class="rep-name">'+esc(p.nombre)+'</span>'+
        '<span class="rep-tot">'+money(p.total)+'</span></summary>'+
        (resumen.length?'<div class="rep-concepts">'+resumen.map(function(c){return '<span><b>'+esc(c.nom)+'</b> '+money(c.total)+'</span>';}).join("")+'</div>':'')+
        '<table class="data rep-table"><thead><tr><th>Periodo</th><th>Concepto</th><th>Tipo</th><th style="text-align:right">Monto</th></tr></thead><tbody>'+
        detalle.join("")+'</tbody></table></details>';
    });
  }
  host.innerHTML=html;
}

function reporteFilas(){
  var R=datosReporte(), out=[];
  Object.keys(R.porColab).forEach(function(cid){
    var p=R.porColab[cid];
    var filas=Object.keys(p.filas).map(function(k){return p.filas[k];}).sort(function(a,b){return a.order-b.order;});
    filas.forEach(function(f){
      var conceptos=Object.keys(f.conceptos||{}).map(function(k){return f.conceptos[k];}).sort(function(a,b){return a.tipo.localeCompare(b.tipo)||a.nom.localeCompare(b.nom);});
      if(!conceptos.length){out.push({periodo:f.label,colaborador:p.nombre,concepto:"Neto",tipo:"Total",monto:f.total,order:f.order});return;}
      conceptos.forEach(function(c){out.push({periodo:f.label,colaborador:p.nombre,concepto:c.nom,tipo:c.tipo,monto:c.total,order:f.order});});
    });
  });
  out.sort(function(a,b){return a.order-b.order||a.colaborador.localeCompare(b.colaborador)||a.concepto.localeCompare(b.concepto);});
  return {filas:out,total:R.total};
}

function exportarReportePDF(){
  var R=datosReporteColumnas();
  if(!R.filas.length){toast("No hay datos para exportar","err");return;}
  var heads=R.cols.map(function(c){return '<th style="text-align:right">'+esc(c)+'</th>';}).join("");
  var rows=R.filas.map(function(f){return '<tr><td>'+esc(f.colaborador)+'</td>'+
    R.cols.map(function(c){return '<td style="text-align:right">'+(f.conceptos[c]?moneySigned(f.conceptos[c]):money(0))+'</td>';}).join("")+
    '<td style="text-align:right;font-weight:700">'+money(f.total)+'</td></tr>';}).join("");
  var rango=(S.repIni||"inicio")+" a "+(S.repFin||"hoy");
  var html='<div class="rep-print"><h2 style="font-family:Space Grotesk">Reporte de n&oacute;mina - Lienzo Libreria</h2>'+
    '<p>Periodo: '+REP_PERIODOS[S.repPeriodo].nom+' &middot; Rango: '+esc(rango)+' &middot; Concepto: '+esc(S.repConcepto||"Todos")+'</p>'+
    '<table class="r-table" style="width:100%;border-collapse:collapse"><thead><tr><th>Colaborador</th>'+heads+'<th style="text-align:right">Total</th></tr></thead>'+
    '<tbody>'+rows+'</tbody><tfoot><tr><td style="text-align:right;font-weight:700" colspan="'+(R.cols.length+1)+'">Total</td><td style="text-align:right;font-weight:700">'+money(R.total)+'</td></tr></tfoot></table></div>';
  var area=$("#printarea");area.className="print-only print-reporte";area.innerHTML=html;setPrintPageStyle("reporte");
  printIsolado();
}

function exportarReporteXLS(){
  var R=datosReporteColumnas();
  if(!R.filas.length){toast("No hay datos para exportar","err");return;}
  var heads=R.cols.map(function(c){return '<th>'+esc(c)+'</th>';}).join("");
  var rows=R.filas.map(function(f){return '<tr><td>'+esc(f.colaborador)+'</td>'+
    R.cols.map(function(c){return '<td>'+(Number(f.conceptos[c])||0).toFixed(2)+'</td>';}).join("")+
    '<td>'+(Number(f.total)||0).toFixed(2)+'</td></tr>';}).join("");
  var tabla='<table><thead><tr><th>Colaborador</th>'+heads+'<th>Total</th></tr></thead><tbody>'+rows+
    '<tr><td colspan="'+(R.cols.length+1)+'">Total</td><td>'+(Number(R.total)||0).toFixed(2)+'</td></tr></tbody></table>';
  var xls='<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="utf-8"></head><body>'+tabla+'</body></html>';
  var blob=new Blob(["\ufeff"+xls],{type:"application/vnd.ms-excel"});
  var url=(window.URL||window.webkitURL).createObjectURL(blob);
  var a=document.createElement("a");a.href=url;a.download="reporte-nomina.xls";document.body.appendChild(a);a.click();a.remove();
  setTimeout(function(){(window.URL||window.webkitURL).revokeObjectURL(url);},1500);
  toast("Archivo .xls generado","ok");
}

function palResumenReporte(){
  var R=palFiltrado(), total=R.items.length, done=R.items.filter(function(a){return a.done;}).length;
  var pending=total-done, assigned=total, pct=total?Math.round(done/total*100):0;
  return {items:R.items,total:total,done:done,pending:pending,assigned:assigned,unassigned:R.unassigned,pct:pct};
}
function viewReportePAL(v){
  var card=el("div",{class:"card report-pal-card"});
  card.innerHTML='<div class="card-head"><div><h2>Reporte PAL</h2>'+
    '<p class="sub">Cumplimiento, tareas completadas, pendientes, sin asignar e historial de check-in.</p></div>'+
    '<div class="btn-row"><button class="btn btn-sm" id="palRepPrint">'+ICON.print+' Imprimir</button></div></div>'+
    '<div class="rep-filters pal-report-filters">'+
      '<div class="rep-filter-line rep-filter-main">'+
        '<div class="field pal-range-field"><label>Periodo De Fecha</label><div class="pal-date-range"><input type="date" id="palRepDesde" value="'+esc(S.repPalDesde||S.repPalFecha)+'"><span>a</span><input type="date" id="palRepHasta" value="'+esc(S.repPalHasta||S.repPalFecha)+'"></div></div>'+
      '</div>'+
      '<div class="rep-filter-line rep-filter-dates">'+
        '<div class="field"><label>Colaborador</label><select id="palRepCol"><option value="">Todos</option>'+colsDeSucursal().map(function(c){return '<option value="'+c.id+'"'+(c.id===S.repPalCol?" selected":"")+'>'+esc(c.nombre)+'</option>';}).join("")+'</select></div>'+
        '<div class="field"><label>Tipo</label><select id="palRepTipo"><option value="">Diarias Y Semanales</option><option value="diaria"'+(S.repPalTipo==="diaria"?" selected":"")+'>Diarias</option><option value="semanal"'+(S.repPalTipo==="semanal"?" selected":"")+'>Semanales</option></select></div>'+
      '</div>'+
    '</div><div id="palRepBody"></div>';
  v.appendChild(card);
  ["Desde","Hasta","Col","Tipo"].forEach(function(k){
    var id="#palRep"+k, elx=$(id);if(!elx)return;
    elx.addEventListener("change",function(){
      S.repPalDesde=$("#palRepDesde").value||fechaISO(new Date());S.repPalHasta=$("#palRepHasta").value||S.repPalDesde;S.repPalCol=$("#palRepCol").value;S.repPalTipo=$("#palRepTipo").value;pintarReportePAL();
    });
  });
  $("#palRepPrint").addEventListener("click",imprimirReportePAL);
  pintarReportePAL();
}
function pintarReportePAL(){
  var host=$("#palRepBody");if(!host)return;
  var R=palResumenReporte();
  var byDay={};R.items.forEach(function(a){byDay[a.fecha]=byDay[a.fecha]||{label:a.fecha,total:0,done:0};byDay[a.fecha].total++;if(a.done)byDay[a.fecha].done++;});
  var buckets=Object.keys(byDay).sort().map(function(k){return {label:k,total:byDay[k].total?Math.round(byDay[k].done/byDay[k].total*100):0};});
  var rows=R.items.map(function(a){
    var hist=(a.history||[]).map(function(h){return (h.done?"Marcada ":"Desmarcada ")+fechaLarga(h.at)+" "+horaCorta(h.at);}).join(" | ");
    return '<tr><td>'+esc(a.fecha)+'</td><td>'+esc(a.col.nombre)+'</td><td>'+esc(a.task.nombre)+'</td><td>'+esc(a.tipo)+'</td><td>'+(a.done?horaCorta(a.at):"Pendiente")+'</td><td>'+esc(hist)+'</td></tr>';
  }).join("")||'<tr><td colspan="6"><div class="empty">Sin tareas para los filtros seleccionados.</div></td></tr>';
  host.innerHTML='<div class="pal-kpis"><div><b>'+R.pct+'%</b><span>Cumplimiento</span></div><div><b>'+R.done+'</b><span>Tareas completadas</span></div><div><b>'+R.pending+'</b><span>Tareas pendientes</span></div><div><b>'+R.assigned+'</b><span>Con responsable asignado</span></div><div class="warn"><b>'+R.unassigned+'</b><span>Sin asignar</span></div></div>'+
    '<div class="rep-chart">'+chartSVG(buckets)+'</div>'+
    '<h3 class="rep-h3">Detalle PAL</h3><div class="table-wrap"><table class="data rep-table"><thead><tr><th>Fecha</th><th>Colaborador</th><th>Tarea</th><th>Tipo</th><th>Hora final</th><th>Historial</th></tr></thead><tbody>'+rows+'</tbody></table></div>';
}
function imprimirReportePAL(){
  var R=palResumenReporte();
  var rows=R.items.map(function(a){return '<tr><td>'+esc(a.fecha)+'</td><td>'+esc(a.col.nombre)+'</td><td>'+esc(a.task.nombre)+'</td><td>'+esc(a.tipo)+'</td><td>'+(a.done?horaCorta(a.at):"Pendiente")+'</td></tr>';}).join("");
  var html='<div class="rep-print"><h2 style="font-family:Space Grotesk">Reporte PAL</h2><p>Cumplimiento: '+R.pct+'% · Completadas: '+R.done+' · Pendientes: '+R.pending+' · Sin asignar: '+R.unassigned+'</p>'+
    '<table class="r-table" style="width:100%;border-collapse:collapse"><thead><tr><th>Fecha</th><th>Colaborador</th><th>Tarea</th><th>Tipo</th><th>Hora</th></tr></thead><tbody>'+rows+'</tbody></table></div>';
  var area=$("#printarea");area.className="print-only print-reporte";area.innerHTML=html;setPrintPageStyle("reporte");printIsolado();
}
var _viewReporteNomina=viewReporte;
viewReporte=function(v){
  var tabs=el("div",{class:"subtabs report-subtabs"},'<button data-repsub="nomina" class="'+(S.repSub!=="pal"&&S.repSub!=="pedidos"&&S.repSub!=="incidencias"?"active":"")+'">Reporte De Nómina</button><button data-repsub="pal" class="'+(S.repSub==="pal"?"active":"")+'">Reporte PAL</button><button data-repsub="pedidos" class="'+(S.repSub==="pedidos"?"active":"")+'">Reporte Pedidos</button><button data-repsub="incidencias" class="'+(S.repSub==="incidencias"?"active":"")+'">Reporte Incidencias</button>');
  v.appendChild(tabs);
  $$("#view [data-repsub]").forEach(function(b){b.addEventListener("click",function(){S.repSub=b.getAttribute("data-repsub");go("reporte");});});
  if(S.repSub==="pal")viewReportePAL(v);
  else if(S.repSub==="pedidos")ensurePedidosLoaded().then(function(){viewReportePedidos(v);});
  else if(S.repSub==="incidencias")ensurePedidosLoaded().then(function(){viewReporteIncidencias(v);});
  else _viewReporteNomina(v);
};

/* ============================================================
   PEDIDOS Y SOLICITUDES
   ============================================================ */
function ensurePedidosData(){
  if(!S.pedidosData||typeof S.pedidosData!=="object")S.pedidosData={pedidos:[],solicitudes:[],incidencias:[],eventos:[],seqPedido:0,seqSolicitud:0,seqIncidencia:0,seqEvento:0};
  if(!Array.isArray(S.pedidosData.pedidos))S.pedidosData.pedidos=[];
  if(!Array.isArray(S.pedidosData.solicitudes))S.pedidosData.solicitudes=[];
  if(!Array.isArray(S.pedidosData.incidencias))S.pedidosData.incidencias=[];
  if(!Array.isArray(S.pedidosData.eventos))S.pedidosData.eventos=[];
  S.pedidosData.seqPedido=Number(S.pedidosData.seqPedido)||0;
  S.pedidosData.seqSolicitud=Number(S.pedidosData.seqSolicitud)||0;
  S.pedidosData.seqIncidencia=Number(S.pedidosData.seqIncidencia)||0;
  S.pedidosData.seqEvento=Number(S.pedidosData.seqEvento)||0;
}
function normalizarPedidosData(d){S.pedidosData=d||{};ensurePedidosData();return S.pedidosData;}
function pedidosDataParaGuardar(){
  ensurePedidosData();
  return {
    pedidos:JSON.parse(JSON.stringify(S.pedidosData.pedidos||[])),
    solicitudes:JSON.parse(JSON.stringify(S.pedidosData.solicitudes||[])),
    incidencias:JSON.parse(JSON.stringify(S.pedidosData.incidencias||[])),
    eventos:JSON.parse(JSON.stringify(S.pedidosData.eventos||[])),
    seqPedido:Number(S.pedidosData.seqPedido)||0,
    seqSolicitud:Number(S.pedidosData.seqSolicitud)||0,
    seqIncidencia:Number(S.pedidosData.seqIncidencia)||0,
    seqEvento:Number(S.pedidosData.seqEvento)||0
  };
}
function pedidoNo(n){return "PED-"+String(n).padStart(4,"0");}
function solicitudNo(n){return "SOL-"+String(n).padStart(4,"0");}
function hoyISO(){return fechaISO(new Date());}
function mesDeFecha(f){return String(f||"").slice(0,7);}
function enMesPedido(o,mes){return !mes||mesDeFecha(o.creado||"")===mes||mesDeFecha(o.entregadoFecha||"")===mes||mesDeFecha(o.atendidoFecha||"")===mes;}
function pedidoFecha(o){return o.entregadoFecha||o.creado||"";}
function solicitudFecha(o){return o.atendidoFecha||o.creado||"";}
function valReq(id,label){var elx=$(id),v=elx?String(elx.value||"").trim():"";if(!v){toast(label+" es obligatorio","err");if(elx)elx.focus();return null;}return v;}
function guardarPedidosYRepintar(msg){return DataStore.guardarPedidos().then(function(d){if(d&&!d.error){toast(msg||"Guardado","ok");pintarPedidos();}});}
function btnValidando(btn,label){
  if(!btn)return function(){};
  var old=btn.innerHTML;
  btn.disabled=true;btn.textContent=label||"Validando...";
  return function(){btn.disabled=false;btn.innerHTML=old;};
}
function viewPedidos(v){
  S.pedidosSub=S.pedidosSub||"pedidos";
  var tabs=el("div",{class:"subtabs pedidos-subtabs"},'<button data-pedsub="pedidos" class="'+(S.pedidosSub==="pedidos"?"active":"")+'">Pedidos</button><button data-pedsub="eventos" class="'+(S.pedidosSub==="eventos"?"active":"")+'">Eventos</button><button data-pedsub="incidencias" class="'+(S.pedidosSub==="incidencias"?"active":"")+'">Incidencias</button>');
  v.appendChild(tabs);
  $$("#view [data-pedsub]").forEach(function(b){b.addEventListener("click",function(){S.pedidosSub=b.getAttribute("data-pedsub");go("pedidos");});});
  if(S.pedidosSub==="incidencias")viewIncidencias(v);
  else if(S.pedidosSub==="eventos")viewEventos(v);
  else viewPedidosMain(v);
}
function viewPedidosMain(v){
  ensurePedidosData();
  var card=el("div",{class:"card pedidos-card"});
  card.innerHTML='<div class="card-head"><div><h2>Pedidos</h2><p class="sub">Gestiona pedidos de libros y solicitudes especiales.</p></div>'+
    '<div class="actions"><button class="btn btn-primary" id="newPedido">+ Nuevo Pedido</button><button class="btn btn-strong" id="newSolicitud">+ Nueva Solicitud</button></div></div>'+
    '<div class="filters pedidos-filters"><div class="field"><label>Mes</label><input type="month" id="pedMes" value="'+esc(S.pedidosMes||fechaISO(new Date()).slice(0,7))+'"></div></div>'+
    '<div id="pedidosHost"></div>';
  v.appendChild(card);
  $("#newPedido").addEventListener("click",modalNuevoPedido);
  $("#newSolicitud").addEventListener("click",modalNuevaSolicitud);
  $("#pedMes").addEventListener("change",function(){S.pedidosMes=this.value;pintarPedidos();});
  pintarPedidos();
}
function eventoNo(n){return "EVT-"+String(n).padStart(4,"0");}
function eventoPorId(id){ensurePedidosData();return S.pedidosData.eventos.find(function(x){return x.id===id;});}
function eventosSucursal(){ensurePedidosData();return S.pedidosData.eventos.filter(function(x){return !x.sucursalId||x.sucursalId===S.sucursalId;});}
function eventosDelDia(dISO){return eventosSucursal().filter(function(x){return (x.fecha||"")===dISO;}).sort(function(a,b){return String(a.hora||"").localeCompare(String(b.hora||""))||String(a.createdAt||"").localeCompare(String(b.createdAt||""));});}
function eventoTipoLabel(t){return t==="evento"?"Evento":"Reservación";}
function eventoEstadoLabel(x){return x&&x.estado==="cancelado"?"Cancelado":"Activo";}
function viewEventos(v){
  ensurePedidosData();
  S.eventosFecha=S.eventosFecha||hoyISO();
  var card=el("div",{class:"card pedidos-card eventos-card"});
  card.innerHTML='<div class="card-head"><div><h2>Eventos</h2><p class="sub">Consulta reservaciones y eventos especiales por día en '+esc(sucursalActiva().nombre)+'.</p></div><div class="actions"><button class="btn btn-primary" id="newReservacion">+ Nueva reservación</button><button class="btn btn-strong" id="newEvento">+ Registrar evento</button></div></div>'+
    '<div class="eventos-toolbar"><button class="btn eventos-nav-btn" id="eventosPrev">‹ Anterior</button><div class="field"><label>Seleccionar día</label><input type="date" id="eventosFecha" value="'+esc(S.eventosFecha)+'"></div><button class="btn eventos-today-btn" id="eventosHoy">Este Día</button><button class="btn eventos-nav-btn" id="eventosNext">Siguiente ›</button></div>'+
    '<div id="eventosHost"></div>';
  v.appendChild(card);
  $("#newReservacion").addEventListener("click",function(){modalEvento(null,"reservacion");});
  $("#newEvento").addEventListener("click",function(){modalEvento(null,"evento");});
  $("#eventosFecha").addEventListener("change",function(){S.eventosFecha=this.value||hoyISO();pintarEventos();});
  $("#eventosHoy").addEventListener("click",function(){S.eventosFecha=hoyISO();$("#eventosFecha").value=S.eventosFecha;pintarEventos();});
  $("#eventosPrev").addEventListener("click",function(){S.eventosFecha=fechaISO(sumaDias(fechaLocal(S.eventosFecha||hoyISO()),-1));$("#eventosFecha").value=S.eventosFecha;pintarEventos();});
  $("#eventosNext").addEventListener("click",function(){S.eventosFecha=fechaISO(sumaDias(fechaLocal(S.eventosFecha||hoyISO()),1));$("#eventosFecha").value=S.eventosFecha;pintarEventos();});
  pintarEventos();
}
function pintarEventos(){
  var host=$("#eventosHost");if(!host)return;
  var fecha=S.eventosFecha||hoyISO(), arr=eventosDelDia(fecha);
  var rows=arr.map(function(x){
    var cancel=x.estado==="cancelado";
    return '<div class="evento-row '+(cancel?'cancelado':'')+'" data-ver-evento="'+esc(x.id)+'">'+
      '<div class="evento-time"><b>'+esc(x.hora||"--:--")+'</b><span>'+esc(eventoTipoLabel(x.tipo))+'</span></div>'+
      '<div class="evento-main"><b>'+esc(x.cliente||"Sin cliente")+'</b><span>'+esc((x.personas||0)+' persona(s) · '+(x.contacto||"Sin contacto"))+'</span>'+(cancel?'<em>Cancelado</em>':'')+'</div>'+
      '<div class="pedido-actions"><button class="btn btn-sm" data-cancel-evento="'+esc(x.id)+'">Cancelar</button><button class="btn btn-danger-soft btn-sm" data-del-evento="'+esc(x.id)+'">Eliminar</button></div>'+
    '</div>';
  }).join("")||'<div class="empty">'+ICON.doc+'Sin reservaciones o eventos para este día.</div>';
  host.innerHTML='<div class="eventos-day-head"><h3>'+esc(fechaPedidoVisible(fecha))+'</h3><span>'+arr.length+' registro(s)</span></div><div class="eventos-list">'+rows+'</div>';
  $$("[data-ver-evento]").forEach(function(r){r.addEventListener("click",function(e){if(e.target.closest("button"))return;verEvento(r.getAttribute("data-ver-evento"));});});
  $$("[data-cancel-evento]").forEach(function(b){b.addEventListener("click",function(e){e.stopPropagation();cancelarEvento(b.getAttribute("data-cancel-evento"));});});
  $$("[data-del-evento]").forEach(function(b){b.addEventListener("click",function(e){e.stopPropagation();eliminarEvento(b.getAttribute("data-del-evento"));});});
}
function modalEvento(id,tipoNuevo){
  var actual=id?eventoPorId(id):null;
  var x=actual?Object.assign({},actual):{tipo:tipoNuevo||"reservacion",fecha:S.eventosFecha||hoyISO(),hora:"",cliente:"",contacto:"",personas:1,detalles:"",estado:"activo"};
  var body='<div class="form-grid evento-form"><div class="field"><label>Fecha</label><input id="evtFecha" type="date" value="'+esc(x.fecha||hoyISO())+'"></div>'+
    '<div class="field"><label>Hora</label><input id="evtHora" type="time" value="'+esc(x.hora||"")+'"></div>'+
    '<div class="field"><label>Nombre del cliente</label><input id="evtCliente" value="'+esc(x.cliente||"")+'"></div>'+
    '<div class="field"><label>Número de contacto</label><input id="evtContacto" type="tel" value="'+esc(x.contacto||"")+'"></div>'+
    '<div class="field"><label>Número de personas</label><input id="evtPersonas" type="number" min="1" step="1" value="'+esc(x.personas||1)+'"></div>'+
    '<div class="field evento-wide"><label>Detalles</label><textarea id="evtDetalles" rows="4">'+esc(x.detalles||"")+'</textarea></div></div>';
  modal(actual?("Editar "+eventoTipoLabel(x.tipo)):("Nueva "+eventoTipoLabel(x.tipo).toLowerCase()),"Registra fecha, hora y datos del cliente.",body,function(){
    var fecha=valReq("#evtFecha","Fecha"),hora=valReq("#evtHora","Hora"),cliente=valReq("#evtCliente","Nombre del cliente"),contacto=valReq("#evtContacto","Número de contacto"),personas=Number($("#evtPersonas").value)||0;
    if([fecha,hora,cliente,contacto].some(function(v){return v==null;}))return false;
    if(!(personas>0)){toast("El número de personas debe ser mayor a cero","err");return false;}
    var reset=btnValidando($("#mSave"),"Guardando...");
    var bak=pedidosDataParaGuardar();
    x.fecha=fecha;x.hora=hora;x.cliente=cliente;x.contacto=contacto;x.personas=personas;x.detalles=$("#evtDetalles").value.trim();x.updatedAt=new Date().toISOString();
    if(actual){Object.assign(actual,x);}
    else{var n=++S.pedidosData.seqEvento;x.id=uid("evt");x.numero=eventoNo(n);x.createdAt=new Date().toISOString();x.sucursalId=S.sucursalId;S.pedidosData.eventos.push(x);}
    S.eventosFecha=fecha;
    DataStore.guardarPedidos().then(function(d){
      reset();
      if(d&&!d.error){toast(actual?"Registro actualizado":"Registro guardado","ok");cerrarModal();pintarEventos();}
      else{S.pedidosData=bak;ensurePedidosData();}
    }).catch(function(){S.pedidosData=bak;ensurePedidosData();reset();});
    return false;
  });
  var cm=$("#modal .modal");if(cm)cm.classList.add("evento-modal");
}
function cancelarEvento(id){
  var x=eventoPorId(id);if(!x)return;
  var bak=pedidosDataParaGuardar();
  x.estado="cancelado";x.canceladoEn=new Date().toISOString();
  DataStore.guardarPedidos().then(function(d){if(d&&!d.error){toast("Registro cancelado","ok");pintarEventos();}else{S.pedidosData=bak;ensurePedidosData();pintarEventos();}}).catch(function(){S.pedidosData=bak;ensurePedidosData();pintarEventos();});
}
function eliminarEvento(id){
  var x=eventoPorId(id);if(!x)return;
  function del(){var bak=pedidosDataParaGuardar();S.pedidosData.eventos=S.pedidosData.eventos.filter(function(e){return e.id!==id;});DataStore.guardarPedidos().then(function(d){if(d&&!d.error){toast("Registro eliminado","ok");pintarEventos();}else{S.pedidosData=bak;ensurePedidosData();pintarEventos();}}).catch(function(){S.pedidosData=bak;ensurePedidosData();pintarEventos();});}
  if(x.tipo==="evento")pedirPasswordCualquiera("Eliminar evento",function(){cerrarModal();del();});
  else confirmar("Eliminar reservación","Se quitará del día seleccionado.",del);
}
function verEvento(id){
  var x=eventoPorId(id);if(!x)return;
  var body='<div class="detail-grid">'+detalle("Folio",x.numero||"")+detalle("Tipo",eventoTipoLabel(x.tipo))+detalle("Estado",eventoEstadoLabel(x))+detalle("Fecha",fechaPedidoVisible(x.fecha))+detalle("Hora",x.hora||"")+detalle("Cliente",x.cliente||"")+detalle("Contacto",x.contacto||"")+detalle("Personas",x.personas||0)+'</div><div class="detail-item inc-detail-wide"><span>Detalles</span><b>'+esc(x.detalles||"—")+'</b></div>';
  modal("Detalle de "+eventoTipoLabel(x.tipo).toLowerCase(),"Información registrada para la sucursal.",body,null,'<button class="btn" id="evtEdit">Editar</button><button class="btn" id="evtClose">Cerrar</button>');
  $("#evtClose").addEventListener("click",cerrarModal);
  $("#evtEdit").addEventListener("click",function(){cerrarModal();setTimeout(function(){modalEvento(id);},80);});
}
function incidenciaNo(n){return "INC-"+String(n).padStart(4,"0");}
function incidenciaTipoNombre(id){var t=incidenciaTipos().find(function(x){return x.id===id;});return t?t.nombre:(id||"Sin clasificación");}
function incidenciaPorId(id){ensurePedidosData();return S.pedidosData.incidencias.find(function(x){return x.id===id;});}
function incidenciasSucursal(){ensurePedidosData();return S.pedidosData.incidencias.filter(function(x){return !x.sucursalId||x.sucursalId===S.sucursalId;});}
function fechaRegistroIncidencia(x){return x.registradoEn||x.creado||x.fecha||"";}
function fechaRegistroVisible(x){var f=fechaRegistroIncidencia(x);if(!f)return "Sin fecha";if(String(f).indexOf("T")>0){var d=new Date(f);if(!isNaN(d.getTime()))return d.toLocaleString("es-MX",{day:"2-digit",month:"2-digit",year:"numeric",hour:"2-digit",minute:"2-digit"});}return fechaPedidoVisible(String(f).slice(0,10));}
function viewIncidencias(v){
  ensurePedidosData();incidenciaTipos();
  var card=el("div",{class:"card pedidos-card incidencias-card"});
  card.innerHTML='<div class="card-head"><div><h2>Incidencias</h2><p class="sub">Registra incidencias operativas y mermas de '+esc(sucursalActiva().nombre)+'.</p></div><div class="actions"><button class="btn btn-primary" id="newIncidencia">+ Nueva incidencia</button></div></div><div class="filters pedidos-filters"><div class="field"><label>Mes</label><input type="month" id="incMes" value="'+esc(S.pedidosMes||hoyISO().slice(0,7))+'"></div></div><div id="incidenciasHost"></div>';
  v.appendChild(card);
  $("#newIncidencia").addEventListener("click",function(){modalIncidencia(null);});
  $("#incMes").addEventListener("change",function(){S.pedidosMes=this.value;pintarIncidencias();});
  pintarIncidencias();
}
function pintarIncidencias(){
  var host=$("#incidenciasHost");if(!host)return;var mes=S.pedidosMes||"";
  var arr=incidenciasSucursal().filter(function(x){return !mes||mesDeFecha(x.fecha||x.creado)===mes;}).sort(function(a,b){return String(b.fecha||b.creado).localeCompare(String(a.fecha||a.creado));});
  var rows=arr.map(function(x){return '<div class="pedido-row incidencia-row" data-ver-inc="'+esc(x.id)+'"><div><b>'+esc(x.numero)+' · '+esc(x.descripcion)+'</b><span>'+esc(incidenciaTipoNombre(x.tipo))+' · Incidencia: '+esc(fechaPedidoVisible(x.fecha||x.creado))+' · '+esc(x.cantidad)+' '+esc(x.unidad||"unidad(es)")+'</span></div><div class="pedido-actions"><button class="btn btn-sm" data-print-inc="'+esc(x.id)+'">'+ICON.print+' Imprimir</button><button class="btn btn-sm" data-edit-inc="'+esc(x.id)+'">Editar</button><button class="btn btn-danger-soft btn-sm" data-del-inc="'+esc(x.id)+'">Eliminar</button></div></div>';}).join("")||'<div class="empty">'+ICON.doc+'Sin incidencias registradas en este mes.</div>';
  host.innerHTML='<div class="inc-resumen"><span>'+arr.length+' registro(s)</span></div><details class="pedido-list" open><summary>Incidencias y mermas <span>'+arr.length+'</span></summary><div class="pedido-list-body">'+rows+'</div></details>';
  $$('[data-ver-inc]').forEach(function(r){r.addEventListener("click",function(e){if(e.target.closest("button"))return;verIncidencia(r.getAttribute("data-ver-inc"));});});
  $$('[data-print-inc]').forEach(function(b){b.addEventListener("click",function(e){e.stopPropagation();imprimirIncidenciaTermica(b.getAttribute("data-print-inc"));});});
  $$('[data-edit-inc]').forEach(function(b){b.addEventListener("click",function(e){e.stopPropagation();editarIncidenciaSeguro(b.getAttribute("data-edit-inc"));});});
  $$('[data-del-inc]').forEach(function(b){b.addEventListener("click",function(e){e.stopPropagation();eliminarIncidencia(b.getAttribute("data-del-inc"));});});
}
function opcionesIncidenciaTipo(sel){return incidenciaTipos().filter(function(t){return t.activo!==false||t.id===sel;}).map(function(t){return '<option value="'+esc(t.id)+'"'+(t.id===sel?' selected':'')+'>'+esc(t.nombre)+'</option>';}).join("");}
function modalIncidencia(id){
  var actual=id?incidenciaPorId(id):null, x=actual?Object.assign({},actual):{fecha:hoyISO(),tipo:"",descripcion:"",cantidad:1,unidad:"unidad(es)",costo:0,encargado:"",responsable:"",notas:""};
  var body='<div class="form-grid incidencia-form"><div class="field"><label>Fecha de incidencia</label><input id="incFecha" type="date" value="'+esc(x.fecha||hoyISO())+'"></div><div class="field"><label>Clasificación</label><select id="incTipo"><option value="">Selecciona</option>'+opcionesIncidenciaTipo(x.tipo)+'</select></div><div class="field inc-wide"><label>Descripción</label><input id="incDescripcion" value="'+esc(x.descripcion||"")+'"></div><div class="field"><label>Cantidad</label><input id="incCantidad" type="number" min="0.01" step="0.01" value="'+esc(x.cantidad||1)+'"></div><div class="field"><label>Unidad</label><select id="incUnidad">'+["unidad(es)","pieza(s)","kg","litro(s)","paquete(s)","caja(s)"].map(function(u){return '<option'+(u===x.unidad?' selected':'')+'>'+u+'</option>';}).join("")+'</select></div><div class="field"><label>Valor estimado</label><input id="incCosto" type="number" min="0" step="0.01" value="'+esc(x.costo||0)+'"></div><div class="field"><label>Encargado en turno</label><input id="incEncargado" value="'+esc(x.encargado||"")+'"></div><div class="field"><label>Responsable</label><input id="incResponsable" value="'+esc(x.responsable||"")+'"></div><div class="field inc-wide inc-notes-field"><label>Notas</label><textarea id="incNotas" rows="3">'+esc(x.notas||"")+'</textarea></div></div>';
  modal(actual?"Editar incidencia":"Nueva incidencia","Registra la información de la incidencia o merma.",body,function(){
    var fecha=valReq("#incFecha","Fecha"),tipo=valReq("#incTipo","Clasificación"),descripcion=valReq("#incDescripcion","Descripción"),cantidad=Number($("#incCantidad").value);if(fecha==null||tipo==null||descripcion==null)return false;if(!(cantidad>0)){toast("La cantidad debe ser mayor a cero","err");return false;}
    x.fecha=fecha;x.tipo=tipo;x.descripcion=descripcion;x.cantidad=cantidad;x.unidad=$("#incUnidad").value;x.costo=Number($("#incCosto").value)||0;x.encargado=$("#incEncargado").value.trim();x.responsable=$("#incResponsable").value.trim();x.notas=$("#incNotas").value.trim();x.actualizadoEn=new Date().toISOString();
    if(actual){Object.assign(actual,x);}else{var n=++S.pedidosData.seqIncidencia;x.id=uid("inc");x.numero=incidenciaNo(n);x.creado=hoyISO();x.registradoEn=new Date().toISOString();x.sucursalId=S.sucursalId;S.pedidosData.incidencias.push(x);}
    DataStore.guardarPedidos().then(function(d){if(d&&!d.error){toast(actual?"Incidencia actualizada":"Incidencia guardada","ok");pintarIncidencias();}});
  });
  var cm=$("#modal .modal");if(cm)cm.classList.add("incidencia-modal");
}
function editarIncidenciaSeguro(id){pedirPasswordAccion("Editar incidencia","horarios",function(){cerrarModal();modalIncidencia(id);});}
function eliminarIncidencia(id){pedirPasswordAccion("Eliminar incidencia","admin",function(){S.pedidosData.incidencias=S.pedidosData.incidencias.filter(function(x){return x.id!==id;});cerrarModal();DataStore.guardarPedidos().then(function(d){if(d&&!d.error){toast("Incidencia eliminada","ok");pintarIncidencias();}});});}
function verIncidencia(id){var x=incidenciaPorId(id);if(!x)return;var body='<div class="detail-grid">'+detalle("Folio",x.numero)+detalle("Fecha de registro",fechaRegistroVisible(x))+detalle("Fecha de incidencia",fechaPedidoVisible(x.fecha||x.creado))+detalle("Clasificación",incidenciaTipoNombre(x.tipo))+detalle("Cantidad",x.cantidad+' '+(x.unidad||""))+detalle("Valor estimado",money(x.costo||0))+detalle("Encargado en turno",x.encargado||"—")+detalle("Responsable",x.responsable||"—")+'</div><div class="detail-item inc-detail-wide"><span>Descripción</span><b>'+esc(x.descripcion||"")+'</b></div><div class="detail-item inc-detail-wide"><span>Notas</span><b>'+esc(x.notas||"—")+'</b></div>';modal("Detalle de incidencia","Información registrada para la sucursal.",body,null,'<button class="btn" id="incPrintDetail">'+ICON.print+' Imprimir</button><button class="btn" id="incClose">Cerrar</button>');$("#incClose").addEventListener("click",cerrarModal);$("#incPrintDetail").addEventListener("click",function(){cerrarModal();setTimeout(function(){imprimirIncidenciaTermica(id);},80);});}
function imprimirIncidenciaTermica(id){var x=incidenciaPorId(id);if(!x)return;function ln(a,b){return '<div class="ln"><span>'+esc(a)+'</span><span class="n">'+esc(b)+'</span></div>';}var html='<div class="thermal-page"><div class="ticket inc-ticket"><div class="tk-brand-name">'+esc((S.config&&S.config.razonSocial)||"Lienzo Librería")+'</div><div class="center inc-ticket-title">REPORTE DE INCIDENCIA</div><hr>'+ln("Folio:",x.numero||"")+ln("Sucursal:",sucursalActiva().nombre)+ln("Registro:",fechaRegistroVisible(x))+ln("Incidencia:",fechaPedidoVisible(x.fecha||x.creado))+ln("Clasificación:",incidenciaTipoNombre(x.tipo))+'<hr><div class="inc-ticket-desc"><b>Descripción</b><br>'+esc(x.descripcion||"")+'</div>'+ln("Cantidad:",(x.cantidad||0)+' '+(x.unidad||""))+ln("Valor estimado:",money(x.costo||0))+ln("Encargado:",x.encargado||"—")+ln("Responsable:",x.responsable||"—")+(x.notas?'<hr><div class="inc-ticket-desc"><b>Notas</b><br>'+esc(x.notas)+'</div>':'')+'<div class="inc-ticket-signatures"><div><span></span><b>Encargado de sucursal</b></div><div><span></span><b>Responsable</b></div></div></div></div>';var area=$("#printarea");area.className="print-only print-termica print-incidencia-termica";area.innerHTML=html;setPrintPageStyle("termica");setTimeout(function(){window.print();},80);}
function fechaPedidoVisible(f){return f?fechaTexto(fechaLocal(f)):"Sin fecha";}
function pedidoNotasTexto(p){return (p.notas||[]).map(function(n){return (n.fecha?fechaPedidoVisible(n.fecha)+": ":"")+n.texto;}).join(" | ");}
function pedirPasswordAccion(titulo,scope,ok){
  modal(titulo,"",'<div class="field"><label>Contraseña</label><input id="accionPwd" type="password" autocomplete="current-password"></div>',function(){
    var pwd=valReq("#accionPwd","Contraseña");if(pwd==null)return false;
    var reset=btnValidando($("#mSave"),"Validando...");
    DataStore.autenticar(scope,pwd).then(function(r){if(!r||!r.ok){toast("Contraseña incorrecta","err");reset();return;}ok();})
      .catch(function(){toast("No se pudo validar","err");reset();});
    return false;
  });
}
function pedirPasswordCualquiera(titulo,ok){
  modal(titulo,"",'<div class="field"><label>Contraseña</label><input id="accionPwd" type="password" autocomplete="current-password"></div>',function(){
    var pwd=valReq("#accionPwd","Contraseña");if(pwd==null)return false;
    var reset=btnValidando($("#mSave"),"Validando...");
    function probar(scopes){
      if(!scopes.length){toast("Contraseña incorrecta","err");reset();return;}
      var scope=scopes.shift();
      DataStore.autenticar(scope,pwd).then(function(r){if(r&&r.ok){ok();return;}probar(scopes);})
        .catch(function(){probar(scopes);});
    }
    probar(["horarios","admin","docs"]);
    return false;
  });
}
function pintarPedidos(){
  ensurePedidosData();
  var host=$("#pedidosHost");if(!host)return;
  if(!S.pedidosLoaded&&_pedidosLoadPromise){host.innerHTML='<div class="empty"><span class="spin"></span><br>Cargando pedidos...</div>';return;}
  var mes=S.pedidosMes||"";
  var pedidos=S.pedidosData.pedidos.filter(function(p){return enMesPedido(p,mes);});
  var pendientes=pedidos.filter(function(p){return (p.estado||"pendiente")==="pendiente";});
  var entregados=pedidos.filter(function(p){return p.estado==="entregado";});
  var solicitudes=S.pedidosData.solicitudes.filter(function(s){return enMesPedido(s,mes);});
  host.innerHTML=pedidosSection("Pedidos Pendientes",pendientes,"pendientes")+pedidosSection("Pedidos Entregados",entregados,"entregados")+solicitudesSection(solicitudes);
  bindPedidos();
}
function pedidosSection(title,arr,tipo){
  var rows=arr.length?arr.map(function(p){
    var nota=p.notas&&p.notas.length?' · '+p.notas.length+' nota(s)':"";
    if(tipo==="pendientes")return '<div class="pedido-row" data-ver-pedido="'+esc(p.id)+'"><div><b>'+esc(p.numero)+' · '+esc(p.titulo)+'</b><span>'+esc(p.cliente)+' · Pedido: '+esc(fechaPedidoVisible(p.creado))+nota+'</span></div><div class="pedido-actions"><button class="btn btn-ok btn-sm" data-entregar="'+esc(p.id)+'">Entregar</button><button class="btn btn-sm" data-nota-pedido="'+esc(p.id)+'">Nota</button><button class="btn btn-danger-soft btn-sm" data-cancelar-pedido="'+esc(p.id)+'">Cancelar</button></div></div>';
    return '<div class="pedido-row delivered" data-ver-pedido="'+esc(p.id)+'"><div><b>'+esc(p.numero)+' · '+esc(p.titulo)+'</b><span>'+esc(p.cliente)+' · Pedido: '+esc(fechaPedidoVisible(p.creado))+' · Entregado: '+esc(fechaPedidoVisible(p.entregadoFecha||p.creado))+' · Ticket: '+esc(p.ticket||"")+nota+'</span></div><div class="pedido-actions"><button class="btn btn-sm" data-devolver-pedido="'+esc(p.id)+'">Devolución</button><button class="btn btn-danger-soft btn-sm" data-elim-pedido-admin="'+esc(p.id)+'">Eliminar</button></div></div>';
  }).join(""):'<div class="empty">'+ICON.doc+'Sin registros.</div>';
  return '<details class="pedido-list"><summary>'+esc(title)+' <span>'+arr.length+'</span></summary><div class="pedido-list-body">'+rows+'</div></details>';
}
function solicitudesSection(arr){
  var rows=arr.length?arr.map(function(s){var at=s.estado==="atendida";return '<div class="pedido-row solicitud '+(at?"done":"")+'" data-ver-sol="'+esc(s.id)+'"><div><b>'+esc(s.numero)+' · '+esc(s.titulo)+'</b><span>'+esc(s.cliente)+' · Solicitud: '+esc(fechaPedidoVisible(s.creado))+(at?' · Atendida: '+esc(fechaPedidoVisible(s.atendidoFecha)):'')+'</span></div><div class="pedido-actions"><span class="pill '+(at?"ok":"")+'">'+(at?"Atendida":"Pendiente")+'</span><button class="btn btn-danger-soft btn-sm" data-elim-sol="'+esc(s.id)+'">Eliminar</button></div></div>';}).join(""):'<div class="empty">'+ICON.doc+'Sin solicitudes.</div>';
  return '<details class="pedido-list"><summary>Solicitudes <span>'+arr.length+'</span></summary><div class="pedido-list-body">'+rows+'</div></details>';
}
function bindPedidos(){
  $$("[data-ver-pedido]").forEach(function(r){r.addEventListener("click",function(e){if(e.target.closest("button"))return;verPedido(r.getAttribute("data-ver-pedido"));});});
  $$("[data-entregar]").forEach(function(b){b.addEventListener("click",function(e){e.stopPropagation();entregarPedido(b.getAttribute("data-entregar"));});});
  $$("[data-nota-pedido]").forEach(function(b){b.addEventListener("click",function(e){e.stopPropagation();agregarNotaPedido(b.getAttribute("data-nota-pedido"));});});
  $$("[data-cancelar-pedido]").forEach(function(b){b.addEventListener("click",function(e){e.stopPropagation();cancelarPedido(b.getAttribute("data-cancelar-pedido"));});});
  $$("[data-elim-pedido-admin]").forEach(function(b){b.addEventListener("click",function(e){e.stopPropagation();eliminarPedidoAdmin(b.getAttribute("data-elim-pedido-admin"));});});
  $$("[data-devolver-pedido]").forEach(function(b){b.addEventListener("click",function(e){e.stopPropagation();devolverPedido(b.getAttribute("data-devolver-pedido"));});});
  $$("[data-ver-sol]").forEach(function(r){r.addEventListener("click",function(e){if(e.target.closest("button"))return;verSolicitud(r.getAttribute("data-ver-sol"));});});
  $$("[data-elim-sol]").forEach(function(b){b.addEventListener("click",function(e){e.stopPropagation();eliminarSolicitudSeguro(b.getAttribute("data-elim-sol"));});});
}
function modalNuevoPedido(){
  var body='<div class="form-grid pedidos-form"><div class="field"><label>Título De Libro</label><input id="pedTitulo"></div><div class="field"><label>Página De Referencia</label><input id="pedPagina"></div><div class="field"><label>Precio Dado</label><input id="pedPrecio" type="number" min="0" step="0.01"></div><div class="field"><label>Nombre De Cliente</label><input id="pedCliente"></div><div class="field"><label>Teléfono De Cliente</label><input id="pedTel" type="tel"></div><div class="field"><label>Número De Ticket</label><input id="pedTicket"></div></div>';
  modal("Nuevo Pedido","Todos los campos son obligatorios excepto pagina de referencia.",body,function(){
    var titulo=valReq("#pedTitulo","Título De Libro"),precio=valReq("#pedPrecio","Precio Dado"),cliente=valReq("#pedCliente","Nombre De Cliente"),tel=valReq("#pedTel","Teléfono De Cliente"),ticket=valReq("#pedTicket","Número De Ticket");
    if([titulo,precio,cliente,tel,ticket].some(function(x){return x==null;}))return false;
    ensurePedidosData();var n=++S.pedidosData.seqPedido;
    S.pedidosData.pedidos.push({id:uid("ped"),numero:pedidoNo(n),titulo:titulo,pagina:$("#pedPagina").value.trim(),precio:+precio||0,cliente:cliente,telefono:tel,ticket:ticket,estado:"pendiente",creado:hoyISO()});
    guardarPedidosYRepintar("Pedido guardado");
  });
  var cm=$("#modal .modal");if(cm)cm.classList.add("pedidos-modal");
}
function modalNuevaSolicitud(){
  var body='<div class="form-grid pedidos-form"><div class="field"><label>Título De Libro</label><input id="solTitulo"></div><div class="field"><label>Autor</label><input id="solAutor"></div><div class="field"><label>Editorial</label><input id="solEditorial"></div><div class="field"><label>ISBN</label><input id="solISBN"></div><div class="field"><label>Nombre De Cliente</label><input id="solCliente"></div><div class="field"><label>Número De Teléfono</label><input id="solTel" type="tel"></div></div>';
  modal("Nueva Solicitud","Autor, editorial e ISBN son opcionales.",body,function(){
    var titulo=valReq("#solTitulo","Título De Libro"),cliente=valReq("#solCliente","Nombre De Cliente"),tel=valReq("#solTel","Número De Teléfono");if([titulo,cliente,tel].some(function(x){return x==null;}))return false;
    ensurePedidosData();var n=++S.pedidosData.seqSolicitud;
    S.pedidosData.solicitudes.push({id:uid("sol"),numero:solicitudNo(n),titulo:titulo,autor:$("#solAutor").value.trim(),editorial:$("#solEditorial").value.trim(),isbn:$("#solISBN").value.trim(),cliente:cliente,telefono:tel,notas:[],estado:"pendiente",creado:hoyISO()});
    guardarPedidosYRepintar("Solicitud guardada");
  });
  var cm=$("#modal .modal");if(cm)cm.classList.add("pedidos-modal");
}
function pedidoPorId(id){ensurePedidosData();return S.pedidosData.pedidos.find(function(p){return p.id===id;});}
function solicitudPorId(id){ensurePedidosData();return S.pedidosData.solicitudes.find(function(s){return s.id===id;});}
function detalle(k,v){return '<div class="detail-item"><span>'+esc(k)+'</span><b>'+esc(v==null?"":v)+'</b></div>';}
function verPedido(id){
  var p=pedidoPorId(id);if(!p)return;
  var notas=(p.notas||[]).map(function(n,i){
    return '<li class="pedido-note-row"><div><b>'+esc(fechaPedidoVisible(n.fecha))+':</b> '+esc(n.texto)+'</div><div class="pedido-note-actions"><button class="btn btn-mini" data-ped-note-edit="'+i+'">Editar</button><button class="btn btn-mini btn-danger-soft" data-ped-note-del="'+i+'">Eliminar</button></div></li>';
  }).join("");
  var isEnt=p.estado==="entregado";
  var body='<div class="detail-grid">'+detalle("Número De Pedido",p.numero)+detalle("Título De Libro",p.titulo)+detalle("Fecha De Pedido",fechaPedidoVisible(p.creado))+detalle("Página De Referencia",p.pagina||"—")+detalle("Precio Dado",money(p.precio))+detalle("Nombre De Cliente",p.cliente)+detalle("Teléfono De Cliente",p.telefono)+(isEnt?detalle("Número De Ticket",p.ticket):"")+detalle("Estado",isEnt?"Entregado":"Pendiente")+(p.entregadoFecha?detalle("Fecha De Entrega",fechaPedidoVisible(p.entregadoFecha)):"")+'</div><div class="note-list"><h4>Notas</h4>'+(notas?'<ul>'+notas+'</ul>':'<p class="small">Sin notas registradas.</p>')+'</div>';
  modal("Detalle Del Pedido","Información completa del pedido.",body,null,'<button class="btn" id="cerrarPrev">Cerrar</button>');
  $("#cerrarPrev").addEventListener("click",cerrarModal);
  $$("[data-ped-note-edit]").forEach(function(b){b.addEventListener("click",function(){editarNotaPedido(id,+b.getAttribute("data-ped-note-edit"));});});
  $$("[data-ped-note-del]").forEach(function(b){b.addEventListener("click",function(){eliminarNotaPedido(id,+b.getAttribute("data-ped-note-del"));});});
}
function agregarNotaPedido(id){
  var p=pedidoPorId(id);if(!p)return;
  modal("Agregar Nota","",'<div class="field"><label>Nota</label><textarea id="pedNota" rows="3"></textarea></div>',function(){var txt=valReq("#pedNota","Nota");if(txt==null)return false;p.notas=p.notas||[];p.notas.push({fecha:hoyISO(),texto:txt});guardarPedidosYRepintar("Nota guardada");});
}
function editarNotaPedido(id,idx){
  var p=pedidoPorId(id);if(!p||!p.notas||!p.notas[idx])return;
  var n=p.notas[idx];
  var body='<div class="field"><label>Nota</label><textarea id="pedNotaEdit" rows="3">'+esc(n.texto||"")+'</textarea></div><div class="field"><label>Contraseña</label><input id="pedNotaPass" type="password" autocomplete="current-password"></div>';
  modal("Editar Nota","",body,function(){
    var txt=valReq("#pedNotaEdit","Nota"), pass=valReq("#pedNotaPass","Contraseña");if(txt==null||pass==null)return false;
    var reset=btnValidando($("#mSave"),"Validando...");
    DataStore.autenticar("horarios",pass).then(function(r){
      if(!r||!r.ok){toast("Contraseña incorrecta","err");reset();return;}
      n.texto=txt;n.editada=hoyISO();cerrarModal();guardarPedidosYRepintar("Nota actualizada");
    }).catch(function(){toast("No se pudo validar","err");reset();});
    return false;
  });
}
function eliminarNotaPedido(id,idx){
  var p=pedidoPorId(id);if(!p||!p.notas||!p.notas[idx])return;
  pedirPasswordAccion("Eliminar Nota","horarios",function(){p.notas.splice(idx,1);cerrarModal();guardarPedidosYRepintar("Nota eliminada");});
}
function cancelarPedido(id){
  var p=pedidoPorId(id);if(!p)return;
  pedirPasswordAccion("Cancelar Pedido","horarios",function(){p.estado="cancelado";p.canceladoFecha=hoyISO();cerrarModal();guardarPedidosYRepintar("Pedido cancelado");});
}
function eliminarPedidoAdmin(id){
  pedirPasswordAccion("Eliminar Pedido","admin",function(){S.pedidosData.pedidos=S.pedidosData.pedidos.filter(function(x){return x.id!==id;});cerrarModal();guardarPedidosYRepintar("Pedido eliminado");});
}
function devolverPedido(id){
  var p=pedidoPorId(id);if(!p)return;
  pedirPasswordAccion("Registrar Devolución","horarios",function(){p.estado="devuelto";p.devueltoFecha=hoyISO();cerrarModal();guardarPedidosYRepintar("Devolución registrada");});
}
function entregarPedido(id){
  var p=pedidoPorId(id);if(!p)return;
  modal("Entregar Pedido","El ticket debe coincidir con el registrado.",'<div class="field"><label>Número De Ticket</label><input id="entTicket"></div>',function(){var t=valReq("#entTicket","Número De Ticket");if(t==null)return false;if(t!==String(p.ticket)){toast("El ticket no coincide","err");return false;}p.estado="entregado";p.entregadoFecha=hoyISO();guardarPedidosYRepintar("Pedido entregado");});
}
function verSolicitud(id){
  var s=solicitudPorId(id);if(!s)return;
  var notas=(s.notas||[]).map(function(n,i){
    return '<li class="pedido-note-row"><div><b>'+esc(fechaPedidoVisible(n.fecha))+':</b> '+esc(n.texto)+'</div><div class="pedido-note-actions"><button class="btn btn-mini" data-sol-note-edit="'+i+'">Editar</button><button class="btn btn-mini btn-danger-soft" data-sol-note-del="'+i+'">Eliminar</button></div></li>';
  }).join("");
  var body='<div class="detail-grid">'+detalle("Número De Solicitud",s.numero)+detalle("Título De Libro",s.titulo)+detalle("Fecha De Solicitud",fechaPedidoVisible(s.creado))+detalle("Autor",s.autor||"—")+detalle("Editorial",s.editorial||"—")+detalle("ISBN",s.isbn||"—")+detalle("Nombre De Cliente",s.cliente)+detalle("Número De Teléfono",s.telefono)+detalle("Estado",s.estado==="atendida"?"Atendida":"Pendiente")+(s.atendidoFecha?detalle("Fecha De Atención",fechaPedidoVisible(s.atendidoFecha)):"")+'</div><div class="field" style="margin-top:14px"><label>Agregar Nota</label><textarea id="solNota" rows="3"></textarea></div><div class="note-list"><h4>Notas</h4>'+(notas?'<ul>'+notas+'</ul>':'<p class="small">Sin notas registradas.</p>')+'</div>';
  var foot='<button class="btn" id="solClose">Cerrar</button><button class="btn" id="solSaveNote">Guardar Nota</button>'+(s.estado==="atendida"?'':'<button class="btn btn-primary" id="solAttend">Atender Solicitud</button>');
  modal("Detalle De Solicitud","Registra seguimiento y atención.",body,null,foot);
  $("#solClose").addEventListener("click",cerrarModal);
  $("#solSaveNote").addEventListener("click",function(){var txt=$("#solNota").value.trim();if(!txt){toast("Agrega una nota","err");return;}s.notas=s.notas||[];s.notas.push({fecha:hoyISO(),texto:txt});cerrarModal();guardarPedidosYRepintar("Nota guardada");});
  var at=$("#solAttend");if(at)at.addEventListener("click",function(){var txt=$("#solNota").value.trim();if(!txt){toast("Para atender la solicitud debes agregar una nota","err");return;}s.notas=s.notas||[];s.notas.push({fecha:hoyISO(),texto:txt});s.estado="atendida";s.atendidoFecha=hoyISO();cerrarModal();guardarPedidosYRepintar("Solicitud atendida");});
  $$("[data-sol-note-edit]").forEach(function(b){b.addEventListener("click",function(){editarNotaSolicitud(id,+b.getAttribute("data-sol-note-edit"));});});
  $$("[data-sol-note-del]").forEach(function(b){b.addEventListener("click",function(){eliminarNotaSolicitud(id,+b.getAttribute("data-sol-note-del"));});});
}
function editarNotaSolicitud(id,idx){
  var s=solicitudPorId(id);if(!s||!s.notas||!s.notas[idx])return;
  var n=s.notas[idx];
  var body='<div class="field"><label>Nota</label><textarea id="solNotaEdit" rows="3">'+esc(n.texto||"")+'</textarea></div><div class="field"><label>Contraseña</label><input id="solNotaPass" type="password" autocomplete="current-password"></div>';
  modal("Editar Nota","",body,function(){
    var txt=valReq("#solNotaEdit","Nota"), pass=valReq("#solNotaPass","Contraseña");if(txt==null||pass==null)return false;
    var reset=btnValidando($("#mSave"),"Validando...");
    DataStore.autenticar("horarios",pass).then(function(r){
      if(!r||!r.ok){toast("Contraseña incorrecta","err");reset();return;}
      n.texto=txt;n.editada=hoyISO();cerrarModal();guardarPedidosYRepintar("Nota actualizada");
    }).catch(function(){toast("No se pudo validar","err");reset();});
    return false;
  });
}
function eliminarNotaSolicitud(id,idx){
  var s=solicitudPorId(id);if(!s||!s.notas||!s.notas[idx])return;
  pedirPasswordAccion("Eliminar Nota","horarios",function(){s.notas.splice(idx,1);cerrarModal();guardarPedidosYRepintar("Nota eliminada");});
}
function eliminarSolicitudSeguro(id){
  var s=solicitudPorId(id);if(!s)return;
  pedirPasswordAccion("Eliminar Solicitud",s.estado==="atendida"?"admin":"horarios",function(){S.pedidosData.solicitudes=S.pedidosData.solicitudes.filter(function(x){return x.id!==id;});cerrarModal();guardarPedidosYRepintar("Solicitud eliminada");});
}
function pedidosRangoReporte(){var desde=S.pedRepModo==="rango"?(S.pedRepDesde||hoyISO()):(S.pedRepMes||hoyISO().slice(0,7))+"-01";var hasta=S.pedRepModo==="rango"?(S.pedRepHasta||desde):fechaISO(new Date(+desde.slice(0,4),+desde.slice(5,7),0));if(desde>hasta){var t=desde;desde=hasta;hasta=t;}return {desde:desde,hasta:hasta};}
function inRangeFecha(f,r){return f&&f>=r.desde&&f<=r.hasta;}
function datosReportePedidos(){
  ensurePedidosData();var r=pedidosRangoReporte(),tipo=S.pedRepTipo||"todos";
  var pedidos=S.pedidosData.pedidos.filter(function(p){return inRangeFecha(pedidoFecha(p),r);}), solicitudes=S.pedidosData.solicitudes.filter(function(s){return inRangeFecha(solicitudFecha(s),r);});
  var pedDone=pedidos.filter(function(p){return p.estado==="entregado";}).length, solDone=solicitudes.filter(function(s){return s.estado==="atendida";}).length, rows=[];
  if(tipo==="todos"||tipo==="pedidos")pedidos.forEach(function(p){rows.push({grupo:p.estado==="entregado"?"Pedidos Entregados":"Pedidos Pendientes",tipo:"Pedido",numero:p.numero,titulo:p.titulo,pagina:p.pagina,precio:p.precio,cliente:p.cliente,telefono:p.telefono,ticket:p.ticket,estado:p.estado,fecha:p.entregadoFecha||p.creado});});
  if(tipo==="todos"||tipo==="solicitudes")solicitudes.forEach(function(s){rows.push({grupo:s.estado==="atendida"?"Solicitudes Atendidas":"Solicitudes Pendientes",tipo:"Solicitud",numero:s.numero,titulo:s.titulo,autor:s.autor,editorial:s.editorial,isbn:s.isbn,cliente:s.cliente,telefono:s.telefono,notas:(s.notas||[]).map(function(n){return n.texto;}).join(" | "),estado:s.estado,fecha:s.atendidoFecha||s.creado});});
  return {pedidos:pedidos.length,solicitudes:solicitudes.length,pedPend:pedidos.length-pedDone,solPend:solicitudes.length-solDone,pedPct:pedidos.length?Math.round(pedDone/pedidos.length*100):0,solPct:solicitudes.length?Math.round(solDone/solicitudes.length*100):0,rows:rows,rango:r};
}
function viewReportePedidos(v){
  var card=el("div",{class:"card"});
  card.innerHTML='<div class="card-head"><div><h2>Reporte Pedidos</h2><p class="sub">Pedidos, solicitudes, cumplimiento y detalle para impresión o Excel.</p></div><div class="actions"><button class="btn" id="pedRepPrint">'+ICON.print+' Imprimir A4</button><button class="btn" id="pedRepXls">'+ICON.doc+' Excel (.xls)</button></div></div><div class="filters pedidos-report-filters"><div class="field"><label>Tipo</label><select id="pedRepTipo"><option value="todos">Pedidos Y Solicitudes</option><option value="pedidos">Pedidos</option><option value="solicitudes">Solicitudes</option></select></div><div class="field"><label>Periodo</label><select id="pedRepModo"><option value="mes">Mes</option><option value="rango">Fecha X A Y</option></select></div><div class="field ped-rep-month"><label>Mes</label><input type="month" id="pedRepMes" value="'+esc(S.pedRepMes)+'"></div><div class="field ped-rep-range"><label>Desde</label><input type="date" id="pedRepDesde" value="'+esc(S.pedRepDesde)+'"></div><div class="field ped-rep-range"><label>Hasta</label><input type="date" id="pedRepHasta" value="'+esc(S.pedRepHasta)+'"></div></div><div id="pedRepHost"></div>';
  v.appendChild(card);$("#pedRepTipo").value=S.pedRepTipo;$("#pedRepModo").value=S.pedRepModo;
  ["Tipo","Modo","Mes","Desde","Hasta"].forEach(function(k){$("#pedRep"+k).addEventListener("change",function(){S.pedRepTipo=$("#pedRepTipo").value;S.pedRepModo=$("#pedRepModo").value;S.pedRepMes=$("#pedRepMes").value;S.pedRepDesde=$("#pedRepDesde").value;S.pedRepHasta=$("#pedRepHasta").value;pintarReportePedidos();});});
  $("#pedRepPrint").addEventListener("click",imprimirReportePedidos);$("#pedRepXls").addEventListener("click",exportarReportePedidosXLS);pintarReportePedidos();
}
function pintarReportePedidos(){
  var host=$("#pedRepHost");if(!host)return;var R=datosReportePedidos();
  $$(".ped-rep-range").forEach(function(x){x.style.display=S.pedRepModo==="rango"?"grid":"none";});$$(".ped-rep-month").forEach(function(x){x.style.display=S.pedRepModo==="mes"?"grid":"none";});
  var cards='<div class="kpis pedidos-kpis">'+pedKpi("Pedidos",R.pedidos)+pedKpi("Solicitudes",R.solicitudes)+pedKpi("Pedidos Pendientes",R.pedPend)+pedKpi("Solicitudes Pendientes",R.solPend)+pedKpi("Cumplimiento Pedidos",R.pedPct+"%")+pedKpi("Cumplimiento Solicitudes",R.solPct+"%")+'</div>';
  var groups={};R.rows.forEach(function(r){groups[r.grupo]=groups[r.grupo]||[];groups[r.grupo].push(r);});
  var detail=Object.keys(groups).map(function(g){return '<h3 class="rep-h3">'+esc(g)+'</h3>'+tablaPedidosReporte(groups[g]);}).join("")||'<div class="empty">'+ICON.doc+'Sin datos para el filtro seleccionado.</div>';
  host.innerHTML=cards+detail;
}
function pedKpi(lbl,val){return '<div class="stat"><b>'+esc(val)+'</b><span>'+esc(lbl)+'</span></div>';}
function notasTicketReporte(r){var a=[];if(r.notas)a.push(r.notas);if(r.ticket&&r.estado==="entregado")a.push("Ticket: "+r.ticket);return a.join(" | ");}
function tablaPedidosReporte(rows,printable){var cls=printable?'ped-print-table':'data rep-table';var table='<table class="'+cls+'"><thead><tr><th>Tipo</th><th>Número</th><th>Título</th><th>Referencia / Autor</th><th>Precio / Editorial</th><th>ISBN</th><th>Cliente</th><th>Teléfono</th><th>Estado</th><th>Fecha</th><th>Notas / Ticket</th></tr></thead><tbody>'+rows.map(function(r){return '<tr><td>'+esc(r.tipo)+'</td><td>'+esc(r.numero)+'</td><td>'+esc(r.titulo)+'</td><td>'+esc(r.pagina||r.autor||"")+'</td><td>'+esc(r.precio!=null?money(r.precio):(r.editorial||""))+'</td><td>'+esc(r.isbn||"")+'</td><td>'+esc(r.cliente)+'</td><td>'+esc(r.telefono)+'</td><td>'+esc(r.estado)+'</td><td>'+esc(r.fecha||"")+'</td><td>'+esc(notasTicketReporte(r))+'</td></tr>';}).join("")+'</tbody></table>';return printable?table:'<div class="table-wrap">'+table+'</div>';}
function imprimirReportePedidos(){var R=datosReportePedidos(),html='<div class="rep-print"><h2 style="font-family:Space Grotesk">Reporte Pedidos</h2><p>'+esc(R.rango.desde)+' a '+esc(R.rango.hasta)+'</p>'+tablaPedidosReporte(R.rows,true)+'</div>';var area=$("#printarea");area.className="print-only print-pedidos";area.innerHTML=html;setPrintPageStyle("pedidos");printIsolado();}
function exportarReportePedidosXLS(){var R=datosReportePedidos(),rows=R.rows.map(function(r){return '<tr><td>'+esc(r.tipo)+'</td><td>'+esc(r.numero)+'</td><td>'+esc(r.titulo)+'</td><td>'+esc(r.pagina||r.autor||"")+'</td><td>'+esc(r.precio!=null?Number(r.precio).toFixed(2):(r.editorial||""))+'</td><td>'+esc(r.isbn||"")+'</td><td>'+esc(r.cliente)+'</td><td>'+esc(r.telefono)+'</td><td>'+esc(r.estado)+'</td><td>'+esc(r.fecha||"")+'</td><td>'+esc(notasTicketReporte(r))+'</td></tr>';}).join("");var xls='<html xmlns:x="urn:schemas-microsoft-com:office:excel"><head><meta charset="utf-8"></head><body><table><thead><tr><th>Tipo</th><th>Número</th><th>Título</th><th>Referencia / Autor</th><th>Precio / Editorial</th><th>ISBN</th><th>Cliente</th><th>Teléfono</th><th>Estado</th><th>Fecha</th><th>Notas / Ticket</th></tr></thead><tbody>'+rows+'</tbody></table></body></html>';var blob=new Blob(["\ufeff"+xls],{type:"application/vnd.ms-excel"}),url=URL.createObjectURL(blob),a=document.createElement("a");a.href=url;a.download="reporte-pedidos.xls";document.body.appendChild(a);a.click();a.remove();URL.revokeObjectURL(url);}

function incidenciasRangoReporte(){var desde=S.incRepModo==="rango"?(S.incRepDesde||hoyISO()):(S.incRepMes||hoyISO().slice(0,7))+"-01";var hasta=S.incRepModo==="rango"?(S.incRepHasta||desde):fechaISO(new Date(+desde.slice(0,4),+desde.slice(5,7),0));if(desde>hasta){var t=desde;desde=hasta;hasta=t;}return {desde:desde,hasta:hasta};}
function datosReporteIncidencias(){var r=incidenciasRangoReporte(),tipo=S.incRepTipo||"todos";var rows=incidenciasSucursal().filter(function(x){var f=x.fecha||x.creado;return inRangeFecha(f,r)&&(tipo==="todos"||x.tipo===tipo);}).sort(function(a,b){return String(a.fecha||a.creado).localeCompare(String(b.fecha||b.creado));});return {rows:rows,rango:r,cantidad:rows.reduce(function(s,x){return s+(Number(x.cantidad)||0);},0),costo:rows.reduce(function(s,x){return s+(Number(x.costo)||0);},0),tipos:new Set(rows.map(function(x){return x.tipo;})).size};}
function viewReporteIncidencias(v){
  incidenciaTipos();var card=el("div",{class:"card"});
  card.innerHTML='<div class="card-head"><div><h2>Reporte Incidencias</h2><p class="sub">Consulta incidencias y mermas por clasificación, mes o rango de fechas.</p></div><div class="actions"><button class="btn" id="incRepPrint">'+ICON.print+' Imprimir A4</button><button class="btn" id="incRepXls">'+ICON.doc+' Excel (.xls)</button></div></div><div class="filters pedidos-report-filters incidencias-report-filters"><div class="field"><label>Clasificación</label><select id="incRepTipo"><option value="todos">Todas</option>'+incidenciaTipos().map(function(t){return '<option value="'+esc(t.id)+'">'+esc(t.nombre)+'</option>';}).join("")+'</select></div><div class="field"><label>Periodo</label><select id="incRepModo"><option value="mes">Mes</option><option value="rango">Fecha X A Y</option></select></div><div class="field inc-rep-month"><label>Mes</label><input type="month" id="incRepMes" value="'+esc(S.incRepMes)+'"></div><div class="field inc-rep-range"><label>Desde</label><input type="date" id="incRepDesde" value="'+esc(S.incRepDesde)+'"></div><div class="field inc-rep-range"><label>Hasta</label><input type="date" id="incRepHasta" value="'+esc(S.incRepHasta)+'"></div></div><div id="incRepHost"></div>';
  v.appendChild(card);$("#incRepTipo").value=S.incRepTipo;$("#incRepModo").value=S.incRepModo;
  ["Tipo","Modo","Mes","Desde","Hasta"].forEach(function(k){$("#incRep"+k).addEventListener("change",function(){S.incRepTipo=$("#incRepTipo").value;S.incRepModo=$("#incRepModo").value;S.incRepMes=$("#incRepMes").value;S.incRepDesde=$("#incRepDesde").value;S.incRepHasta=$("#incRepHasta").value;pintarReporteIncidencias();});});
  $("#incRepPrint").addEventListener("click",imprimirReporteIncidencias);$("#incRepXls").addEventListener("click",exportarReporteIncidenciasXLS);pintarReporteIncidencias();
}
function tablaReporteIncidencias(rows,printable){var cls=printable?'ped-print-table':'data rep-table';var table='<table class="'+cls+'"><thead><tr><th>Folio</th><th>Fecha de registro</th><th>Fecha de incidencia</th><th>Clasificación</th><th>Descripción</th><th>Cantidad</th><th>Unidad</th><th>Valor estimado</th><th>Encargado en turno</th><th>Responsable</th><th>Notas</th></tr></thead><tbody>'+rows.map(function(x){return '<tr><td>'+esc(x.numero||"")+'</td><td>'+esc(fechaRegistroVisible(x))+'</td><td>'+esc(x.fecha||x.creado||"")+'</td><td>'+esc(incidenciaTipoNombre(x.tipo))+'</td><td>'+esc(x.descripcion||"")+'</td><td>'+esc(x.cantidad||0)+'</td><td>'+esc(x.unidad||"")+'</td><td>'+esc(Number(x.costo||0).toFixed(2))+'</td><td>'+esc(x.encargado||"")+'</td><td>'+esc(x.responsable||"")+'</td><td>'+esc(x.notas||"")+'</td></tr>';}).join("")+'</tbody></table>';return printable?table:'<div class="table-wrap">'+table+'</div>';}
function pintarReporteIncidencias(){var host=$("#incRepHost");if(!host)return;var R=datosReporteIncidencias();$$('.inc-rep-range').forEach(function(x){x.style.display=S.incRepModo==="rango"?"grid":"none";});$$('.inc-rep-month').forEach(function(x){x.style.display=S.incRepModo==="mes"?"grid":"none";});host.innerHTML='<div class="kpis pedidos-kpis incidencias-kpis">'+pedKpi("Registros",R.rows.length)+pedKpi("Clasificaciones",R.tipos)+pedKpi("Cantidad total",Number(R.cantidad.toFixed(2)))+pedKpi("Valor estimado",money(R.costo))+'</div>'+(R.rows.length?tablaReporteIncidencias(R.rows):'<div class="empty">'+ICON.doc+'Sin incidencias para el filtro seleccionado.</div>');}
function imprimirReporteIncidencias(){var R=datosReporteIncidencias(),html='<div class="rep-print"><h2 style="font-family:Space Grotesk">Reporte Incidencias</h2><p>'+esc(sucursalActiva().nombre)+' · '+esc(R.rango.desde)+' a '+esc(R.rango.hasta)+'</p><p>Registros: '+R.rows.length+' · Cantidad: '+Number(R.cantidad.toFixed(2))+' · Valor estimado: '+money(R.costo)+'</p>'+tablaReporteIncidencias(R.rows,true)+'</div>';var area=$("#printarea");area.className="print-only print-pedidos";area.innerHTML=html;setPrintPageStyle("pedidos");printIsolado();}
function exportarReporteIncidenciasXLS(){var R=datosReporteIncidencias(),xls='<html xmlns:x="urn:schemas-microsoft-com:office:excel"><head><meta charset="utf-8"></head><body><h2>Reporte Incidencias</h2><p>'+esc(sucursalActiva().nombre)+' · '+esc(R.rango.desde)+' a '+esc(R.rango.hasta)+'</p>'+tablaReporteIncidencias(R.rows,true)+'</body></html>';var blob=new Blob(["\ufeff"+xls],{type:"application/vnd.ms-excel"}),url=URL.createObjectURL(blob),a=document.createElement("a");a.href=url;a.download="reporte-incidencias.xls";document.body.appendChild(a);a.click();a.remove();URL.revokeObjectURL(url);}

function campo(label,id,val,type){
  if(type==="date")val=fechaInput(val);
  return '<div class="field"><label>'+label+'</label><input id="f-'+id+'" type="'+(type||"text")+'" value="'+(val==null?"":esc(val))+'"></div>';}
function campoInline(label,id,val,type){
  if(type==="date")val=fechaInput(val);
  return '<div class="field" style="max-width:200px;margin:0"><label>'+label+'</label><input id="'+id+'" type="'+(type||"text")+'" value="'+(val==null?"":esc(val))+'"></div>';}
function opts(map,sel){return Object.keys(map).map(function(k){return '<option value="'+k+'"'+(k===sel?" selected":"")+'>'+map[k]+'</option>';}).join("");}

var _modalCb=null;
function modal(title,sub,bodyHTML,onSave,extraFootHTML){
  var bg=$("#modal");
  bg.innerHTML='<div class="modal"><h3>'+esc(title)+'</h3>'+(sub?'<p class="sub">'+esc(sub)+'</p>':'')+
    '<div class="modal-body">'+bodyHTML+'</div>'+
    '<div class="modal-foot">'+(extraFootHTML||"")+
      (onSave?'<button class="btn" id="mCancel">Cancelar</button><button class="btn btn-primary" id="mSave">Guardar</button>':'')+
    '</div></div>';
  bg.classList.add("open");
  _modalCb=onSave;
  if(onSave){
    $("#mSave").addEventListener("click",function(){var r=onSave();if(r!==false)cerrarModal();});
    $("#mCancel").addEventListener("click",cancelarModal);
  }
  bg.onclick=function(e){if(e.target===bg)cancelarModal();};
}
function cancelarModal(){if(S.sync)S.sync.pending=false;cerrarModal();}
function cerrarModal(){
  var bg=$("#modal");bg.classList.remove("open");bg.innerHTML="";
  setTimeout(function(){if(S.sync&&S.sync.pending&&!edicionActiva()){S.sync.pending=false;solicitarSyncVivo("modal-cerrado",true);}},180);
}
function confirmar(title,sub,onYes){
  modal(title,sub,'<p class="small">Esta acción no se puede deshacer.</p>',function(){onYes();},'');
}

function toast(msg,kind){
  var w=$("#toasts");var t=el("div",{class:"toast"+(kind?" "+kind:"")},esc(msg));
  w.appendChild(t);setTimeout(function(){t.style.opacity="0";setTimeout(function(){t.remove();},300);},2400);
}

/* ============================================================
   DOCUMENTACION DE COLABORADORES
   ============================================================ */
function ensureDocsConfig(){
  if(!S.config.docFields||!Array.isArray(S.config.docFields)||!S.config.docFields.length){
    S.config.docFields=LEGAL_FIELDS_DEFAULT.slice();
  }
  var have={};S.config.docFields.forEach(function(f){have[f.id]=true;});
  LEGAL_FIELDS_DEFAULT.forEach(function(f){if(!have[f.id])S.config.docFields.push(f);});
  if(!S.config.docTemplates||!Array.isArray(S.config.docTemplates))S.config.docTemplates=[];
}
function legalDe(c){c.legal=c.legal&&typeof c.legal==="object"?c.legal:{};return c.legal;}
function docFields(){ensureDocsConfig();return S.config.docFields||[];}
function docTemplates(){ensureDocsConfig();return S.config.docTemplates||[];}
function docUnlocked(){return !!S.auth.docs;}
function bloquearDocs(){
  S.auth.docs=false;
  S.sessions.docs="";
  S.docTplId="";
  toast("Documentacion bloqueada","ok");
  if(S.colSub==="documentacion"&&$("#colSubHost"))renderColDocs($("#colSubHost"));
  else go(S.tab);
}
function pedirDocsUnlock(cb){
  if(docUnlocked()){if(cb)cb();return;}
  var body='<div class="doc-lock">'+
    '<div class="doc-lock-icon">'+ICON.lock+'</div>'+
    '<p class="sub">Esta sección contiene datos personales sensibles. Solicita acceso para continuar.</p>'+ 
    '<div class="field"><label>Contraseña maestra</label><input id="docPwd" type="password" autocomplete="current-password"></div>'+
    '<div class="note"><span>'+ICON.info+'</span><div><b>Seguridad</b>Validación adicional necesaria.</div></div>'+ 
    '</div>';
  modal("Documentacion protegida","Acceso exclusivo con contraseña maestra.",body,function(){
    var pwd=$("#docPwd").value||"";
    if(!pwd){toast("Escribe la contraseña maestra","err");return false;}
    var btn=$("#mSave");
    var reset=btnValidando(btn,"Validando...");
    DataStore.autenticar("master",pwd).then(function(d){
      if(d&&d.ok){
        S.auth.docs=true;S.sessions.docs=d.session||"";S.loaded=false;
        cargarDatosCompletosSilencioso().then(function(ok){
          if(ok===false){toast("No se pudo cargar documentacion","err");reset();return;}
          cerrarModal();toast("Documentacion desbloqueada","ok");
          setTimeout(function(){if(cb)cb();},0);
        }).catch(function(){toast("No se pudo cargar documentacion","err");reset();});
      }
      else{toast("Contraseña maestra incorrecta","err");reset();}
    }).catch(function(){
      toast("No se pudo validar","err");
      reset();
    });
    return false;
  });
  var cm=$("#modal .modal");if(cm)cm.classList.add("doc-auth-modal");
  var sv=$("#mSave");if(sv)sv.innerHTML=ICON.lock+" Entrar";
}
function campoLegalHTML(f,val){
  var id='f-legal-'+f.id, type=f.type==="date"?"date":(f.type==="number"?"number":"text");
  if(f.id==="dias_vacaciones_anuales"&&(val==null||val===""))val=12;
  if(f.id==="edad")return '<div class="field"><label>'+esc(f.label)+'</label><input id="'+id+'" type="number" value="'+esc(val||"")+'" readonly></div>';
  if(f.type==="textarea")return '<div class="field"><label>'+esc(f.label)+'</label><textarea id="'+id+'" rows="2">'+esc(val||"")+'</textarea></div>';
  return '<div class="field"><label>'+esc(f.label)+'</label><input id="'+id+'" type="'+type+'" value="'+esc(val||"")+'"></div>';
}
function markerList(){
  var base=[
    ["colaborador.nombre","Nombre del colaborador"],["colaborador.puesto","Puesto"],["colaborador.depto","Departamento"],
    ["colaborador.rfc","RFC"],["colaborador.curp","CURP"],["colaborador.nss","NSS"],["colaborador.sucursal","Sucursal"],
    ["colaborador.ingreso","Fecha de ingreso"],["colaborador.sueldo","Sueldo"],["empresa.razonSocial","Razon social"],
    ["empresa.rfc","RFC empresa"],["empresa.registroPatronal","Registro patronal"],["empresa.domicilio","Domicilio empresa"],
    ["documento.fecha","Fecha fija del documento"],["documento.fecha_iso","Fecha fija en formato ISO"],["documento.fecha_texto","Fecha fija en texto"],
    ["fecha.hoy","Fecha de hoy"],["fecha.hoy_iso","Fecha de hoy en formato ISO"],["fecha.hoy_texto","Fecha de hoy en texto"],
    ["extra.hechos","Dato especial capturado antes de generar"],["extra.observaciones","Observaciones capturadas antes de generar"]
  ];
  docFields().forEach(function(f){base.push(["legal."+f.id,f.label]);});
  return base;
}
function markerListForTpl(tpl){
  var arr=markerList().slice(), seen={};
  arr.forEach(function(m){seen[m[0]]=true;});
  parsePreFields(tpl).forEach(function(f){
    var k="extra."+f.id;
    if(!seen[k])arr.push([k,f.label]);
  });
  return arr;
}
function htmlActionList(){
  return [
    {nom:"Titulo 1",tip:"Encabezado principal del documento.",snip:"<h1>Texto del titulo</h1>"},
    {nom:"Titulo 2",tip:"Subtitulo para secciones importantes.",snip:"<h2>Texto del subtitulo</h2>"},
    {nom:"Titulo 3",tip:"Subtitulo menor dentro de una seccion.",snip:"<h3>Texto del apartado</h3>"},
    {nom:"Parrafo",tip:"Bloque normal de texto.",snip:"<p>Texto del parrafo.</p>"},
    {nom:"Salto",tip:"Baja una linea sin crear un parrafo nuevo.",snip:"<br>"},
    {nom:"Negritas",tip:"Resalta texto en negritas.",snip:"<b>Texto importante</b>"},
    {nom:"Cursiva",tip:"Muestra texto en cursiva.",snip:"<i>Texto en cursiva</i>"},
    {nom:"Subrayado",tip:"Subraya una palabra o frase.",snip:"<u>Texto subrayado</u>"},
    {nom:"Lista num.",tip:"Lista numerada para clausulas o pasos.",snip:"<ol>\\n  <li>Primer punto</li>\\n  <li>Segundo punto</li>\\n</ol>"},
    {nom:"Vinetas",tip:"Lista con vinetas para puntos no numerados.",snip:"<ul>\\n  <li>Primer punto</li>\\n  <li>Segundo punto</li>\\n</ul>"},
    {nom:"Linea",tip:"Linea horizontal divisoria.",snip:"<hr>"},
    {nom:"Tabla",tip:"Tabla simple para datos o firmas.",snip:"<table>\\n  <tr><td>Campo</td><td>Valor</td></tr>\\n</table>"},
    {nom:"Alinear izquierda",tip:"Alinea el texto o bloque a la izquierda.",wrap:["<div style=\"text-align:left\">","</div>"],sample:"Texto alineado a la izquierda"},
    {nom:"Alinear derecha",tip:"Alinea el texto o bloque a la derecha.",wrap:["<div style=\"text-align:right\">","</div>"],sample:"Texto alineado a la derecha"},
    {nom:"Centrar",tip:"Centra el texto seleccionado o crea un bloque centrado.",wrap:["<div style=\"text-align:center\">","</div>"],sample:"Texto centrado"},
    {nom:"Justificar",tip:"Justifica el texto seleccionado o crea un bloque justificado.",wrap:["<div style=\"text-align:justify\">","</div>"],sample:"Texto justificado"},
    {nom:"Texto pequeno",tip:"Texto reducido para notas o aclaraciones.",snip:"<small>Nota legal</small>"},
    {nom:"Letra 10",tip:"Texto con tamano de letra de 10 puntos.",wrap:["<span style=\"font-size:10pt\">","</span>"],sample:"Texto 10 pt"},
    {nom:"Letra 12",tip:"Texto con tamano de letra de 12 puntos.",wrap:["<span style=\"font-size:12pt\">","</span>"],sample:"Texto 12 pt"},
    {nom:"Letra 14",tip:"Texto con tamano de letra de 14 puntos.",wrap:["<span style=\"font-size:14pt\">","</span>"],sample:"Texto 14 pt"},
    {nom:"Mayusculas",tip:"Convierte visualmente el texto seleccionado a mayusculas.",wrap:["<span style=\"text-transform:uppercase\">","</span>"],sample:"Texto en mayusculas"},
    {nom:"Minusculas",tip:"Convierte visualmente el texto seleccionado a minusculas.",wrap:["<span style=\"text-transform:lowercase\">","</span>"],sample:"Texto en minusculas"},
    {nom:"Imagen 25%",tip:"Inserta una imagen pequeña. Sustituye URL_O_DATA_DE_LA_IMAGEN por la URL o data:image.",snip:"<img src=\"URL_O_DATA_DE_LA_IMAGEN\" alt=\"Imagen\" style=\"width:25%;height:auto\">"},
    {nom:"Imagen 50%",tip:"Inserta una imagen mediana. Sustituye URL_O_DATA_DE_LA_IMAGEN por la URL o data:image.",snip:"<img src=\"URL_O_DATA_DE_LA_IMAGEN\" alt=\"Imagen\" style=\"width:50%;height:auto\">"},
    {nom:"Imagen 100%",tip:"Inserta una imagen de ancho completo. Sustituye URL_O_DATA_DE_LA_IMAGEN por la URL o data:image.",snip:"<img src=\"URL_O_DATA_DE_LA_IMAGEN\" alt=\"Imagen\" style=\"width:100%;height:auto\">"},
    {nom:"Imagen fija",tip:"Inserta una imagen con tamano exacto editable en pixeles.",snip:"<img src=\"URL_O_DATA_DE_LA_IMAGEN\" alt=\"Imagen\" style=\"width:180px;height:auto\">"},
    {nom:"Img en linea",tip:"Imagen en linea con el texto.",snip:"<img src=\"URL_O_DATA_DE_LA_IMAGEN\" alt=\"Imagen\" style=\"width:120px;height:auto;vertical-align:middle;margin:0 6px\">"},
    {nom:"Img cuadrado",tip:"Imagen flotante con texto alrededor.",snip:"<img src=\"URL_O_DATA_DE_LA_IMAGEN\" alt=\"Imagen\" style=\"width:160px;height:auto;float:left;margin:0 12px 8px 0\">"},
    {nom:"Img estrecho",tip:"Imagen flotante compacta con texto cercano.",snip:"<img src=\"URL_O_DATA_DE_LA_IMAGEN\" alt=\"Imagen\" style=\"width:120px;height:auto;float:right;margin:0 0 6px 10px\">"},
    {nom:"Img arriba-abajo",tip:"Imagen en bloque; el texto queda antes y despues.",snip:"<div style=\"text-align:center;margin:10px 0\"><img src=\"URL_O_DATA_DE_LA_IMAGEN\" alt=\"Imagen\" style=\"width:50%;height:auto\"></div>"},
    {nom:"Img detras texto",tip:"Imagen como marca de agua detras del texto del bloque.",snip:"<div style=\"position:relative;min-height:180px;padding:18px\"><img src=\"URL_O_DATA_DE_LA_IMAGEN\" alt=\"Imagen\" style=\"position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:55%;height:auto;opacity:.18;z-index:0\"><div style=\"position:relative;z-index:1\">Texto sobre la imagen</div></div>"},
    {nom:"Img delante texto",tip:"Imagen superpuesta por delante del texto del bloque.",snip:"<div style=\"position:relative;min-height:180px;padding:18px\"><div>Texto detras de la imagen</div><img src=\"URL_O_DATA_DE_LA_IMAGEN\" alt=\"Imagen\" style=\"position:absolute;right:0;top:0;width:160px;height:auto;z-index:2\"></div>"},
    {nom:"Espacio firma",tip:"Agrega espacio vertical antes de una firma.",snip:"<div style=\"height:48px\"></div>"},
    {nom:"2 firmas",tip:"Crea dos espacios paralelos para firmas de contrato.",snip:"<table style=\"width:100%;margin-top:48px;border-collapse:collapse\">\\n  <tr>\\n    <td style=\"width:50%;text-align:center;padding:0 18px\">____________________________<br>Firma colaborador</td>\\n    <td style=\"width:50%;text-align:center;padding:0 18px\">____________________________<br>Firma empresa</td>\\n  </tr>\\n</table>"},
    {nom:"2 columnas",tip:"Divide el contenido en dos columnas.",snip:"<table style=\"width:100%;border-collapse:collapse\">\\n  <tr>\\n    <td style=\"width:50%;vertical-align:top;padding-right:14px\">Columna izquierda</td>\\n    <td style=\"width:50%;vertical-align:top;padding-left:14px\">Columna derecha</td>\\n  </tr>\\n</table>"}
  ];
}
function insertEditorText(ta,text){
  var s=ta.selectionStart||0,e=ta.selectionEnd||0;
  var top=ta.scrollTop;
  ta.value=ta.value.slice(0,s)+text+ta.value.slice(e);
  ta.focus();
  ta.selectionStart=ta.selectionEnd=s+text.length;
  ta.scrollTop=top;
}
function wrapEditorSelection(ta,start,end,sample){
  var s=ta.selectionStart||0,e=ta.selectionEnd||0, sel=ta.value.slice(s,e)||sample||"Texto";
  var top=ta.scrollTop;
  var text=start+sel+end;
  ta.value=ta.value.slice(0,s)+text+ta.value.slice(e);
  ta.focus();
  ta.selectionStart=s+start.length;
  ta.selectionEnd=s+start.length+sel.length;
  ta.scrollTop=top;
}
function docIngresoKey(c){return c.reingresoFecha||c.ingreso||"actual";}
function docVersiones(c,tplId){
  var l=legalDe(c), k=tplId||S.docTplId||"general";
  l._docVersiones=l._docVersiones||{};
  l._docVersiones[k]=Array.isArray(l._docVersiones[k])?l._docVersiones[k]:[];
  return l._docVersiones[k];
}
function docVersionActual(c,tplId){
  var arr=docVersiones(c,tplId), key=docIngresoKey(c);
  if(S.docVerId){var byId=arr.filter(function(v){return v.id===S.docVerId;})[0];if(byId)return byId;}
  return arr.filter(function(v){return v.ingresoKey===key;})[0]||null;
}
function parsePreFields(tpl){
  return String(tpl&&tpl.preFields||"").split(/\r?\n/).map(function(line){
    line=line.trim();if(!line)return null;
    var p=line.split("|"), key=slugField(p[0]||"campo");
    return {id:key,label:(p[1]||p[0]||key).trim(),type:(p[2]||"textarea").trim()};
  }).filter(Boolean);
}
function collectDocExtra(tpl){
  var out={};
  parsePreFields(tpl).forEach(function(f){var inp=$("#doc-extra-"+f.id);out[f.id]=inp?inp.value:"";});
  return out;
}
function docFechaElegida(){
  var inp=$("#docDate"), val=inp&&inp.value?inp.value:"";
  return /^\d{4}-\d{2}-\d{2}$/.test(val)?val:fechaISO(new Date());
}
function crearDocVersion(c,tpl){
  var arr=docVersiones(c,tpl.id), key=docIngresoKey(c), fecha=docFechaElegida();
  var v={id:uid("ver"),tplId:tpl.id,nombre:tpl.nombre||"Documento",ingresoKey:key,fechaISO:fecha,createdAt:new Date().toISOString(),extra:collectDocExtra(tpl),rendered:""};
  arr.push(v);
  S.docVerId=v.id;
  v.rendered=renderTemplate(tpl,c,v,true);
  return v;
}
function asegurarDocVersion(c,tpl){
  var key=docIngresoKey(c), v=docVersiones(c,tpl.id).filter(function(x){return x.ingresoKey===key;})[0];
  return v||crearDocVersion(c,tpl);
}
function eliminarDocVersion(c,tplId,verId){
  var arr=docVersiones(c,tplId), idx=-1;
  arr.forEach(function(v,i){if(v.id===verId)idx=i;});
  if(idx>=0)arr.splice(idx,1);
  S.docVerId="";
  DataStore.guardarColab(c);
}
function docData(c){
  var l=legalDe(c), emp=S.config||{}, out={};
  Object.keys(c||{}).forEach(function(k){out["colaborador."+k]=c[k];});
  Object.keys(l||{}).forEach(function(k){out["legal."+k]=l[k];});
  ["razonSocial","rfc","registroPatronal","domicilio","empresa"].forEach(function(k){out["empresa."+k]=emp[k]||"";});
  var ver=docVersionActual(c,S.docTplId), hoyISO=fechaISO(new Date());
  out["documento.fecha_iso"]=(ver&&ver.fechaISO)||hoyISO;
  out["documento.fecha"]=fechaLarga(new Date(out["documento.fecha_iso"]+"T00:00:00"));
  out["documento.fecha_texto"]=fechaTexto(new Date(out["documento.fecha_iso"]+"T00:00:00"));
  if(ver&&ver.extra)Object.keys(ver.extra).forEach(function(k){out["extra."+k]=ver.extra[k];});
  var ref=ver?new Date(out["documento.fecha_iso"]+"T00:00:00"):new Date();
  out["fecha.hoy_iso"]=ver?out["documento.fecha_iso"]:hoyISO;
  out["fecha.hoy"]=fechaLarga(ref);
  out["fecha.hoy_texto"]=fechaTexto(ref);
  return out;
}
function sanitizeDocHtml(html){
  return String(html||"")
    .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi,"")
    .replace(/\son\w+="[^"]*"/gi,"")
    .replace(/\son\w+='[^']*'/gi,"");
}
function renderTemplate(tpl,c,ver,raw){
  if(ver&&ver.rendered&&!raw)return '<div class="doc-render">'+ver.rendered+'</div>';
  var html=sanitizeDocHtml(tpl&&tpl.html||"");
  var data=docData(c);
  html=html.replace(/\{\{\s*([^}]+?)\s*\}\}/g,function(_,k){return esc(data[k.trim()]||"");});
  if(raw)return html;
  return '<div class="doc-render">'+html+'</div>';
}
function imprimirDocumento(){
  var c=S.colaboradores.filter(function(x){return x.id===S.docColId;})[0];
  var t=docTemplates().filter(function(x){return x.id===S.docTplId;})[0];
  if(!c||!t){toast("Selecciona colaborador y formato","err");return;}
  var existed=!!docVersionActual(c,S.docTplId);
  var ver=docVersionActual(c,S.docTplId)||asegurarDocVersion(c,t);
  function doPrint(){
    var html='<div class="doc-print">'+renderTemplate(t,c,ver)+'</div>';
    var area=$("#printarea");area.className="print-only print-doc";area.innerHTML=html;setPrintPageStyle("reporte");
    syncDocVersionInput();
    pintarDocPreview();
    printIsolado();
  }
  if(existed){doPrint();return;}
  DataStore.guardarColab(c).then(function(d){if(d&&!d.error){toast("Version guardada","ok");doPrint();}});
}
function viewColaboradores(v){
  var card=el("div",{class:"card"});
  card.innerHTML='<div class="card-head"><div><h2>Colaboradores</h2>'+
    '<p class="sub">Listado editable. El sueldo puede asignarse por hora, semana o mes.</p></div>'+
    '<button class="btn btn-primary" id="addCol">+ Nuevo colaborador</button></div>'+
    '<div class="subtabs doc-subtabs"><button data-colsub="listado" class="'+(S.colSub!=="documentacion"?"active":"")+'">Listado</button>'+
      '<button data-colsub="documentacion" class="'+(S.colSub==="documentacion"?"active":"")+'">'+ICON.doc+' Documentacion</button></div>'+
    '<div id="colSubHost"></div>';
  v.appendChild(card);
  $("#addCol").addEventListener("click",function(){editarColab(null);});
  $$("#view [data-colsub]").forEach(function(b){b.addEventListener("click",function(){S.colSub=b.getAttribute("data-colsub");go("colaboradores");});});
  if(S.colSub==="documentacion")renderColDocs($("#colSubHost"));
  else renderColList($("#colSubHost"));
}
function renderColList(host){
  host.innerHTML='<div class="search search-lg" style="width:100%;max-width:none;margin-bottom:16px"><span>'+ICON.search+'</span><input id="qCol" placeholder="Buscar por nombre o puesto..."></div>'+
    '<div class="row filtro-row" style="margin-bottom:14px">'+
      '<span class="lbl filtro-lbl">Mostrar</span>'+
      '<span class="chip2" data-f="activos">Activos</span>'+
      '<span class="chip2" data-f="baja">Baja</span>'+
      '<span class="chip2" data-f="todos">Todos</span>'+
    '</div>'+
    '<div class="table-wrap"><table class="data"><thead><tr>'+
    '<th>Nombre</th><th>Puesto</th><th>Sucursal</th><th>Sueldo</th><th>Tipo</th><th>Estado</th><th></th>'+
    '</tr></thead><tbody id="colBody"></tbody></table></div>';
  $$("#view [data-f]").forEach(function(c){c.classList.toggle("active",c.getAttribute("data-f")===S.colFiltro);
    c.addEventListener("click",function(){S.colFiltro=c.getAttribute("data-f");
      $$("#view [data-f]").forEach(function(x){x.classList.toggle("active",x===c);});
      pintarColab($("#qCol")?$("#qCol").value:"");});});
  $("#qCol").addEventListener("input",function(){pintarColab(this.value);});
  pintarColab("");
}
function renderColDocs(host){
  ensureDocsConfig();
  if(!docUnlocked()){
    host.innerHTML='<div class="doc-protected"><div class="doc-lock-icon">'+ICON.lock+'</div><h3>Documentacion protegida</h3>'+
      '<p class="sub">Desbloquea esta area para generar contratos, avisos, reglamentos y otros documentos con datos sensibles.</p>'+
      '<button class="btn btn-primary" id="unlockDocs">'+ICON.lock+' Desbloquear documentacion</button></div>';
    $("#unlockDocs").addEventListener("click",function(){pedirDocsUnlock(function(){go("colaboradores");});});
    return;
  }
  var cols=S.colaboradores.slice().sort(function(a,b){return (a.nombre||"").localeCompare(b.nombre||"");});
  if(!S.docColId&&cols[0])S.docColId=cols[0].id;
  var tpls=docTemplates().filter(function(t){return t.activo!==false;});
  if(!S.docTplId&&tpls[0])S.docTplId=tpls[0].id;
  host.innerHTML='<div class="doc-panel">'+
    '<div class="doc-controls">'+
      '<div class="doc-filter-row">'+
      '<div class="field"><label>Colaborador</label><select id="docCol">'+cols.map(function(c){return '<option value="'+c.id+'"'+(c.id===S.docColId?" selected":"")+'>'+esc(c.nombre||"Sin nombre")+'</option>';}).join("")+'</select></div>'+
      '<div class="field"><label>Formato</label><select id="docTpl"><option value="">Selecciona formato</option>'+tpls.map(function(t){return '<option value="'+t.id+'"'+(t.id===S.docTplId?" selected":"")+'>'+esc(t.nombre)+'</option>';}).join("")+'</select></div>'+
      '<div class="field"><label>Version del documento</label><select id="docVer"></select></div>'+
      '<div class="field doc-date-field"><label>Fecha del documento</label><input type="date" id="docDate"></div>'+
      '</div>'+
      '<div class="doc-action-row">'+
      '<button class="btn doc-new-btn" id="docNewVer">Nueva version</button>'+
      '<button class="btn danger" id="docDelVer">Eliminar version</button>'+
      '<button class="btn btn-primary" id="docPrint">'+ICON.print+' Imprimir / PDF</button>'+
      '<button class="btn doc-lock-btn" id="docLock">'+ICON.lock+' Bloquear</button>'+
      '</div>'+
    '</div>'+
    '<div id="docExtraHost"></div>'+
    '<div class="doc-preview" id="docPreview"></div>'+
    '</div>';
  $("#docCol").addEventListener("change",function(){S.docColId=this.value;S.docVerId="";syncDocVersionInput();syncDocDateInput();pintarDocExtraFields();pintarDocPreview();});
  $("#docTpl").addEventListener("change",function(){S.docTplId=this.value;S.docVerId="";syncDocVersionInput();syncDocDateInput();pintarDocExtraFields();pintarDocPreview();});
  $("#docVer").addEventListener("change",function(){S.docVerId=this.value;syncDocDateInput();pintarDocExtraFields();pintarDocPreview();});
  $("#docNewVer").addEventListener("click",function(){
    var c=S.colaboradores.filter(function(x){return x.id===S.docColId;})[0];
    var t=docTemplates().filter(function(x){return x.id===S.docTplId;})[0];
    if(!c||!t){toast("Selecciona colaborador y formato","err");return;}
    crearDocVersion(c,t);
    DataStore.guardarColab(c).then(function(d){if(d&&!d.error){syncDocVersionInput();syncDocDateInput();pintarDocPreview();toast("Version creada","ok");}});
  });
  $("#docDelVer").addEventListener("click",function(){
    var c=S.colaboradores.filter(function(x){return x.id===S.docColId;})[0], ver=S.docVerId;
    if(!c||!ver){toast("Selecciona una version","err");return;}
    confirmar("Eliminar version","Se quitara esta version guardada del documento. Las demas versiones se conservan.",function(){
      eliminarDocVersion(c,S.docTplId,ver);syncDocVersionInput();pintarDocPreview();toast("Version eliminada","ok");
    });
  });
  $("#docPrint").addEventListener("click",imprimirDocumento);
  $("#docLock").addEventListener("click",bloquearDocs);
  syncDocVersionInput();
  syncDocDateInput();
  pintarDocExtraFields();
  pintarDocPreview();
}
function syncDocVersionInput(){
  var inp=$("#docVer");if(!inp)return;
  var c=S.colaboradores.filter(function(x){return x.id===S.docColId;})[0];
  if(!c||!S.docTplId){inp.innerHTML='<option value="">Sin versiones</option>';return;}
  var arr=docVersiones(c,S.docTplId);
  if(!arr.length){inp.innerHTML='<option value="">Se creara al generar</option>';S.docVerId="";return;}
  var cur=docVersionActual(c,S.docTplId);
  S.docVerId=cur?cur.id:"";
  inp.innerHTML='<option value="">Crear/generar version actual</option>'+arr.map(function(v,i){
    return '<option value="'+v.id+'"'+(v.id===S.docVerId?" selected":"")+'>Version '+(i+1)+' - '+fechaLarga(new Date(v.fechaISO+"T00:00:00"))+(v.ingresoKey===docIngresoKey(c)?" (actual)":"")+'</option>';
  }).join("");
}
function syncDocDateInput(){
  var inp=$("#docDate");if(!inp)return;
  var c=S.colaboradores.filter(function(x){return x.id===S.docColId;})[0];
  var ver=c?docVersionActual(c,S.docTplId):null;
  inp.value=(ver&&ver.fechaISO)||inp.value||fechaISO(new Date());
  inp.title="Opcional. Si cambias esta fecha antes de crear una nueva version, sustituye la fecha de generacion del documento.";
}
function pintarDocExtraFields(){
  var host=$("#docExtraHost");if(!host)return;
  var t=docTemplates().filter(function(x){return x.id===S.docTplId;})[0];
  var c=S.colaboradores.filter(function(x){return x.id===S.docColId;})[0];
  var fields=parsePreFields(t), ver=c?docVersionActual(c,S.docTplId):null;
  if(!fields.length){host.innerHTML="";return;}
  host.innerHTML='<div class="doc-extra-box"><div><h3>Datos especiales del documento</h3><p class="sub">Captura esta informacion antes de crear una nueva version. Al generarla quedara fija en esa version.</p></div>'+
    '<div class="grid-2">'+fields.map(function(f){
      var val=ver&&ver.extra?ver.extra[f.id]:"", dis=ver?' disabled':'';
      if(f.type==="text")return '<div class="field"><label>'+esc(f.label)+'</label><input id="doc-extra-'+f.id+'" value="'+esc(val)+'"'+dis+'></div>';
      if(f.type==="date")return '<div class="field"><label>'+esc(f.label)+'</label><input type="date" id="doc-extra-'+f.id+'" value="'+esc(val)+'"'+dis+'></div>';
      return '<div class="field"><label>'+esc(f.label)+'</label><textarea id="doc-extra-'+f.id+'" rows="3"'+dis+'>'+esc(val)+'</textarea></div>';
    }).join("")+'</div>'+
    (ver?'<p class="small">Esta version ya fue generada. Para modificar estos datos crea una nueva version.</p>':'')+'</div>';
}
function pintarDocPreview(){
  var host=$("#docPreview");if(!host)return;
  var c=S.colaboradores.filter(function(x){return x.id===S.docColId;})[0];
  var t=docTemplates().filter(function(x){return x.id===S.docTplId;})[0];
  if(!docTemplates().length){host.innerHTML='<div class="empty">'+ICON.doc+'Aun no hay formatos. Agregalos en Configuracion > Formatos de documentacion.</div>';return;}
  if(!c||!t){host.innerHTML='<div class="empty">'+ICON.doc+'Selecciona colaborador y formato.</div>';return;}
  var ver=docVersionActual(c,S.docTplId);
  if(!ver){host.innerHTML='<div class="empty">'+ICON.doc+'Este documento aun no tiene una version generada. Usa "Nueva version" o "Imprimir / PDF" para crear la primera con fecha fija.</div>';return;}
  host.innerHTML=renderTemplate(t,c,ver);
}
function editarColab(c){
  var nuevo=!c;
  if(!nuevo&&!docUnlocked()){
    var colIdEditar=c.id;
    pedirDocsUnlock(function(){
      var actualizado=S.colaboradores.filter(function(x){return x.id===colIdEditar;})[0];
      editarColab(actualizado||c);
    });
    return;
  }
  var original=c||null;
  c=JSON.parse(JSON.stringify(c||{id:uid("col"),tipoSueldo:"mes",sucursal:sucursalActiva().nombre,estado:"activo",legal:{}}));
  var sucOpts=S.sucursales.map(function(s){return '<option value="'+esc(s.nombre)+'"'+(s.nombre===(c.sucursal||sucursalActiva().nombre)?" selected":"")+'>'+esc(s.nombre)+'</option>';}).join("");
  var legal=legalDe(c), legalHtml="", puedeEditarLegal=nuevo||docUnlocked();
  if(puedeEditarLegal){
    legalHtml='<h3 class="form-section-title">Informacion legal y documentacion</h3><div class="grid-2">'+
      docFields().map(function(f){return campoLegalHTML(f,legal[f.id]);}).join("")+'</div>';
  }else{
    legalHtml='<div class="note doc-note"><span>'+ICON.lock+'</span><div><b>Datos legales protegidos</b>Desbloquea Documentacion para ver o editar campos sensibles del colaborador.</div></div>';
  }
  var body='<div class="grid-2">'+
    campo("Nombre completo","nombre",c.nombre,"text")+
    campo("Puesto","puesto",c.puesto,"text")+
    campo("Departamento","depto",c.depto,"text")+
    '<div class="field"><label>Sucursal</label><select id="f-sucursal">'+sucOpts+'</select></div>'+
    campo("RFC","rfc",c.rfc,"text")+
    campo("CURP","curp",c.curp,"text")+
    campo("NSS","nss",c.nss,"text")+
    campo("Fecha de ingreso","ingreso",c.ingreso,"date")+
    '</div>'+
    '<div class="colab-pay-grid">'+
      '<div class="field"><label>Tipo de sueldo</label><select id="f-tipoSueldo">'+opts(TIPOS_SUELDO,c.tipoSueldo)+'</select></div>'+
      campo("Monto del sueldo","sueldo",c.sueldo,"number")+
      campo("Horas objetivo / semana","horasObjetivo",c.horasObjetivo,"number")+
    '</div>'+
    legalHtml+
    '<div class="field colab-notes"><label>Notas del colaborador</label>'+
      '<textarea id="f-notas" rows="2" placeholder="Notas internas">'+esc(c.notas||"")+'</textarea></div></div>';
  modal(nuevo?"Nuevo colaborador":"Editar colaborador","Datos usados en horarios, nomina y documentacion.",body,function(){
    ["nombre","puesto","depto","rfc","curp","nss","ingreso","sueldo","horasObjetivo"].forEach(function(k){
      var inp=$("#f-"+k);if(inp)c[k]=inp.type==="number"?(+inp.value||0):inp.value;});
    c.sucursal=$("#f-sucursal").value;
    c.tipoSueldo=$("#f-tipoSueldo").value;
    c.notas=$("#f-notas").value;
    if(puedeEditarLegal){
      c.legal=c.legal||{};
      docFields().forEach(function(f){var inp=$("#f-legal-"+f.id);if(inp)c.legal[f.id]=inp.value;});
      if(c.legal.fecha_nacimiento)c.legal.edad=edadDesdeFecha(c.legal.fecha_nacimiento);
    }
    if(!c.estado)c.estado="activo";
    if(!c.nombre){toast("Falta el nombre","err");return false;}
    var btn=$("#mSave"), reset=btn?btnValidando(btn,"Guardando..."):function(){};
    DataStore.guardarColab(c).then(function(d){
      reset();
      if(d&&!d.error){toast("Colaborador guardado","ok");if(S.sync)S.sync.pending=false;cerrarModal();}
    }).catch(function(){reset();});
    return false;
  });
  var bg=$("#modal"), cm=bg?bg.querySelector(".modal"):null;
  if(cm){
    cm.classList.add("colab-modal");
    Array.prototype.slice.call(bg.children).forEach(function(ch){
      if(ch.classList&&ch.classList.contains("modal-foot"))cm.appendChild(ch);
    });
  }
  var fn=$("#f-legal-fecha_nacimiento"), edad=$("#f-legal-edad");
  if(fn&&edad){
    function updEdad(){edad.value=edadDesdeFecha(fn.value)||"";}
    fn.addEventListener("change",updEdad);fn.addEventListener("input",updEdad);updEdad();
  }
}
function renderDocsConfig(v){
  ensureDocsConfig();
  var card=el("div",{class:"card"});
  if(!docUnlocked()){
    card.innerHTML='<div class="card-head"><div><h2>Documentacion</h2>'+
      '<p class="sub">Campos legales y formatos HTML para generar documentos autocompletados.</p></div>'+
      '<button class="btn btn-primary" id="cfgUnlockDocs">'+ICON.lock+' Desbloquear</button></div>'+
      '<div class="note"><span>'+ICON.lock+'</span><div><b>Seguridad</b>Esta configuración requiere acceso adicional. Solicita soporte técnico.</div></div>';
    v.appendChild(card);
    $("#cfgUnlockDocs").addEventListener("click",function(){
      pedirDocsUnlock(function(){
        var parent=card.parentNode;if(!parent)return;
        var tmp=el("div");
        parent.insertBefore(tmp,card);
        renderDocsConfig(tmp);
        var fresh=tmp.firstElementChild;
        if(fresh)parent.replaceChild(fresh,card);
        tmp.remove();
      });
    });
    return;
  }
  card.innerHTML='<div class="card-head"><div><h2>Documentacion</h2>'+
    '<p class="sub">Define campos legales y administra formatos HTML con marcadores autocompletables.</p></div>'+
    '<div class="btn-row"><button class="btn btn-sm" id="lockDocsCfg">'+ICON.lock+' Bloquear</button><button class="btn btn-sm" id="addDocField">+ Campo</button><button class="btn btn-sm" id="addDocTpl">+ Formato</button></div></div>'+
    '<h3 class="rep-h3">Campos legales del colaborador</h3>'+
    '<div class="table-wrap"><table class="data"><thead><tr><th>Campo</th><th>Marcador</th><th>Tipo</th><th>Sensible</th><th></th></tr></thead><tbody id="docFieldsBody"></tbody></table></div>'+
    '<h3 class="rep-h3">Formatos de documento</h3>'+
    '<div class="table-wrap"><table class="data"><thead><tr><th>Formato</th><th>Estado</th><th></th></tr></thead><tbody id="docTplBody"></tbody></table></div>';
  v.appendChild(card);
  $("#lockDocsCfg").addEventListener("click",bloquearDocs);
  $("#addDocField").addEventListener("click",function(){editarDocField(-1);});
  $("#addDocTpl").addEventListener("click",function(){editarDocTpl(-1);});
  pintarDocsConfigTables();
}
function pintarDocsConfigTables(){
  var fb=$("#docFieldsBody"), tb=$("#docTplBody");if(!fb||!tb)return;
  fb.innerHTML=docFields().map(function(f,i){return '<tr><td><b>'+esc(f.label)+'</b><div class="small">'+esc(f.id)+'</div></td>'+
    '<td><span class="pill">{{legal.'+esc(f.id)+'}}</span></td><td>'+esc(f.type||"text")+'</td>'+
    '<td>'+(f.sensitive?'<span class="badge-est baja">Sensible</span>':'<span class="badge-est activo">General</span>')+'</td>'+
    '<td style="text-align:right"><button class="iconbtn" data-edit-field="'+i+'">'+ICON.edit+'</button><button class="iconbtn danger" data-del-field="'+i+'">'+ICON.trash+'</button></td></tr>';}).join("");
  tb.innerHTML=docTemplates().map(function(t,i){return '<tr><td><b>'+esc(t.nombre||"Sin nombre")+'</b><div class="small">'+esc(t.id)+'</div></td>'+
    '<td>'+(t.activo===false?'<span class="badge-est baja">Inactivo</span>':'<span class="badge-est activo">Activo</span>')+'</td>'+
    '<td style="text-align:right"><button class="iconbtn" data-edit-tpl="'+i+'">'+ICON.edit+'</button><button class="iconbtn danger" data-del-tpl="'+i+'">'+ICON.trash+'</button></td></tr>';}).join("") || '<tr><td colspan="3"><div class="empty">'+ICON.doc+'Aun no hay formatos.</div></td></tr>';
  $$("[data-edit-field]").forEach(function(b){b.addEventListener("click",function(){editarDocField(+b.getAttribute("data-edit-field"));});});
  $$("[data-del-field]").forEach(function(b){b.addEventListener("click",function(){var i=+b.getAttribute("data-del-field"),bak=S.config.docFields.slice();S.config.docFields.splice(i,1);guardarConfigConfirmado("",pintarDocsConfigTables).then(function(ok){if(!ok){S.config.docFields=bak;pintarDocsConfigTables();}}).catch(function(){S.config.docFields=bak;pintarDocsConfigTables();});});});
  $$("[data-edit-tpl]").forEach(function(b){b.addEventListener("click",function(){editarDocTpl(+b.getAttribute("data-edit-tpl"));});});
  $$("[data-del-tpl]").forEach(function(b){b.addEventListener("click",function(){var i=+b.getAttribute("data-del-tpl"),bak=S.config.docTemplates.slice();S.config.docTemplates.splice(i,1);guardarConfigConfirmado("",pintarDocsConfigTables).then(function(ok){if(!ok){S.config.docTemplates=bak;pintarDocsConfigTables();}}).catch(function(){S.config.docTemplates=bak;pintarDocsConfigTables();});});});
}
function slugField(s){return String(s||"campo").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"").replace(/[^a-z0-9]+/g,"_").replace(/^_+|_+$/g,"")||uid("campo");}
function editarDocField(i){
  var f=i>=0?Object.assign({},S.config.docFields[i]):{id:"",label:"",type:"text",sensitive:true,docs:true};
  var body='<div class="doc-field-form"><div class="grid-2">'+campo("Nombre del campo","df-label",f.label,"text")+
    '<div class="field"><label>Tipo</label><select id="df-type">'+["text","textarea","date","number"].map(function(t){return '<option value="'+t+'"'+(t===f.type?" selected":"")+'>'+t+'</option>';}).join("")+'</select></div>'+
    campo("Clave / marcador","df-id",f.id,"text")+
    '<label class="check chk-incl doc-sensitive-check"><input type="checkbox" id="df-sensitive"'+(f.sensitive!==false?" checked":"")+'> Campo sensible</label></div>'+
    '<div class="type-help"><b>Tipos de campo</b><span><b>text</b>: texto corto como banco, estado civil o folio.</span><span><b>textarea</b>: texto largo como domicilio completo u observaciones.</span><span><b>date</b>: fechas con selector de calendario.</span><span><b>number</b>: valores numericos como edad, numero o cantidad.</span></div></div>';
  modal(i>=0?"Editar campo legal":"Nuevo campo legal","La clave genera el marcador {{legal.clave}}.",body,function(){
    var label=$("#f-df-label").value.trim(), id=$("#f-df-id").value.trim()||slugField(label);
    if(!label){toast("Falta el nombre del campo","err");return false;}
    var nf={id:slugField(id),label:label,type:$("#df-type").value,sensitive:$("#df-sensitive").checked,docs:true};
    var bak=S.config.docFields.slice(), btn=$("#mSave"), reset=btn?btnValidando(btn,"Guardando..."):function(){};
    if(i>=0)S.config.docFields[i]=nf;else S.config.docFields.push(nf);
    guardarConfigConfirmado("Campo guardado",pintarDocsConfigTables).then(function(ok){reset();if(ok)cerrarModal();else{S.config.docFields=bak;pintarDocsConfigTables();}}).catch(function(){reset();S.config.docFields=bak;pintarDocsConfigTables();});
    return false;
  });
  var cm=$("#modal .modal");if(cm)cm.classList.add("doc-field-modal");
}
function editarDocTpl(i){
  var t=i>=0?Object.assign({},S.config.docTemplates[i]):{id:uid("doc").toUpperCase(),nombre:"Nuevo documento",activo:true,preFields:"",html:"<h1>{{colaborador.nombre}}</h1>\\n<p>Documento generado el {{documento.fecha_texto}}.</p>"};
  var markers=markerListForTpl(t);
  var body=campo("Nombre del formato","dt-nombre",t.nombre,"text")+
    '<label class="check chk-incl"><input type="checkbox" id="dt-activo"'+(t.activo!==false?" checked":"")+'> Activo</label>'+
    '<div class="field"><label>Campos para capturar antes de generar</label><textarea id="dt-prefields" rows="4" placeholder="hechos|Hechos narrados|textarea&#10;lugar|Lugar de los hechos|text">'+esc(t.preFields||"")+'</textarea></div>'+
    '<div class="type-help"><b>Campos especiales</b><span>Escribe un campo por linea con el formato <b>clave|Etiqueta|tipo</b>.</span><span>Tipos disponibles: <b>text</b>, <b>textarea</b>, <b>date</b>.</span><span>Despues usa el marcador <b>{{extra.clave}}</b> dentro de la plantilla.</span></div>'+
    '<div class="field"><label>Plantilla HTML / texto</label><textarea id="dt-html" rows="12" class="doc-editor">'+esc(t.html||"")+'</textarea></div>'+
    '<details class="doc-insert-panel"><summary>Insertar marcador</summary><div class="marker-grid marker-actions">'+markers.map(function(m){return '<button type="button" class="btn btn-sm" title="'+esc(m[1])+'" data-marker="{{'+esc(m[0])+'}}">{{'+esc(m[0])+'}}</button>';}).join("")+'</div></details>'+
    '<details class="doc-insert-panel"><summary>Insertar HTML</summary><div class="marker-grid html-actions">'+htmlActionList().map(function(a){
      if(a.wrap)return '<button type="button" class="btn btn-sm" title="'+esc(a.tip)+'" data-wrap-start="'+esc(a.wrap[0])+'" data-wrap-end="'+esc(a.wrap[1])+'" data-sample="'+esc(a.sample||"Texto")+'">'+esc(a.nom)+'</button>';
      return '<button type="button" class="btn btn-sm" title="'+esc(a.tip)+'" data-html="'+esc(a.snip)+'">'+esc(a.nom)+'</button>';
    }).join("")+'</div></details>';
  modal(i>=0?"Editar formato":"Nuevo formato","Usa marcadores para autocompletar la informacion del colaborador.",body,function(){
    t.nombre=$("#f-dt-nombre").value.trim();
    t.activo=$("#dt-activo").checked;
    t.preFields=$("#dt-prefields").value;
    t.html=$("#dt-html").value;
    if(!t.nombre){toast("Falta el nombre del formato","err");return false;}
    var bak=S.config.docTemplates.slice(), btn=$("#mSave"), reset=btn?btnValidando(btn,"Guardando..."):function(){};
    if(i>=0)S.config.docTemplates[i]=t;else S.config.docTemplates.push(t);
    guardarConfigConfirmado("Formato guardado",pintarDocsConfigTables).then(function(ok){reset();if(ok)cerrarModal();else{S.config.docTemplates=bak;pintarDocsConfigTables();}}).catch(function(){reset();S.config.docTemplates=bak;pintarDocsConfigTables();});
    return false;
  });
  var cm=$("#modal .modal");if(cm)cm.classList.add("doc-template-modal");
  $$(".marker-actions [data-marker]").forEach(function(b){b.addEventListener("click",function(){insertEditorText($("#dt-html"),b.getAttribute("data-marker"));});});
  $$(".html-actions [data-html]").forEach(function(b){b.addEventListener("click",function(){insertEditorText($("#dt-html"),b.getAttribute("data-html"));});});
  $$(".html-actions [data-wrap-start]").forEach(function(b){b.addEventListener("click",function(){wrapEditorSelection($("#dt-html"),b.getAttribute("data-wrap-start"),b.getAttribute("data-wrap-end"),b.getAttribute("data-sample"));});});
}
var _viewConfigBaseDocs=viewConfig;
viewConfig=function(v){
  _viewConfigBaseDocs(v);
  renderDocsConfig(v);
  var passwords=v.querySelector(".access-passwords-card"),backup=v.querySelector(".backup-card");
  if(passwords)v.appendChild(passwords);
  if(backup)v.appendChild(backup);
};

/* ------------------------------------------------------------ */
window.LienzoApp={init:init,_state:S};
if(document.readyState!=="loading")init();
else document.addEventListener("DOMContentLoaded",function(){init();});

})();